import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
};

export type ActivateAdvertisinBoInput = {
  /** advertising id */
  advertisingId: Scalars['String'];
};

export type AddConnectFilesInput = {
  connectFileIds: Array<Scalars['String']>;
};

/** 유저 광고 활동 로그 */
export type AdsActivityLogInput = {
  /** 활동 타입 */
  activityType: CapaActivityType;
  /** ads impression id */
  adsImpressionId: Scalars['String'];
  /** 이메일 */
  email?: InputMaybe<Scalars['String']>;
  /** 아이피 */
  ip: Scalars['String'];
  /** 캐파 서비스 타입 */
  service?: InputMaybe<CapaServiceType>;
  /** url */
  url: Scalars['String'];
};

/** input for allow partner to download rfq files */
export type AllowRfqDrawingFileDownloadInput = {
  /** partner id */
  quotationPartnerId: Scalars['String'];
  /** rfq id */
  rfqId: Scalars['String'];
  /** status for file download */
  status?: InputMaybe<CapaQuotationRfqAllowOpenFileStatus>;
};

export type AnnotationComment = {
  __typename?: 'AnnotationComment';
  comment?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isParent?: Maybe<Scalars['Boolean']>;
  status?: Maybe<CapaQuotationSharedFileAnnotationStatus>;
  userId?: Maybe<Scalars['String']>;
  userName?: Maybe<Scalars['String']>;
};

export type AnnotationCommentBo = {
  __typename?: 'AnnotationCommentBO';
  comment?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['String']>;
  edited?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  isParent?: Maybe<Scalars['Boolean']>;
  status?: Maybe<CapaQuotationSharedFileAnnotationStatus>;
  updatedAt?: Maybe<Scalars['String']>;
  userName?: Maybe<Scalars['String']>;
};

/** ITP event reward */
export type ApproveItpEventInput = {
  /** ITP event id */
  itpEventId: Scalars['String'];
};

/** 파트너 이메일로 승인 */
export type ApprovedQuotationPartnerByEmailInput = {
  /** 이메일 */
  email: Scalars['String'];
};

export type Authentication = {
  __typename?: 'Authentication';
  /** JWT */
  accessToken: Scalars['String'];
  expiresIn: Scalars['Float'];
  redirectUrl?: Maybe<Scalars['String']>;
  /** JWT */
  refreshToken: Scalars['String'];
  tokenType: Scalars['String'];
};

/** 캐파 로그인 */
export type AuthenticationInput = {
  /** device token */
  deviceToken?: InputMaybe<Scalars['String']>;
  /** 이메일 */
  email: Scalars['String'];
  /** 비밀번호 */
  password: Scalars['String'];
  /** 캐파 서비스 타입 */
  service: CapaServiceType;
  /** user language */
  userLanguage?: InputMaybe<Language>;
};

export type AuthenticationOutput = {
  __typename?: 'AuthenticationOutput';
  data?: Maybe<Authentication>;
  /** errorMessage */
  errorMessage?: Maybe<Scalars['String']>;
  /** CAPA ERROR CODE */
  result: CapaErrorCode;
};

export enum BackOfficeAccess {
  AccountManagement = 'ACCOUNT_MANAGEMENT',
  ClientComment = 'CLIENT_COMMENT',
  ClientRead = 'CLIENT_READ',
  DashboardRead = 'DASHBOARD_READ',
  PartnerAdd = 'PARTNER_ADD',
  PartnerApprove = 'PARTNER_APPROVE',
  PartnerComment = 'PARTNER_COMMENT',
  PartnerModify = 'PARTNER_MODIFY',
  PartnerRatingRead = 'PARTNER_RATING_READ',
  PartnerRead = 'PARTNER_READ',
  PartnerRemove = 'PARTNER_REMOVE',
  RfqComment = 'RFQ_COMMENT',
  RfqRead = 'RFQ_READ',
  RfqStop = 'RFQ_STOP',
  ServiceRatingRead = 'SERVICE_RATING_READ',
  StampEventApprove = 'STAMP_EVENT_APPROVE',
  StampEventComment = 'STAMP_EVENT_COMMENT',
  StampEventDownload = 'STAMP_EVENT_DOWNLOAD',
  StampEventRead = 'STAMP_EVENT_READ'
}

export enum BackOfficeAdminRole {
  Admin = 'ADMIN',
  Noedit = 'NOEDIT',
  Vietnam = 'VIETNAM',
  Xaccount = 'XACCOUNT'
}

export enum BackOfficeUserDeptType {
  Crm = 'CRM',
  Dev = 'DEV',
  Pd = 'PD',
  Rnd = 'RND'
}

export enum BackOfficeUserStatus {
  /** 가입 */
  Registered = 'REGISTERED',
  /** 탈퇴 */
  Withdraw = 'WITHDRAW'
}

export type BatchShutDownQuotationPartnerChatRoomsInput = {
  serviceType: CapaQuotationServiceType;
};

export type Capa3DPos = {
  __typename?: 'CAPA3DPos';
  x: Scalars['Float'];
  y: Scalars['Float'];
  z: Scalars['Float'];
};

export type Capa3DPosInput = {
  x: Scalars['Float'];
  y: Scalars['Float'];
  z: Scalars['Float'];
};

export type CapaAccountInfo = {
  accountNumber: Scalars['String'];
  bankCode: CapaBankCode;
  /** bank account holder name */
  holderName: Scalars['String'];
  holderPhone: Scalars['String'];
};

/** 액티비티 타입 */
export enum CapaActivityType {
  ActionInput = 'ACTION_INPUT',
  ButtonClick = 'BUTTON_CLICK',
  LinkClick = 'LINK_CLICK',
  PageVisit = 'PAGE_VISIT'
}

/** 광고 노출 정보 */
export type CapaAdsActivityLog = {
  __typename?: 'CAPAAdsActivityLog';
  /** 광고 타입 (상단 배너, 카드 등등) */
  activityType: CapaActivityType;
  /** 광고 노출 정보 id */
  count: Scalars['Float'];
  /** 광고 타입 (상단 배너, 카드 등등) */
  service: CapaServiceType;
};

export type CapaAdsActivityLogsOutput = {
  __typename?: 'CAPAAdsActivityLogsOutput';
  data?: Maybe<Array<CapaAdsActivityLog>>;
  /** errorMessage */
  errorMessage?: Maybe<Scalars['String']>;
  /** CAPA ERROR CODE */
  result: CapaErrorCode;
};

/** 광고 노출 정보 */
export type CapaAdsImpressionBo = {
  __typename?: 'CAPAAdsImpressionBO';
  /** 광고 정보 id */
  advertismentId: Scalars['ID'];
  /** 광고 이미지 백그라운드 컬러 */
  backgroundColor?: Maybe<Scalars['String']>;
  /** 광고 내용 */
  contents: Scalars['String'];
  /** create at */
  createdAt: Scalars['String'];
  /** 광고 종료일 */
  expiredAt?: Maybe<Scalars['String']>;
  /** 광고 이미지 id */
  fileId: Scalars['ID'];
  /** 광고 노출 정보 id */
  id: Scalars['ID'];
  /** 광고 링크 */
  linkUrl: Scalars['String'];
  /** 광고 타이틀 */
  title: Scalars['String'];
  /** 광고 타입 (상단 배너, 카드 등등) */
  type: CapaAdvertisementType;
  /** update at */
  updatedAt: Scalars['String'];
};

export type CapaAdsImpressionsBoOutput = {
  __typename?: 'CAPAAdsImpressionsBOOutput';
  data?: Maybe<Array<CapaAdsImpressionBo>>;
  /** errorMessage */
  errorMessage?: Maybe<Scalars['String']>;
  /** CAPA ERROR CODE */
  result: CapaErrorCode;
};

/** 광고 정보 */
export type CapaAdvertisementBo = {
  __typename?: 'CAPAAdvertisementBO';
  /** 광고 노출 정보 */
  adsImpressions?: Maybe<Array<CapaAdsImpressionBo>>;
  /** 전화번호 */
  contact: Scalars['String'];
  /** create at */
  createdAt: Scalars['String'];
  /** 이메일 */
  email: Scalars['String'];
  /** 광고 정보 id */
  id: Scalars['ID'];
  /** 담당자명 */
  managerName: Scalars['String'];
  /** 회사명 */
  organizationName: Scalars['String'];
  /** 현재 광고 상태 */
  status: CapaAdvertisementStatus;
  /** update at */
  updatedAt: Scalars['String'];
};

export enum CapaAdvertisementStatus {
  /** 승인 */
  Approved = 'APPROVED',
  /** 삭제 */
  Deleted = 'DELETED',
  /** 만료 */
  Expired = 'EXPIRED',
  /** 등록 */
  Registered = 'REGISTERED'
}

/** 광고 노출 타입 */
export enum CapaAdvertisementType {
  /** 채팅방 카드 */
  ChatRoomCard = 'CHAT_ROOM_CARD',
  /** 상단 배너 */
  TopBanner = 'TOP_BANNER'
}

export type CapaAdvertisementsBoOutput = {
  __typename?: 'CAPAAdvertisementsBOOutput';
  data?: Maybe<Array<CapaAdvertisementBo>>;
  /** errorMessage */
  errorMessage?: Maybe<Scalars['String']>;
  /** CAPA ERROR CODE */
  result: CapaErrorCode;
};

export type CapaAdvertising = {
  __typename?: 'CAPAAdvertising';
  /** ads Impression list */
  adsImpressions: Array<CapaAdvertisingAdsImpression>;
  /** advertising id */
  id: Scalars['String'];
  /** 호스팅할 서비스 타입 (배너, 카드) */
  serviceType: CapaServiceType;
  /** 광고 타입 (배너, 카드) */
  type: CapaAdvertisementType;
};

export type CapaAdvertisingAdsImpression = {
  __typename?: 'CAPAAdvertisingAdsImpression';
  /** ads impression id */
  advertismentId: Scalars['String'];
  /** backgroundColor */
  backgroundColor: Scalars['String'];
  /** contents */
  contents: Scalars['String'];
  /** expiredAt */
  expiredAt?: Maybe<Scalars['String']>;
  /** file id */
  fildId: Scalars['String'];
  /** ads impression id */
  id: Scalars['String'];
  /** linkUrl */
  linkUrl: Scalars['String'];
  /** title */
  title: Scalars['String'];
};

export type CapaAdvertisingBo = {
  __typename?: 'CAPAAdvertisingBO';
  /** ads Impression list */
  adsImpressionIds: Array<Scalars['String']>;
  /** advertising id */
  id: Scalars['String'];
  /** 호스팅할 서비스 타입 (배너, 카드) */
  serviceType: CapaServiceType;
  /** 광고 타입 (배너, 카드) */
  type: CapaAdvertisementType;
};

export type CapaAdvertisingsBoOutput = {
  __typename?: 'CAPAAdvertisingsBOOutput';
  data?: Maybe<Array<CapaAdvertisingBo>>;
  /** errorMessage */
  errorMessage?: Maybe<Scalars['String']>;
  /** CAPA ERROR CODE */
  result: CapaErrorCode;
};

export type CapaAdvertisingsOutput = {
  __typename?: 'CAPAAdvertisingsOutput';
  data?: Maybe<Array<CapaAdvertising>>;
  /** errorMessage */
  errorMessage?: Maybe<Scalars['String']>;
  /** CAPA ERROR CODE */
  result: CapaErrorCode;
};

export type CapaAvailableReview = {
  __typename?: 'CAPAAvailableReview';
  chatRoomId: Scalars['String'];
  isComplete: Scalars['Boolean'];
  /** 파트너 회사명 */
  organizationName?: Maybe<Scalars['String']>;
  profileId?: Maybe<Scalars['String']>;
  /** 발주 발행일 */
  purchaseOrderCreatedAt?: Maybe<Scalars['String']>;
  quotationPartnerId: Scalars['String'];
};

export enum CapaboBypassSearchUserType {
  Client = 'CLIENT',
  Partner = 'PARTNER'
}

/** 파트너 가입 히스토리 */
export type CapaboPartnerHistoryModel = {
  __typename?: 'CAPABOPartnerHistoryModel';
  createdAt?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  manager?: Maybe<Scalars['String']>;
  managerBOId?: Maybe<Scalars['String']>;
  quotationPartnerId: Scalars['String'];
  rejectReason?: Maybe<Scalars['String']>;
  rejectType?: Maybe<CapaQuotationPartnerRejectType>;
  /** 유저 id */
  resultType: CapaQuotationPartnerStatus;
};

export type CapaBackOffice = {
  __typename?: 'CAPABackOffice';
  accessList?: Maybe<Array<BackOfficeAccess>>;
  dept: Scalars['String'];
  email: Scalars['String'];
  /** capa backoffice user id */
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
  nickName?: Maybe<Scalars['String']>;
  role: Scalars['String'];
  status?: Maybe<BackOfficeUserStatus>;
  task?: Maybe<Scalars['String']>;
};

/** BackOffice 커넥트 그룹 필터타입 */
export enum CapaBackOfficeConnectGroupsFilterType {
  /** 실사용 그룹 */
  Activate = 'ACTIVATE',
  /** 전체 */
  Default = 'DEFAULT',
  /** 테스트 그룹 */
  Test = 'TEST'
}

export type CapaBackOfficeRole = {
  __typename?: 'CAPABackOfficeRole';
  accessList?: Maybe<Array<BackOfficeAccess>>;
  role: Scalars['String'];
};

export type CapaBackOfficeUserOutput = {
  __typename?: 'CAPABackOfficeUserOutput';
  data?: Maybe<CapaBackOffice>;
  /** errorMessage */
  errorMessage?: Maybe<Scalars['String']>;
  /** CAPA ERROR CODE */
  result: CapaErrorCode;
};

/** BackOffice 유저 필터타입 */
export enum CapaBackOfficeUsersFilterType {
  /** 실사용자 계정 */
  Activate = 'ACTIVATE',
  /** 전체 */
  Default = 'DEFAULT',
  /** 테스트 계정 */
  Test = 'TEST'
}

export type CapaBackOfficeUsersOutput = {
  __typename?: 'CAPABackOfficeUsersOutput';
  data?: Maybe<Array<CapaBackOffice>>;
  /** errorMessage */
  errorMessage?: Maybe<Scalars['String']>;
  /** CAPA ERROR CODE */
  result: CapaErrorCode;
};

/** 은행 코드 */
export enum CapaBankCode {
  /** 부산은행 */
  BusanBank = 'BUSAN_BANK',
  /** 한국씨티은행_한미은행 */
  CityHanmiBank = 'CITY_HANMI_BANK',
  /** 신협 */
  CreditUnionBank = 'CREDIT_UNION_BANK',
  /** 대구은행 */
  DaeguBank = 'DAEGU_BANK',
  /** 하나은행_서울은행 */
  HanaSeoulBank = 'HANA_SEOUL_BANK',
  /** 기업은행 */
  Ibk = 'IBK',
  /** 전북 */
  JeonbukBank = 'JEONBUK_BANK',
  /** 카카오뱅크 */
  KakaoBank = 'KAKAO_BANK',
  /** KB국민은행 */
  KbBank = 'KB_BANK',
  /** 산업은행 */
  Kdb = 'KDB',
  /** 외환은행 */
  Keb = 'KEB',
  /** 새마을금고 */
  Kfcc = 'KFCC',
  /** 광주은행 */
  KwangjuBank = 'KWANGJU_BANK',
  /** 경남은행 */
  KyongnamBank = 'KYONGNAM_BANK',
  /** 케이뱅크 */
  KBank = 'K_BANK',
  /** 농협 */
  NhBank = 'NH_BANK',
  /** 우체국 */
  PostBank = 'POST_BANK',
  /** SC제일은행 */
  ScBank = 'SC_BANK',
  /** 신한은행 */
  ShinhanBank = 'SHINHAN_BANK',
  /** 수협 */
  ShBank = 'SH_BANK',
  /** 토스뱅크 */
  TossBank = 'TOSS_BANK',
  /** 우리은행 */
  WooriBank = 'WOORI_BANK'
}

/** 엠베서더 */
export type CapaBoAmbassador = {
  __typename?: 'CAPABoAmbassador';
  /** 담당자 휴대폰 번호 */
  cellphoneNumber?: Maybe<Scalars['String']>;
  /** 초대 고객 수 */
  cntClient?: Maybe<Scalars['Float']>;
  /** 초대 파트너 수 */
  cntPartner?: Maybe<Scalars['Float']>;
  /** 사업자 등록 번호 */
  companyRegistrationNumber?: Maybe<Scalars['String']>;
  /** 엠베서더 등록일 */
  createdAt?: Maybe<Scalars['String']>;
  /** 담당자 이메일 */
  email?: Maybe<Scalars['String']>;
  /** ambassador id */
  id?: Maybe<Scalars['ID']>;
  /** 최근 초대일 */
  lastInvitedAt?: Maybe<Scalars['String']>;
  /** 담당자명 */
  managerName?: Maybe<Scalars['String']>;
  /** 엠베서더 회사명 */
  organizationName?: Maybe<Scalars['String']>;
};

export type CapaBoAmbassadorApprovedPartnerUser = {
  __typename?: 'CAPABoAmbassadorApprovedPartnerUser';
  /** 승인일 */
  approvedAt?: Maybe<Scalars['String']>;
  /** 휴대폰 번호 */
  cellphoneNumber?: Maybe<Scalars['String']>;
  /** 채팅수 */
  chatCnt?: Maybe<Scalars['Float']>;
  /** 가입일 */
  createdAt?: Maybe<Scalars['String']>;
  /** 담당자명 */
  managerName?: Maybe<Scalars['String']>;
  /** 파트너명 */
  organizationName?: Maybe<Scalars['String']>;
  /** 수주수 */
  purchaseOrderCnt?: Maybe<Scalars['Float']>;
  /** quotation partner id */
  quotationPartnerId?: Maybe<Scalars['ID']>;
  /** 유입경로 */
  route?: Maybe<Array<CapaInflowRoute>>;
  /** 제안수 */
  suggestionCnt?: Maybe<Scalars['Float']>;
};

export type CapaBoAmbassadorApprovedPartnerUsers = {
  __typename?: 'CAPABoAmbassadorApprovedPartnerUsers';
  /** 초대 파트너 */
  approvedPartnerUsers?: Maybe<Array<CapaBoAmbassadorApprovedPartnerUser>>;
  /** 초대 파트너 수 */
  cntApprovedPartner?: Maybe<Scalars['Float']>;
};

export type CapaBoAmbassadorClientUser = {
  __typename?: 'CAPABoAmbassadorClientUser';
  /** 휴대폰 번호 */
  cellphoneNumber?: Maybe<Scalars['String']>;
  /** 채팅수 */
  chatCnt?: Maybe<Scalars['Float']>;
  /** 가입일 */
  createdAt?: Maybe<Scalars['String']>;
  /** 담당자명 */
  managerName?: Maybe<Scalars['String']>;
  /** 고객명 */
  organizationName?: Maybe<Scalars['String']>;
  /** 발주수 */
  purchaseOrderCnt?: Maybe<Scalars['Float']>;
  /** quotation user id */
  quotationUserId?: Maybe<Scalars['ID']>;
  /** 견적요청수 */
  rfqCnt?: Maybe<Scalars['Float']>;
  /** 유입경로 */
  route?: Maybe<Array<CapaInflowRoute>>;
};

export type CapaBoAmbassadorClientUsers = {
  __typename?: 'CAPABoAmbassadorClientUsers';
  /** 초대 고객 */
  clientUsers?: Maybe<Array<CapaBoAmbassadorClientUser>>;
  /** 초대 고객 수 */
  cntClient?: Maybe<Scalars['Float']>;
};

/** 엠베서더 초대 현황 */
export type CapaBoAmbassadorInvitationStatus = {
  __typename?: 'CAPABoAmbassadorInvitationStatus';
  /** ambassador id */
  ambassadorId?: Maybe<Scalars['ID']>;
  /** 승인 파트너 수 및 목록 */
  approvedPartnerUsersAndCount?: Maybe<CapaBoAmbassadorApprovedPartnerUsers>;
  /** 담당자 휴대폰 번호 */
  cellphoneNumber?: Maybe<Scalars['String']>;
  /** 초대 고객 수 및 목록 */
  clientUsersAndCount?: Maybe<CapaBoAmbassadorClientUsers>;
  /** 고객 누적 방문 수 */
  clientViewCount?: Maybe<Scalars['Float']>;
  /** 엠베서더 등록일 */
  createdAt?: Maybe<Scalars['String']>;
  /** 담당자 이메일 */
  email?: Maybe<Scalars['String']>;
  /** 초대 고객 수 */
  invitedClientCount?: Maybe<Scalars['Float']>;
  /** 초대 파트너 수 */
  invitedPartnerCount?: Maybe<Scalars['Float']>;
  /** 최근 초대일 */
  lastInvitedAt?: Maybe<Scalars['String']>;
  /** 담당자명 */
  managerName?: Maybe<Scalars['String']>;
  /** 승인 대기 파트너 수 및 목록 */
  notApprovedPartnerUsersAndCount?: Maybe<CapaBoAmbassadorNotApprovedPartnerUsers>;
  /** 회사명 */
  organizationName?: Maybe<Scalars['String']>;
  /** 파트너 누적 방문 수 */
  partnerViewCount?: Maybe<Scalars['Float']>;
};

export type CapaBoAmbassadorInvitationStatusOutput = {
  __typename?: 'CAPABoAmbassadorInvitationStatusOutput';
  data?: Maybe<CapaBoAmbassadorInvitationStatus>;
  /** errorMessage */
  errorMessage?: Maybe<Scalars['String']>;
  /** CAPA ERROR CODE */
  result: CapaErrorCode;
};

export type CapaBoAmbassadorNotApprovedPartnerUser = {
  __typename?: 'CAPABoAmbassadorNotApprovedPartnerUser';
  /** 휴대폰 번호 */
  cellphoneNumber?: Maybe<Scalars['String']>;
  /** 가입일 */
  createdAt?: Maybe<Scalars['String']>;
  /** 담당자명 */
  managerName?: Maybe<Scalars['String']>;
  /** 파트너명 */
  organizationName?: Maybe<Scalars['String']>;
  /** quotation partner id */
  quotationPartnerId?: Maybe<Scalars['ID']>;
  /** 유입경로 */
  route?: Maybe<Array<CapaInflowRoute>>;
};

export type CapaBoAmbassadorNotApprovedPartnerUsers = {
  __typename?: 'CAPABoAmbassadorNotApprovedPartnerUsers';
  /** 승인 대기 파트너 수 */
  cntNotApprovedPartner?: Maybe<Scalars['Float']>;
  /** 승인 대기 파트너 */
  notApprovedPartnerUsers?: Maybe<Array<CapaBoAmbassadorNotApprovedPartnerUser>>;
};

export type CapaBoAmbassadorsOutput = {
  __typename?: 'CAPABoAmbassadorsOutput';
  data?: Maybe<Array<CapaBoAmbassador>>;
  /** errorMessage */
  errorMessage?: Maybe<Scalars['String']>;
  /** CAPA ERROR CODE */
  result: CapaErrorCode;
};

/** 코멘트 */
export type CapaBoComment = {
  __typename?: 'CAPABoComment';
  /** comment */
  comment?: Maybe<Scalars['String']>;
  /** 코멘트 생성일 */
  createdAt?: Maybe<Scalars['String']>;
  /** bo user name */
  name?: Maybe<Scalars['String']>;
  /** bo user nickName */
  nickName?: Maybe<Scalars['String']>;
};

export type CapaBoCommentQuotationUsers = {
  __typename?: 'CAPABoCommentQuotationUsers';
  /** 유저별 comments */
  comments?: Maybe<Array<CapaBoComment>>;
  /** quotation user id */
  quotationUserId?: Maybe<Scalars['ID']>;
};

export type CapaBoCommentsOutput = {
  __typename?: 'CAPABoCommentsOutput';
  data?: Maybe<CapaBoCommentQuotationUsers>;
  /** errorMessage */
  errorMessage?: Maybe<Scalars['String']>;
  /** CAPA ERROR CODE */
  result: CapaErrorCode;
};

/** 캐파 BO 메모 정보 */
export type CapaBoMemo = {
  __typename?: 'CAPABoMemo';
  back_office_id: Scalars['ID'];
  /** 메모 생성일 */
  created_at: Scalars['String'];
  id: Scalars['ID'];
  /** memo */
  memo: Scalars['String'];
  /** name */
  name: Scalars['String'];
  /** nick_name */
  nick_name: Scalars['String'];
  /** role */
  role: Scalars['String'];
  /** 유저 id */
  user_id: Scalars['ID'];
};

export type CapaBoMemosOutput = {
  __typename?: 'CAPABoMemosOutput';
  data?: Maybe<Array<CapaBoMemo>>;
  /** errorMessage */
  errorMessage?: Maybe<Scalars['String']>;
  /** CAPA ERROR CODE */
  result: CapaErrorCode;
};

export type CapaBypassComplaintInput = {
  /** 불편사항 타입 */
  complaintType: Array<CapaBypassComplaintType>;
  /** 유저 타입 */
  complaintUserType: Array<CapaboBypassSearchUserType>;
  limit?: InputMaybe<Scalars['Float']>;
  offset?: InputMaybe<Scalars['Float']>;
};

export enum CapaBypassComplaintType {
  /** 캐파 채팅 불편사항 */
  ChatComplaint = 'CHAT_COMPLAINT',
  /** 연락처 교환 x */
  NotExchangeCallNumber = 'NOT_EXCHANGE_CALL_NUMBER',
  /** 어떤 설정도 하지 않음. */
  NoAction = 'NO_ACTION',
  /** 통화필요 */
  RequiredCallNumber = 'REQUIRED_CALL_NUMBER'
}

export type CapacxManagementRequiredRfq = {
  __typename?: 'CAPACXManagementRequiredRfq';
  /** 견적요청일 */
  createdAt?: Maybe<Scalars['String']>;
  /** 프로젝트명 */
  projectName?: Maybe<Scalars['String']>;
  /** rfq id */
  rfqId?: Maybe<Scalars['String']>;
  /** 서비스타입 */
  serviceType?: Maybe<CapaQuotationServiceType>;
  /** RFQ 상태 */
  status?: Maybe<CapaRfqStatus>;
  /** 총 수량 */
  totalQuantity?: Maybe<Scalars['Float']>;
  /** 조회수 */
  viewCount?: Maybe<Scalars['Float']>;
  /** 조회파트너수 */
  viewPartnerCount?: Maybe<Scalars['Float']>;
};

export type CapacxManagementRequiredUserBo = {
  __typename?: 'CAPACXManagementRequiredUserBO';
  /** 고객유형 */
  bizType?: Maybe<CapaQuotationUserBizType>;
  /** 휴대전화 */
  cellphoneNumber?: Maybe<Scalars['String']>;
  /** 코멘트 수 */
  commentCount?: Maybe<Scalars['Float']>;
  /** 이메일 */
  email?: Maybe<Scalars['String']>;
  /** 고객명 */
  managerName?: Maybe<Scalars['String']>;
  /** 회사명 */
  organizationName?: Maybe<Scalars['String']>;
  quotationUserId: Scalars['String'];
  /** CX 관리 대상 rfq 목록 */
  requiredManagementRfqs?: Maybe<Array<CapacxManagementRequiredRfq>>;
};

export type CapacxManagementRequiredUsersBo = {
  __typename?: 'CAPACXManagementRequiredUsersBO';
  count?: Maybe<Scalars['Float']>;
  requiredManagementUsers?: Maybe<Array<CapacxManagementRequiredUserBo>>;
  unReadCount?: Maybe<Scalars['Float']>;
};

export type CapacxManagementRequiredUsersBoOutput = {
  __typename?: 'CAPACXManagementRequiredUsersBOOutput';
  data?: Maybe<CapacxManagementRequiredUsersBo>;
  /** errorMessage */
  errorMessage?: Maybe<Scalars['String']>;
  /** CAPA ERROR CODE */
  result: CapaErrorCode;
};

/** 캐파 견적 서비스 타입 */
export enum CapaCapabilitiesStatusType {
  /** 활성 */
  Active = 'ACTIVE',
  /** 비활성 */
  Inactive = 'INACTIVE',
  /** 보류중 */
  Pending = 'PENDING'
}

/** 챗 첨부 파일 */
export type CapaChatFile = {
  __typename?: 'CAPAChatFile';
  fileId?: Maybe<Scalars['ID']>;
  /** 파일 이름 */
  fileName?: Maybe<Scalars['String']>;
};

export type CapaChatMessageRead = {
  __typename?: 'CAPAChatMessageRead';
  lastChatMessageId?: Maybe<Scalars['ID']>;
};

export type CapaChatMessagesReadOutput = {
  __typename?: 'CAPAChatMessagesReadOutput';
  data?: Maybe<CapaChatMessageRead>;
  /** errorMessage */
  errorMessage?: Maybe<Scalars['String']>;
  /** CAPA ERROR CODE */
  result: CapaErrorCode;
};

export type CapaChatRoom = {
  __typename?: 'CAPAChatRoom';
  id: Scalars['ID'];
};

export type CapaChatRoomUser = {
  __typename?: 'CAPAChatRoomUser';
  id: Scalars['ID'];
  /** 유저 타입 */
  userType: CapaChatRoomUserType;
};

export enum CapaChatRoomUserType {
  /** 손님 */
  Guest = 'GUEST',
  /** 멤버 */
  Member = 'MEMBER',
  /** 주인 */
  Owner = 'OWNER'
}

/** 캐파 클러우드 유저 정보 */
export type CapaCloudUser = {
  __typename?: 'CAPACloudUser';
  /** 사용가능한 드라이브 용량 (단위: byte) */
  availSize: Scalars['Float'];
  /** 전체 드라이브 용량 (단위: byte) */
  driveSize: Scalars['Float'];
  /** capa user email */
  email: Scalars['String'];
  /** capa cloud user id */
  id: Scalars['ID'];
  /** [필수] 개인정보 수집 및 활용 동의 */
  privacyAgreed?: Maybe<Scalars['Boolean']>;
  /** [선택] 프로모션 정보 수신 동의 */
  promotionAgreed?: Maybe<Scalars['Boolean']>;
  /** [필수] 캐파 서비스 이용약관 동의 */
  serviceAgreed?: Maybe<Scalars['Boolean']>;
  /** 사용중인 드라이브 용량 (단위: byte) */
  usedSize: Scalars['Float'];
};

/** 캐파 BO 클러우드 유저 정보 */
export type CapaCloudUserBo = {
  __typename?: 'CAPACloudUserBO';
  /** 클라우드 유저 생성일 */
  createdAt: Scalars['String'];
  /** 전체 드라이브 용량 (단위: byte) */
  driveSize: Scalars['Float'];
  /** capa user email */
  email: Scalars['String'];
  /** 사용중인 드라이브 용량 (단위: byte) */
  usedSize: Scalars['Float'];
};

export type CapaCloudUserOutput = {
  __typename?: 'CAPACloudUserOutput';
  data?: Maybe<CapaCloudUser>;
  /** errorMessage */
  errorMessage?: Maybe<Scalars['String']>;
  /** CAPA ERROR CODE */
  result: CapaErrorCode;
};

export type CapaCloudUsersBoOutput = {
  __typename?: 'CAPACloudUsersBOOutput';
  data?: Maybe<Array<CapaCloudUserBo>>;
  /** errorMessage */
  errorMessage?: Maybe<Scalars['String']>;
  /** CAPA ERROR CODE */
  result: CapaErrorCode;
};

export type CapaComplaintQuotationChatMessageModel = {
  __typename?: 'CAPAComplaintQuotationChatMessageModel';
  receiveComplaintQuotationChatMessageModels: Array<CapaReceiveComplaintQuotationChatMessageModel>;
  totalCnt?: Maybe<Scalars['Float']>;
};

export type CapaComplaintRfqInfoModel = {
  __typename?: 'CAPAComplaintRfqInfoModel';
  projectName?: Maybe<Scalars['String']>;
  rfqId: Scalars['String'];
};

export type CapaComplaintUserInfoModel = {
  __typename?: 'CAPAComplaintUserInfoModel';
  /** 유저 타입 */
  complaintUserType?: Maybe<CapaboBypassSearchUserType>;
  userId: Scalars['String'];
  userName?: Maybe<Scalars['String']>;
};

export type CapaConnectAnnotation = {
  __typename?: 'CAPAConnectAnnotation';
  anchorPos?: Maybe<Capa3DPos>;
  chatRoomId?: Maybe<Scalars['String']>;
  comments?: Maybe<Array<CapaConnectAnnotationComment>>;
  connectFileId?: Maybe<Scalars['String']>;
  connectFileName?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['String']>;
  drawingFile?: Maybe<Scalars['String']>;
  groupId?: Maybe<Scalars['String']>;
  groupUserId?: Maybe<Scalars['String']>;
  handlePos?: Maybe<Capa3DPos>;
  hasNew?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  nodeId?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['String']>;
};

export type CapaConnectAnnotationBo = {
  __typename?: 'CAPAConnectAnnotationBO';
  anchorPos?: Maybe<Capa3DPos>;
  chatRoomId?: Maybe<Scalars['String']>;
  comments?: Maybe<Array<CapaConnectAnnotationCommentBo>>;
  connectFileId?: Maybe<Scalars['String']>;
  connectFileName?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['String']>;
  drawingFile?: Maybe<Scalars['String']>;
  groupId?: Maybe<Scalars['String']>;
  groupUserId?: Maybe<Scalars['String']>;
  handlePos?: Maybe<Capa3DPos>;
  hasNew?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  nodeId?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['String']>;
  userName?: Maybe<Scalars['String']>;
};

export type CapaConnectAnnotationComment = {
  __typename?: 'CAPAConnectAnnotationComment';
  comment?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['String']>;
  edited?: Maybe<Scalars['Boolean']>;
  email?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['String']>;
  userName?: Maybe<Scalars['String']>;
};

export type CapaConnectAnnotationCommentBo = {
  __typename?: 'CAPAConnectAnnotationCommentBO';
  comment?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['String']>;
  edited?: Maybe<Scalars['Boolean']>;
  email?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['String']>;
  userName?: Maybe<Scalars['String']>;
};

export type CapaConnectAnnotationOutput = {
  __typename?: 'CAPAConnectAnnotationOutput';
  data?: Maybe<CapaConnectAnnotation>;
  /** errorMessage */
  errorMessage?: Maybe<Scalars['String']>;
  /** CAPA ERROR CODE */
  result: CapaErrorCode;
};

export type CapaConnectAnnotationsOutput = {
  __typename?: 'CAPAConnectAnnotationsOutput';
  data?: Maybe<Array<CapaConnectAnnotation>>;
  /** errorMessage */
  errorMessage?: Maybe<Scalars['String']>;
  /** CAPA ERROR CODE */
  result: CapaErrorCode;
};

export type CapaConnectChatFile = {
  __typename?: 'CAPAConnectChatFile';
  fileId?: Maybe<Scalars['String']>;
  fileName?: Maybe<Scalars['String']>;
  filePermission?: Maybe<ConnectUserFileStatus>;
  /** 파일크기 byte */
  fileSize?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['ID']>;
  linkStatus?: Maybe<ConnectUserFileLinkStatus>;
  /** original ext */
  originalFileExt?: Maybe<Scalars['String']>;
  permission?: Maybe<CapaQuotationRfqAllowOpenFileStatus>;
  thumbnailUri?: Maybe<Scalars['String']>;
};

export type CapaConnectChatMessage = {
  __typename?: 'CAPAConnectChatMessage';
  chatFiles?: Maybe<Array<CapaConnectChatFile>>;
  chatRoomId?: Maybe<Scalars['String']>;
  /** 생성일 */
  createdAt?: Maybe<Scalars['String']>;
  fileOwnerEmail?: Maybe<Scalars['String']>;
  fileOwnerName?: Maybe<Scalars['String']>;
  groupId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['ID']>;
  message?: Maybe<CapaConnectChatMessageUnion>;
  senderEmail?: Maybe<Scalars['String']>;
  senderId?: Maybe<Scalars['String']>;
  senderName?: Maybe<Scalars['String']>;
  /** 안읽은수 */
  unReadCount?: Maybe<Scalars['Float']>;
};

export type CapaConnectChatMessageAnnotation = {
  __typename?: 'CAPAConnectChatMessageAnnotation';
  annotationId?: Maybe<Scalars['String']>;
  comment?: Maybe<Scalars['String']>;
  commentId?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  messageType: CapaConnectChatMessageType;
  userName?: Maybe<Scalars['String']>;
};

export type CapaConnectChatMessageFileShared = {
  __typename?: 'CAPAConnectChatMessageFileShared';
  fileName?: Maybe<Scalars['String']>;
  messageType: CapaConnectChatMessageType;
  userName?: Maybe<Scalars['String']>;
};

export type CapaConnectChatMessageInvited = {
  __typename?: 'CAPAConnectChatMessageInvited';
  messageType: CapaConnectChatMessageType;
  userName?: Maybe<Scalars['String']>;
};

export type CapaConnectChatMessageLeave = {
  __typename?: 'CAPAConnectChatMessageLeave';
  messageType: CapaConnectChatMessageType;
  userName?: Maybe<Scalars['String']>;
};

export type CapaConnectChatMessageMessage = {
  __typename?: 'CAPAConnectChatMessageMessage';
  fileCount?: Maybe<Scalars['Float']>;
  message?: Maybe<Scalars['String']>;
  messageType: CapaConnectChatMessageType;
};

export type CapaConnectChatMessageRemoved = {
  __typename?: 'CAPAConnectChatMessageRemoved';
  messageType: CapaConnectChatMessageType;
  userName?: Maybe<Scalars['String']>;
};

export enum CapaConnectChatMessageType {
  Annotation = 'ANNOTATION',
  FileShared = 'FILE_SHARED',
  Invite = 'INVITE',
  Leave = 'LEAVE',
  Message = 'MESSAGE',
  RemoveFromGroup = 'REMOVE_FROM_GROUP',
  System = 'SYSTEM',
  Tutorial = 'TUTORIAL'
}

export type CapaConnectChatMessageUnion = CapaConnectChatMessageAnnotation | CapaConnectChatMessageFileShared | CapaConnectChatMessageInvited | CapaConnectChatMessageLeave | CapaConnectChatMessageMessage | CapaConnectChatMessageRemoved | CapaConnectChatTutorialMessage;

export type CapaConnectChatMessagesOutput = {
  __typename?: 'CAPAConnectChatMessagesOutput';
  data?: Maybe<Array<CapaConnectChatMessage>>;
  /** errorMessage */
  errorMessage?: Maybe<Scalars['String']>;
  /** CAPA ERROR CODE */
  result: CapaErrorCode;
};

export type CapaConnectChatRoom = {
  __typename?: 'CAPAConnectChatRoom';
  chatMessages?: Maybe<Array<CapaConnectChatMessage>>;
  chatRoomId?: Maybe<Scalars['String']>;
  chatRoomStatus?: Maybe<CapaConnectChatRoomStatus>;
  /** 생성일 */
  createdAt?: Maybe<Scalars['String']>;
  /** 수정일 */
  updatedAt?: Maybe<Scalars['String']>;
};

/** 챗룸 상태 */
export enum CapaConnectChatRoomStatus {
  Closed = 'CLOSED',
  Opened = 'OPENED'
}

export type CapaConnectChatTutorialMessage = {
  __typename?: 'CAPAConnectChatTutorialMessage';
  fileCount?: Maybe<Scalars['Float']>;
  message?: Maybe<Scalars['String']>;
  messageType: CapaConnectChatMessageType;
  uiType?: Maybe<Scalars['String']>;
};

/** 캐파 커넥트 유저 정보 */
export type CapaConnectContactUser = {
  __typename?: 'CAPAConnectContactUser';
  /** capa user email */
  email: Scalars['String'];
  /** capa cloud user id */
  id: Scalars['ID'];
  /** isCapaUser */
  isCapaUser?: Maybe<Scalars['Boolean']>;
  /** memo */
  memo?: Maybe<Scalars['String']>;
  /** nick name */
  nickName?: Maybe<Scalars['String']>;
};

export type CapaConnectContactUsersOutput = {
  __typename?: 'CAPAConnectContactUsersOutput';
  data?: Maybe<Array<CapaConnectContactUser>>;
  /** errorMessage */
  errorMessage?: Maybe<Scalars['String']>;
  /** CAPA ERROR CODE */
  result: CapaErrorCode;
};

export type CapaConnectFeedback = {
  __typename?: 'CAPAConnectFeedback';
  connectUserId?: Maybe<Scalars['String']>;
  /** 생성일 */
  createdAt?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  feedback?: Maybe<Scalars['String']>;
  /** 피드백 관련 파일 */
  files?: Maybe<Array<CapaFile>>;
  /** 피드백 ID */
  id?: Maybe<Scalars['ID']>;
  /** 테스트 유무 */
  isTest: Scalars['Boolean'];
  rating?: Maybe<Scalars['Float']>;
  /** 수정일 */
  updatedAt?: Maybe<Scalars['String']>;
  userName?: Maybe<Scalars['String']>;
};

export type CapaConnectFeedbacksBoOutput = {
  __typename?: 'CAPAConnectFeedbacksBOOutput';
  data?: Maybe<Array<CapaConnectFeedback>>;
  /** errorMessage */
  errorMessage?: Maybe<Scalars['String']>;
  /** CAPA ERROR CODE */
  result: CapaErrorCode;
};

export type CapaConnectFileDetail = {
  __typename?: 'CAPAConnectFileDetail';
  /** 파일네임 */
  fileName: Scalars['String'];
  /** 파일패스 */
  filePath: Scalars['String'];
  filePermission?: Maybe<ConnectUserFileStatus>;
  groups?: Maybe<Array<CapaConnectGroup>>;
  /** 커넥트파일아이디 */
  id: Scalars['String'];
  /** isFile */
  isFile?: Maybe<Scalars['Boolean']>;
  linkStatus?: Maybe<ConnectUserFileLinkStatus>;
  /** original ext */
  originalFileExt?: Maybe<Scalars['String']>;
  /** thumbnail */
  thumbnail?: Maybe<Scalars['String']>;
};

export type CapaConnectFileDetailOutput = {
  __typename?: 'CAPAConnectFileDetailOutput';
  data?: Maybe<CapaConnectFileDetail>;
  /** errorMessage */
  errorMessage?: Maybe<Scalars['String']>;
  /** CAPA ERROR CODE */
  result: CapaErrorCode;
};

export type CapaConnectFilePermission = {
  __typename?: 'CAPAConnectFilePermission';
  accessLevel?: Maybe<Scalars['String']>;
  connectUserId?: Maybe<Scalars['String']>;
  email: Scalars['String'];
  fileId: Scalars['String'];
  fileName: Scalars['String'];
  groupUserId?: Maybe<Scalars['String']>;
  isCapaUser?: Maybe<Scalars['Boolean']>;
  permission?: Maybe<CapaQuotationRfqAllowOpenFileStatus>;
  userName?: Maybe<Scalars['String']>;
};

export type CapaConnectFilePermissionOutput = {
  __typename?: 'CAPAConnectFilePermissionOutput';
  data?: Maybe<Array<CapaConnectFilePermission>>;
  /** errorMessage */
  errorMessage?: Maybe<Scalars['String']>;
  /** CAPA ERROR CODE */
  result: CapaErrorCode;
};

/** 내드리이브 */
export type CapaConnectFolder = {
  __typename?: 'CAPAConnectFolder';
  /** 파일명 */
  folderName: Scalars['String'];
  /** 커넥트 파일 ID */
  id?: Maybe<Scalars['ID']>;
};

export type CapaConnectGroup = {
  __typename?: 'CAPAConnectGroup';
  /** 커넥트유저네임 */
  accessLevel: CapaConnectGroupAccessLevel;
  /** 파일명 */
  chatRoomId?: Maybe<Scalars['String']>;
  /** 생성일 (업로드 일시) */
  createdAt?: Maybe<Scalars['String']>;
  /** 그룹공유파일들 */
  files?: Maybe<Array<CapaConnectSharedFile>>;
  /** 파일명 */
  groupName?: Maybe<Scalars['String']>;
  /** 그룹 ID */
  id?: Maybe<Scalars['ID']>;
  message?: Maybe<CapaQuotationChatMessageUnion>;
  unReadCount?: Maybe<Scalars['Float']>;
  /** 수정일 */
  updatedAt?: Maybe<Scalars['String']>;
  /** 그룹멤버 */
  users?: Maybe<Array<CapaConnectGroupUser>>;
};

export enum CapaConnectGroupAccessLevel {
  Manager = 'MANAGER',
  Member = 'MEMBER',
  Owner = 'OWNER'
}

export type CapaConnectGroupBo = {
  __typename?: 'CAPAConnectGroupBO';
  /** 그룹 주석 */
  annotations?: Maybe<Array<CapaConnectAnnotationBo>>;
  chatRoomId?: Maybe<Scalars['String']>;
  /** 생성일 (업로드 일시) */
  createdAt?: Maybe<Scalars['String']>;
  /** 그룹공유파일들 */
  files?: Maybe<Array<CapaConnectGroupFileBo>>;
  /** 파일명 */
  groupName?: Maybe<Scalars['String']>;
  /** 그룹 ID */
  id?: Maybe<Scalars['ID']>;
  /** 테스트 그룹 유무 */
  isTest: Scalars['Boolean'];
  /** 마지막 채팅시간 */
  lastMessageAt?: Maybe<Scalars['String']>;
  /** 가입 구성원 수 */
  registeredUsers?: Maybe<Scalars['Float']>;
  /** 그룹 상태 */
  status?: Maybe<CapaConnectGroupStatus>;
  /** 채팅 개수 */
  totalChats?: Maybe<Scalars['Float']>;
  /** 수정일 */
  updatedAt?: Maybe<Scalars['String']>;
  /** 그룹멤버 */
  users?: Maybe<Array<CapaConnectGroupUserBo>>;
};

export type CapaConnectGroupBoOutput = {
  __typename?: 'CAPAConnectGroupBOOutput';
  data?: Maybe<CapaConnectGroupBo>;
  /** errorMessage */
  errorMessage?: Maybe<Scalars['String']>;
  /** CAPA ERROR CODE */
  result: CapaErrorCode;
};

export type CapaConnectGroupChatRoom = {
  __typename?: 'CAPAConnectGroupChatRoom';
  accessLevel?: Maybe<CapaConnectGroupAccessLevel>;
  /** 챗룸 아이디 */
  chatRoomId: Scalars['String'];
  /** 생성일 (업로드 일시) */
  createdAt?: Maybe<Scalars['String']>;
  /** 그룹 ID */
  groupId?: Maybe<Scalars['ID']>;
  /** 그룹 이름 */
  groupName: Scalars['String'];
  lastMessage?: Maybe<CapaConnectChatMessageUnion>;
  originalFileExt?: Maybe<Scalars['String']>;
  senderEmail?: Maybe<Scalars['String']>;
  senderName?: Maybe<Scalars['String']>;
  /** 썸네일 */
  thumbnail?: Maybe<Scalars['String']>;
  totalMembers?: Maybe<Scalars['Float']>;
  unReadCount?: Maybe<Scalars['Float']>;
  /** 수정일 */
  updatedAt?: Maybe<Scalars['String']>;
  /** 그룹멤버 */
  users?: Maybe<Array<CapaConnectGroupUser>>;
};

export type CapaConnectGroupChatRoomOutput = {
  __typename?: 'CAPAConnectGroupChatRoomOutput';
  data?: Maybe<CapaConnectGroupChatRoom>;
  /** errorMessage */
  errorMessage?: Maybe<Scalars['String']>;
  /** CAPA ERROR CODE */
  result: CapaErrorCode;
};

export type CapaConnectGroupChatRoomsOutput = {
  __typename?: 'CAPAConnectGroupChatRoomsOutput';
  data?: Maybe<Array<CapaConnectGroupChatRoom>>;
  /** errorMessage */
  errorMessage?: Maybe<Scalars['String']>;
  /** CAPA ERROR CODE */
  result: CapaErrorCode;
};

export type CapaConnectGroupFileBo = {
  __typename?: 'CAPAConnectGroupFileBO';
  /** 파일 주인 유저네임 */
  connectUserName?: Maybe<Scalars['String']>;
  /** 공유 시간 (업로드 일시) */
  createdAt?: Maybe<Scalars['String']>;
  /** 파일 주인 이메일 */
  email: Scalars['String'];
  fileExtension?: Maybe<Scalars['String']>;
  fileId?: Maybe<Scalars['String']>;
  /** 파일 주인 유저네임 */
  fileName?: Maybe<Scalars['String']>;
  /** 파일 용량 in bytes */
  fileSize?: Maybe<Scalars['Float']>;
  /** 커넥트파일아이디 */
  id: Scalars['String'];
  isFile?: Maybe<Scalars['Boolean']>;
  /** 수정일 */
  updatedAt?: Maybe<Scalars['String']>;
  /** 주인 user ID */
  userId?: Maybe<Scalars['ID']>;
};

export type CapaConnectGroupOutput = {
  __typename?: 'CAPAConnectGroupOutput';
  data?: Maybe<CapaConnectGroup>;
  /** errorMessage */
  errorMessage?: Maybe<Scalars['String']>;
  /** CAPA ERROR CODE */
  result: CapaErrorCode;
};

export enum CapaConnectGroupStatus {
  Deleted = 'DELETED',
  Registered = 'REGISTERED'
}

export type CapaConnectGroupUser = {
  __typename?: 'CAPAConnectGroupUser';
  /** 커넥트유저네임 */
  accessLevel: CapaConnectGroupAccessLevel;
  /** 커넥트유저네임 */
  connectUserName?: Maybe<Scalars['String']>;
  /** 생성일 (업로드 일시) */
  createdAt?: Maybe<Scalars['String']>;
  /** 이메일 */
  email: Scalars['String'];
  /** 그룹 ID */
  groupId?: Maybe<Scalars['ID']>;
  /** 그룹 유저 ID */
  id?: Maybe<Scalars['ID']>;
  /** 캐파유저냐 */
  isCapaUser?: Maybe<Scalars['Boolean']>;
  /** 수정일 */
  updatedAt?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['ID']>;
};

export enum CapaConnectGroupUserAction {
  Remove = 'REMOVE',
  Update = 'UPDATE'
}

export type CapaConnectGroupUserBo = {
  __typename?: 'CAPAConnectGroupUserBO';
  /** 커넥트 그룹 권한 */
  accessLevel: CapaConnectGroupAccessLevel;
  /** 커넥트유저네임 */
  connectUserName?: Maybe<Scalars['String']>;
  /** 생성일 (그룹 초대 시점) */
  createdAt?: Maybe<Scalars['String']>;
  /** 이메일 */
  email: Scalars['String'];
  /** 그룹 ID */
  groupId?: Maybe<Scalars['ID']>;
  /** 그룹 유저 ID */
  id?: Maybe<Scalars['ID']>;
  /** 캐파유저냐 */
  isCapaUser?: Maybe<Scalars['Boolean']>;
  /** 테스트 계정 유무 */
  isTest: Scalars['Boolean'];
  /** 커넥트유저상태 */
  status?: Maybe<CapaConnectUserStatus>;
  /** 수정일 */
  updatedAt?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['ID']>;
};

export type CapaConnectGroupsBoOutput = {
  __typename?: 'CAPAConnectGroupsBOOutput';
  data?: Maybe<Array<CapaConnectGroupBo>>;
  /** errorMessage */
  errorMessage?: Maybe<Scalars['String']>;
  /** CAPA ERROR CODE */
  result: CapaErrorCode;
};

export type CapaConnectGroupsOutput = {
  __typename?: 'CAPAConnectGroupsOutput';
  data?: Maybe<Array<CapaConnectGroup>>;
  /** errorMessage */
  errorMessage?: Maybe<Scalars['String']>;
  /** CAPA ERROR CODE */
  result: CapaErrorCode;
};

export type CapaConnectIssue = {
  __typename?: 'CAPAConnectIssue';
  connectUserId?: Maybe<Scalars['String']>;
  /** 생성일 */
  createdAt?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  /** 이슈 관련 파일 */
  files?: Maybe<Array<CapaFile>>;
  /** 이슈 ID */
  id?: Maybe<Scalars['ID']>;
  /** 테스트 유무 */
  isTest: Scalars['Boolean'];
  issue?: Maybe<Scalars['String']>;
  /** 수정일 */
  updatedAt?: Maybe<Scalars['String']>;
  userName?: Maybe<Scalars['String']>;
};

export type CapaConnectIssuesBoOutput = {
  __typename?: 'CAPAConnectIssuesBOOutput';
  data?: Maybe<Array<CapaConnectIssue>>;
  /** errorMessage */
  errorMessage?: Maybe<Scalars['String']>;
  /** CAPA ERROR CODE */
  result: CapaErrorCode;
};

export type CapaConnectMyDrive = {
  __typename?: 'CAPAConnectMyDrive';
  files?: Maybe<Array<CapaConnectMyFile>>;
  path?: Maybe<Array<CapaConnectFolder>>;
};

/** 내드리이브 */
export type CapaConnectMyDrivesOutput = {
  __typename?: 'CAPAConnectMyDrivesOutput';
  data?: Maybe<CapaConnectMyDrive>;
  /** errorMessage */
  errorMessage?: Maybe<Scalars['String']>;
  /** CAPA ERROR CODE */
  result: CapaErrorCode;
};

/** 내파일들 */
export type CapaConnectMyFile = {
  __typename?: 'CAPAConnectMyFile';
  /** 생성일 (업로드 일시) */
  createdAt?: Maybe<Scalars['String']>;
  /** 도면 파일 뷰어 URL */
  drawingFile?: Maybe<Scalars['String']>;
  /** 파일확장자 */
  fileExtension?: Maybe<Scalars['String']>;
  /** 실제 파일 ID */
  fileId?: Maybe<Scalars['String']>;
  /** 파일명 */
  fileName: Scalars['String'];
  /** file owner email */
  fileOwnerEmail?: Maybe<Scalars['String']>;
  /** file owner username */
  fileOwnerUsername?: Maybe<Scalars['String']>;
  /** 파일경로 */
  filePath: Scalars['String'];
  filePermission?: Maybe<ConnectUserFileStatus>;
  /** 파일크기 byte */
  fileSize?: Maybe<Scalars['Float']>;
  /** 커넥트 파일 ID */
  id?: Maybe<Scalars['ID']>;
  /** 파일이냐 아니냐 */
  isFile: Scalars['Boolean'];
  /** 공유이냐 아니냐 */
  isShared: Scalars['Boolean'];
  linkStatus?: Maybe<ConnectUserFileLinkStatus>;
  /** original ext */
  originalFileExt?: Maybe<Scalars['String']>;
  /** 파일 변환 상태 */
  status?: Maybe<CapaFileConvertStatus>;
  /** 썸네일 */
  thumbnail?: Maybe<Scalars['String']>;
  /** 썸네일 */
  thumbnailUri?: Maybe<Scalars['String']>;
  /** 수정일 */
  updatedAt?: Maybe<Scalars['String']>;
};

export type CapaConnectOnlineUser = {
  __typename?: 'CAPAConnectOnlineUser';
  email?: Maybe<Scalars['String']>;
};

export type CapaConnectOnlineUsersOutput = {
  __typename?: 'CAPAConnectOnlineUsersOutput';
  data?: Maybe<Array<CapaConnectOnlineUser>>;
  /** errorMessage */
  errorMessage?: Maybe<Scalars['String']>;
  /** CAPA ERROR CODE */
  result: CapaErrorCode;
};

/** 캐파 커넥트 유저 정보 */
export type CapaConnectSearchUser = {
  __typename?: 'CAPAConnectSearchUser';
  /** capa cloud user id */
  connectUserId?: Maybe<Scalars['String']>;
  /** capa user email */
  email: Scalars['String'];
  /** capa cloud user id */
  userId?: Maybe<Scalars['String']>;
  /** name */
  userName?: Maybe<Scalars['String']>;
};

export type CapaConnectSearchUsersOutput = {
  __typename?: 'CAPAConnectSearchUsersOutput';
  data?: Maybe<Array<CapaConnectSearchUser>>;
  /** errorMessage */
  errorMessage?: Maybe<Scalars['String']>;
  /** CAPA ERROR CODE */
  result: CapaErrorCode;
};

export type CapaConnectSharedFile = {
  __typename?: 'CAPAConnectSharedFile';
  /** 커넥트유저네임 */
  connectUserName?: Maybe<Scalars['String']>;
  /** 생성일 (업로드 일시) */
  createdAt?: Maybe<Scalars['String']>;
  /** 도면 파일 뷰어 URL */
  drawingFile?: Maybe<Scalars['String']>;
  /** 이메일 */
  email: Scalars['String'];
  /** 파일확장자 */
  fileExtension?: Maybe<Scalars['String']>;
  /** 실제 파일 ID */
  fileId?: Maybe<Scalars['String']>;
  /** 파일명 */
  fileName: Scalars['String'];
  /** file owner email */
  fileOwnerEmail?: Maybe<Scalars['String']>;
  /** file owner username */
  fileOwnerUsername?: Maybe<Scalars['String']>;
  /** 파일경로 */
  filePath: Scalars['String'];
  filePermission?: Maybe<ConnectUserFileStatus>;
  /** 파일크기 byte */
  fileSize?: Maybe<Scalars['Float']>;
  /** 그룹 ID */
  groupId?: Maybe<Scalars['ID']>;
  hasCommentThread?: Maybe<ConnectSharedFileCommentThread>;
  /** 커넥트 파일 ID */
  id?: Maybe<Scalars['ID']>;
  /** 파일이냐 아니냐 */
  isFile: Scalars['Boolean'];
  isFirstShared?: Maybe<Scalars['Boolean']>;
  /** 공유이냐 아니냐 */
  isShared: Scalars['Boolean'];
  linkStatus?: Maybe<ConnectUserFileLinkStatus>;
  /** original ext */
  originalFileExt?: Maybe<Scalars['String']>;
  permission?: Maybe<CapaQuotationRfqAllowOpenFileStatus>;
  /** 파일 변환 상태 */
  status?: Maybe<CapaFileConvertStatus>;
  /** 썸네일 */
  thumbnail?: Maybe<Scalars['String']>;
  /** 썸네일 */
  thumbnailUri?: Maybe<Scalars['String']>;
  /** 수정일 */
  updatedAt?: Maybe<Scalars['String']>;
};

export enum CapaConnectSharedFileType {
  All = 'ALL',
  Cad = 'CAD',
  Document = 'DOCUMENT',
  Other = 'OTHER',
  Photo = 'PHOTO',
  Video = 'VIDEO'
}

export type CapaConnectSharedFilesOutput = {
  __typename?: 'CAPAConnectSharedFilesOutput';
  data?: Maybe<Array<CapaConnectSharedFile>>;
  /** errorMessage */
  errorMessage?: Maybe<Scalars['String']>;
  /** CAPA ERROR CODE */
  result: CapaErrorCode;
};

export type CapaConnectTutorial = {
  __typename?: 'CAPAConnectTutorial';
  fileId: Scalars['String'];
  message: Scalars['String'];
};

export type CapaConnectUpdate = {
  __typename?: 'CAPAConnectUpdate';
  anchorPos?: Maybe<Capa3DPos>;
  annotationId?: Maybe<Scalars['String']>;
  authorEmail?: Maybe<Scalars['String']>;
  authorId?: Maybe<Scalars['String']>;
  authorName?: Maybe<Scalars['String']>;
  comment?: Maybe<Scalars['String']>;
  commentId?: Maybe<Scalars['String']>;
  edited?: Maybe<Scalars['Boolean']>;
  email?: Maybe<Scalars['String']>;
  groupId?: Maybe<Scalars['String']>;
  handlePos?: Maybe<Capa3DPos>;
  modelId?: Maybe<Scalars['String']>;
  nodeId?: Maybe<Scalars['Float']>;
  timestamp?: Maybe<Scalars['String']>;
  /** 업데이트 타입 */
  type?: Maybe<CapaConnectUpdateType>;
  username?: Maybe<Scalars['String']>;
};

export type CapaConnectUpdateOutput = {
  __typename?: 'CAPAConnectUpdateOutput';
  data?: Maybe<CapaConnectUpdate>;
  /** errorMessage */
  errorMessage?: Maybe<Scalars['String']>;
  /** CAPA ERROR CODE */
  result: CapaErrorCode;
};

export enum CapaConnectUpdateType {
  AnnotationAdd = 'ANNOTATION_ADD',
  AnnotationCommentAdd = 'ANNOTATION_COMMENT_ADD',
  AnnotationCommentDelete = 'ANNOTATION_COMMENT_DELETE',
  AnnotationCommentUpdate = 'ANNOTATION_COMMENT_UPDATE',
  AnnotationDelete = 'ANNOTATION_DELETE',
  AnnotationOpen = 'ANNOTATION_OPEN',
  AnnotationUpdate = 'ANNOTATION_UPDATE',
  ChatUpdate = 'CHAT_UPDATE',
  FileUpdate = 'FILE_UPDATE',
  GroupUpdate = 'GROUP_UPDATE',
  MemberUpdate = 'MEMBER_UPDATE'
}

/** 캐파 커넥트 유저 정보 */
export type CapaConnectUser = {
  __typename?: 'CAPAConnectUser';
  /** 사용가능한 드라이브 용량 (단위: byte) */
  availSize: Scalars['Float'];
  chatRoomUserId?: Maybe<Scalars['String']>;
  /** 전체 드라이브 용량 (단위: byte) */
  driveSize: Scalars['Float'];
  /** capa user email */
  email: Scalars['String'];
  /** capa cloud user id */
  id: Scalars['ID'];
  notificationFilter: CapaConnectUserNotificationFilter;
  /** [필수] 개인정보 수집 및 활용 동의 */
  privacyAgreed?: Maybe<Scalars['Boolean']>;
  /** [선택] 프로모션 정보 수신 동의 */
  promotionAgreed?: Maybe<Scalars['Boolean']>;
  /** [필수] 캐파 서비스 이용약관 동의 */
  serviceAgreed?: Maybe<Scalars['Boolean']>;
  /** 사용중인 드라이브 용량 (단위: byte) */
  usedSize: Scalars['Float'];
  /** userId */
  userId?: Maybe<Scalars['String']>;
  /** name */
  userName?: Maybe<Scalars['String']>;
};

/** 캐파 BO 커넥트 유저 정보 */
export type CapaConnectUserBo = {
  __typename?: 'CAPAConnectUserBO';
  /** 커넥트 유저 생성일 */
  createdAt: Scalars['String'];
  /** 전체 드라이브 용량 (단위: byte) */
  driveSize: Scalars['Float'];
  /** capa connect user email */
  email: Scalars['String'];
  files?: Maybe<Array<CapaConnectMyFile>>;
  /** 커넥트 그룹 */
  groups?: Maybe<Array<CapaConnectUserGroupBo>>;
  /** capa backoffice connect user id */
  id: Scalars['ID'];
  /** 테스트 계정 유무 */
  isTest: Scalars['Boolean'];
  /** 커넥트 유저 마지막 로그인 */
  lastLoginAt?: Maybe<Scalars['String']>;
  /** 가입 경로 */
  route?: Maybe<Array<CapaInflowRoute>>;
  /** 상태 CAPAConnectUserStatus */
  status: CapaConnectUserStatus;
  /** 커넥트 업로드 파일 개수 */
  totalFiles?: Maybe<Scalars['Float']>;
  /** 커넥트 그룹 개수 */
  totalGroups?: Maybe<Scalars['Float']>;
  /** 커넥트 참여 그룹 개수 */
  totalMemberGroups?: Maybe<Scalars['Float']>;
  /** 커넥트 생성한 그룹 개수 */
  totalOwnerGroups?: Maybe<Scalars['Float']>;
  /** 커넥트 공유한 파일 개수 */
  totalSharedFiles?: Maybe<Scalars['Float']>;
  /** 사용중인 드라이브 용량 (단위: byte) */
  usedSize: Scalars['Float'];
  /** capa backoffice user id */
  userId: Scalars['ID'];
  /** capa connect user name */
  userName?: Maybe<Scalars['String']>;
};

export type CapaConnectUserBoOutput = {
  __typename?: 'CAPAConnectUserBOOutput';
  data?: Maybe<CapaConnectUserBo>;
  /** errorMessage */
  errorMessage?: Maybe<Scalars['String']>;
  /** CAPA ERROR CODE */
  result: CapaErrorCode;
};

export type CapaConnectUserFile = {
  __typename?: 'CAPAConnectUserFile';
  filePermission?: Maybe<ConnectUserFileStatus>;
  id?: Maybe<Scalars['ID']>;
  linkStatus?: Maybe<ConnectUserFileLinkStatus>;
};

/** 내파일들 */
export type CapaConnectUserFileBo = {
  __typename?: 'CAPAConnectUserFileBO';
  /** 생성일 (업로드 일시) */
  createdAt?: Maybe<Scalars['String']>;
  /** 파일확장자 */
  fileExtension?: Maybe<Scalars['String']>;
  /** 실제 파일 ID */
  fileId?: Maybe<Scalars['String']>;
  /** 파일명 */
  fileName: Scalars['String'];
  /** file owner email */
  fileOwnerEmail?: Maybe<Scalars['String']>;
  /** file owner username */
  fileOwnerUsername?: Maybe<Scalars['String']>;
  filePermission?: Maybe<ConnectUserFileStatus>;
  /** 파일크기 byte */
  fileSize?: Maybe<Scalars['Float']>;
  /** 커넥트 파일 ID */
  id?: Maybe<Scalars['ID']>;
  /** 파일이냐 아니냐 */
  isFile: Scalars['Boolean'];
  /** Test 계정 유무 */
  isTest: Scalars['Boolean'];
  linkStatus?: Maybe<ConnectUserFileLinkStatus>;
  /** 파일 변환 상태 */
  status?: Maybe<CapaFileConvertStatus>;
  /** 수정일 */
  updatedAt?: Maybe<Scalars['String']>;
  /** 방문자 수 */
  visitorsCount?: Maybe<Scalars['Float']>;
};

export type CapaConnectUserFileLinksBo = {
  __typename?: 'CAPAConnectUserFileLinksBO';
  activeFilesCount?: Maybe<Scalars['Float']>;
  files?: Maybe<Array<CapaConnectUserFileBo>>;
  totalCount?: Maybe<Scalars['Float']>;
};

export type CapaConnectUserFileOutput = {
  __typename?: 'CAPAConnectUserFileOutput';
  data?: Maybe<CapaConnectUserFile>;
  /** errorMessage */
  errorMessage?: Maybe<Scalars['String']>;
  /** CAPA ERROR CODE */
  result: CapaErrorCode;
};

export type CapaConnectUserGroupBo = {
  __typename?: 'CAPAConnectUserGroupBO';
  /** 커넥트유저네임 */
  accessLevel: CapaConnectGroupAccessLevel;
  createdAt?: Maybe<Scalars['String']>;
  groupName?: Maybe<Scalars['String']>;
  /** capa backoffice connect group id */
  id: Scalars['ID'];
  status?: Maybe<Scalars['String']>;
  /** 주석 댓글 개수 */
  totalGroupAnnotationComments?: Maybe<Scalars['Float']>;
  /** 주석 개수 */
  totalGroupAnnotations?: Maybe<Scalars['Float']>;
};

/** notification filter */
export type CapaConnectUserNotificationFilter = {
  __typename?: 'CAPAConnectUserNotificationFilter';
  chatPush?: Maybe<Scalars['Boolean']>;
  commentThreadEmail?: Maybe<Scalars['Boolean']>;
  commentThreadPush?: Maybe<Scalars['Boolean']>;
  fileEmail?: Maybe<Scalars['Boolean']>;
  filePush?: Maybe<Scalars['Boolean']>;
  groupEmail?: Maybe<Scalars['Boolean']>;
  groupPush?: Maybe<Scalars['Boolean']>;
};

export type CapaConnectUserOutput = {
  __typename?: 'CAPAConnectUserOutput';
  data?: Maybe<CapaConnectUser>;
  /** errorMessage */
  errorMessage?: Maybe<Scalars['String']>;
  /** CAPA ERROR CODE */
  result: CapaErrorCode;
};

export enum CapaConnectUserStatus {
  /** 탈퇴 */
  Deleted = 'DELETED',
  /** 가입 */
  Registered = 'REGISTERED'
}

export type CapaConnectUsersBoOutput = {
  __typename?: 'CAPAConnectUsersBOOutput';
  data?: Maybe<Array<CapaConnectUserBo>>;
  /** errorMessage */
  errorMessage?: Maybe<Scalars['String']>;
  /** CAPA ERROR CODE */
  result: CapaErrorCode;
};

/** 캐파 RFQ 상담 시작 방식 */
export enum CapaConsultingStartMethod {
  /** old rfq - 견적서 없이 상담 가능 */
  OldConsulting = 'OLD_CONSULTING',
  /** 견적서 없이 회사소개서만으로도 상담 가능 */
  PartnerIntroductionAvailable = 'PARTNER_INTRODUCTION_AVAILABLE',
  /** 견적서 있어야만 상담 가능 */
  QuotationRequired = 'QUOTATION_REQUIRED'
}

export type CapaDataCount = {
  __typename?: 'CAPADataCount';
  count: Scalars['Float'];
};

export type CapaDesignDetail = {
  __typename?: 'CAPADesignDetail';
  /** 요청 작업 */
  services?: Maybe<Array<CapaDesignService>>;
};

export type CapaDesignService = {
  __typename?: 'CAPADesignService';
  serviceType?: Maybe<CapaDesignServiceType>;
};

/** design service type */
export enum CapaDesignServiceType {
  /** 제품 디자인 */
  MechanicalDesign = 'MECHANICAL_DESIGN',
  /** 기구 설계  */
  ProductDesign = 'PRODUCT_DESIGN'
}

/** 방해금지 기간 설정 */
export type CapaDoNotDisturbFilter = {
  __typename?: 'CAPADoNotDisturbFilter';
  /** 시작 시간 */
  from?: Maybe<Scalars['Float']>;
  isActive?: Maybe<Scalars['Boolean']>;
  /** 끝나는 시간 */
  to?: Maybe<Scalars['Float']>;
};

/** 방해금지 기간 설정 */
export type CapaDoNotDisturbFilterInput = {
  /** 시작 시간 */
  from?: InputMaybe<Scalars['Float']>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  /** 끝나는 시간 */
  to?: InputMaybe<Scalars['Float']>;
};

/** 에러코드 */
export enum CapaErrorCode {
  /** 광고 정보를 찾지 못함 */
  AdvertisementNotFound = 'ADVERTISEMENT_NOT_FOUND',
  /** 광고 정보를 찾지 못함 */
  AdvertisingNotFound = 'ADVERTISING_NOT_FOUND',
  /** ALREADY_APPROVED */
  AlreadyApproved = 'ALREADY_APPROVED',
  AlreadyEvaluated = 'ALREADY_EVALUATED',
  /** 이미 구매확정을 연기했습니다.  */
  AlreadyExtendedConfirmPurchase = 'ALREADY_EXTENDED_CONFIRM_PURCHASE',
  AlreadyHaveFileInDrive = 'ALREADY_HAVE_FILE_IN_DRIVE',
  AlreadyRated = 'ALREADY_RATED',
  /** 이미 환불되었습니다. */
  AlreadyRefunded = 'ALREADY_REFUNDED',
  AlreadyReplied = 'ALREADY_REPLIED',
  /** 거래리뷰 요청을 이미 전송했습니다. */
  AlreadyRequestRegisterTransactionReview = 'ALREADY_REQUEST_REGISTER_TRANSACTION_REVIEW',
  /** 이미 소개서를 보냈습니다 */
  AlreadySendIntroduction = 'ALREADY_SEND_INTRODUCTION',
  /** 이미 등록된 서브몰이 있습니다. */
  AlreadySubmallExists = 'ALREADY_SUBMALL_EXISTS',
  /** 이미 구독중입니다. */
  AlreadySubscribed = 'ALREADY_SUBSCRIBED',
  /** 이미 탈퇴한 BO 회원입니다. */
  AlreadyWithdrawnBoUser = 'ALREADY_WITHDRAWN_BO_USER',
  /** 동일 정보의 엠베서더가 이미 존재합니다. */
  AmbassadorAlreadyExists = 'AMBASSADOR_ALREADY_EXISTS',
  /** 엠베서더를 찾을 수 없습니다. */
  AmbassadorNotFound = 'AMBASSADOR_NOT_FOUND',
  /** BACKOFFICE_NOT_FOUND */
  BackofficeNotFound = 'BACKOFFICE_NOT_FOUND',
  /** 잘못된 요청입니다. */
  BadRequest = 'BAD_REQUEST',
  /** 아직 결제되지 않았습니다. */
  BeforePayment = 'BEFORE_PAYMENT',
  /** BO 유저를 찾을 수 없습니다. */
  BoUserNotFound = 'BO_USER_NOT_FOUND',
  /** 바이패스 관련 고객 불만 정보가 존재하지 않습니다. */
  BypassComplaintNotExists = 'BYPASS_COMPLAINT_NOT_EXISTS',
  /** cancel payment가 존재하지 않습니다 */
  CancelPaymentNotFound = 'CANCEL_PAYMENT_NOT_FOUND',
  /** CANNOT_ADD_THEMSELF_TO_CONTACT_LIST */
  CannotAddThemselfToContactList = 'CANNOT_ADD_THEMSELF_TO_CONTACT_LIST',
  /** CANNOT_CHANGE_RFQ_FILE_OPEN_STATUS */
  CannotChangeRfqFileOpenStatus = 'CANNOT_CHANGE_RFQ_FILE_OPEN_STATUS',
  /** CANNOT_CREATE_CHATROOM */
  CannotCreateChatroom = 'CANNOT_CREATE_CHATROOM',
  /** CANNOT_INVITE_CAPA_OFFICIAL */
  CannotInviteCapaOfficial = 'CANNOT_INVITE_CAPA_OFFICIAL',
  CannotInviteSelf = 'CANNOT_INVITE_SELF',
  /** 환불 요청이 불가능합니다. */
  CannotRequestRefund = 'CANNOT_REQUEST_REFUND',
  /** 제조 시작이 불가능합니다. */
  CannotStartProcessing = 'CANNOT_START_PROCESSING',
  CellPhoneCodeMismatch = 'CELL_PHONE_CODE_MISMATCH',
  ChatroomAlreadyOpened = 'CHATROOM_ALREADY_OPENED',
  /** CHATROOM_EXISTS */
  ChatroomExists = 'CHATROOM_EXISTS',
  /** CHATROOM_NOT_FOUND */
  ChatroomNotFound = 'CHATROOM_NOT_FOUND',
  /** CHATROOM_NOT_OPENED */
  ChatroomNotOpened = 'CHATROOM_NOT_OPENED',
  /** 채팅 유저가 존재하지 않습니다. */
  ChatUserNotFound = 'CHAT_USER_NOT_FOUND',
  ClossingBusiness = 'CLOSSING_BUSINESS',
  /** 클라우드 사용자가 이미 존재 합니다. */
  CloudUserExists = 'CLOUD_USER_EXISTS',
  /** 클라우드 사용자를 찾을 수 없습니다. */
  CloudUserNotFound = 'CLOUD_USER_NOT_FOUND',
  /** 검증 코드가 일치하지 않습니다. */
  CodeMismatch = 'CODE_MISMATCH',
  /** 사업자등록번호가 일치하지 않습니다. */
  CompanyRegistrationNumberMismatch = 'COMPANY_REGISTRATION_NUMBER_MISMATCH',
  ConnectContactUserAlreadyExists = 'CONNECT_CONTACT_USER_ALREADY_EXISTS',
  /** CONNECT_FILE_CAN_NOT_BE_DOWNLOADED */
  ConnectFileCanNotBeDownloaded = 'CONNECT_FILE_CAN_NOT_BE_DOWNLOADED',
  /** 커넥트 사용자가 이미 존재 합니다. */
  ConnectUserExists = 'CONNECT_USER_EXISTS',
  /** 커넥트 사용자를 찾을 수 없습니다. */
  ConnectUserNotFound = 'CONNECT_USER_NOT_FOUND',
  ConnectUserNotInGroup = 'CONNECT_USER_NOT_IN_GROUP',
  /** 상담리뷰가 이미 존재합니다. */
  ConsultingReviewAlreadyExists = 'CONSULTING_REVIEW_ALREADY_EXISTS',
  /** 상담리뷰가 존재하지 않습니다. */
  ConsultingReviewNotFound = 'CONSULTING_REVIEW_NOT_FOUND',
  /** 상담리뷰 작성할 수 있는 시간을 초과하였습니다. */
  ConsultingReviewTimeExceed = 'CONSULTING_REVIEW_TIME_EXCEED',
  /** 현재 서버 배포중 입니다. */
  DeployingServer = 'DEPLOYING_SERVER',
  DestinationIsFile = 'DESTINATION_IS_FILE',
  DestinationNotFound = 'DESTINATION_NOT_FOUND',
  /** 거래 금액이 일치하지 않습니다. */
  DismatchPaymentAmount = 'DISMATCH_PAYMENT_AMOUNT',
  /** PG사 정보와 CAPA DB가 매칭이 되지 않습니다. */
  DismatchPaymentInfo = 'DISMATCH_PAYMENT_INFO',
  /** 중복된 사업자 등록 번호 입니다. */
  DuplicateCompanyRegistrationNo = 'DUPLICATE_COMPANY_REGISTRATION_NO',
  DuplicateDesignRfq = 'DUPLICATE_DESIGN_RFQ',
  /** 중복된 이메일 입니다. */
  DuplicateEmail = 'DUPLICATE_EMAIL',
  DuplicateGroupName = 'DUPLICATE_GROUP_NAME',
  /** 이미 존재하는 PCB 요청서입니다. */
  DuplicatePcbRfq = 'DUPLICATE_PCB_RFQ',
  /** DUPLICATE_RFQ_ID */
  DuplicateRfqId = 'DUPLICATE_RFQ_ID',
  EmailCodeMismatch = 'EMAIL_CODE_MISMATCH',
  /** 에러 */
  Error = 'ERROR',
  EscrowError = 'ESCROW_ERROR',
  EscrowShippingError = 'ESCROW_SHIPPING_ERROR',
  EscrowTokenError = 'ESCROW_TOKEN_ERROR',
  FetchAnnotationNotFound = 'FETCH_ANNOTATION_NOT_FOUND',
  /** FETCH_MESSAGES_FAILED */
  FetchMessagesFailed = 'FETCH_MESSAGES_FAILED',
  /** 도면 파일 변환에 실패 하였습니다. */
  FileConversionFailed = 'FILE_CONVERSION_FAILED',
  FileExists = 'FILE_EXISTS',
  /** 파일을 찾을 수 없습니다. */
  FileNotFound = 'FILE_NOT_FOUND',
  /** FILE_OWNER_NOT_FOUND */
  FileOwnerNotFound = 'FILE_OWNER_NOT_FOUND',
  /** can't configure firebase admin */
  FirebaseConfigurationError = 'FIREBASE_CONFIGURATION_ERROR',
  GroupAlreadyExists = 'GROUP_ALREADY_EXISTS',
  GroupNotExists = 'GROUP_NOT_EXISTS',
  /** GROUP_USER_ALREADY_EXISTS */
  GroupUserAlreadyExists = 'GROUP_USER_ALREADY_EXISTS',
  /** 허브스팟 사용자가 이미 존재합니다. */
  HubspotUserExists = 'HUBSPOT_USER_EXISTS',
  IamportGetPaymentDataError = 'IAMPORT_GET_PAYMENT_DATA_ERROR',
  IamportGetTokenError = 'IAMPORT_GET_TOKEN_ERROR',
  /** ICX (industrial complex) 정보가 없습니다. */
  IcxNotExist = 'ICX_NOT_EXIST',
  /** 유효하지 않은 사업자 등록 번호 입니다. */
  InavlidCompanyRegistrationNo = 'INAVLID_COMPANY_REGISTRATION_NO',
  InvalidAccessLevel = 'INVALID_ACCESS_LEVEL',
  /** 유효하지 않은 엠베서더 ID 입니다. */
  InvalidAmbassadorId = 'INVALID_AMBASSADOR_ID',
  InvalidAnnotation = 'INVALID_ANNOTATION',
  /** 잘 못된 은행 코드입니다 */
  InvalidBankCode = 'INVALID_BANK_CODE',
  InvalidComment = 'INVALID_COMMENT',
  InvalidDestination = 'INVALID_DESTINATION',
  InvalidFileOwner = 'INVALID_FILE_OWNER',
  InvalidGroupUser = 'INVALID_GROUP_USER',
  /** INVALID_NOTIFICATION_SEQ */
  InvalidNotificationSeq = 'INVALID_NOTIFICATION_SEQ',
  InvalidPath = 'INVALID_PATH',
  /** 잘못된 결제 상태 */
  InvalidPaymentStatus = 'INVALID_PAYMENT_STATUS',
  /** 잘 못된 pg 코드입니다 */
  InvalidPgProvider = 'INVALID_PG_PROVIDER',
  /** 유효하지 않은 추천인 ID 입니다. */
  InvalidReferralId = 'INVALID_REFERRAL_ID',
  /** INVALID_RFQ_STATUS */
  InvalidRfqStatus = 'INVALID_RFQ_STATUS',
  /** puchase order 상태 값으로 변경이 불가능 합니다 */
  InvalidStatusToUpdatePurchaseOrder = 'INVALID_STATUS_TO_UPDATE_PURCHASE_ORDER',
  /** 유효하지 않은 토큰 입니다. */
  InvalidToken = 'INVALID_TOKEN',
  InActiveServiceIncluded = 'IN_ACTIVE_SERVICE_INCLUDED',
  IsExistCompanyRegistration = 'IS_EXIST_COMPANY_REGISTRATION',
  IsExistSignature = 'IS_EXIST_SIGNATURE',
  IsNotExistCompanyInfo = 'IS_NOT_EXIST_COMPANY_INFO',
  IsNotExistPurchaseOrder = 'IS_NOT_EXIST_PURCHASE_ORDER',
  IsNotExistRfqQuotation = 'IS_NOT_EXIST_RFQ_QUOTATION',
  /** ITP_EVENT_EXIST */
  ItpEventExist = 'ITP_EVENT_EXIST',
  /** ITP_EVENT_NOT_FOUND */
  ItpEventNotFound = 'ITP_EVENT_NOT_FOUND',
  JsbEventExist = 'JSB_EVENT_EXIST',
  JsbEventNotFound = 'JSB_EVENT_NOT_FOUND',
  /** MAKE_PDF_ERROR */
  MakePdfError = 'MAKE_PDF_ERROR',
  MigrationAlreadyCompleted = 'MIGRATION_ALREADY_COMPLETED',
  /** 한개 이상의 파라미터 값이 필요합니다. */
  MoreThanOneParameterValueRequired = 'MORE_THAN_ONE_PARAMETER_VALUE_REQUIRED',
  NiceDnbAccssTokenError = 'NICE_DNB_ACCSS_TOKEN_ERROR',
  NiceDnbCompanyOverViewError = 'NICE_DNB_COMPANY_OVER_VIEW_ERROR',
  NiceDnbIsClosedBusinessError = 'NICE_DNB_IS_CLOSED_BUSINESS_ERROR',
  /** 동의가 필요합니다. */
  NotAgreed = 'NOT_AGREED',
  /** 권한이 없습니다. */
  NotAllowedUser = 'NOT_ALLOWED_USER',
  NotAllServiceTypesIncluded = 'NOT_ALL_SERVICE_TYPES_INCLUDED',
  NotCloseAllChatRooms = 'NOT_CLOSE_ALL_CHAT_ROOMS',
  NotCompleteRfqTransaction = 'NOT_COMPLETE_RFQ_TRANSACTION',
  NotConfirmRfqPurchaseOrderWithItem = 'NOT_CONFIRM_RFQ_PURCHASE_ORDER_WITH_ITEM',
  NotConfirmRfqQuotation = 'NOT_CONFIRM_RFQ_QUOTATION',
  NotConfirmRfqTransaction = 'NOT_CONFIRM_RFQ_TRANSACTION',
  NotCreateDetailedQuotation = 'NOT_CREATE_DETAILED_QUOTATION',
  NotCreatePurchaseOrder = 'NOT_CREATE_PURCHASE_ORDER',
  NotCreatePurchaseOrderWithItem = 'NOT_CREATE_PURCHASE_ORDER_WITH_ITEM',
  NotCreateQuotationChatRoom = 'NOT_CREATE_QUOTATION_CHAT_ROOM',
  NotCreateSimpleQuotation = 'NOT_CREATE_SIMPLE_QUOTATION',
  /** 클라우드 용량이 부족합니다. */
  NotEnoughCloudStorage = 'NOT_ENOUGH_CLOUD_STORAGE',
  /** 커넥트 용량이 부족합니다. */
  NotEnoughConnectStorage = 'NOT_ENOUGH_CONNECT_STORAGE',
  NotEvaluateRfqPartners = 'NOT_EVALUATE_RFQ_PARTNERS',
  NotExistImagePortfolio = 'NOT_EXIST_IMAGE_PORTFOLIO',
  NotExistPdfFile = 'NOT_EXIST_PDF_FILE',
  NotExistQuotationServiceType = 'NOT_EXIST_QUOTATION_SERVICE_TYPE',
  NotExpireRfq = 'NOT_EXPIRE_RFQ',
  NotFetchQuotationChatRoom = 'NOT_FETCH_QUOTATION_CHAT_ROOM',
  NotFetchQuotationServiceRating = 'NOT_FETCH_QUOTATION_SERVICE_RATING',
  NotFoundAnnotation = 'NOT_FOUND_ANNOTATION',
  NotFoundAnnotationComment = 'NOT_FOUND_ANNOTATION_COMMENT',
  NotFoundAnnotationParentComment = 'NOT_FOUND_ANNOTATION_PARENT_COMMENT',
  NotFoundChatRoom = 'NOT_FOUND_CHAT_ROOM',
  NotFoundChatRoomMessageFile = 'NOT_FOUND_CHAT_ROOM_MESSAGE_FILE',
  NotFoundPartnerChatRoom = 'NOT_FOUND_PARTNER_CHAT_ROOM',
  NotFoundQuotationAnnotationSharedFileId = 'NOT_FOUND_QUOTATION_ANNOTATION_SHARED_FILE_ID',
  NotFoundQuotationFile = 'NOT_FOUND_QUOTATION_FILE',
  NotFountChatRoomUser = 'NOT_FOUNT_CHAT_ROOM_USER',
  NotIncludePortfolioFile = 'NOT_INCLUDE_PORTFOLIO_FILE',
  /** 어노테이션이 일치하지 않습니다. */
  NotMatchAnnotation = 'NOT_MATCH_ANNOTATION',
  NotMatchChatRoomMessageFile = 'NOT_MATCH_CHAT_ROOM_MESSAGE_FILE',
  NotMatchDrawingFile = 'NOT_MATCH_DRAWING_FILE',
  NotMatchFileType = 'NOT_MATCH_FILE_TYPE',
  NotMatchPartnerUserType = 'NOT_MATCH_PARTNER_USER_TYPE',
  NotMatchUser = 'NOT_MATCH_USER',
  NotQuitQuotationChatRoom = 'NOT_QUIT_QUOTATION_CHAT_ROOM',
  NotRallowRfqDrawingFileDownload = 'NOT_RALLOW_RFQ_DRAWING_FILE_DOWNLOAD',
  NotRateQuotationService = 'NOT_RATE_QUOTATION_SERVICE',
  NotReadAllManagement = 'NOT_READ_ALL_MANAGEMENT',
  NotReadQuotationChatMessage = 'NOT_READ_QUOTATION_CHAT_MESSAGE',
  NotReadRfqPurchaseOrder = 'NOT_READ_RFQ_PURCHASE_ORDER',
  NotReadRfqQuotation = 'NOT_READ_RFQ_QUOTATION',
  NotRegisterQuotationPartner = 'NOT_REGISTER_QUOTATION_PARTNER',
  NotRegisterQuotationUser = 'NOT_REGISTER_QUOTATION_USER',
  NotRegisterRequestRfqPurchaseorder = 'NOT_REGISTER_REQUEST_RFQ_PURCHASEORDER',
  NotRegisterRequestRfqPurchaseOrderWithItem = 'NOT_REGISTER_REQUEST_RFQ_PURCHASE_ORDER_WITH_ITEM',
  NotRegisterRequestRfqQuotation = 'NOT_REGISTER_REQUEST_RFQ_QUOTATION',
  NotRegisterRfqrfq = 'NOT_REGISTER_RFQRFQ',
  NotReplyRfqReview = 'NOT_REPLY_RFQ_REVIEW',
  NotRequestAdjustRfqPurchaseOrder = 'NOT_REQUEST_ADJUST_RFQ_PURCHASE_ORDER',
  NotRequestAdjustRfqPurchaseOrderWithItem = 'NOT_REQUEST_ADJUST_RFQ_PURCHASE_ORDER_WITH_ITEM',
  NotRequestAdjustRfqQuotation = 'NOT_REQUEST_ADJUST_RFQ_QUOTATION',
  NotRequestCompleteRfqTransaction = 'NOT_REQUEST_COMPLETE_RFQ_TRANSACTION',
  NotRequestConfirmRfqTransaction = 'NOT_REQUEST_CONFIRM_RFQ_TRANSACTION',
  NotReviewed = 'NOT_REVIEWED',
  NotReviewReplyPeriod = 'NOT_REVIEW_REPLY_PERIOD',
  NotReviewRfq = 'NOT_REVIEW_RFQ',
  NotSaveRfqFilter = 'NOT_SAVE_RFQ_FILTER',
  NotSendPartnerMessage = 'NOT_SEND_PARTNER_MESSAGE',
  NotSendQuotationChatMessage = 'NOT_SEND_QUOTATION_CHAT_MESSAGE',
  NotServiceTypeIncluded = 'NOT_SERVICE_TYPE_INCLUDED',
  NotSuggestService = 'NOT_SUGGEST_SERVICE',
  NotToggleFavorite = 'NOT_TOGGLE_FAVORITE',
  NotUpdateQuotationPartner = 'NOT_UPDATE_QUOTATION_PARTNER',
  NotUpdateQuotationUser = 'NOT_UPDATE_QUOTATION_USER',
  NotUpdateRfqStatus = 'NOT_UPDATE_RFQ_STATUS',
  NotVerifyCompanyRegistrationNumber = 'NOT_VERIFY_COMPANY_REGISTRATION_NUMBER',
  /** NO_CHAT_USERS */
  NoChatUsers = 'NO_CHAT_USERS',
  /** 사업자 등록증을 입력해야 합니다. */
  NoCompanyRegistrationFile = 'NO_COMPANY_REGISTRATION_FILE',
  NoMatchPortfolioImageLength = 'NO_MATCH_PORTFOLIO_IMAGE_LENGTH',
  NoMessage = 'NO_MESSAGE',
  /** 해당 MERCHATN_UID에 해당되는 거래건이 없습니다 */
  NoPaymentOfMerchantUid = 'NO_PAYMENT_OF_MERCHANT_UID',
  NoPortfolioImage = 'NO_PORTFOLIO_IMAGE',
  OverFileSize = 'OVER_FILE_SIZE',
  /** 어노테이션 부모 댓글은 삭제할 수 없습니다. */
  ParentCommentCannotDelete = 'PARENT_COMMENT_CANNOT_DELETE',
  /** 유효하지 않은 파라미터 입니다. */
  ParmeterValidationError = 'PARMETER_VALIDATION_ERROR',
  PassedReviewPeriod = 'PASSED_REVIEW_PERIOD',
  /** 비밀번호가 일치하지 않습니다. */
  PasswordIncorrect = 'PASSWORD_INCORRECT',
  /** 나이스페이 api not success */
  PaymentApiResultNotSuccess = 'PAYMENT_API_RESULT_NOT_SUCCESS',
  /** 나이스페이 api success */
  PaymentApiResultSuccess = 'PAYMENT_API_RESULT_SUCCESS',
  /** 에스크로 및 결제 input에 null인 값이 있습니다. */
  PaymentInputNonNullable = 'PAYMENT_INPUT_NON_NULLABLE',
  /** 에스크로 및 결제 input에 invalid값이 있습니다.  */
  PaymentInvalidInput = 'PAYMENT_INVALID_INPUT',
  /** 결제 정보를 찾을 수 없습니다. */
  PaymentNotFound = 'PAYMENT_NOT_FOUND',
  /** 아임포트 혹은 나이스페이 api 호출 실패 */
  PaymenyApiCallFail = 'PAYMENY_API_CALL_FAIL',
  PcbPdfError = 'PCB_PDF_ERROR',
  ProvideOnlyOneFileId = 'PROVIDE_ONLY_ONE_FILE_ID',
  /** 거부된 발주서입니다. */
  PurchaseOrderRejected = 'PURCHASE_ORDER_REJECTED',
  /** SQL문에서 에러가 발생하였습니다. */
  QueryError = 'QUERY_ERROR',
  QuotationChatroomNotFound = 'QUOTATION_CHATROOM_NOT_FOUND',
  /** 이미 파트너가 존재합니다. */
  QuotationPartnerExists = 'QUOTATION_PARTNER_EXISTS',
  /** 파트너를 찾을 수 없습니다. */
  QuotationPartnerNotFound = 'QUOTATION_PARTNER_NOT_FOUND',
  /** 파트너의 유저를 찾을 수 없습니다. */
  QuotationPartnerUserNotFound = 'QUOTATION_PARTNER_USER_NOT_FOUND',
  /** 고객이 이미 존재 합니다. */
  QuotationUserExists = 'QUOTATION_USER_EXISTS',
  /** 고객을 찾을 수 없습니다. */
  QuotationUserNotFound = 'QUOTATION_USER_NOT_FOUND',
  QuotationUserRegistrationFailed = 'QUOTATION_USER_REGISTRATION_FAILED',
  /** READ_MESSAGE_FAILED */
  ReadMessageFailed = 'READ_MESSAGE_FAILED',
  /** 환불 계좌가 존재하지 않습니다 */
  RefundBankNotFound = 'REFUND_BANK_NOT_FOUND',
  /** 배송등록 불가능 - 가능한 스텝이 아님 */
  RegisterShippingDisableForStep = 'REGISTER_SHIPPING_DISABLE_FOR_STEP',
  RequestRfqDrawingFileDownload = 'REQUEST_RFQ_DRAWING_FILE_DOWNLOAD',
  RequiredDetailedRequest = 'REQUIRED_DETAILED_REQUEST',
  RfqAlreadyComplete = 'RFQ_ALREADY_COMPLETE',
  /** RFQ_ALREADY_CONFIRMED */
  RfqAlreadyConfirmed = 'RFQ_ALREADY_CONFIRMED',
  /** RFQ_ALREADY_STOPPED */
  RfqAlreadyStopped = 'RFQ_ALREADY_STOPPED',
  /** RFQ_FILTER_NOT_PROVIDE_SERVICE_TYPE */
  RfqFilterNotProvideServiceType = 'RFQ_FILTER_NOT_PROVIDE_SERVICE_TYPE',
  RfqNotComplete = 'RFQ_NOT_COMPLETE',
  RfqNotConfirmed = 'RFQ_NOT_CONFIRMED',
  /** RFQ_NOT_FOUND */
  RfqNotFound = 'RFQ_NOT_FOUND',
  RfqNotQuotationUser = 'RFQ_NOT_QUOTATION_USER',
  /** 결제 프로세스 진행중입니다. */
  RfqPaymentInProgress = 'RFQ_PAYMENT_IN_PROGRESS',
  /** RFQ_PURCHASE_ORDER_ALREADY_CONFIRMED */
  RfqPurchaseOrderAlreadyConfirmed = 'RFQ_PURCHASE_ORDER_ALREADY_CONFIRMED',
  /** RFQ_PURCHASE_ORDER_ALREADY_REGISTERED */
  RfqPurchaseOrderAlreadyRegistered = 'RFQ_PURCHASE_ORDER_ALREADY_REGISTERED',
  /** RFQ_PURCHASE_ORDER_NOT_FOUND */
  RfqPurchaseOrderNotFound = 'RFQ_PURCHASE_ORDER_NOT_FOUND',
  /** RFQ_QUOTATION_ALREADY_CONFIRMED */
  RfqQuotationAlreadyConfirmed = 'RFQ_QUOTATION_ALREADY_CONFIRMED',
  /** RFQ_QUOTATION_ALREADY_REGISTERED */
  RfqQuotationAlreadyRegistered = 'RFQ_QUOTATION_ALREADY_REGISTERED',
  /** RFQ_QUOTATION_AND_QUOTATION_PARTNER_INTRODUCTION_NOT_FOUND */
  RfqQuotationAndQuotationPartnerIntroductionNotFound = 'RFQ_QUOTATION_AND_QUOTATION_PARTNER_INTRODUCTION_NOT_FOUND',
  /** RFQ_QUOTATION_NOT_CONFIRMED */
  RfqQuotationNotConfirmed = 'RFQ_QUOTATION_NOT_CONFIRMED',
  /** RFQ_QUOTATION_NOT_FOUND */
  RfqQuotationNotFound = 'RFQ_QUOTATION_NOT_FOUND',
  /** RFQ_QUOTATION_NOT_FOUND_PARTNER_INTRODUCTION_FOUND */
  RfqQuotationNotFoundPartnerIntroductionFound = 'RFQ_QUOTATION_NOT_FOUND_PARTNER_INTRODUCTION_FOUND',
  /** RFQ_QUOTATION_OR_QUOTATION_PARTNER_INTRODUCTION_NOT_FOUND */
  RfqQuotationOrQuotationPartnerIntroductionNotFound = 'RFQ_QUOTATION_OR_QUOTATION_PARTNER_INTRODUCTION_NOT_FOUND',
  /** RFQ_QUOTATION_PARTNER_INTRODUCTION_NOT_FOUND */
  RfqQuotationPartnerIntroductionNotFound = 'RFQ_QUOTATION_PARTNER_INTRODUCTION_NOT_FOUND',
  RfqTransactionNotFound = 'RFQ_TRANSACTION_NOT_FOUND',
  RfqUpdateNotComplete = 'RFQ_UPDATE_NOT_COMPLETE',
  SameDestination = 'SAME_DESTINATION',
  /** SEND_MESSAGE_FAILED */
  SendMessageFailed = 'SEND_MESSAGE_FAILED',
  SharpImageResizeError = 'SHARP_IMAGE_RESIZE_ERROR',
  /** 이미 예상 배송정보가 등록되었습니다. */
  ShippingAlreadyRegisted = 'SHIPPING_ALREADY_REGISTED',
  /** 배송정보를 찾을 수 없습니다. */
  ShippingNotFound = 'SHIPPING_NOT_FOUND',
  /** 파트너가 배송지 입력을 하지 않았습니다.  */
  ShippingNotRegistered = 'SHIPPING_NOT_REGISTERED',
  /** 서브몰 미등록 파트너 */
  SubmallNotFound = 'SUBMALL_NOT_FOUND',
  /** 성공 */
  Success = 'SUCCESS',
  /** 토큰이 만료되었습니다. */
  TokenExpired = 'TOKEN_EXPIRED',
  /** 토큰이 일치하지 않습니다. */
  TokenMismatch = 'TOKEN_MISMATCH',
  /** 거래리뷰가 이미 존재합니다. */
  TransactionReviewAlreadyExists = 'TRANSACTION_REVIEW_ALREADY_EXISTS',
  /** 거래리뷰가 존재하지 않습니다. */
  TransactionReviewNotFound = 'TRANSACTION_REVIEW_NOT_FOUND',
  /** 거래리뷰 작성할 수 있는 시간을 초과하였습니다. */
  TransactionReviewTimeExceed = 'TRANSACTION_REVIEW_TIME_EXCEED',
  /** 허가 되지 않은 접근입니다. */
  Unauthorized = 'UNAUTHORIZED',
  /** 통합 유저를 찾을 수 없습니다. */
  UserNotFound = 'USER_NOT_FOUND',
  /** 거절됀 사용자 */
  UserRejected = 'USER_REJECTED',
  ValidCompanyRegistrationNo = 'VALID_COMPANY_REGISTRATION_NO'
}

export type CapaFetchAvailableFilterRfq = {
  __typename?: 'CAPAFetchAvailableFilterRfq';
  chatRooms?: Maybe<Scalars['Float']>;
  createdAt: Scalars['String'];
  detailedServiceType?: Maybe<CapaQuotationDetailedServiceType>;
  eventType?: Maybe<CapaQuotationRfqEventType>;
  id: Scalars['String'];
  isFavorite?: Maybe<Scalars['Boolean']>;
  isNew: Scalars['Boolean'];
  isSendIntroduction: Scalars['Boolean'];
  isSendQuotation: Scalars['Boolean'];
  isTest: Scalars['Boolean'];
  managerName?: Maybe<Scalars['String']>;
  organizationName?: Maybe<Scalars['String']>;
  pageViews?: Maybe<Scalars['Float']>;
  projectName: Scalars['String'];
  quantity?: Maybe<Scalars['Float']>;
  serviceType: CapaQuotationServiceType;
  shortAddress?: Maybe<Scalars['String']>;
  status: CapaRfqStatus;
  thumbnailId?: Maybe<Scalars['String']>;
  uniqueViews?: Maybe<Scalars['Float']>;
};

export type CapaFetchAvailableFilterRfqs = {
  __typename?: 'CAPAFetchAvailableFilterRfqs';
  count: Scalars['Float'];
  rfqs?: Maybe<Array<CapaFetchAvailableFilterRfq>>;
};

export type CapaFetchAvailableFilterRfqsOutput = {
  __typename?: 'CAPAFetchAvailableFilterRfqsOutput';
  data?: Maybe<CapaFetchAvailableFilterRfqs>;
  /** errorMessage */
  errorMessage?: Maybe<Scalars['String']>;
  /** CAPA ERROR CODE */
  result: CapaErrorCode;
};

/** CAPAFetchQuotationPartnerProjectManagementDetail */
export type CapaFetchQuotationPartnerProjectManagementDetail = {
  __typename?: 'CAPAFetchQuotationPartnerProjectManagementDetail';
  /** 도면 관리 */
  drawingFile?: Maybe<CapaRfqPartnerManagementElement>;
  /** 발주서 */
  purchaseOrder?: Maybe<CapaRfqPartnerManagementElement>;
  /** 견적서 */
  quotation?: Maybe<CapaRfqPartnerManagementElement>;
};

/** CAPAFetchQuotationPartnerProjectManagementDetailOuput */
export type CapaFetchQuotationPartnerProjectManagementDetailOutput = {
  __typename?: 'CAPAFetchQuotationPartnerProjectManagementDetailOutput';
  data?: Maybe<CapaFetchQuotationPartnerProjectManagementDetail>;
  /** errorMessage */
  errorMessage?: Maybe<Scalars['String']>;
  /** CAPA ERROR CODE */
  result: CapaErrorCode;
};

export type CapaFetchQuotationPartnerProjectManagementRfqs = {
  __typename?: 'CAPAFetchQuotationPartnerProjectManagementRfqs';
  count: Scalars['Float'];
  managements: Array<CapaQuotationPartnerProjectManagement>;
};

/** CAPAFetchQuotationPartnerProjectManagementRfqsOutput */
export type CapaFetchQuotationPartnerProjectManagementRfqsOutput = {
  __typename?: 'CAPAFetchQuotationPartnerProjectManagementRfqsOutput';
  data?: Maybe<CapaFetchQuotationPartnerProjectManagementRfqs>;
  /** errorMessage */
  errorMessage?: Maybe<Scalars['String']>;
  /** CAPA ERROR CODE */
  result: CapaErrorCode;
};

/** CAPAFetchQuotationUserProjectManagementDetail */
export type CapaFetchQuotationUserProjectManagementDetail = {
  __typename?: 'CAPAFetchQuotationUserProjectManagementDetail';
  /** 도면 관리 */
  drawingFile?: Maybe<CapaRfqManagementElement>;
  /** 발주서 */
  purchaseOrder?: Maybe<CapaRfqManagementElement>;
  /** 견적서 */
  quotation?: Maybe<CapaRfqManagementElement>;
};

/** CAPARfqProjectManagementOutput */
export type CapaFetchQuotationUserProjectManagementDetailOuput = {
  __typename?: 'CAPAFetchQuotationUserProjectManagementDetailOuput';
  data?: Maybe<CapaFetchQuotationUserProjectManagementDetail>;
  /** errorMessage */
  errorMessage?: Maybe<Scalars['String']>;
  /** CAPA ERROR CODE */
  result: CapaErrorCode;
};

export type CapaFetchQuotationUserProjectManagementRfqs = {
  __typename?: 'CAPAFetchQuotationUserProjectManagementRfqs';
  count: Scalars['Float'];
  managements: Array<CapaQuotationUserProjectManagement>;
};

/** CAPAFetchQuotationUserProjectManagementListOutput */
export type CapaFetchQuotationUserProjectManagementRfqsOutput = {
  __typename?: 'CAPAFetchQuotationUserProjectManagementRfqsOutput';
  data?: Maybe<CapaFetchQuotationUserProjectManagementRfqs>;
  /** errorMessage */
  errorMessage?: Maybe<Scalars['String']>;
  /** CAPA ERROR CODE */
  result: CapaErrorCode;
};

export type CapaFetchRfqStatus = {
  __typename?: 'CAPAFetchRfqStatus';
  /** rfq 상태값 */
  rfqStatus: CapaRfqStatus;
};

export type CapaFile = {
  __typename?: 'CAPAFile';
  fileExtension?: Maybe<Scalars['String']>;
  fileId: Scalars['ID'];
  fileMimetype?: Maybe<Scalars['String']>;
  fileName?: Maybe<Scalars['String']>;
  /** 파일 용량 in bytes */
  fileSize?: Maybe<Scalars['Float']>;
  /** old File System id */
  oldFileId?: Maybe<Scalars['String']>;
  /** 파일 변환 상태 */
  status?: Maybe<CapaFileConvertStatus>;
};

/** 도면 파일 변환 처리 상태 */
export enum CapaFileConvertStatus {
  /** 변환완료 */
  Converted = 'CONVERTED',
  /** 변환중 */
  Converting = 'CONVERTING',
  /** 변환실패 */
  Failed = 'FAILED',
  /** 변환요청 */
  Processing = 'PROCESSING',
  /** 큐등록 */
  Queued = 'QUEUED'
}

export type CapaFileStatus = {
  __typename?: 'CAPAFileStatus';
  fileId: Scalars['ID'];
  /** 파일 변환 상태 */
  status?: Maybe<CapaFileConvertStatus>;
};

export type CapaFileStatusOutput = {
  __typename?: 'CAPAFileStatusOutput';
  data?: Maybe<CapaFileStatus>;
  /** errorMessage */
  errorMessage?: Maybe<Scalars['String']>;
  /** CAPA ERROR CODE */
  result: CapaErrorCode;
};

/** CAPAFilterableServiceType */
export type CapaFilterableServiceType = {
  casting?: InputMaybe<CapaServiceTypeDetailFilter>;
  cnc?: InputMaybe<CapaServiceTypeDetailFilter>;
  design?: InputMaybe<CapaServiceTypeDetailFilter>;
  inj?: InputMaybe<CapaServiceTypeDetailFilter>;
  mechanicalDesign?: InputMaybe<CapaServiceTypeDetailFilter>;
  pcb?: InputMaybe<CapaServiceTypeDetailFilter>;
  printing?: InputMaybe<CapaServiceTypeDetailFilter>;
  productDesign?: InputMaybe<CapaServiceTypeDetailFilter>;
  sheetMetal?: InputMaybe<CapaServiceTypeDetailFilter>;
};

/** 캐파 견적 파트너가 보는 채팅방룸 */
export type CapaInProgressQuotationPartnerChatRoom = {
  __typename?: 'CAPAInProgressQuotationPartnerChatRoom';
  chatRoomId: Scalars['String'];
  chatRoomStatus: CapaQuotationChatRoomStatus;
  createdAt?: Maybe<Scalars['String']>;
  /** detailedServiceType */
  detailedServiceType?: Maybe<Array<CapaQuotationDetailedServiceType>>;
  managerName?: Maybe<Scalars['String']>;
  organizationName?: Maybe<Scalars['String']>;
  projectName: Scalars['String'];
  /** 수량 */
  quantity?: Maybe<Scalars['Float']>;
  quotaionUserId: Scalars['String'];
  quotationUserStatus: CapaQuotationUserStatus;
  rfqId: Scalars['String'];
  serviceType: CapaQuotationServiceType;
  status: CapaRfqConsultingChatStatusType;
  thumbnailId?: Maybe<Scalars['String']>;
};

export type CapaInProgressQuotationPartnerChatRooms = {
  __typename?: 'CAPAInProgressQuotationPartnerChatRooms';
  chatRooms?: Maybe<Array<CapaInProgressQuotationPartnerChatRoom>>;
  count: Scalars['Float'];
};

/** 캐파 견적 파트너가 보는 채팅방 chatRooms Output */
export type CapaInProgressQuotationPartnerChatRoomsOutput = {
  __typename?: 'CAPAInProgressQuotationPartnerChatRoomsOutput';
  data?: Maybe<CapaInProgressQuotationPartnerChatRooms>;
  /** errorMessage */
  errorMessage?: Maybe<Scalars['String']>;
  /** CAPA ERROR CODE */
  result: CapaErrorCode;
};

/** 유입경로 */
export enum CapaInflowRoute {
  /** 홍보 기사 */
  Article = 'ARTICLE',
  /** 카파 블로그 */
  CapaBlog = 'CAPA_BLOG',
  /** 카페 등 커뮤니티 */
  Community = 'COMMUNITY',
  /** 크리에이터블 홈페이지 및 블로그 */
  Creatable = 'CREATABLE',
  /**
   * 우편물
   * @deprecated Duplicate @link {CAPAInflowRoute.PAPER}
   */
  Dm = 'DM',
  /** 이메일 광고 */
  Email = 'EMAIL',
  /** 기타 */
  Etc = 'ETC',
  /** 인터넷 검색 */
  Internet = 'INTERNET',
  /** 인터넷 광고(구글/네이버 등/0 */
  InternetAdd = 'INTERNET_ADD',
  /** 언론 보도 */
  MediaReport = 'MEDIA_REPORT',
  /** 오프라인 영업 */
  Offline = 'OFFLINE',
  /** 지면 광고 (우편, 브로셔 등) */
  Paper = 'PAPER',
  /** 전화 광고 */
  Phone = 'PHONE',
  /** 홍보 현수막 */
  Placard = 'PLACARD',
  /** 서비스설명회 (온라인포함) */
  Presentation = 'PRESENTATION',
  /** 지인 및 기관 추천 */
  Recommendation = 'RECOMMENDATION',
  /** 문자 광고 */
  Sms = 'SMS',
  /** SNS 광고(인스타, 페이스북 등) */
  Sns = 'SNS'
}

/** ITP 이벤트 신청 목록 BO */
export type CapaItpEventBo = {
  __typename?: 'CAPAItpEventBO';
  /** ITP 이벤트 신청 승인 날짜 */
  approvedAt?: Maybe<Scalars['String']>;
  /** ITP 이벤트 신청 승인 BO 아이디 */
  approvedById?: Maybe<Scalars['String']>;
  /** ITP 이벤트 신청 승인 BO 이름 */
  approvedByName?: Maybe<Scalars['String']>;
  /** ITP RFQ 고객 전화번호 */
  cellphoneNumber?: Maybe<Scalars['String']>;
  /** ITP RFQ 거래 완료 금액 */
  completeCost?: Maybe<Scalars['String']>;
  /** ITP RFQ 고객 이메일 */
  email?: Maybe<Scalars['String']>;
  /** ITP 이벤트 증빙자료 */
  files?: Maybe<Array<CapaFile>>;
  /** ITP 이벤트 아이디 */
  id?: Maybe<Scalars['ID']>;
  /** ITP RFQ 프로젝트 이름 */
  projectName?: Maybe<Scalars['String']>;
  /** ITP RFQ 매칭 파트너 이름 */
  quotationPartnerOrganizationName?: Maybe<Scalars['String']>;
  /** ITP RFQ QUOTATION USER 아이디 */
  quotationUserId?: Maybe<Scalars['String']>;
  /** ITP RFQ QUOTATION USER 고객 이름 */
  quotationUserName?: Maybe<Scalars['String']>;
  /** ITP 이벤트 officecon에 보낸 날짜 */
  sentAt?: Maybe<Scalars['String']>;
  /** ITP 이벤트 신청 승인 BO 아이디 */
  sentById?: Maybe<Scalars['String']>;
  /** ITP 이벤트 신청 승인 BO 이름 */
  sentByName?: Maybe<Scalars['String']>;
};

/** ITP 이벤트 증빙용 파일 */
export type CapaItpEventFile = {
  __typename?: 'CAPAItpEventFile';
  /** ITP 이벤트 증빙 파일 아이디 */
  fileId?: Maybe<Scalars['ID']>;
  /** 파일 이름 */
  fileName?: Maybe<Scalars['String']>;
};

/** ITP 이벤트 목록 표출 종류 */
export enum CapaItpEventListTypeEnum {
  /** 전체 목록 표출 */
  All = 'ALL',
  /** 승인 ITP 이벤트 신청 목록 표출 */
  Approved = 'APPROVED',
  /** 확인전 목록 표출 */
  Ready = 'READY',
  /**
   * 거절 ITP 이벤트 신청 목록 표출
   * @deprecated 디자인상 목록이 있으나, 실제 값이 존재 할 수 없음
   */
  Reject = 'REJECT',
  /** 전송완료 ITP 이벤트 신청 목록 표출 */
  Sent = 'SENT'
}

/** ITP 이벤트 신청 목록 BO */
export type CapaItpEventXlsxDownload = {
  __typename?: 'CAPAItpEventXlsxDownload';
  /** ITP RFQ 고객 전화번호 */
  cellphoneNumber?: Maybe<Scalars['String']>;
  /** ITP RFQ 고객 이메일 */
  email?: Maybe<Scalars['String']>;
  /** ITP 이벤트 아이디 */
  id?: Maybe<Scalars['ID']>;
};

export type CapaItpEventsBoOutput = {
  __typename?: 'CAPAItpEventsBOOutput';
  data?: Maybe<Array<CapaItpEventBo>>;
  /** errorMessage */
  errorMessage?: Maybe<Scalars['String']>;
  /** CAPA ERROR CODE */
  result: CapaErrorCode;
};

/** Jsb 이벤트 신청 목록 BO */
export type CapaJsbEventBo = {
  __typename?: 'CAPAJsbEventBO';
  /** Jsb 계좌 */
  account?: Maybe<Scalars['String']>;
  /** Jsb 이벤트 신청 승인 날짜 */
  approvedAt?: Maybe<Scalars['String']>;
  /** Jsb 이벤트 신청 승인 BO 아이디 */
  approvedById?: Maybe<Scalars['String']>;
  /** Jsb 이벤트 신청 승인 BO 이름 */
  approvedByName?: Maybe<Scalars['String']>;
  /** Jsb 은행 */
  bank?: Maybe<Scalars['String']>;
  /** Jsb RFQ 고객 전화번호 */
  cellphoneNumber?: Maybe<Scalars['String']>;
  /** Jsb RFQ 거래 완료 금액 */
  completeCost?: Maybe<Scalars['String']>;
  /** Jsb RFQ 고객 이메일 */
  email?: Maybe<Scalars['String']>;
  /** Jsb 이벤트 증빙자료 */
  files?: Maybe<Array<CapaFile>>;
  /** Jsb 이벤트 아이디 */
  id?: Maybe<Scalars['ID']>;
  /** Jsb RFQ 프로젝트 이름 */
  projectName?: Maybe<Scalars['String']>;
  /** Jsb RFQ 매칭 파트너 이름 */
  quotationPartnerOrganizationName?: Maybe<Scalars['String']>;
  /** Jsb RFQ QUOTATION USER 아이디 */
  quotationUserId?: Maybe<Scalars['String']>;
  /** Jsb RFQ QUOTATION USER 고객 이름 */
  quotationUserName?: Maybe<Scalars['String']>;
};

/** JSB 이벤트 증빙용 파일 */
export type CapaJsbEventFile = {
  __typename?: 'CAPAJsbEventFile';
  /** JSB 이벤트 증빙 파일 아이디 */
  fileId?: Maybe<Scalars['ID']>;
  /** 파일 이름 */
  fileName?: Maybe<Scalars['String']>;
};

/** JSB 이벤트 목록 표출 종류 */
export enum CapaJsbEventListTypeEnum {
  /** 전체 목록 표출 */
  All = 'ALL',
  /** 승인 JSB 이벤트 신청 목록 표출 */
  Approved = 'APPROVED',
  /** 확인전 목록 표출 */
  Ready = 'READY',
  /**
   * 거절 JSB 이벤트 신청 목록 표출
   * @deprecated 디자인상 목록이 있으나, 실제 값이 존재 할 수 없음
   */
  Reject = 'REJECT'
}

/** JSB 이벤트 신청 목록 BO */
export type CapaJsbEventXlsxDownload = {
  __typename?: 'CAPAJsbEventXlsxDownload';
  /** JSB RFQ 고객 계좌 */
  account?: Maybe<Scalars['String']>;
  /** JSB RFQ 고객 은행 */
  bank?: Maybe<Scalars['String']>;
  /** JSB RFQ 고객 전화번호 */
  cellphoneNumber?: Maybe<Scalars['String']>;
  /** JSB RFQ 고객 이메일 */
  email?: Maybe<Scalars['String']>;
  /** JSB 이벤트 아이디 */
  id?: Maybe<Scalars['ID']>;
};

export type CapaJsbEventsBoOutput = {
  __typename?: 'CAPAJsbEventsBOOutput';
  data?: Maybe<Array<CapaJsbEventBo>>;
  /** errorMessage */
  errorMessage?: Maybe<Scalars['String']>;
  /** CAPA ERROR CODE */
  result: CapaErrorCode;
};

/** 내드리이브 */
export type CapaMyDrive = {
  __typename?: 'CAPAMyDrive';
  /** 생성일 (업로드 일시) */
  createdAt: Scalars['String'];
  /** 파일 ID */
  fileId: Scalars['ID'];
  /** 파일명 */
  fileName: Scalars['String'];
  /** 파일크기 byte */
  fileSize: Scalars['Float'];
  /**
   * Legacy 파일 ID
   * @deprecated Legacy
   */
  oldFileId?: Maybe<Scalars['String']>;
  /** 파일 변환 상태 */
  status?: Maybe<CapaFileConvertStatus>;
  /** 썸네일 */
  thumbnails?: Maybe<Scalars['String']>;
  /** 수정일 */
  updatedAt: Scalars['String'];
  /** 도면 파일 뷰어 URL */
  viewerUrl?: Maybe<Scalars['String']>;
};

/** 내드리이브 */
export type CapaMyDrivesOutput = {
  __typename?: 'CAPAMyDrivesOutput';
  data?: Maybe<Array<CapaMyDrive>>;
  /** errorMessage */
  errorMessage?: Maybe<Scalars['String']>;
  /** CAPA ERROR CODE */
  result: CapaErrorCode;
};

export type CapaNewChatMessage = {
  __typename?: 'CAPANewChatMessage';
  id?: Maybe<Scalars['ID']>;
};

export type CapaNotification = {
  __typename?: 'CAPANotification';
  /** 생성일 (업로드 일시) */
  createdAt: Scalars['String'];
  data?: Maybe<CapaNotificationUnion>;
  read?: Maybe<Scalars['Boolean']>;
  seq: Scalars['Float'];
  serviceType: CapaServiceType;
};

export type CapaNotificationConnect = {
  __typename?: 'CAPANotificationConnect';
  accessLevel?: Maybe<CapaConnectGroupAccessLevel>;
  annotationId?: Maybe<Scalars['String']>;
  chatRoomId?: Maybe<Scalars['String']>;
  comment?: Maybe<Scalars['String']>;
  commentId?: Maybe<Scalars['String']>;
  connectFileId?: Maybe<Scalars['String']>;
  fileName?: Maybe<Scalars['String']>;
  groupId?: Maybe<Scalars['String']>;
  groupName?: Maybe<Scalars['String']>;
  groupUserId?: Maybe<Scalars['String']>;
  message?: Maybe<Scalars['String']>;
  notificationType: CapaNotificationType;
  oldGroupName?: Maybe<Scalars['String']>;
  toBeShown?: Maybe<Scalars['String']>;
  userName?: Maybe<Scalars['String']>;
};

export type CapaNotificationDefault = {
  __typename?: 'CAPANotificationDefault';
  chatRoomId?: Maybe<Scalars['String']>;
  notificationType: CapaNotificationType;
};

export type CapaNotificationRfq = {
  __typename?: 'CAPANotificationRfq';
  adjustRequest?: Maybe<Scalars['String']>;
  chatRoomId?: Maybe<Scalars['String']>;
  /** 정산 완료 금액 */
  depositAmt?: Maybe<Scalars['Float']>;
  managerName?: Maybe<Scalars['String']>;
  notificationType: CapaNotificationType;
  organizationName?: Maybe<Scalars['String']>;
  projectName?: Maybe<Scalars['String']>;
  /** 환불 금액 */
  refundAmt?: Maybe<Scalars['Float']>;
  rfqId: Scalars['String'];
  serviceType?: Maybe<CapaQuotationServiceType>;
  totalAmount?: Maybe<Scalars['String']>;
};

export enum CapaNotificationType {
  AllowRequest = 'ALLOW_REQUEST',
  AllowResponse = 'ALLOW_RESPONSE',
  Announcement = 'ANNOUNCEMENT',
  ApprovedPayment = 'APPROVED_PAYMENT',
  AwaitingPayment = 'AWAITING_PAYMENT',
  CancelConfirmed = 'CANCEL_CONFIRMED',
  CancelConfirmedCreditCard = 'CANCEL_CONFIRMED_CREDIT_CARD',
  CancelConfirmedVirtualAccount = 'CANCEL_CONFIRMED_VIRTUAL_ACCOUNT',
  CancelRequested = 'CANCEL_REQUESTED',
  ConnectAccessChange = 'CONNECT_ACCESS_CHANGE',
  ConnectAnnotationComment = 'CONNECT_ANNOTATION_COMMENT',
  ConnectChangeGroupName = 'CONNECT_CHANGE_GROUP_NAME',
  ConnectDeleteGroup = 'CONNECT_DELETE_GROUP',
  ConnectDownloadAccess = 'CONNECT_DOWNLOAD_ACCESS',
  ConnectDownloadGranted = 'CONNECT_DOWNLOAD_GRANTED',
  ConnectFileShared = 'CONNECT_FILE_SHARED',
  ConnectInviteUser = 'CONNECT_INVITE_USER',
  ConnectLeaveGroup = 'CONNECT_LEAVE_GROUP',
  ConnectNewChat = 'CONNECT_NEW_CHAT',
  ConnectRemoveFromGroup = 'CONNECT_REMOVE_FROM_GROUP',
  DelayedConfirmPurchase = 'DELAYED_CONFIRM_PURCHASE',
  EventInvitation = 'EVENT_INVITATION',
  EventRfqConfirm = 'EVENT_RFQ_CONFIRM',
  InduceConfirmPurchase = 'INDUCE_CONFIRM_PURCHASE',
  ItpEventRequestAvailable = 'ITP_EVENT_REQUEST_AVAILABLE',
  PurchaseConfirmed = 'PURCHASE_CONFIRMED',
  PurchaseOrderRegisterRequest = 'PURCHASE_ORDER_REGISTER_REQUEST',
  QuotationChatMessage = 'QUOTATION_CHAT_MESSAGE',
  QuotationChatRoomStatusOpen = 'QUOTATION_CHAT_ROOM_STATUS_OPEN',
  RefundConfirmed = 'REFUND_CONFIRMED',
  RefundConfirmedCreditCard = 'REFUND_CONFIRMED_CREDIT_CARD',
  RefundConfirmedVirtualAccount = 'REFUND_CONFIRMED_VIRTUAL_ACCOUNT',
  RefundRequested = 'REFUND_REQUESTED',
  RejectRfqPurchaseOrderCreditCard = 'REJECT_RFQ_PURCHASE_ORDER_CREDIT_CARD',
  RejectRfqPurchaseOrderVirtualAccount = 'REJECT_RFQ_PURCHASE_ORDER_VIRTUAL_ACCOUNT',
  RfqAdjustQuotation = 'RFQ_ADJUST_QUOTATION',
  RfqComplete = 'RFQ_COMPLETE',
  RfqCompleteRequest = 'RFQ_COMPLETE_REQUEST',
  RfqConfirm = 'RFQ_CONFIRM',
  RfqConfirmRequest = 'RFQ_CONFIRM_REQUEST',
  RfqDownloadAccess = 'RFQ_DOWNLOAD_ACCESS',
  RfqDownloadGranted = 'RFQ_DOWNLOAD_GRANTED',
  RfqExpiration = 'RFQ_EXPIRATION',
  RfqExpirationClient = 'RFQ_EXPIRATION_CLIENT',
  RfqExpirationConfirm = 'RFQ_EXPIRATION_CONFIRM',
  RfqExpirationWarning = 'RFQ_EXPIRATION_WARNING',
  RfqPurchaseOrder = 'RFQ_PURCHASE_ORDER',
  RfqRegistered = 'RFQ_REGISTERED',
  RfqRequestQuotation = 'RFQ_REQUEST_QUOTATION',
  RfqReviewDone = 'RFQ_REVIEW_DONE',
  RfqReviewReplyDone = 'RFQ_REVIEW_REPLY_DONE',
  StampEvent = 'STAMP_EVENT',
  StampInvitationEvent = 'STAMP_INVITATION_EVENT',
  StampWelcomeEvent = 'STAMP_WELCOME_EVENT',
  StartProcessing = 'START_PROCESSING',
  StartShipping = 'START_SHIPPING'
}

export type CapaNotificationUnion = CapaNotificationConnect | CapaNotificationDefault | CapaNotificationRfq;

export type CapaNotifications = {
  __typename?: 'CAPANotifications';
  count: Scalars['Float'];
  notifications: Array<CapaNotification>;
};

export type CapaNotificationsOutput = {
  __typename?: 'CAPANotificationsOutput';
  data?: Maybe<CapaNotifications>;
  /** errorMessage */
  errorMessage?: Maybe<Scalars['String']>;
  /** CAPA ERROR CODE */
  result: CapaErrorCode;
};

/** Payment PG providers */
export enum CapapgProviders {
  Nicepay = 'NICEPAY'
}

export type CapaPartnerBo = {
  __typename?: 'CAPAPartnerBO';
  capabilities?: Maybe<CapaQuotationPartnerCapability>;
  consultingCount?: Maybe<Scalars['Float']>;
  contact?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['String']>;
  email: Scalars['String'];
  id?: Maybe<Scalars['String']>;
  /** 소개서로 제안 수 */
  introductionSuggestionCount?: Maybe<Scalars['Float']>;
  lastLoginAt?: Maybe<Scalars['String']>;
  managerName?: Maybe<Scalars['String']>;
  organizationName?: Maybe<Scalars['String']>;
  /** 총 발주 수 */
  purchaseOrderCount?: Maybe<Scalars['Float']>;
  /** 견적서로 제안 수 */
  quotationSuggestionCount?: Maybe<Scalars['Float']>;
  registrationFileId?: Maybe<Scalars['String']>;
  /** 거부된 발주 수 */
  rejectedPurchaseOrderCount?: Maybe<Scalars['Float']>;
  /** 견적 수 = 상담 시작 방식 및 상담 진행 여부 상관 없이 견적서 1회 이상 발송한 프로젝트 수 */
  rfqReceivedQuotationCount?: Maybe<Scalars['Float']>;
  status?: Maybe<CapaQuotationPartnerStatus>;
};

export type CapaPartnersAndCount = {
  __typename?: 'CAPAPartnersAndCount';
  count?: Maybe<Scalars['Float']>;
  partners?: Maybe<Array<CapaPartnerBo>>;
};

export type CapaPartnersBoOutput = {
  __typename?: 'CAPAPartnersBOOutput';
  count?: Maybe<Scalars['Float']>;
  data?: Maybe<CapaPartnersAndCount>;
  /** errorMessage */
  errorMessage?: Maybe<Scalars['String']>;
  /** CAPA ERROR CODE */
  result: CapaErrorCode;
};

/** 결제 취소 status */
export enum CapaPaymentCancelStatus {
  /** 환불 승인 (파트너 승인은 완료되었지만, 실제로 고객에게 아직 환불 이루어지지 않은 경우) */
  ApprovedRefund = 'APPROVED_REFUND',
  /** BO 계속 진행 통보 */
  ApproveProgressBo = 'APPROVE_PROGRESS_BO',
  /** BO 환불 승인 통보 */
  ApproveRefundBo = 'APPROVE_REFUND_BO',
  /** 결제 취소 완료 */
  CalcellationComplete = 'CALCELLATION_COMPLETE',
  /** 결제 취소 실패 */
  Failed = 'FAILED',
  /** 입금 시간 내 미입금으로 인한 결제 취소 */
  OutstandingPayment = 'OUTSTANDING_PAYMENT',
  /** 발주서 거부로 인한 결제 취소 */
  PurchaseOrderRejected = 'PURCHASE_ORDER_REJECTED',
  /** 환불 완료 (파트너 승인 후, 실제 고객에게 환불 처리까지 완료) */
  RefundComplete = 'REFUND_COMPLETE',
  /** 환불 요청 (파트너 승인 전) */
  RequestRefund = 'REQUEST_REFUND',
  /** 결제 취소 대기중 */
  WaitingForCancellation = 'WAITING_FOR_CANCELLATION'
}

export enum CapaPaymentMethodType {
  /** 신용카드 */
  CreditCard = 'CREDIT_CARD',
  /** 가상계좌 */
  VirtualAccount = 'VIRTUAL_ACCOUNT'
}

/** Payment status */
export enum CapaPaymentStatus {
  /** 나이스페이 콘솔에서 취소 */
  Cancelled = 'CANCELLED',
  /** 취소 실패 (파트너의 승인아래 환불하고자 했는데, 실패하는 경우) */
  CancelFailed = 'CANCEL_FAILED',
  /** 배송지 등록 완료 - 실제 api */
  Delivered = 'DELIVERED',
  /** 뭔가 좋지 않을 일... ex) 가상계좌를 발급했지만, 입금을 하지 않아 실패 처리되는 경우 */
  Failed = 'FAILED',
  /** 결제완료(신용계좌 결제 완료, 가상계좌 입금 완료) */
  Paid = 'PAID',
  /** 지급 대행 완료 */
  PayoutCompleted = 'PAYOUT_COMPLETED',
  /** 지급 대기중  */
  PayoutPending = 'PAYOUT_PENDING',
  PurchaseConfirmed = 'PURCHASE_CONFIRMED',
  /** 결제 대기(가상계좌 발급 후 입금 대기, 소액결제) */
  Ready = 'READY',
  /** 환불 성공 */
  Refunded = 'REFUNDED',
  /** 정산 완료 */
  Settled = 'SETTLED'
}

export type CapaPcbDetail = {
  __typename?: 'CAPAPcbDetail';
  /** 조립 파일 */
  assemblyFiles?: Maybe<Array<CapaQuotationRfqAssemblyFile>>;
  /** 조립 방식 */
  assemblyMethod?: Maybe<Array<CapaRfqPcbassemblyMethod>>;
  /** 조립 수량 */
  assemblyQuantity?: Maybe<Scalars['Float']>;
  /** 제작 파일 */
  fabricationFiles?: Maybe<Array<CapaQuotationRfqFabricationFile>>;
  /** 제작 수량 */
  fabricationQuantity?: Maybe<Scalars['Float']>;
  /** 자재 방법 */
  materialSupplyMethod?: Maybe<CapaRfqPcbMaterialSupplyMethodType>;
  /** 메탈마스크 제공 여부 */
  metalMaskAvailablity?: Maybe<Scalars['Boolean']>;
  /** 요청 작업 */
  services?: Maybe<Array<CapaPcbService>>;
};

export type CapaPcbService = {
  __typename?: 'CAPAPcbService';
  serviceType?: Maybe<CapaPcbServiceType>;
};

/** pcb service type */
export enum CapaPcbServiceType {
  /** 조립 */
  CircuitAssembly = 'CIRCUIT_ASSEMBLY',
  /** 설계 */
  CircuitDesign = 'CIRCUIT_DESIGN',
  /** 제작 */
  CircuitFabrication = 'CIRCUIT_FABRICATION'
}

export type CapaProjectManagementReceivedQuotation = {
  __typename?: 'CAPAProjectManagementReceivedQuotation';
  chatRoomId?: Maybe<Scalars['String']>;
  confirmCount?: Maybe<Scalars['Float']>;
  cost?: Maybe<Scalars['Float']>;
  createdAt?: Maybe<Scalars['String']>;
  deliveryCost?: Maybe<Scalars['Float']>;
  isAdjusted?: Maybe<Scalars['Boolean']>;
  organizationName?: Maybe<Scalars['String']>;
  partnerId?: Maybe<Scalars['String']>;
  profileId?: Maybe<Scalars['String']>;
  quotationId?: Maybe<Scalars['String']>;
  quotationPartnerStatus: CapaQuotationPartnerStatus;
  quotationType?: Maybe<CapaRfqQuotationType>;
  read?: Maybe<Scalars['Boolean']>;
  rfqId?: Maybe<Scalars['String']>;
};

export type CapaProjectManagementReceivedQuotationOutput = {
  __typename?: 'CAPAProjectManagementReceivedQuotationOutput';
  data?: Maybe<Array<CapaProjectManagementReceivedQuotation>>;
  /** errorMessage */
  errorMessage?: Maybe<Scalars['String']>;
  /** CAPA ERROR CODE */
  result: CapaErrorCode;
};

/** equipmentRfqfilter 정보 입력 */
export type CapaPromotionLinkInput = {
  capaBlogLink: Scalars['String'];
};

export type CapaPromotionModel = {
  __typename?: 'CAPAPromotionModel';
  capaBlogLink: Scalars['String'];
  id?: Maybe<Scalars['String']>;
  quotationPartnerId: Scalars['String'];
  status: CapaPromotionStatus;
};

export enum CapaPromotionStatus {
  Deleted = 'DELETED',
  Registered = 'REGISTERED'
}

/** CAPA PURCHASE ORDER STATUS */
export enum CapaPurchaseOrderStatus {
  /** 관리자 콘솔에서 취소 */
  CancelledByAdmin = 'CANCELLED_BY_ADMIN',
  /** 취소 확정 */
  CancelConfirmed = 'CANCEL_CONFIRMED',
  /** 취소 요청 */
  CancelRequested = 'CANCEL_REQUESTED',
  /** 결제 도입 전 발주서 */
  Created = 'CREATED',
  /** 가상계좌 미입금 취소 */
  NotPaidCanceled = 'NOT_PAID_CANCELED',
  /** 결제완료(신용계좌 결제 완료, 가상계좌 입금 완료) */
  Paid = 'PAID',
  /** 발주서가 처음에 생성되었을때 가지는 기본값.백엔드 내부에서 사용되는 상태값으로, 유저에게는 해당 상태를 가진 발주서가 노출되지 않습니다. */
  PaymentFailed = 'PAYMENT_FAILED',
  /** 제조중 */
  Processing = 'PROCESSING',
  /** 결제대기(가상계좌 발급 후 입금 대기, 소액결제) */
  ProcessPayment = 'PROCESS_PAYMENT',
  /** 구매확정 */
  PurchaseConfirmed = 'PURCHASE_CONFIRMED',
  /** 파트너와 고객 양방 승인하에 환불확정 */
  RefundConfirmed = 'REFUND_CONFIRMED',
  /** 환불요청 */
  RefundRequested = 'REFUND_REQUESTED',
  /** 파트너 일방 환불 */
  RejectOrderByPartner = 'REJECT_ORDER_BY_PARTNER',
  /** 배송중, capa에서 취급하는 배송중 */
  Shipping = 'SHIPPING'
}

export type CapaQuotatationAnnotation = {
  __typename?: 'CAPAQuotatationAnnotation';
  anchorPos?: Maybe<Capa3DPos>;
  chatRoomId?: Maybe<Scalars['String']>;
  comments?: Maybe<Array<CapaQuotationAnnotationComment>>;
  createdAt?: Maybe<Scalars['String']>;
  handlePos?: Maybe<Capa3DPos>;
  id?: Maybe<Scalars['String']>;
  isNew?: Maybe<Scalars['Boolean']>;
  nodeId?: Maybe<Scalars['Float']>;
  quotationSharedFileId?: Maybe<Scalars['String']>;
  status?: Maybe<CapaQuotationSharedFileAnnotationStatus>;
  updatedAt?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['String']>;
};

export type CapaQuotationActivity = {
  __typename?: 'CAPAQuotationActivity';
  complete?: Maybe<Scalars['Float']>;
  confirmed?: Maybe<Scalars['Float']>;
  reviewed?: Maybe<Scalars['Float']>;
};

export type CapaQuotationActivityOutput = {
  __typename?: 'CAPAQuotationActivityOutput';
  data?: Maybe<CapaQuotationActivity>;
  /** errorMessage */
  errorMessage?: Maybe<Scalars['String']>;
  /** CAPA ERROR CODE */
  result: CapaErrorCode;
};

export type CapaQuotationAnnotationComment = {
  __typename?: 'CAPAQuotationAnnotationComment';
  /** annotationId */
  annotationId?: Maybe<Scalars['String']>;
  comment?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['String']>;
  edited?: Maybe<Scalars['Boolean']>;
  /** capaFileId */
  fileId?: Maybe<Scalars['String']>;
  /** commentId */
  id?: Maybe<Scalars['String']>;
  isParent?: Maybe<Scalars['Boolean']>;
  status?: Maybe<CapaQuotationSharedFileAnnotationStatus>;
  updatedAt?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['String']>;
  userName?: Maybe<Scalars['String']>;
};

export type CapaQuotationAnnotationCommentMessage = {
  __typename?: 'CAPAQuotationAnnotationCommentMessage';
  annotation?: Maybe<CapaQuotationAnnotationComment>;
  messageType: CapaQuotationChatMessageType;
};

export type CapaQuotationAnnotationOutput = {
  __typename?: 'CAPAQuotationAnnotationOutput';
  data?: Maybe<CapaQuotatationAnnotation>;
  /** errorMessage */
  errorMessage?: Maybe<Scalars['String']>;
  /** CAPA ERROR CODE */
  result: CapaErrorCode;
};

export type CapaQuotationBypassMessage = {
  __typename?: 'CAPAQuotationBypassMessage';
  bypass?: Maybe<CapaQuotationBypassSendMessageTemplateModel>;
  messageType: CapaQuotationChatMessageType;
};

export type CapaQuotationBypassMessageDeleteMessage = {
  __typename?: 'CAPAQuotationBypassMessageDeleteMessage';
  /** chat room message id */
  id?: Maybe<Scalars['String']>;
  messageType: CapaQuotationChatMessageType;
};

export type CapaQuotationBypassSendMessageTemplateModel = {
  __typename?: 'CAPAQuotationBypassSendMessageTemplateModel';
  /** chat room message id */
  id?: Maybe<Scalars['String']>;
};

/** Capability 정보 입력 */
export type CapaQuotationCapabilityInput = {
  /** 캐파 견적 서비스 정보 입력 */
  services?: InputMaybe<Array<CapaQuotationServiceInput>>;
};

/** capability notification filter */
export type CapaQuotationCapabilityNotificationFilter = {
  __typename?: 'CAPAQuotationCapabilityNotificationFilter';
  detailedServices?: Maybe<Array<CapaQuotationDetailedServiceType>>;
  email?: Maybe<Scalars['Boolean']>;
  optionalServices?: Maybe<Array<CapaQuotationServiceType>>;
  push?: Maybe<Scalars['Boolean']>;
  service?: Maybe<CapaQuotationServiceType>;
  sms?: Maybe<Scalars['Boolean']>;
};

/** rfq notification for selected capability */
export type CapaQuotationCapabilityNotificationFilterInput = {
  detailedServices?: InputMaybe<Array<CapaQuotationDetailedServiceType>>;
  /** 이메일 수신 여부 */
  email?: InputMaybe<Scalars['Boolean']>;
  optionalServices?: InputMaybe<Array<CapaQuotationServiceType>>;
  /** Push Notification 수신 여부 */
  push?: InputMaybe<Scalars['Boolean']>;
  service?: InputMaybe<CapaQuotationServiceType>;
  /** 카카오 (실패시 SMS) 수신 여부 */
  sms?: InputMaybe<Scalars['Boolean']>;
};

export type CapaQuotationChatFile = {
  __typename?: 'CAPAQuotationChatFile';
  fileId?: Maybe<Scalars['String']>;
  fileName?: Maybe<Scalars['String']>;
  fileSize?: Maybe<Scalars['Float']>;
};

export type CapaQuotationChatMessage = {
  __typename?: 'CAPAQuotationChatMessage';
  chatFiles?: Maybe<Array<CapaQuotationChatFile>>;
  /** 생성일 */
  createdAt?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['ID']>;
  managerName?: Maybe<Scalars['String']>;
  message?: Maybe<CapaQuotationChatMessageUnion>;
  organizationName?: Maybe<Scalars['String']>;
  profileId?: Maybe<Scalars['String']>;
  senderId?: Maybe<Scalars['String']>;
  senderUserType?: Maybe<CapaQuotationUserType>;
  /** 상태값 */
  status?: Maybe<Scalars['String']>;
  /** 안읽은수 */
  unReadCount?: Maybe<Scalars['Float']>;
};

export type CapaQuotationChatMessageDetailedQuotation = {
  __typename?: 'CAPAQuotationChatMessageDetailedQuotation';
  messageType: CapaQuotationChatMessageType;
  quotation?: Maybe<CapaQuotationDetailedQuotation>;
};

export type CapaQuotationChatMessageMessage = {
  __typename?: 'CAPAQuotationChatMessageMessage';
  message?: Maybe<Scalars['String']>;
  messageType: CapaQuotationChatMessageType;
};

export type CapaQuotationChatMessageRfq = {
  __typename?: 'CAPAQuotationChatMessageRfq';
  messageType: CapaQuotationChatMessageType;
  rfq?: Maybe<CapaQuotationChatRfq>;
};

export type CapaQuotationChatMessageSimpleQuotation = {
  __typename?: 'CAPAQuotationChatMessageSimpleQuotation';
  messageType: CapaQuotationChatMessageType;
  quotation?: Maybe<CapaQuotationSimpleQuotation>;
};

export enum CapaQuotationChatMessageType {
  AdjustedPurchaseOrder = 'ADJUSTED_PURCHASE_ORDER',
  AdjustedQuotation = 'ADJUSTED_QUOTATION',
  AllowRequest = 'ALLOW_REQUEST',
  AllowResponse = 'ALLOW_RESPONSE',
  ApprovedPayment = 'APPROVED_PAYMENT',
  AwaitingPayment = 'AWAITING_PAYMENT',
  BypassDeleted = 'BYPASS_DELETED',
  BypassPrevention = 'BYPASS_PREVENTION',
  CancelConfirmed = 'CANCEL_CONFIRMED',
  CancelRequested = 'CANCEL_REQUESTED',
  ChatStart = 'CHAT_START',
  CompleteRequest = 'COMPLETE_REQUEST',
  ConfirmRequest = 'CONFIRM_REQUEST',
  DateDivider = 'DATE_DIVIDER',
  DelayedConfirmPurchase = 'DELAYED_CONFIRM_PURCHASE',
  Deleted = 'DELETED',
  DetailedQuotation = 'DETAILED_QUOTATION',
  FailedPayment = 'FAILED_PAYMENT',
  InduceConfirmPurchase = 'INDUCE_CONFIRM_PURCHASE',
  InducePurchaseOrderIssue = 'INDUCE_PURCHASE_ORDER_ISSUE',
  InduceQuotationRequest = 'INDUCE_QUOTATION_REQUEST',
  InduceRegisterTransactionReview = 'INDUCE_REGISTER_TRANSACTION_REVIEW',
  InduceRequestRegisterTransactionReview = 'INDUCE_REQUEST_REGISTER_TRANSACTION_REVIEW',
  IntroductionConsultingStart = 'INTRODUCTION_CONSULTING_START',
  Message = 'MESSAGE',
  PurchaseConfirmed = 'PURCHASE_CONFIRMED',
  PurchaseOrderAdjustRequest = 'PURCHASE_ORDER_ADJUST_REQUEST',
  PurchaseOrderAgreement = 'PURCHASE_ORDER_AGREEMENT',
  PurchaseOrderConsultingStart = 'PURCHASE_ORDER_CONSULTING_START',
  PurchaseOrderCreated = 'PURCHASE_ORDER_CREATED',
  PurchaseOrderRegisterRequest = 'PURCHASE_ORDER_REGISTER_REQUEST',
  QuitChatroomClient = 'QUIT_CHATROOM_CLIENT',
  QuitChatroomPartner = 'QUIT_CHATROOM_PARTNER',
  QuotationAdjustRequest = 'QUOTATION_ADJUST_REQUEST',
  QuotationAgreement = 'QUOTATION_AGREEMENT',
  QuotationAnnotationComment = 'QUOTATION_ANNOTATION_COMMENT',
  QuotationAnnotationReComment = 'QUOTATION_ANNOTATION_RE_COMMENT',
  QuotationConsultingStart = 'QUOTATION_CONSULTING_START',
  QuotationCreated = 'QUOTATION_CREATED',
  RefundConfirmed = 'REFUND_CONFIRMED',
  RefundRequested = 'REFUND_REQUESTED',
  RejectedPurchaseOrder = 'REJECTED_PURCHASE_ORDER',
  RejectRfqPurchaseOrder = 'REJECT_RFQ_PURCHASE_ORDER',
  RequestRegisterTransactionReview = 'REQUEST_REGISTER_TRANSACTION_REVIEW',
  RfqComplete = 'RFQ_COMPLETE',
  RfqConfirm = 'RFQ_CONFIRM',
  RfqExpirationConfirm = 'RFQ_EXPIRATION_CONFIRM',
  RfqQuotationRegisterRequest = 'RFQ_QUOTATION_REGISTER_REQUEST',
  RfqStopped = 'RFQ_STOPPED',
  SimpleQuotation = 'SIMPLE_QUOTATION',
  StartProcessing = 'START_PROCESSING',
  StartShipping = 'START_SHIPPING',
  System = 'SYSTEM',
  Withdraw = 'WITHDRAW'
}

export type CapaQuotationChatMessageUnion = CapaQuotationAnnotationCommentMessage | CapaQuotationBypassMessage | CapaQuotationBypassMessageDeleteMessage | CapaQuotationChatMessageDetailedQuotation | CapaQuotationChatMessageMessage | CapaQuotationChatMessageRfq | CapaQuotationChatMessageSimpleQuotation;

export type CapaQuotationChatMessagesOutput = {
  __typename?: 'CAPAQuotationChatMessagesOutput';
  data?: Maybe<Array<CapaQuotationChatMessage>>;
  /** errorMessage */
  errorMessage?: Maybe<Scalars['String']>;
  /** CAPA ERROR CODE */
  result: CapaErrorCode;
};

export type CapaQuotationChatRfq = {
  __typename?: 'CAPAQuotationChatRfq';
  adjustRequest?: Maybe<Scalars['String']>;
  event?: Maybe<CapaQuotationRfqEventType>;
  /** 지급 승인 (구매확정) 예정일 */
  expectedConfirmPurchaseDate?: Maybe<Scalars['Float']>;
  isSendRequest?: Maybe<Scalars['Boolean']>;
  isVisible?: Maybe<Scalars['Boolean']>;
  partnerManagerName?: Maybe<Scalars['String']>;
  partnerOrganizationName?: Maybe<Scalars['String']>;
  projectName?: Maybe<Scalars['String']>;
  /** 결제 대금 */
  purchaseAmount?: Maybe<Scalars['Float']>;
  purchaseOrderId?: Maybe<Scalars['String']>;
  quotationId?: Maybe<Scalars['String']>;
  rejectedReason?: Maybe<Scalars['String']>;
  rfqId?: Maybe<Scalars['String']>;
  userManagerName?: Maybe<Scalars['String']>;
  userOrganizationName?: Maybe<Scalars['String']>;
};

export type CapaQuotationChatRoom = {
  __typename?: 'CAPAQuotationChatRoom';
  chatFiles?: Maybe<Array<CapaQuotationChatFile>>;
  /** Legacy */
  chatMessages?: Maybe<Array<CapaQuotationChatMessage>>;
  /** Legacy */
  chatMessagesCount?: Maybe<Scalars['Float']>;
  chatRoomId?: Maybe<Scalars['String']>;
  chatRoomStatus?: Maybe<CapaQuotationChatRoomStatus>;
  /** 고객이 가장 최근 메세지 읽은 시간 */
  clientLastSeenAt?: Maybe<Scalars['String']>;
  clientStatus?: Maybe<CapaQuotationUserStatus>;
  /** 생성일 */
  createdAt?: Maybe<Scalars['String']>;
  /** 발주서 발행 여부 */
  hasPurchaseOrder?: Maybe<Scalars['Boolean']>;
  /** 견적서 발행 여부 */
  hasQuotation?: Maybe<Scalars['Boolean']>;
  /** 리뷰 작성 여부 */
  hasReview?: Maybe<Scalars['Boolean']>;
  /** old rfq 여부 */
  isOld?: Maybe<Scalars['Boolean']>;
  /** 발주서 확정 여부 */
  isPurchaseOrderConfirmed?: Maybe<Scalars['Boolean']>;
  /** 견적서 확정 여부 */
  isQuotationConfirmed?: Maybe<Scalars['Boolean']>;
  /** 가장 최근 메세지 읽은 시간 */
  partnerLastSeenAt?: Maybe<Scalars['String']>;
  partnerStatus?: Maybe<CapaQuotationPartnerUserStatus>;
  quotationPartnerId?: Maybe<Scalars['String']>;
  rfqId?: Maybe<Scalars['String']>;
  rfqStatus?: Maybe<CapaRfqStatus>;
  /** 수정일 */
  updatedAt?: Maybe<Scalars['String']>;
};

export type CapaQuotationChatRoomAnnotationComment = {
  __typename?: 'CAPAQuotationChatRoomAnnotationComment';
  annotationId?: Maybe<Scalars['String']>;
  commentUsers?: Maybe<Array<CommentUser>>;
  comments?: Maybe<Array<AnnotationComment>>;
  createdAt?: Maybe<Scalars['String']>;
  fileId?: Maybe<Scalars['String']>;
  fileName?: Maybe<Scalars['String']>;
  isNew?: Maybe<Scalars['Boolean']>;
  lastComment?: Maybe<Scalars['String']>;
  quotationSharedFileId?: Maybe<Scalars['String']>;
  status?: Maybe<CapaQuotationSharedFileAnnotationStatus>;
  updatedAt?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['String']>;
  userName?: Maybe<Scalars['String']>;
};

export type CapaQuotationChatRoomAnnotationCommentBo = {
  __typename?: 'CAPAQuotationChatRoomAnnotationCommentBO';
  annotationId?: Maybe<Scalars['String']>;
  commentUsers?: Maybe<Array<CommentUserBo>>;
  comments?: Maybe<Array<AnnotationCommentBo>>;
  createdAt?: Maybe<Scalars['String']>;
  fileId?: Maybe<Scalars['String']>;
  fileName?: Maybe<Scalars['String']>;
  lastComment?: Maybe<Scalars['String']>;
  quotationSharedFileId?: Maybe<Scalars['String']>;
  status?: Maybe<CapaQuotationSharedFileAnnotationStatus>;
  updatedAt?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['String']>;
};

export type CapaQuotationChatRoomAnnotationCommentsOutput = {
  __typename?: 'CAPAQuotationChatRoomAnnotationCommentsOutput';
  data?: Maybe<Array<CapaQuotationChatRoomAnnotationComment>>;
  /** errorMessage */
  errorMessage?: Maybe<Scalars['String']>;
  /** CAPA ERROR CODE */
  result: CapaErrorCode;
};

export type CapaQuotationChatRoomOutput = {
  __typename?: 'CAPAQuotationChatRoomOutput';
  data?: Maybe<CapaQuotationChatRoom>;
  /** errorMessage */
  errorMessage?: Maybe<Scalars['String']>;
  /** CAPA ERROR CODE */
  result: CapaErrorCode;
};

export type CapaQuotationChatRoomSharedFiles = {
  __typename?: 'CAPAQuotationChatRoomSharedFiles';
  annotationStatus?: Maybe<CapaQuotationChatRoomSharedFileAnnotationStatus>;
  fileId?: Maybe<Scalars['String']>;
  fileName?: Maybe<Scalars['String']>;
  quotationSharedFileId?: Maybe<Scalars['String']>;
  quotationSharedFileSize?: Maybe<Scalars['Float']>;
  quotationSharedFileType?: Maybe<CapaQuotationChatRoomSharedFileType>;
};

export type CapaQuotationChatRoomSharedFilesOutput = {
  __typename?: 'CAPAQuotationChatRoomSharedFilesOutput';
  data?: Maybe<Array<CapaQuotationChatRoomSharedFiles>>;
  /** errorMessage */
  errorMessage?: Maybe<Scalars['String']>;
  /** CAPA ERROR CODE */
  result: CapaErrorCode;
};

/** 챗룸 상태 */
export enum CapaQuotationChatRoomStatus {
  /** 고객이 채팅하기 시작 전에 파트너가 서비스 타입을 OFF하면서 채팅방을 모두 종료한 경우 */
  ClosedBeforeConsulting = 'CLOSED_BEFORE_CONSULTING',
  ClosedClient = 'CLOSED_CLIENT',
  ClosedConfirm = 'CLOSED_CONFIRM',
  ClosedPartner = 'CLOSED_PARTNER',
  /** 채팅방 오픈 상태 */
  Opened = 'OPENED',
  /** 채팅방에 파트너만 들어와있는 상태 */
  OpenedPartner = 'OPENED_PARTNER',
  /** 채팅방 종료 상태 */
  Stopped = 'STOPPED'
}

/** 채팅방 필터링 타입 */
export enum CapaQuotationChatRoomsFilterType {
  /** 발주 상담 상태 채팅방 */
  Confirmed = 'CONFIRMED',
  /** 견적 상담 상태 채팅방 */
  Consulting = 'CONSULTING',
  /** 기본 채팅방 */
  Default = 'DEFAULT'
}

export type CapaQuotationChatRoomsTotalCount = {
  __typename?: 'CAPAQuotationChatRoomsTotalCount';
  /** 캐파 서비스 */
  capaService?: Maybe<CapaServiceType>;
  /** 채팅방의 개수 */
  totalCount: Scalars['Float'];
};

export type CapaQuotationCreatePurchaseOrder = {
  __typename?: 'CAPAQuotationCreatePurchaseOrder';
  purchaseOrderId: Scalars['String'];
};

export type CapaQuotationCreatePurchaseOrderOutput = {
  __typename?: 'CAPAQuotationCreatePurchaseOrderOutput';
  data?: Maybe<CapaQuotationCreatePurchaseOrder>;
  /** errorMessage */
  errorMessage?: Maybe<Scalars['String']>;
  /** CAPA ERROR CODE */
  result: CapaErrorCode;
};

export type CapaQuotationDetailedMaterial = {
  __typename?: 'CAPAQuotationDetailedMaterial';
  detailedMaterials?: Maybe<Array<CapaQuotationDetailedMaterialType>>;
  material?: Maybe<CapaQuotationMaterial>;
};

/** 세부 재료 */
export enum CapaQuotationDetailedMaterialType {
  /** ABS */
  Abs = 'ABS',
  /** 아세탈 (POM) */
  AcetalPom = 'ACETAL_POM',
  /** 아크릴 (Acrylic) */
  Acryl = 'ACRYL',
  /** 2024-T3 */
  Aluminum_2024T3 = 'ALUMINUM_2024_T3',
  /** 6061-T6 */
  Aluminum_6061T6 = 'ALUMINUM_6061_T6',
  /** 6063 */
  Aluminum_6063 = 'ALUMINUM_6063',
  /** 7050 */
  Aluminum_7050 = 'ALUMINUM_7050',
  /** 7075-T6 */
  Aluminum_7075T6 = 'ALUMINUM_7075_T6',
  /** 7075-T7351 */
  Aluminum_7075T7351 = 'ALUMINUM_7075_T7351',
  /** 알루미늄 합금 */
  AluminumAlloy = 'ALUMINUM_ALLOY',
  /** MIC-6 */
  AluminumMic_6 = 'ALUMINUM_MIC_6',
  /** ASA */
  Asa = 'ASA',
  /** 베이클라이트(Bakelite) */
  Bakelite = 'BAKELITE',
  /** Copper 101 */
  Copper_101 = 'COPPER_101',
  /** Copper 260(Brass) */
  Copper_260Brass = 'COPPER_260_BRASS',
  /** Copper C110 */
  CopperC110 = 'COPPER_C110',
  /** Copper C360(Brass) */
  CopperC360Brass = 'COPPER_C360_BRASS',
  /** Copper C932(Bronze) */
  CopperC932Bronze = 'COPPER_C932_BRONZE',
  /** 기타(직접입력) */
  Etc = 'ETC',
  /** 일반 황동 */
  GeneralBrass = 'GENERAL_BRASS',
  /** 일반 청동 */
  GeneralBronze = 'GENERAL_BRONZE',
  /** HDPE */
  Hdpe = 'HDPE',
  /** LDPE */
  Ldpe = 'LDPE',
  /** 마그네슘 합금 */
  MagnesiumAlloy = 'MAGNESIUM_ALLOY',
  /** MC Nylon */
  McNylon = 'MC_NYLON',
  /** MC Nylon 66 */
  McNylon_66 = 'MC_NYLON_66',
  /** Nylon(PA 나일론) */
  NylonPa = 'NYLON_PA',
  /** PBT */
  Pbt = 'PBT',
  /** 폴리카보네이트 (PC) */
  Pc = 'PC',
  /** 트라이탄 (PCT) */
  Pct = 'PCT',
  /** 폴리에틸렌 (PE) */
  Pe = 'PE',
  /** PEEK */
  Peek = 'PEEK',
  /** PEI */
  Pei = 'PEI',
  /** PET */
  Pet = 'PET',
  /** PMMA */
  Pmma = 'PMMA',
  /** 폴리프로필렌 (PP) */
  Pp = 'PP',
  /** 폴리스티렌(PS) */
  Ps = 'PS',
  /** PVC */
  Pvc = 'PVC',
  /** 파트너 추천이 필요합니다 */
  Recommend = 'RECOMMEND',
  /** S10C(SM10C) */
  S10CSm10C = 'S10C_SM10C',
  /** S15C(SM15C) */
  S15CSm15C = 'S15C_SM15C',
  /** S20C(SM20C) */
  S20CSm20C = 'S20C_SM20C',
  /** S25C(SM25C) */
  S25CSm25C = 'S25C_SM25C',
  /** S30C(SM30C) */
  S30CSm30C = 'S30C_SM30C',
  /** S35C(SM35C) */
  S35CSm35C = 'S35C_SM35C',
  /** S40C(SM40C) */
  S40CSm40C = 'S40C_SM40C',
  /** S45C(SM45C) */
  S45CSm45C = 'S45C_SM45C',
  /** S50C(SM50C) */
  S50CSm50C = 'S50C_SM50C',
  /** S55C(SM55C) */
  S55CSm55C = 'S55C_SM55C',
  /** SCM415 */
  Scm_415 = 'SCM_415',
  /** SCM420 */
  Scm_420 = 'SCM_420',
  /** SCM440 */
  Scm_440 = 'SCM_440',
  /** SS 15-5 */
  Ss15_5 = 'SS15_5',
  /** SS 17-4 */
  Ss17_4 = 'SS17_4',
  /** SS 18-8 */
  Ss18_8 = 'SS18_8',
  /** SS 235(SS 330) */
  Ss235Ss330 = 'SS235_SS330',
  /** SS 275(SS 400) */
  Ss275Ss400 = 'SS275_SS400',
  /** SS 303 */
  Ss303 = 'SS303',
  /** SS 304 */
  Ss304 = 'SS304',
  /** SS 315(SS 490) */
  Ss315Ss490 = 'SS315_SS490',
  /** SS 316/316L */
  Ss316Ss316L = 'SS316_SS316L',
  /** SS 410(SS 540) */
  Ss410Ss540 = 'SS410_SS540',
  /** SS 416 */
  Ss416 = 'SS416',
  /** SS 420 */
  Ss420 = 'SS420',
  /** SS 450(SS 590) */
  Ss450Ss590 = 'SS450_SS590',
  /** SS 550 */
  Ss550 = 'SS550',
  /** 테플론 (PTFE) */
  Teflon = 'TEFLON',
  /** TPE */
  Tpe = 'TPE',
  /** TPU */
  Tpu = 'TPU',
  /** 아연 합금 */
  ZincAlloy = 'ZINC_ALLOY'
}

export type CapaQuotationDetailedPcbAssemblyItem = {
  __typename?: 'CAPAQuotationDetailedPcbAssemblyItem';
  /** 총액 */
  cost: Scalars['Float'];
  /** 기타 */
  etc?: Maybe<Scalars['String']>;
  /** fileId */
  fileId?: Maybe<Scalars['String']>;
  /** BOM FILE 이름 */
  fileName?: Maybe<Scalars['String']>;
  /** 수량 */
  quantity: Scalars['Float'];
};

export type CapaQuotationDetailedPcbAssemblyItemInput = {
  /** 총액 */
  cost: Scalars['Float'];
  /** 기타 */
  etc?: InputMaybe<Scalars['String']>;
  /** fileId */
  fileId?: InputMaybe<Scalars['String']>;
  /** BOM FILE 이름 */
  fileName?: InputMaybe<Scalars['String']>;
  /** 수량 */
  quantity: Scalars['Float'];
};

export type CapaQuotationDetailedPcbFabricationItem = {
  __typename?: 'CAPAQuotationDetailedPcbFabricationItem';
  /** 총액 */
  cost: Scalars['Float'];
  /** 기타 */
  etc?: Maybe<Scalars['String']>;
  /** fileId */
  fileId?: Maybe<Scalars['String']>;
  /** GERBER FILE 이름 */
  fileName?: Maybe<Scalars['String']>;
  /** 수량 */
  quantity: Scalars['Float'];
  /** 두께 */
  thickness?: Maybe<Scalars['Float']>;
};

export type CapaQuotationDetailedPcbFabricationItemInput = {
  /** 총액 */
  cost: Scalars['Float'];
  /** 기타 */
  etc?: InputMaybe<Scalars['String']>;
  /** fileId */
  fileId?: InputMaybe<Scalars['String']>;
  /** GERBER FILE 이름 */
  fileName?: InputMaybe<Scalars['String']>;
  /** 수량 */
  quantity: Scalars['Float'];
  /** 두께 */
  thickness?: InputMaybe<Scalars['Float']>;
};

export type CapaQuotationDetailedQuotation = {
  __typename?: 'CAPAQuotationDetailedQuotation';
  /** 수정 요청서 읽음 및 내용 */
  adjustRequest?: Maybe<CapaRfqAdjustRequestObject>;
  chatRoomId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['String']>;
  /** 배송비 */
  deliveryCost?: Maybe<Scalars['Float']>;
  design?: Maybe<CapaDesignDetail>;
  /** 수정 범위 및 추가 과금 기준 */
  draftModificationTerms?: Maybe<Scalars['String']>;
  /** 납품 가능일 */
  dueDate?: Maybe<Scalars['String']>;
  /** 견적 설명 */
  etc?: Maybe<Scalars['String']>;
  /** 배송비 포함여부 */
  excludeDeliveryFee?: Maybe<Scalars['Boolean']>;
  /** 견적서 유효기간 */
  expiration?: Maybe<Scalars['String']>;
  /** rfq quotation id */
  id: Scalars['String'];
  /** 가견적 여부 */
  isBeforeConsulting?: Maybe<Scalars['Boolean']>;
  /** 견적서 확정 */
  isConfirmed?: Maybe<Scalars['Boolean']>;
  items?: Maybe<Array<CapaQuotationDetailedQuotationItem>>;
  /** 가장 최신 여부 */
  latest?: Maybe<Scalars['Boolean']>;
  /** 최대 시안 수정 횟수 */
  maxDraftModificationCount?: Maybe<Scalars['Float']>;
  optionalServices?: Maybe<Array<CapaQuotationRfqQuotationOptionalService>>;
  pcb?: Maybe<CapaPcbDetail>;
  pcbAssemblyItems?: Maybe<Array<CapaQuotationDetailedPcbAssemblyItem>>;
  pcbFabricationItems?: Maybe<Array<CapaQuotationDetailedPcbFabricationItem>>;
  projectName?: Maybe<Scalars['String']>;
  /** 발행 정보 */
  publish?: Maybe<CapaQuotationDetailedQuotationPublish>;
  /** 공급가액 */
  quotation?: Maybe<Scalars['Float']>;
  read?: Maybe<Scalars['Boolean']>;
  rfqId: Scalars['String'];
  serviceType?: Maybe<CapaQuotationServiceType>;
  /** 공급자 정보 */
  supply?: Maybe<CapaQuotationDetailedQuotationSupply>;
  type: CapaRfqQuotationType;
};

export type CapaQuotationDetailedQuotationItem = {
  __typename?: 'CAPAQuotationDetailedQuotationItem';
  /** 총액 */
  cost: Scalars['Float'];
  /** 견적 설명 */
  etc?: Maybe<Scalars['String']>;
  fileId?: Maybe<Scalars['String']>;
  /** 재료 이름 */
  fileName?: Maybe<Scalars['String']>;
  material?: Maybe<Scalars['String']>;
  /** 수량 */
  quantity: Scalars['Float'];
};

export type CapaQuotationDetailedQuotationItemInput = {
  /** 총액 */
  cost: Scalars['Float'];
  etc?: InputMaybe<Scalars['String']>;
  fileId?: InputMaybe<Scalars['String']>;
  fileName?: InputMaybe<Scalars['String']>;
  material?: InputMaybe<Scalars['String']>;
  quantity: Scalars['Float'];
};

export type CapaQuotationDetailedQuotationOutput = {
  __typename?: 'CAPAQuotationDetailedQuotationOutput';
  data?: Maybe<CapaQuotationDetailedQuotation>;
  /** errorMessage */
  errorMessage?: Maybe<Scalars['String']>;
  /** CAPA ERROR CODE */
  result: CapaErrorCode;
};

/** 조립 견적 정보 */
export type CapaQuotationDetailedQuotationPcbAssemblyItemInput = {
  /** 총액 */
  cost: Scalars['Float'];
  etc?: InputMaybe<Scalars['String']>;
  fileId?: InputMaybe<Scalars['String']>;
  fileName?: InputMaybe<Scalars['String']>;
  quantity: Scalars['Float'];
};

/** 제작 견정 정보 Item */
export type CapaQuotationDetailedQuotationPcbFabricationItemInput = {
  /** 총액 */
  cost: Scalars['Float'];
  etc?: InputMaybe<Scalars['String']>;
  fileId?: InputMaybe<Scalars['String']>;
  fileName?: InputMaybe<Scalars['String']>;
  quantity: Scalars['Float'];
  /** 두께 */
  thickness?: InputMaybe<Scalars['Float']>;
};

export type CapaQuotationDetailedQuotationPublish = {
  __typename?: 'CAPAQuotationDetailedQuotationPublish';
  /** 고객 담당자명 */
  managerName?: Maybe<Scalars['String']>;
  /** 고객 회사명 */
  organizationName?: Maybe<Scalars['String']>;
  /** 고객 상태 */
  quotationUserStatus?: Maybe<CapaQuotationUserStatus>;
};

export type CapaQuotationDetailedQuotationSupply = {
  __typename?: 'CAPAQuotationDetailedQuotationSupply';
  address?: Maybe<Scalars['String']>;
  companyRegistrationNumber?: Maybe<Scalars['Float']>;
  email?: Maybe<Scalars['String']>;
  /** 담당자명 */
  managerName?: Maybe<Scalars['String']>;
  /** 파트너 회사명 */
  organizationName?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  quotationPartnerId: Scalars['String'];
  quotationPartnerStatus?: Maybe<CapaQuotationPartnerStatus>;
};

export type CapaQuotationDetailedQuotationsOutput = {
  __typename?: 'CAPAQuotationDetailedQuotationsOutput';
  data?: Maybe<Array<CapaQuotationDetailedQuotation>>;
  /** errorMessage */
  errorMessage?: Maybe<Scalars['String']>;
  /** CAPA ERROR CODE */
  result: CapaErrorCode;
};

export type CapaQuotationDetailedService = {
  __typename?: 'CAPAQuotationDetailedService';
  materials?: Maybe<Array<CapaQuotationDetailedMaterial>>;
  type?: Maybe<CapaQuotationDetailedServiceType>;
};

/** 캐파 견적 상세 서비스 정보 입력 */
export type CapaQuotationDetailedServiceInput = {
  /** 재료 정보 입력 */
  materials?: InputMaybe<Array<CapaQuotationMaterialInput>>;
  /** 캐파 견적 상세 서비스 타입 */
  type?: InputMaybe<CapaQuotationDetailedServiceType>;
};

/** 캐파 견적 상세 서비스 타입 */
export enum CapaQuotationDetailedServiceType {
  /** 블로우 사출 (Blow Injection Molding) */
  BlowInjectionMolding = 'BLOW_INJECTION_MOLDING',
  /** 원심 주조(Centrifugal Casting) */
  CentrifugalCasting = 'CENTRIFUGAL_CASTING',
  CircuitAssembly = 'CIRCUIT_ASSEMBLY',
  CircuitDesign = 'CIRCUIT_DESIGN',
  CircuitFabrication = 'CIRCUIT_FABRICATION',
  /** 다이캐스팅(Die Casting) */
  DieCasting = 'DIE_CASTING',
  /** 이중 사출 (Double-Shot Injection Molding) */
  DoubleShotInjectionMolding = 'DOUBLE_SHOT_INJECTION_MOLDING',
  /** 드릴링 (Drilling) */
  Drilling = 'DRILLING',
  Etc = 'ETC',
  /** FDM */
  Fdm = 'FDM',
  /** 일반 사출 (Injection Molding) */
  InjectionMolding = 'INJECTION_MOLDING',
  /** 인서트 사출 (Insert Injection Molding) */
  InsertInjectionMolding = 'INSERT_INJECTION_MOLDING',
  /** 인베스트먼트 주조 (Investment Casting) */
  InvestmentCasting = 'INVESTMENT_CASTING',
  /** 레이저 컷팅 (Laser Cutting) */
  LaserCutting = 'LASER_CUTTING',
  /** 머시닝 센터 (Machining Center) */
  MachiningCenter = 'MACHINING_CENTER',
  MechanicalDesign = 'MECHANICAL_DESIGN',
  /** 밀링 (Milling) */
  Milling = 'MILLING',
  /** MJF */
  Mjf = 'MJF',
  /** Polyjet */
  Polyjet = 'POLYJET',
  /** 프레스 (Press) */
  Press = 'PRESS',
  ProductDesign = 'PRODUCT_DESIGN',
  Prototyping = 'PROTOTYPING',
  Recommend = 'RECOMMEND',
  /** 사형 주조 (Sand Casting) */
  SandCasting = 'SAND_CASTING',
  /** 쉘 주조 (Shell Moulding) */
  ShellCasting = 'SHELL_CASTING',
  /** SLA */
  Sla = 'SLA',
  /** SLM/DMLS */
  SlmDmls = 'SLM_DMLS',
  /** SLS */
  Sls = 'SLS',
  /** 선반 (Turning) */
  Turning = 'TURNING',
  /** 워터젯 컷팅 (Waterjet Cutting) */
  WaterjetCutting = 'WATERJET_CUTTING'
}

/** 재료 */
export enum CapaQuotationMaterial {
  /** ABS(산업용) */
  AbsIndustrial = 'ABS_INDUSTRIAL',
  /** 알루미늄 (Aluminum */
  Aluminum = 'ALUMINUM',
  /** 알루미늄 합금 (Aluminum Alloy) */
  AluminumAlloy = 'ALUMINUM_ALLOY',
  /** 황동 (Brass) */
  Brass = 'BRASS',
  /** 청동 (Bronze) */
  Bronze = 'BRONZE',
  /** 탄소강 (Carbon Steel) */
  CarbonSteel = 'CARBON_STEEL',
  /** 구리 (Copper) */
  Copper = 'COPPER',
  /** 동 합금 (Copper Alloy) */
  CopperAlloy = 'COPPER_ALLOY',
  /** 기타(직접입력) */
  Etc = 'ETC',
  /** 아연 강 (Galvanized Steel)) */
  GalvanizedSteel = 'GALVANIZED_STEEL',
  /** 주철 (Iron) */
  Iron = 'IRON',
  /** 마그네슘 합금 (Magnesium Alloy) */
  MagnesiumAlloy = 'MAGNESIUM_ALLOY',
  /** 금속 (Metal) */
  MetalInj = 'METAL_INJ',
  /** PA12 */
  Pa12 = 'PA12',
  /** PLA */
  Pla = 'PLA',
  /** 플라스틱 (Plastic) */
  Plastic = 'PLASTIC',
  /** 파트너 추천이 필요합니다 */
  Recommend = 'RECOMMEND',
  /** 레진 (반투명) */
  ResinTranslucent = 'RESIN_TRANSLUCENT',
  /** 레진 (투명) */
  ResinTransparent = 'RESIN_TRANSPARENT',
  /** 레진 (흰색) */
  ResinWhite = 'RESIN_WHITE',
  /** 고무 유사 */
  RubberLike = 'RUBBER_LIKE',
  /** 스테인리스 강(Stainless Steel) */
  StainlessSteel = 'STAINLESS_STEEL',
  /** 강철 (Steel) */
  Steel = 'STEEL',
  /** 합금강 (Steel Alloy) */
  SteelAlloy = 'STEEL_ALLOY',
  /** 주강 (Steel) */
  SteelCasting = 'STEEL_CASTING',
  /** Vero (멀티 컬러) */
  Vero = 'VERO',
  /** 아연 합금 (Zinc Alloy) */
  ZincAlloy = 'ZINC_ALLOY'
}

/** 재료 정보 입력 */
export type CapaQuotationMaterialInput = {
  /** 세부 재료 */
  detailedMaterials?: InputMaybe<Array<CapaQuotationDetailedMaterialType>>;
  /** 재료 */
  material?: InputMaybe<CapaQuotationMaterial>;
};

export type CapaQuotationMessaegeSearch = {
  __typename?: 'CAPAQuotationMessaegeSearch';
  createdAt?: Maybe<Scalars['String']>;
  eventType?: Maybe<CapaQuotationRfqEventType>;
  managerName?: Maybe<Scalars['String']>;
  message?: Maybe<CapaQuotationChatMessageUnion>;
  profileId?: Maybe<Scalars['String']>;
  projectName?: Maybe<Scalars['String']>;
  rfqId?: Maybe<Scalars['String']>;
};

export type CapaQuotationMyReceivedQuotation = {
  __typename?: 'CAPAQuotationMyReceivedQuotation';
  chatRoomCreatedAt?: Maybe<Scalars['String']>;
  chatRoomId?: Maybe<Scalars['String']>;
  chatRoomStatus?: Maybe<CapaQuotationChatRoomStatus>;
  confirmCount?: Maybe<Scalars['Float']>;
  cost?: Maybe<Scalars['Float']>;
  createdAt?: Maybe<Scalars['String']>;
  deliveryCost?: Maybe<Scalars['Float']>;
  /** 수정된 견적서 여부 */
  isAdjusted?: Maybe<Scalars['Boolean']>;
  /** 가견적 여부 : 채팅방 OPENED 로 변경되기 전에 작성된 견적서 판별. OPENED 이전에 작성된 경우 true */
  isBeforeConsulting?: Maybe<Scalars['Boolean']>;
  /** 발주서(업체 확정) 발행 여부 */
  isTransaction?: Maybe<Scalars['Boolean']>;
  organizationName?: Maybe<Scalars['String']>;
  partnerId?: Maybe<Scalars['String']>;
  profileId?: Maybe<Scalars['String']>;
  quotationId?: Maybe<Scalars['String']>;
  /** 견적서를 보낸 파트너의 상태 */
  quotationPartnerStatus?: Maybe<CapaQuotationPartnerStatus>;
  quotationType?: Maybe<CapaRfqQuotationType>;
  read?: Maybe<Scalars['Boolean']>;
  rfqId?: Maybe<Scalars['String']>;
  /** 특정 rfq가 파트너로부터 수령한 것 */
  rfqReceivedType?: Maybe<CapaRfqReceivedType>;
};

export type CapaQuotationMyReceivedQuotationsOutput = {
  __typename?: 'CAPAQuotationMyReceivedQuotationsOutput';
  data?: Maybe<Array<CapaQuotationMyReceivedQuotation>>;
  /** errorMessage */
  errorMessage?: Maybe<Scalars['String']>;
  /** CAPA ERROR CODE */
  result: CapaErrorCode;
};

export type CapaQuotationMyRfqReview = {
  __typename?: 'CAPAQuotationMyRfqReview';
  createdAt?: Maybe<Scalars['String']>;
  dueDate?: Maybe<Scalars['Float']>;
  organizationName?: Maybe<Scalars['String']>;
  privateComment?: Maybe<Scalars['String']>;
  projectName?: Maybe<Scalars['String']>;
  publicComment?: Maybe<Scalars['String']>;
  quality?: Maybe<Scalars['Float']>;
  repliedAt?: Maybe<Scalars['String']>;
  replyComment?: Maybe<Scalars['String']>;
  rfqId: Scalars['String'];
  serviceType?: Maybe<CapaQuotationServiceType>;
  thumbnailId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['String']>;
};

export type CapaQuotationMyRfqReviewOutput = {
  __typename?: 'CAPAQuotationMyRfqReviewOutput';
  data?: Maybe<Array<CapaQuotationMyRfqReview>>;
  /** errorMessage */
  errorMessage?: Maybe<Scalars['String']>;
  /** CAPA ERROR CODE */
  result: CapaErrorCode;
};

export type CapaQuotationOptionalService = {
  __typename?: 'CAPAQuotationOptionalService';
  quantity?: Maybe<Scalars['Float']>;
  serviceType?: Maybe<CapaQuotationServiceType>;
};

export type CapaQuotationPartner = {
  __typename?: 'CAPAQuotationPartner';
  capabilities: CapaQuotationPartnerCapability;
  companyIntroduction?: Maybe<Scalars['String']>;
  companyRegistrationNumber: Scalars['String'];
  contact: Scalars['String'];
  /** 생성일 */
  createdAt: Scalars['String'];
  department?: Maybe<Scalars['String']>;
  email: Scalars['String'];
  equipment?: Maybe<Scalars['String']>;
  /** 파트너 업로드 파일 */
  files?: Maybe<Array<CapaQuotationPartnerFile>>;
  foundedIn?: Maybe<Scalars['String']>;
  fullAddress: Scalars['String'];
  id: Scalars['ID'];
  /** ITP 대상 여부 */
  isItp: Scalars['Boolean'];
  managerName: Scalars['String'];
  notificationFilter: CapaQuotationPartnerNotificationFilter;
  numberEmployees?: Maybe<Scalars['String']>;
  organizationName: Scalars['String'];
  position?: Maybe<Scalars['String']>;
  /** [필수] 개인정보 수집 및 활용 동의 */
  privacyAgreed?: Maybe<Scalars['Boolean']>;
  /** [선택] 프로모션 정보 수신 동의 */
  promotionAgreed?: Maybe<Scalars['Boolean']>;
  /** 추천인 ID */
  referralUserId?: Maybe<Scalars['String']>;
  rfqFilter?: Maybe<Scalars['String']>;
  /** [필수] 캐파 서비스 이용약관 동의 */
  serviceAgreed?: Maybe<Scalars['Boolean']>;
  serviceHours?: Maybe<Scalars['String']>;
  shortAddress: Scalars['String'];
  status: CapaQuotationPartnerStatus;
  /** 수정일 */
  updatedAt: Scalars['String'];
  website?: Maybe<Scalars['String']>;
};

export type CapaQuotationPartnerAvailableRequestReview = {
  __typename?: 'CAPAQuotationPartnerAvailableRequestReview';
  chatRoomId: Scalars['String'];
  isSendRequest?: Maybe<Scalars['Boolean']>;
  managerName: Scalars['String'];
  organizationName: Scalars['String'];
  projectName: Scalars['String'];
  /** 발주 완료일 */
  purchaseOrderCreatedAt?: Maybe<Scalars['String']>;
  purchaseOrderValue: Scalars['Float'];
  /** 파트너 유저 아이디 */
  quotationPartnerUserId: Scalars['String'];
  rfqId: Scalars['String'];
  serviceType?: Maybe<CapaQuotationServiceType>;
  thumbnailId?: Maybe<Scalars['String']>;
};

/** 파트너가 리뷰요청 가능한 목록 */
export type CapaQuotationPartnerAvailableRequestReviewsOutput = {
  __typename?: 'CAPAQuotationPartnerAvailableRequestReviewsOutput';
  data?: Maybe<Array<CapaQuotationPartnerAvailableRequestReview>>;
  /** errorMessage */
  errorMessage?: Maybe<Scalars['String']>;
  /** CAPA ERROR CODE */
  result: CapaErrorCode;
};

export type CapaQuotationPartnerBo = {
  __typename?: 'CAPAQuotationPartnerBO';
  capabilities: CapaQuotationPartnerCapability;
  companyIntroduction?: Maybe<Scalars['String']>;
  companyRegistrationNumber: Scalars['String'];
  contact: Scalars['String'];
  /** 생성일 */
  createdAt: Scalars['String'];
  department?: Maybe<Scalars['String']>;
  email: Scalars['String'];
  equipment?: Maybe<Scalars['String']>;
  /** 파트너 업로드 파일 */
  files?: Maybe<Array<CapaQuotationPartnerFile>>;
  foundedIn?: Maybe<Scalars['String']>;
  fullAddress: Scalars['String'];
  id: Scalars['ID'];
  /** CAPA 서비스를 어떻게 알게 되셨나요? (복수 선택 가능) */
  inflowRoute?: Maybe<Array<CapaInflowRoute>>;
  /** ITP 대상 여부 */
  isItp: Scalars['Boolean'];
  managerName: Scalars['String'];
  notificationFilter: CapaQuotationPartnerNotificationFilter;
  numberEmployees?: Maybe<Scalars['String']>;
  organizationName: Scalars['String'];
  position?: Maybe<Scalars['String']>;
  /** [필수] 개인정보 수집 및 활용 동의 */
  privacyAgreed?: Maybe<Scalars['Boolean']>;
  /** [선택] 프로모션 정보 수신 동의 */
  promotionAgreed?: Maybe<Scalars['Boolean']>;
  /** 추천인 ID */
  referralUserId?: Maybe<Scalars['String']>;
  rfqFilter?: Maybe<Scalars['String']>;
  /** [필수] 캐파 서비스 이용약관 동의 */
  serviceAgreed?: Maybe<Scalars['Boolean']>;
  serviceHours?: Maybe<Scalars['String']>;
  shortAddress: Scalars['String'];
  status: CapaQuotationPartnerStatus;
  /** 수정일 */
  updatedAt: Scalars['String'];
  website?: Maybe<Scalars['String']>;
  /** 탈퇴 사유 */
  withdrawnReason?: Maybe<CapaWithdrawnQuotationPartnerReason>;
};

export type CapaQuotationPartnerCapability = {
  __typename?: 'CAPAQuotationPartnerCapability';
  services?: Maybe<Array<CapaQuotationService>>;
};

/** 캐파 견적 파트너가 보는 채팅방룸 */
export type CapaQuotationPartnerChatRoom = {
  __typename?: 'CAPAQuotationPartnerChatRoom';
  chatRoomId: Scalars['String'];
  chatRoomStatus: CapaQuotationChatRoomStatus;
  createdAt?: Maybe<Scalars['String']>;
  detailedServiceType?: Maybe<CapaQuotationDetailedServiceType>;
  lastMessage?: Maybe<CapaQuotationChatMessageUnion>;
  managerName?: Maybe<Scalars['String']>;
  organizationName?: Maybe<Scalars['String']>;
  profileId?: Maybe<Scalars['String']>;
  projectName: Scalars['String'];
  quotaionUserId: Scalars['String'];
  quotationUserStatus: CapaQuotationUserStatus;
  rfqId: Scalars['String'];
  rfqStatus: CapaRfqStatus;
  serviceType: CapaQuotationServiceType;
  thumbnailId?: Maybe<Scalars['String']>;
  /** 안읽은수 */
  unReadCount?: Maybe<Scalars['Float']>;
};

export type CapaQuotationPartnerChatRooms = {
  __typename?: 'CAPAQuotationPartnerChatRooms';
  chatRooms?: Maybe<Array<CapaQuotationPartnerChatRoom>>;
  count: Scalars['Float'];
  /** 읽지 않은 메세지 수 */
  totalUnReadMessagesCount?: Maybe<Array<CapaQuotationPartnerUnReadMessagesCount>>;
};

/** 캐파 견적 파트너가 보는 채팅방 chatRooms Output */
export type CapaQuotationPartnerChatRoomsOutput = {
  __typename?: 'CAPAQuotationPartnerChatRoomsOutput';
  data?: Maybe<CapaQuotationPartnerChatRooms>;
  /** errorMessage */
  errorMessage?: Maybe<Scalars['String']>;
  /** CAPA ERROR CODE */
  result: CapaErrorCode;
};

/** CAPAQuotationPartnerEquipment */
export type CapaQuotationPartnerEquipment = {
  __typename?: 'CAPAQuotationPartnerEquipment';
  /** 생성 날짜 */
  createdAt?: Maybe<Scalars['String']>;
  /** 상세 정보 */
  description?: Maybe<Scalars['String']>;
  /** 장비명 */
  equipmentName: Scalars['String'];
  /** 파트너 파일 업로드 정보 입력 */
  file?: Maybe<CapaQuotationPartnerStrategyFile>;
  /** id */
  id: Scalars['String'];
  /** 수량 */
  quantity: Scalars['Float'];
};

export type CapaQuotationPartnerFile = {
  __typename?: 'CAPAQuotationPartnerFile';
  fileId?: Maybe<Scalars['ID']>;
  fileName?: Maybe<Scalars['String']>;
  fileType?: Maybe<CapaQuotationPartnerFileType>;
};

/** 파트너 파일 타입 */
export enum CapaQuotationPartnerFileType {
  /** 커버 이미지 */
  ImageCover = 'IMAGE_COVER',
  /** 회사 로고 */
  Logo = 'LOGO',
  /** 파트너 파일 및 동영상 */
  PartnerFile = 'PARTNER_FILE',
  /** 포트폴리오 파일 */
  PortfolioFile = 'PORTFOLIO_FILE',
  /** 포트폴리오 이미지 */
  PortfolioImage = 'PORTFOLIO_IMAGE',
  /** 사업자 등록증 */
  Registration = 'REGISTRATION'
}

/** CAPAQuotationPartnerGNB */
export type CapaQuotationPartnerGnb = {
  __typename?: 'CAPAQuotationPartnerGNB';
  /** 모든 채팅방 unread chat count */
  newChatCount: Scalars['Float'];
  /** 발주 상태 채팅방 unread chat count */
  newConfirmedChatCount: Scalars['Float'];
  /** 견적 상태 채팅방 unread chat count */
  newConsultingChatCount: Scalars['Float'];
  newProjectManagementCount: Scalars['Float'];
  /** 새로 들어온 rfq개수 */
  newRfqCount: Scalars['Float'];
};

/** CAPAQuotationPartnerGNBOutput */
export type CapaQuotationPartnerGnbOutput = {
  __typename?: 'CAPAQuotationPartnerGNBOutput';
  data?: Maybe<CapaQuotationPartnerGnb>;
  /** errorMessage */
  errorMessage?: Maybe<Scalars['String']>;
  /** CAPA ERROR CODE */
  result: CapaErrorCode;
};

/** 캐파 파트너 이미지 포토폴리오 타입 */
export enum CapaQuotationPartnerImagePortfolioProduceStepType {
  /** 대량 생산 */
  MassProduction = 'MASS_PRODUCTION',
  /** 시제품 제작 */
  Prototyping = 'PROTOTYPING',
  /** 소량 생산 */
  SmallProduction = 'SMALL_PRODUCTION'
}

/** notification filter */
export type CapaQuotationPartnerNotificationFilter = {
  __typename?: 'CAPAQuotationPartnerNotificationFilter';
  capabilityFilters?: Maybe<Array<CapaQuotationCapabilityNotificationFilter>>;
  chatEmail?: Maybe<Scalars['Boolean']>;
  chatPush?: Maybe<Scalars['Boolean']>;
  chatSMS?: Maybe<Scalars['Boolean']>;
  /** 방해금지 시간 */
  doNotDisturb?: Maybe<CapaDoNotDisturbFilter>;
  /** 캐파 소식 및 혜택 이메일 알림 */
  newsEmail?: Maybe<Scalars['Boolean']>;
  /** 캐파 소식 및 혜택 카카오 (실패시 SMS) 알림 */
  newsSMS?: Maybe<Scalars['Boolean']>;
  /** 프로젝트 이메일 알림 */
  projectEmail?: Maybe<Scalars['Boolean']>;
  /** 프로젝트 알림 설정 */
  projectFilters?: Maybe<Array<CapaRfqProjectFilter>>;
  /** 프로젝트 (Push) 알림 */
  projectPush?: Maybe<Scalars['Boolean']>;
  /** 프로젝트 카카오 (실패시 SMS) 알림 */
  projectSMS?: Maybe<Scalars['Boolean']>;
  rfqEmail?: Maybe<Scalars['Boolean']>;
  rfqPush?: Maybe<Scalars['Boolean']>;
  rfqSMS?: Maybe<Scalars['Boolean']>;
};

/** notification filter */
export type CapaQuotationPartnerNotificationFilterInput = {
  capabilityFilters?: InputMaybe<Array<CapaQuotationCapabilityNotificationFilterInput>>;
  /** email yes/no for new chat messages */
  chatEmail?: InputMaybe<Scalars['Boolean']>;
  /** push notification yes/no for new chat messages */
  chatPush?: InputMaybe<Scalars['Boolean']>;
  /** sms yes/no for new chat messages */
  chatSMS?: InputMaybe<Scalars['Boolean']>;
  /** 방해금지 시간 */
  doNotDisturb?: InputMaybe<CapaDoNotDisturbFilterInput>;
  /** 캐파 소식 및 혜택 이메일 알림 */
  newsEmail?: InputMaybe<Scalars['Boolean']>;
  /** 캐파 소식 및 혜택 카카오 (실패시 SMS) 알림 */
  newsSMS?: InputMaybe<Scalars['Boolean']>;
  /** 프로젝트 이메일 알림 */
  projectEmail?: InputMaybe<Scalars['Boolean']>;
  /** 프로젝트 알림 설정 */
  projectFilters?: InputMaybe<Array<CapaRfqProjectFilterInput>>;
  /** 프로젝트 Push 알림 */
  projectPush?: InputMaybe<Scalars['Boolean']>;
  /** 프로젝트 카카오 (실패시 SMS) 알림 */
  projectSMS?: InputMaybe<Scalars['Boolean']>;
  /** email yes/no for rfq registration for all capabilities */
  rfqEmail?: InputMaybe<Scalars['Boolean']>;
  /** push notification yes/no for rfq registration for all capabilities */
  rfqPush?: InputMaybe<Scalars['Boolean']>;
  /** sms yes/no for rfq registration for all capabilities */
  rfqSMS?: InputMaybe<Scalars['Boolean']>;
};

export type CapaQuotationPartnerOutput = {
  __typename?: 'CAPAQuotationPartnerOutput';
  data?: Maybe<CapaQuotationPartner>;
  /** errorMessage */
  errorMessage?: Maybe<Scalars['String']>;
  /** CAPA ERROR CODE */
  result: CapaErrorCode;
};

export type CapaQuotationPartnerPageViewCountModel = {
  __typename?: 'CAPAQuotationPartnerPageViewCountModel';
  pageView: Scalars['String'];
};

/** CAPAQuotationPartnerPortfolio */
export type CapaQuotationPartnerPortfolio = {
  __typename?: 'CAPAQuotationPartnerPortfolio';
  /** 파트너 캐파빌리티 jsonb array of { service_type, process_method, material, detailed_material, etc } */
  capabilities?: Maybe<Array<CapaQuotationPartnerPortfolioService>>;
  /** 고객 */
  client?: Maybe<Scalars['String']>;
  /** 상세 정보 */
  description?: Maybe<Scalars['String']>;
  /** 파트너 파일 업로드 정보 입력 */
  files: Array<CapaQuotationPartnerStrategyFile>;
  id: Scalars['String'];
  /** 제조 단계 */
  produceStep?: Maybe<CapaQuotationPartnerImagePortfolioProduceStepType>;
  /** 제품 종류 */
  productType?: Maybe<Scalars['String']>;
  /** 프로젝트 명 */
  projectName: Scalars['String'];
  /** 제품 용도 */
  projectPurpose?: Maybe<Array<CapaQuotationProductPurpose>>;
  /** 수량 */
  quantity?: Maybe<Scalars['Float']>;
};

/** 캐파 견적 서비스 정보 입력 */
export type CapaQuotationPartnerPortfolioService = {
  __typename?: 'CAPAQuotationPartnerPortfolioService';
  /** 캐파 견적 상세 서비스 정보 입력 */
  detailedServices?: Maybe<Array<CapaQuotationDetailedServiceType>>;
  /** 캐파 견적 서비스 타입 */
  service?: Maybe<CapaQuotationServiceType>;
};

/** CAPAQuotationPartnerProjectManagement */
export type CapaQuotationPartnerProjectManagement = {
  __typename?: 'CAPAQuotationPartnerProjectManagement';
  chatRoomId: Scalars['String'];
  createdAt: Scalars['String'];
  isConfirmedAnotherCompany: Scalars['Boolean'];
  isNew: Scalars['Boolean'];
  managerName?: Maybe<Scalars['String']>;
  organizationName?: Maybe<Scalars['String']>;
  projectName: Scalars['String'];
  quotationUserStatus?: Maybe<CapaQuotationUserStatus>;
  rfqId: Scalars['String'];
  serviceType: CapaQuotationServiceType;
  thumbnail?: Maybe<Scalars['String']>;
  type?: Maybe<CapaRfqProjectManagementType>;
};

export type CapaQuotationPartnerProjectParticipationStatusBo = {
  __typename?: 'CAPAQuotationPartnerProjectParticipationStatusBO';
  chatRoomStatus?: Maybe<CapaQuotationChatRoomStatus>;
  createdAt?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  lastMessageAt?: Maybe<Scalars['String']>;
  projectName?: Maybe<Scalars['String']>;
  quotation?: Maybe<Scalars['Float']>;
  quotationCreatedDates?: Maybe<Array<Scalars['String']>>;
  rfqId?: Maybe<Scalars['String']>;
  rfqProgress?: Maybe<CapaRfqProgressBoStatus>;
  serviceType?: Maybe<CapaQuotationServiceType>;
};

export enum CapaQuotationPartnerRejectType {
  /** 연락이 되지 않음 */
  CantInTouch = 'CANT_IN_TOUCH',
  /** ETC */
  Etc = 'ETC',
  /** 파트너 요건 불충 */
  Insufficient = 'INSUFFICIENT',
  /** 고객이 잘못 가입함 */
  JoinMistake = 'JOIN_MISTAKE'
}

/** 파트너가 받은 리뷰 목록 */
export type CapaQuotationPartnerRfqReviewOutput = {
  __typename?: 'CAPAQuotationPartnerRfqReviewOutput';
  data?: Maybe<CapaQuotationPartnerRfqReviewResult>;
  /** errorMessage */
  errorMessage?: Maybe<Scalars['String']>;
  /** CAPA ERROR CODE */
  result: CapaErrorCode;
};

export type CapaQuotationPartnerRfqReviewResult = {
  __typename?: 'CAPAQuotationPartnerRfqReviewResult';
  reviewAveragePoint?: Maybe<Scalars['Float']>;
  reviewCount?: Maybe<Scalars['Int']>;
  /** 별점 5점 개수 */
  reviewPointRatio?: Maybe<CapaReviewPointRatio>;
  reviews?: Maybe<Array<CapaRfqReview>>;
};

export enum CapaQuotationPartnerStatus {
  /** 승인 */
  Approved = 'APPROVED',
  /** 삭제 */
  Deleted = 'DELETED',
  /** 등록 */
  Registered = 'REGISTERED',
  /** 거절 */
  Rejected = 'REJECTED'
}

/** CAPAQuotationPartnerStrategy */
export type CapaQuotationPartnerStrategy = {
  __typename?: 'CAPAQuotationPartnerStrategy';
  /** 평균 응답 시간 */
  averageResponseTime?: Maybe<Scalars['String']>;
  capabilities?: Maybe<CapaQuotationPartnerCapability>;
  /** 인증 관련 정보 */
  certifications?: Maybe<Array<CapaQuotationPartnerTechnologyModel>>;
  companyIntroduction?: Maybe<Scalars['String']>;
  companyRegistrationNumber: Scalars['String'];
  contact?: Maybe<Scalars['String']>;
  /** 파트너 커버 파일 */
  cover?: Maybe<CapaQuotationPartnerStrategyFile>;
  /** 생성일 */
  createdAt: Scalars['String'];
  department?: Maybe<Scalars['String']>;
  detailAddress?: Maybe<Scalars['String']>;
  email: Scalars['String'];
  equipments?: Maybe<Array<CapaQuotationPartnerEquipment>>;
  /** 공장 주소 */
  factoryAddress?: Maybe<Scalars['String']>;
  /** 공장 주소 */
  factoryDetailAddress?: Maybe<Scalars['String']>;
  foundedIn?: Maybe<Scalars['String']>;
  fullAddress?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  /** ITP 대상 여부 */
  isItp: Scalars['Boolean'];
  /** 파트너 로고 파일 */
  logo?: Maybe<CapaQuotationPartnerStrategyFile>;
  managerName: Scalars['String'];
  notificationFilter: CapaQuotationPartnerNotificationFilter;
  numberEmployees?: Maybe<Scalars['String']>;
  organizationName?: Maybe<Scalars['String']>;
  /** 파트너 업로드 파일 ex) 사진 및 동영상 관련 */
  partnerFiles?: Maybe<Array<CapaQuotationPartnerStrategyFile>>;
  /** 파트너 페이지 조회수 */
  partnerPageViewCount?: Maybe<Scalars['Float']>;
  /** 특허 관련 정보 */
  patents?: Maybe<Array<CapaQuotationPartnerTechnologyModel>>;
  portfolios?: Maybe<Array<CapaQuotationPartnerPortfolio>>;
  position?: Maybe<Scalars['String']>;
  /** [필수] 개인정보 수집 및 활용 동의 */
  privacyAgreed?: Maybe<Scalars['Boolean']>;
  /** [선택] 프로모션 정보 수신 동의 */
  promotionAgreed?: Maybe<Scalars['Boolean']>;
  /** 캐파 블로그 및 홍보 관련 */
  promotionModels?: Maybe<Array<CapaPromotionModel>>;
  /** 추천인 ID */
  referralUserId?: Maybe<Scalars['String']>;
  /** 사업자 등록증 자료 */
  registrations: Array<CapaQuotationPartnerStrategyFile>;
  /** 리뷰 */
  reviews?: Maybe<CapaQuotationPartnerRfqReviewResult>;
  rfqFilter?: Maybe<Scalars['String']>;
  /** [필수] 캐파 서비스 이용약관 동의 */
  serviceAgreed?: Maybe<Scalars['Boolean']>;
  serviceHours?: Maybe<Scalars['String']>;
  shortAddress?: Maybe<Scalars['String']>;
  status: CapaQuotationPartnerStatus;
  /** 완료 거래 수 */
  transactionCount?: Maybe<Scalars['Float']>;
  /** 수정일 */
  updatedAt: Scalars['String'];
};

export type CapaQuotationPartnerStrategyBo = {
  __typename?: 'CAPAQuotationPartnerStrategyBO';
  /** 파트너 승인 날짜 */
  approvedAt?: Maybe<Scalars['String']>;
  /** 파트너 승인 담당자 이름 */
  approver?: Maybe<Scalars['String']>;
  /** 파트너 승인 담당자 BO id */
  approverBOId?: Maybe<Scalars['ID']>;
  /** 평균 응답 시간 */
  averageResponseTime?: Maybe<Scalars['String']>;
  capabilities?: Maybe<CapaQuotationPartnerCapability>;
  /** 인증 관련 정보 */
  certifications?: Maybe<Array<CapaQuotationPartnerTechnologyModel>>;
  companyIntroduction?: Maybe<Scalars['String']>;
  companyRegistrationNumber: Scalars['String'];
  contact?: Maybe<Scalars['String']>;
  /** 파트너 커버 파일 */
  cover?: Maybe<CapaQuotationPartnerStrategyFile>;
  /** 생성일 */
  createdAt: Scalars['String'];
  department?: Maybe<Scalars['String']>;
  detailAddress?: Maybe<Scalars['String']>;
  email: Scalars['String'];
  equipment?: Maybe<Scalars['String']>;
  equipments?: Maybe<Array<CapaQuotationPartnerEquipment>>;
  /** 공장 주소 */
  factoryAddress?: Maybe<Scalars['String']>;
  factoryDetailAddress?: Maybe<Scalars['String']>;
  foundedIn?: Maybe<Scalars['String']>;
  fullAddress?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  /** CAPA 서비스를 어떻게 알게 되셨나요? (복수 선택 가능) */
  inflowRoute?: Maybe<Array<CapaInflowRoute>>;
  /** ITP 대상 여부 */
  isItp: Scalars['Boolean'];
  /** 파트너 로고 파일 */
  logo?: Maybe<CapaQuotationPartnerStrategyFile>;
  managerName: Scalars['String'];
  notificationFilter: CapaQuotationPartnerNotificationFilter;
  numberEmployees?: Maybe<Scalars['String']>;
  organizationName?: Maybe<Scalars['String']>;
  /** 파트너 업로드 파일 ex) 사진 및 동영상 관련 */
  partnerFiles?: Maybe<Array<CapaQuotationPartnerStrategyFile>>;
  partnerHistoryModels?: Maybe<Array<CapaboPartnerHistoryModel>>;
  /** 파트너 페이지 조회수 */
  partnerPageViewCount?: Maybe<Scalars['Float']>;
  /** 특허 관련 정보 */
  patents?: Maybe<Array<CapaQuotationPartnerTechnologyModel>>;
  portfolios?: Maybe<Array<CapaQuotationPartnerPortfolio>>;
  position?: Maybe<Scalars['String']>;
  /** [필수] 개인정보 수집 및 활용 동의 */
  privacyAgreed?: Maybe<Scalars['Boolean']>;
  /** [선택] 프로모션 정보 수신 동의 */
  promotionAgreed?: Maybe<Scalars['Boolean']>;
  /** 캐파 블로그 및 홍보 관련 */
  promotionModels?: Maybe<Array<CapaPromotionModel>>;
  /** 추천인 ID */
  referralUserId?: Maybe<Scalars['String']>;
  /** 사업자 등록증 자료 */
  registrations: Array<CapaQuotationPartnerStrategyFile>;
  rfqFilter?: Maybe<Scalars['String']>;
  /** [필수] 캐파 서비스 이용약관 동의 */
  serviceAgreed?: Maybe<Scalars['Boolean']>;
  serviceHours?: Maybe<Scalars['String']>;
  shortAddress?: Maybe<Scalars['String']>;
  status: CapaQuotationPartnerStatus;
  /** 완료 거래 수 */
  transactionCount?: Maybe<Scalars['Float']>;
  /** 수정일 */
  updatedAt: Scalars['String'];
  website?: Maybe<Scalars['String']>;
  /** 탈퇴 사유 */
  withdrawnReason?: Maybe<CapaWithdrawnQuotationPartnerReason>;
};

export type CapaQuotationPartnerStrategyBoOutput = {
  __typename?: 'CAPAQuotationPartnerStrategyBOOutput';
  data?: Maybe<CapaQuotationPartnerStrategyBo>;
  /** errorMessage */
  errorMessage?: Maybe<Scalars['String']>;
  /** CAPA ERROR CODE */
  result: CapaErrorCode;
};

export type CapaQuotationPartnerStrategyFile = {
  __typename?: 'CAPAQuotationPartnerStrategyFile';
  /** fileExtension */
  fileExtension?: Maybe<Scalars['String']>;
  /** fileId */
  fileId?: Maybe<Scalars['ID']>;
  /** mimeType */
  fileMimetype?: Maybe<Scalars['String']>;
  /** fileName */
  fileName?: Maybe<Scalars['String']>;
  /** fileSize */
  fileSize?: Maybe<Scalars['String']>;
  /** fileType */
  fileType?: Maybe<CapaQuotationPartnerStrategyFileType>;
  /** strategy file id */
  id: Scalars['ID'];
  /** videoThumbnailFileId */
  videoThumbnailFileId?: Maybe<Scalars['ID']>;
  /** youtubeURL */
  youtubeURL?: Maybe<Scalars['String']>;
};

/** 파트너 기술 관련 파일 상태 */
export enum CapaQuotationPartnerStrategyFileType {
  /** 인증 관련 파일 */
  CertificationFile = 'CERTIFICATION_FILE',
  /** 장비 관련 파일 */
  EquipmentFile = 'EQUIPMENT_FILE',
  /** 커버이미지 */
  ImageCover = 'IMAGE_COVER',
  /** 로고 파일 */
  Logo = 'LOGO',
  /** 파트너 파일(사진 및 동영상 파일) */
  PartnerFile = 'PARTNER_FILE',
  /** 특허 관련 파일 */
  PatentFile = 'PATENT_FILE',
  /** 이미지 포토폴리오 관련 파일 */
  PortfolioFile = 'PORTFOLIO_FILE',
  /** 사업자등록증 파일 */
  Registration = 'REGISTRATION',
  /** 유튜브 URL */
  YoutubeUrl = 'YOUTUBE_URL'
}

/** 파트너 파일 정보 입력 */
export type CapaQuotationPartnerStrategyFileUploadInput = {
  /** fk 캐파 파일 아이디 */
  fileId?: InputMaybe<Scalars['String']>;
  /** videoThumbnailFileId  아이디 */
  videoThumbnailFileId?: InputMaybe<Scalars['String']>;
  /** youtube url */
  youtubeURL?: InputMaybe<Scalars['String']>;
};

/** CAPAQuotationPartnerStrategyOutput */
export type CapaQuotationPartnerStrategyOutput = {
  __typename?: 'CAPAQuotationPartnerStrategyOutput';
  data?: Maybe<CapaQuotationPartnerStrategy>;
  /** errorMessage */
  errorMessage?: Maybe<Scalars['String']>;
  /** CAPA ERROR CODE */
  result: CapaErrorCode;
};

/** 파트너 파일 정보 입력 */
export type CapaQuotationPartnerStrategyRegistrationFileUploadInput = {
  /** fk 캐파 파일 아이디 */
  fileId?: InputMaybe<Scalars['String']>;
};

export type CapaQuotationPartnerTechnologyInput = {
  /** 발급 기관 */
  certificationAuthority: Scalars['String'];
  /** 설명 */
  description?: InputMaybe<Scalars['String']>;
  /** 유효 기간 종료일 */
  expirationPeriodEnd?: InputMaybe<Scalars['String']>;
  /** 유효 기간 시작일 */
  expirationPeriodStart?: InputMaybe<Scalars['String']>;
  /** fk 캐파 파일 아이디 */
  fileId: Scalars['String'];
  /** 인증 /특허 명 */
  technicalName: Scalars['String'];
};

export type CapaQuotationPartnerTechnologyModel = {
  __typename?: 'CAPAQuotationPartnerTechnologyModel';
  /** 발급 기관 */
  certificationAuthority?: Maybe<Scalars['String']>;
  /** 설명 */
  description?: Maybe<Scalars['String']>;
  /** 유효 기간 종료일 */
  expirationPeriodEnd?: Maybe<Scalars['String']>;
  /** 유효 기간 시작일 */
  expirationPeriodStart?: Maybe<Scalars['String']>;
  /** file */
  file?: Maybe<CapaQuotationPartnerStrategyFile>;
  /** capa_quotation_partner_technology 테이블 id */
  id: Scalars['ID'];
  /** fk CAPAQuotationPartnerEntity#id */
  quotationPartnerId: Scalars['ID'];
  /** fk CAPAQuotationPartnerStrategyFileEntity#id */
  strategyFileId?: Maybe<Scalars['ID']>;
  /** 인증 /특허 명 */
  technicalName?: Maybe<Scalars['String']>;
  /** 파일 종류 ex) 인증 / 특허 */
  technologyType: CapaQuotationPartnerTechnologyType;
};

/** 파트너 기술 관련 파일 상태 */
export enum CapaQuotationPartnerTechnologyType {
  /** 인증 */
  Certification = 'CERTIFICATION',
  /** 특허 */
  Patent = 'PATENT'
}

/** 파트너가 읽지 않은 메세지들의 수 (채팅방의 진척도에 따라 구분) */
export type CapaQuotationPartnerUnReadMessagesCount = {
  __typename?: 'CAPAQuotationPartnerUnReadMessagesCount';
  /** 해당 채팅방의 진척도 */
  chatRoomFilter?: Maybe<CapaQuotationChatRoomsFilterType>;
  /** 읽지 않은 메세지들의 총 수  */
  total?: Maybe<Scalars['Float']>;
};

export enum CapaQuotationPartnerUserStatus {
  /** 맴버가입됨 */
  Applied = 'APPLIED',
  /** 승인 */
  Approved = 'APPROVED',
  /** 삭제 */
  Deleted = 'DELETED',
  /** 거절 */
  Rejected = 'REJECTED'
}

export type CapaQuotationPartnersProjectParticipationStatusBo = {
  __typename?: 'CAPAQuotationPartnersProjectParticipationStatusBO';
  closedChatroomCount?: Maybe<Scalars['Float']>;
  introductionSuggestionCount?: Maybe<Scalars['Float']>;
  openedChatroomCount?: Maybe<Scalars['Float']>;
  projectParticipationStatus?: Maybe<Array<CapaQuotationPartnerProjectParticipationStatusBo>>;
  purchaseOrderCount?: Maybe<Scalars['Float']>;
  quotationSuggestionCount?: Maybe<Scalars['Float']>;
  rejectedPurchaseOrderCount?: Maybe<Scalars['Float']>;
  rfqReceivedQuotationCount?: Maybe<Scalars['Float']>;
};

export type CapaQuotationPartnersProjectParticipationStatusBoOutput = {
  __typename?: 'CAPAQuotationPartnersProjectParticipationStatusBOOutput';
  data?: Maybe<CapaQuotationPartnersProjectParticipationStatusBo>;
  /** errorMessage */
  errorMessage?: Maybe<Scalars['String']>;
  /** CAPA ERROR CODE */
  result: CapaErrorCode;
};

export type CapaQuotationPaymentManage = {
  __typename?: 'CAPAQuotationPaymentManage';
  completionAmount?: Maybe<Scalars['Float']>;
  estimatedAmount?: Maybe<Scalars['Float']>;
  paymentManageModel?: Maybe<Array<CapaQuotationPaymentManageModel>>;
};

/** CAPAQuotationPaymentManageModel */
export type CapaQuotationPaymentManageModel = {
  __typename?: 'CAPAQuotationPaymentManageModel';
  cancelAmount?: Maybe<Scalars['Float']>;
  cancelId?: Maybe<Scalars['String']>;
  cancelReason?: Maybe<Scalars['String']>;
  cancelStatus?: Maybe<CapaPaymentCancelStatus>;
  clientOrganizationName?: Maybe<Scalars['String']>;
  /** commission */
  commission?: Maybe<Scalars['Float']>;
  confirmPurchase: Scalars['Boolean'];
  /** 생성일 */
  createdAt?: Maybe<Scalars['String']>;
  isRead: Scalars['Boolean'];
  paidAt?: Maybe<Scalars['String']>;
  partnerOrganizationName?: Maybe<Scalars['String']>;
  projectName?: Maybe<Scalars['String']>;
  /** purchase order id */
  purchaseOrderId?: Maybe<Scalars['String']>;
  purchaseOrderStatus: CapaPurchaseOrderStatus;
  quotationId: Scalars['String'];
  /** quotation partner id */
  quotationPartnerId: Scalars['String'];
  /** quotation partner user id */
  quotationPartnerUserId: Scalars['String'];
  /** quotation user id */
  quotationUserId: Scalars['String'];
  /** rfq id */
  rfqId: Scalars['String'];
  status: CapaPaymentStatus;
  thumbnailId?: Maybe<Scalars['String']>;
  /** total amount */
  totalAmount: Scalars['Float'];
  /** 수정일 */
  updatedAt?: Maybe<Scalars['String']>;
  virtualAccountId?: Maybe<Scalars['String']>;
};

export type CapaQuotationPaymentManageModelOutput = {
  __typename?: 'CAPAQuotationPaymentManageModelOutput';
  data?: Maybe<CapaQuotationPaymentManage>;
  /** errorMessage */
  errorMessage?: Maybe<Scalars['String']>;
  /** CAPA ERROR CODE */
  result: CapaErrorCode;
};

/** Product Purpose */
export enum CapaQuotationProductPurpose {
  Aerospace = 'AEROSPACE',
  AgricultureFarming = 'AGRICULTURE_FARMING',
  ArchitectureConstruction = 'ARCHITECTURE_CONSTRUCTION',
  ArtsExhibition = 'ARTS_EXHIBITION',
  AutomobileTransportation = 'AUTOMOBILE_TRANSPORTATION',
  BroadcastCommunicationMultimedia = 'BROADCAST_COMMUNICATION_MULTIMEDIA',
  EducationToys = 'EDUCATION_TOYS',
  EnergyBatteries = 'ENERGY_BATTERIES',
  Etc = 'ETC',
  ExperimentInspectionDiagnosisMeasuring = 'EXPERIMENT_INSPECTION_DIAGNOSIS_MEASURING',
  FashionBeauty = 'FASHION_BEAUTY',
  Furniture = 'FURNITURE',
  GadgetsPartsComponents = 'GADGETS_PARTS_COMPONENTS',
  HouseholdAppliance = 'HOUSEHOLD_APPLIANCE',
  InteriorLiving = 'INTERIOR_LIVING',
  KitchenFood = 'KITCHEN_FOOD',
  ManufacturinEquipmentIndustrialMachineAndParts = 'MANUFACTURIN_EQUIPMENT_INDUSTRIAL_MACHINE_AND_PARTS',
  MedicalHealthcare = 'MEDICAL_HEALTHCARE',
  MilitarySafety = 'MILITARY_SAFETY',
  OceanIndustryShipbuilding = 'OCEAN_INDUSTRY_SHIPBUILDING',
  OpticsMaterials = 'OPTICS_MATERIALS',
  PersonalHobby = 'PERSONAL_HOBBY',
  Pets = 'PETS',
  PropsOfficeSupplies = 'PROPS_OFFICE_SUPPLIES',
  ResearchAndDevelopment = 'RESEARCH_AND_DEVELOPMENT',
  RoboticsDroneIotSmartDevice = 'ROBOTICS_DRONE_IOT_SMART_DEVICE',
  SemiconductorElectronicBoards = 'SEMICONDUCTOR_ELECTRONIC_BOARDS',
  SportsOutdoors = 'SPORTS_OUTDOORS'
}

/** 캐파 견적 서비스 타입 */
export enum CapaQuotationRecommendation {
  /** 공차가 중요해요 */
  Allowance = 'ALLOWANCE',
  /** 내부식성이 중요해요 */
  CorrosionResistant = 'CORROSION_RESISTANT',
  /** 상담 후 결정할게요 */
  DecideAfterConsulting = 'DECIDE_AFTER_CONSULTING',
  /** 탄성이 높아야해요 */
  Elasticity = 'ELASTICITY',
  /** 기타(직접입력) */
  Etc = 'ETC',
  /** 유연성이 중요해요 */
  Flexibility = 'FLEXIBILITY',
  /** 가벼워야해요 */
  Light = 'LIGHT',
  /** 내충격성이 중요해요 */
  ShockResistance = 'SHOCK_RESISTANCE',
  /** 강도가 중요해요 */
  Strength = 'STRENGTH',
  /** 표면품질이 중요해요 */
  SurfaceQuality = 'SURFACE_QUALITY',
  /** 열 변형이 적어야해요 */
  ThermalStrain = 'THERMAL_STRAIN'
}

/** CAPA RFQ Allow Open FILE Status */
export enum CapaQuotationRfqAllowOpenFileStatus {
  /** allowed */
  Allow = 'ALLOW',
  /** denied */
  Denied = 'DENIED',
  /** request */
  Request = 'REQUEST'
}

/** CAPAQuotationRfqAssemblyFile */
export type CapaQuotationRfqAssemblyFile = {
  __typename?: 'CAPAQuotationRfqAssemblyFile';
  fileId: Scalars['String'];
  fileName: Scalars['String'];
  fileSize?: Maybe<Scalars['Float']>;
  quantity: Scalars['Float'];
};

export type CapaQuotationRfqAvailableRfq = {
  __typename?: 'CAPAQuotationRfqAvailableRfq';
  chatRooms?: Maybe<Scalars['Float']>;
  createdAt: Scalars['String'];
  detailedServiceType?: Maybe<CapaQuotationDetailedServiceType>;
  eventType?: Maybe<CapaQuotationRfqEventType>;
  id: Scalars['String'];
  isFavorite?: Maybe<Scalars['Boolean']>;
  isNew: Scalars['Boolean'];
  managerName?: Maybe<Scalars['String']>;
  organizationName?: Maybe<Scalars['String']>;
  pageViews?: Maybe<Scalars['Float']>;
  projectName: Scalars['String'];
  quantity?: Maybe<Scalars['Float']>;
  serviceType: CapaQuotationServiceType;
  shortAddress?: Maybe<Scalars['String']>;
  status: CapaRfqStatus;
  thumbnailId?: Maybe<Scalars['String']>;
  uniqueViews?: Maybe<Scalars['Float']>;
};

export type CapaQuotationRfqAvailableRfqs = {
  __typename?: 'CAPAQuotationRfqAvailableRfqs';
  count: Scalars['Float'];
  rfqs?: Maybe<Array<CapaQuotationRfqAvailableRfq>>;
};

export type CapaQuotationRfqAvailableRfqsOutput = {
  __typename?: 'CAPAQuotationRfqAvailableRfqsOutput';
  data?: Maybe<CapaQuotationRfqAvailableRfqs>;
  /** errorMessage */
  errorMessage?: Maybe<Scalars['String']>;
  /** CAPA ERROR CODE */
  result: CapaErrorCode;
};

export type CapaQuotationRfqDetail = {
  __typename?: 'CAPAQuotationRfqDetail';
  budgetOpen?: Maybe<Scalars['Boolean']>;
  canDownload?: Maybe<Scalars['Boolean']>;
  chatRoom?: Maybe<CapaQuotationChatRoom>;
  consultingStartMethod?: Maybe<CapaConsultingStartMethod>;
  createdAt: Scalars['String'];
  design?: Maybe<CapaDesignDetail>;
  detailedRequest?: Maybe<Scalars['String']>;
  detailedServiceType?: Maybe<CapaQuotationDetailedServiceType>;
  drawingFiles?: Maybe<Array<CapaQuotationRfqDrawingFile>>;
  dueDate?: Maybe<Scalars['String']>;
  dueNegotiable?: Maybe<Scalars['Boolean']>;
  eventType?: Maybe<CapaQuotationRfqEventType>;
  favorite?: Maybe<Scalars['Boolean']>;
  id: Scalars['String'];
  isOldRfq?: Maybe<Scalars['Boolean']>;
  isSendIntroduction?: Maybe<Scalars['Boolean']>;
  isSendQuotation?: Maybe<Scalars['Boolean']>;
  manufacturingStage?: Maybe<CapaRfqManufacturingStage>;
  maxEstimatedBudget?: Maybe<Scalars['Float']>;
  minEstimatedBudget?: Maybe<Scalars['Float']>;
  optionalServices?: Maybe<Array<CapaQuotationOptionalService>>;
  owner?: Maybe<CapaQuotationUser>;
  pcb?: Maybe<CapaPcbDetail>;
  projectName?: Maybe<Scalars['String']>;
  projectPurpose?: Maybe<CapaQuotationProductPurpose>;
  projectPurposeDetail?: Maybe<Scalars['String']>;
  publicOpen?: Maybe<Scalars['Boolean']>;
  quotation?: Maybe<CapaQuotationRfqQuotation>;
  referenceFiles?: Maybe<Array<CapaQuotationRfqReferenceFile>>;
  serviceType?: Maybe<CapaQuotationServiceType>;
  status?: Maybe<CapaRfqStatus>;
  transaction?: Maybe<CapaQuotationRfqTransaction>;
};

export type CapaQuotationRfqDetailOutput = {
  __typename?: 'CAPAQuotationRfqDetailOutput';
  data?: Maybe<CapaQuotationRfqDetail>;
  /** errorMessage */
  errorMessage?: Maybe<Scalars['String']>;
  /** CAPA ERROR CODE */
  result: CapaErrorCode;
};

export type CapaQuotationRfqDrawingFile = {
  __typename?: 'CAPAQuotationRfqDrawingFile';
  detailedMaterial?: Maybe<CapaQuotationDetailedMaterialType>;
  etc?: Maybe<Scalars['String']>;
  fileId: Scalars['String'];
  fileName?: Maybe<Scalars['String']>;
  fileSize?: Maybe<Scalars['Float']>;
  material?: Maybe<CapaQuotationMaterial>;
  quantity?: Maybe<Scalars['Float']>;
  recommendation?: Maybe<Array<CapaQuotationRecommendation>>;
};

/** CAPA RFQ EVENT TYPE */
export enum CapaQuotationRfqEventType {
  /** 일반적인 rfq */
  General = 'GENERAL',
  /** ITP 이벤트 타입 */
  Itp = 'ITP',
  /** ITPX졸사빠 이벤트 타입 */
  Itpjsb = 'ITPJSB',
  /** 졸사빠 이벤트 타입 */
  Jsb = 'JSB'
}

/** CAPAQuotationRfqFabricationFile */
export type CapaQuotationRfqFabricationFile = {
  __typename?: 'CAPAQuotationRfqFabricationFile';
  fileId: Scalars['String'];
  fileName: Scalars['String'];
  fileSize?: Maybe<Scalars['Float']>;
  quantity: Scalars['Float'];
  thickness: Scalars['Float'];
};

/** RfqFilter 정보 입력 */
export type CapaQuotationRfqFilterInput = {
  /** 캐파 견적 서비스 정보 입력 */
  services?: InputMaybe<Array<CapaRfqFilterQuotationServiceInput>>;
};

export type CapaQuotationRfqMyCompleteRfq = {
  __typename?: 'CAPAQuotationRfqMyCompleteRfq';
  completeAt?: Maybe<Scalars['String']>;
  confirmedAt: Scalars['String'];
  id: Scalars['String'];
  managerName: Scalars['String'];
  organizationName: Scalars['String'];
  projectName: Scalars['String'];
  reviewed: Scalars['Boolean'];
  serviceType: CapaQuotationServiceType;
  thumbnailId?: Maybe<Scalars['String']>;
  transactionComplete?: Maybe<Scalars['Boolean']>;
};

export type CapaQuotationRfqMyCompleteRfqOutput = {
  __typename?: 'CAPAQuotationRfqMyCompleteRfqOutput';
  data?: Maybe<Array<CapaQuotationRfqMyCompleteRfq>>;
  /** errorMessage */
  errorMessage?: Maybe<Scalars['String']>;
  /** CAPA ERROR CODE */
  result: CapaErrorCode;
};

export type CapaQuotationRfqMyRfq = {
  __typename?: 'CAPAQuotationRfqMyRfq';
  chatRoomStatus?: Maybe<CapaQuotationChatRoomStatus>;
  createdAt?: Maybe<Scalars['String']>;
  detailedServiceType?: Maybe<CapaQuotationDetailedServiceType>;
  eventType?: Maybe<CapaQuotationRfqEventType>;
  id: Scalars['String'];
  message?: Maybe<CapaQuotationChatMessageUnion>;
  organizationName?: Maybe<Scalars['String']>;
  projectName: Scalars['String'];
  quantity?: Maybe<Scalars['Float']>;
  serviceType: CapaQuotationServiceType;
  shortAddress?: Maybe<Scalars['String']>;
  status: CapaRfqStatus;
  thumbnailId?: Maybe<Scalars['String']>;
  unReadCount?: Maybe<Scalars['Float']>;
};

export type CapaQuotationRfqMyRfqs = {
  __typename?: 'CAPAQuotationRfqMyRfqs';
  count: Scalars['Float'];
  rfqs?: Maybe<Array<CapaQuotationRfqMyRfq>>;
};

export type CapaQuotationRfqMyRfqsOutput = {
  __typename?: 'CAPAQuotationRfqMyRfqsOutput';
  data?: Maybe<CapaQuotationRfqMyRfqs>;
  /** errorMessage */
  errorMessage?: Maybe<Scalars['String']>;
  /** CAPA ERROR CODE */
  result: CapaErrorCode;
};

export type CapaQuotationRfqPartner = {
  __typename?: 'CAPAQuotationRfqPartner';
  chatRoomId: Scalars['String'];
  downloaded?: Maybe<Scalars['Boolean']>;
  hasEvaluated?: Maybe<Scalars['Boolean']>;
  isNew?: Maybe<Scalars['Boolean']>;
  organizationName?: Maybe<Scalars['String']>;
  permission?: Maybe<CapaQuotationRfqAllowOpenFileStatus>;
  profileId?: Maybe<Scalars['String']>;
  quotationPartnerId: Scalars['String'];
};

export type CapaQuotationRfqPartnerEvaluation = {
  __typename?: 'CAPAQuotationRfqPartnerEvaluation';
  detailed?: Maybe<Scalars['Float']>;
  helpful?: Maybe<Scalars['Float']>;
  kind?: Maybe<Scalars['Float']>;
  quick?: Maybe<Scalars['Float']>;
};

export type CapaQuotationRfqPartnerEvaluationOutput = {
  __typename?: 'CAPAQuotationRfqPartnerEvaluationOutput';
  data?: Maybe<CapaQuotationRfqPartnerEvaluation>;
  /** errorMessage */
  errorMessage?: Maybe<Scalars['String']>;
  /** CAPA ERROR CODE */
  result: CapaErrorCode;
};

export type CapaQuotationRfqPartnersOutput = {
  __typename?: 'CAPAQuotationRfqPartnersOutput';
  data?: Maybe<Array<CapaQuotationRfqPartner>>;
  /** errorMessage */
  errorMessage?: Maybe<Scalars['String']>;
  /** CAPA ERROR CODE */
  result: CapaErrorCode;
};

export type CapaQuotationRfqPurchaseOrder = {
  __typename?: 'CAPAQuotationRfqPurchaseOrder';
  /** 수정 요청서 읽음 및 내용 */
  adjustRequest?: Maybe<CapaRfqAdjustRequestObject>;
  chatRoomId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['String']>;
  /** 배송비(견적서) */
  deliveryCost?: Maybe<Scalars['Float']>;
  /** 수정 범위 및 추가 과금 기준(견적서) */
  draftModificationTerms?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  /** 검수 기간 */
  inspectionPeriod?: Maybe<Scalars['Float']>;
  /** 검수 항목 */
  inspections?: Maybe<Array<CapaQuotationRfqPurchaseOrderInspection>>;
  /** 발주서 확정 */
  isConfirmed?: Maybe<Scalars['Boolean']>;
  isRejected?: Maybe<Scalars['Boolean']>;
  /** (견적서) */
  items?: Maybe<Array<CapaQuotationDetailedQuotationItem>>;
  /** 최신 발주서 */
  latest?: Maybe<Scalars['Boolean']>;
  /** 최대 시안 수정 횟수(견적서) */
  maxDraftModificationCount?: Maybe<Scalars['Float']>;
  /** 결제 대금 */
  paymentAmount?: Maybe<Scalars['Float']>;
  /** 결제 정보 */
  payments?: Maybe<Array<CapaQuotationRfqPurchaseOrderProvision>>;
  pcb?: Maybe<CapaPcbDetail>;
  /** pcb - 조립 */
  pcbAssemblyItems?: Maybe<Array<CapaQuotationDetailedPcbAssemblyItem>>;
  /** pcb -제작 */
  pcbFabricationItems?: Maybe<Array<CapaQuotationDetailedPcbFabricationItem>>;
  /** 발주처 정보 */
  publish?: Maybe<CapaQuotationRfqPurchaseOrderPublish>;
  /** 공급가액(견적서) */
  quotation?: Maybe<Scalars['Float']>;
  quotationCreatedAt?: Maybe<Scalars['String']>;
  read?: Maybe<Scalars['Boolean']>;
  /** 수주처 정보 */
  receiver?: Maybe<CapaQuotationRfqPurchaseOrderReceiver>;
  rfqId: Scalars['String'];
  /** 납품주소 */
  shipAddress?: Maybe<Scalars['String']>;
  /** 납품일 */
  shipDate?: Maybe<Scalars['String']>;
  /** 납품상세주소 */
  shipDetailAddress?: Maybe<Scalars['String']>;
  /** 발주서 상태 */
  status: CapaPurchaseOrderStatus;
  /** 이관 정보 */
  transfer?: Maybe<CapaRfqPurchaseOrderTransfer>;
};

export type CapaQuotationRfqPurchaseOrderInspection = {
  __typename?: 'CAPAQuotationRfqPurchaseOrderInspection';
  /** 검수 요청 사항 */
  inspectionRequest?: Maybe<Scalars['String']>;
  /** 검수 조건 */
  inspectionType?: Maybe<CapaRfqPurchaseOrderInspectionType>;
};

export type CapaQuotationRfqPurchaseOrderInspectionInput = {
  /** 검수 요청 사항 */
  inspectionRequest?: InputMaybe<Scalars['String']>;
  /** 검수 조건 */
  inspectionType?: InputMaybe<CapaRfqPurchaseOrderInspectionType>;
};

export type CapaQuotationRfqPurchaseOrderOutput = {
  __typename?: 'CAPAQuotationRfqPurchaseOrderOutput';
  data?: Maybe<CapaQuotationRfqPurchaseOrder>;
  /** errorMessage */
  errorMessage?: Maybe<Scalars['String']>;
  /** CAPA ERROR CODE */
  result: CapaErrorCode;
};

export type CapaQuotationRfqPurchaseOrderProvision = {
  __typename?: 'CAPAQuotationRfqPurchaseOrderProvision';
  /** 지급 금액 */
  provisionCost?: Maybe<Scalars['Float']>;
  /** 지급 날짜 */
  provisionDate?: Maybe<Scalars['String']>;
  /** 기타(직접입력) */
  provisionEtc?: Maybe<Scalars['String']>;
  /** 지급 비율 */
  provisionPercent?: Maybe<Scalars['Float']>;
  /** 지급 타입 */
  provisionType?: Maybe<CapaRfqPurchaseOrderPaymentProvisionType>;
};

export type CapaQuotationRfqPurchaseOrderProvisionInput = {
  /** 지급 금액 */
  provisionCost: Scalars['Float'];
  /** 지급 날짜 */
  provisionDate: Scalars['String'];
  /** 기타(직접입력) */
  provisionEtc?: InputMaybe<Scalars['String']>;
  /** 지급 비율 */
  provisionPercent: Scalars['Float'];
  /** 지급 타입 */
  provisionType: CapaRfqPurchaseOrderPaymentProvisionType;
};

export type CapaQuotationRfqPurchaseOrderPublish = {
  __typename?: 'CAPAQuotationRfqPurchaseOrderPublish';
  /** 사업자등록번호 */
  companyRegistrationNumber?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  /** 담당자명 */
  managerName?: Maybe<Scalars['String']>;
  /** 고객 회사명 */
  organizationName?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  /** 고객 상태 */
  quotationUserStatus?: Maybe<CapaQuotationUserStatus>;
};

export type CapaQuotationRfqPurchaseOrderReceiver = {
  __typename?: 'CAPAQuotationRfqPurchaseOrderReceiver';
  /** 파트너 주소 */
  adress?: Maybe<Scalars['String']>;
  /** 사업자등록번호 */
  companyRegistrationNumber?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  /** 담당자명 */
  managerName?: Maybe<Scalars['String']>;
  /** 파트너 회사명 */
  organizationName?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  /** 파트너 id */
  quotationPartnerId: Scalars['String'];
  /** 파트너 상태 */
  quotationPartnerStatus: CapaQuotationPartnerStatus;
};

export type CapaQuotationRfqPurchaseOrdersOutput = {
  __typename?: 'CAPAQuotationRfqPurchaseOrdersOutput';
  data?: Maybe<Array<CapaQuotationRfqPurchaseOrder>>;
  /** errorMessage */
  errorMessage?: Maybe<Scalars['String']>;
  /** CAPA ERROR CODE */
  result: CapaErrorCode;
};

export type CapaQuotationRfqQuotation = {
  __typename?: 'CAPAQuotationRfqQuotation';
  excludeDeliveryFee?: Maybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  messageId?: Maybe<Scalars['String']>;
  /** 견적가 */
  quotation: Scalars['Float'];
  quotationPartnerId?: Maybe<Scalars['String']>;
  rfqId?: Maybe<Scalars['String']>;
};

export type CapaQuotationRfqQuotationOptionalService = {
  __typename?: 'CAPAQuotationRfqQuotationOptionalService';
  serviceType?: Maybe<CapaQuotationServiceType>;
};

export type CapaQuotationRfqReferenceFile = {
  __typename?: 'CAPAQuotationRfqReferenceFile';
  fileId: Scalars['String'];
  fileName: Scalars['String'];
  fileSize?: Maybe<Scalars['Float']>;
};

export type CapaQuotationRfqReview = {
  __typename?: 'CAPAQuotationRfqReview';
  dueDate?: Maybe<Scalars['Float']>;
  privateComment?: Maybe<Scalars['String']>;
  publicComment?: Maybe<Scalars['String']>;
  quality?: Maybe<Scalars['Float']>;
  repliedAt?: Maybe<Scalars['String']>;
  replyComment?: Maybe<Scalars['String']>;
};

export type CapaQuotationRfqSearch = {
  __typename?: 'CAPAQuotationRfqSearch';
  chatRooms?: Maybe<Scalars['Float']>;
  createdAt?: Maybe<Scalars['String']>;
  detailedRequest?: Maybe<Scalars['String']>;
  detailedServiceType?: Maybe<CapaQuotationDetailedServiceType>;
  eventType?: Maybe<CapaQuotationRfqEventType>;
  organizationName?: Maybe<Scalars['String']>;
  projectName?: Maybe<Scalars['String']>;
  quantity?: Maybe<Scalars['Float']>;
  rfqId?: Maybe<Scalars['String']>;
  serviceType?: Maybe<CapaQuotationServiceType>;
  shortAddress?: Maybe<Scalars['String']>;
  thumbnailId?: Maybe<Scalars['String']>;
};

export type CapaQuotationRfqTransaction = {
  __typename?: 'CAPAQuotationRfqTransaction';
  completeAt?: Maybe<Scalars['String']>;
  completeCost?: Maybe<Scalars['Float']>;
  isItp?: Maybe<Scalars['Boolean']>;
  organizationName?: Maybe<Scalars['String']>;
  quotationPartnerId: Scalars['String'];
  rfqId: Scalars['String'];
  transactionComplete?: Maybe<Scalars['Boolean']>;
};

export type CapaQuotationSearch = {
  __typename?: 'CAPAQuotationSearch';
  messages: Array<CapaQuotationMessaegeSearch>;
  rfqs: Array<CapaQuotationRfqSearch>;
};

export type CapaQuotationSearchOutput = {
  __typename?: 'CAPAQuotationSearchOutput';
  data?: Maybe<CapaQuotationSearch>;
  /** errorMessage */
  errorMessage?: Maybe<Scalars['String']>;
  /** CAPA ERROR CODE */
  result: CapaErrorCode;
};

export type CapaQuotationService = {
  __typename?: 'CAPAQuotationService';
  detailedServices?: Maybe<Array<CapaQuotationDetailedService>>;
  optionalServices?: Maybe<Array<CapaQuotationServiceType>>;
  service?: Maybe<CapaQuotationServiceType>;
  status: CapaCapabilitiesStatusType;
};

/** 캐파 견적 서비스 정보 입력 */
export type CapaQuotationServiceInput = {
  /** 캐파 견적 상세 서비스 정보 입력 */
  detailedServices?: InputMaybe<Array<CapaQuotationDetailedServiceInput>>;
  /** 추가 서비스 타입 (벤딩, 용접, 시제품, 제품디자인 */
  optionalServices?: InputMaybe<Array<CapaQuotationServiceType>>;
  /** 캐파 견적 서비스 타입 */
  service?: InputMaybe<CapaQuotationServiceType>;
  /** 해당 serviceType의 상태값 */
  status: CapaCapabilitiesStatusType;
};

export type CapaQuotationServiceRating = {
  __typename?: 'CAPAQuotationServiceRating';
  comment?: Maybe<Scalars['String']>;
  rated: Scalars['Boolean'];
  rating?: Maybe<Scalars['Float']>;
};

export type CapaQuotationServiceRatingOutput = {
  __typename?: 'CAPAQuotationServiceRatingOutput';
  data?: Maybe<CapaQuotationServiceRating>;
  /** errorMessage */
  errorMessage?: Maybe<Scalars['String']>;
  /** CAPA ERROR CODE */
  result: CapaErrorCode;
};

/** 캐파 견적 서비스 타입 */
export enum CapaQuotationServiceType {
  /** 벤딩 판금 가공 */
  Bending = 'BENDING',
  /** 주조 */
  Casting = 'CASTING',
  /** CNC */
  Cnc = 'CNC',
  /** 디자인/설계 */
  Design = 'DESIGN',
  /** 금형사출 */
  Inj = 'INJ',
  /** 기구설계 */
  MechanicalDesign = 'MECHANICAL_DESIGN',
  /** 전자회로 */
  Pcb = 'PCB',
  /** 3D 프린터 */
  Printing = 'PRINTING',
  /** 제품 디자인 설계 */
  ProductDesign = 'PRODUCT_DESIGN',
  /** 시제품 제작 설계 */
  Prototyping = 'PROTOTYPING',
  /** 판금가공 */
  SheetMetal = 'SHEET_METAL',
  /** 용접 판금 가공 */
  Weilding = 'WEILDING'
}

/** CAPAQuotationSharedFileAnnotationStatus */
export enum CapaQuotationSharedFileAnnotationStatus {
  /** DELETED */
  Deleted = 'DELETED',
  /** REGISTERED */
  Registered = 'REGISTERED'
}

export type CapaQuotationSimpleQuotation = {
  __typename?: 'CAPAQuotationSimpleQuotation';
  etc?: Maybe<Scalars['String']>;
  excludeDeliveryFee?: Maybe<Scalars['Boolean']>;
  quotation?: Maybe<Scalars['Float']>;
};

export type CapaQuotationSpecificAnnotationComment = {
  __typename?: 'CAPAQuotationSpecificAnnotationComment';
  comment?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['String']>;
  edited?: Maybe<Scalars['Boolean']>;
  email?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isParent?: Maybe<Scalars['Boolean']>;
  status?: Maybe<CapaQuotationSharedFileAnnotationStatus>;
  updatedAt?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['String']>;
  userName?: Maybe<Scalars['String']>;
};

export type CapaQuotationUpdate = {
  __typename?: 'CAPAQuotationUpdate';
  anchorPos?: Maybe<Capa3DPos>;
  annotationCreatedAt?: Maybe<Scalars['String']>;
  annotationId?: Maybe<Scalars['String']>;
  annotationUpdatedAt?: Maybe<Scalars['String']>;
  chatRoomId?: Maybe<Scalars['String']>;
  comment?: Maybe<Scalars['String']>;
  commentCreatedAt?: Maybe<Scalars['String']>;
  commentId?: Maybe<Scalars['String']>;
  commentUpdatedAt?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  handlePos?: Maybe<Capa3DPos>;
  nodeId?: Maybe<Scalars['Float']>;
  quotationSharedFileId?: Maybe<Scalars['String']>;
  status?: Maybe<CapaQuotationSharedFileAnnotationStatus>;
  /** 업데이트 타입 */
  type?: Maybe<CapaQuotationUpdateType>;
  userId?: Maybe<Scalars['String']>;
  userName?: Maybe<Scalars['String']>;
};

export type CapaQuotationUpdateOutput = {
  __typename?: 'CAPAQuotationUpdateOutput';
  data?: Maybe<CapaQuotationUpdate>;
  /** errorMessage */
  errorMessage?: Maybe<Scalars['String']>;
  /** CAPA ERROR CODE */
  result: CapaErrorCode;
};

export enum CapaQuotationUpdateType {
  AnnotationAdd = 'ANNOTATION_ADD',
  AnnotationCommentAdd = 'ANNOTATION_COMMENT_ADD',
  AnnotationCommentDelete = 'ANNOTATION_COMMENT_DELETE',
  AnnotationCommentUpdate = 'ANNOTATION_COMMENT_UPDATE',
  AnnotationDelete = 'ANNOTATION_DELETE',
  AnnotationOpen = 'ANNOTATION_OPEN',
  AnnotationUpdate = 'ANNOTATION_UPDATE'
}

export type CapaQuotationUser = {
  __typename?: 'CAPAQuotationUser';
  /** 사업자 여부 */
  bizType?: Maybe<CapaQuotationUserBizType>;
  /** 휴대폰 번호 */
  cellphoneNumber?: Maybe<Scalars['String']>;
  /** 회사소개 */
  companyIntroduction?: Maybe<Scalars['String']>;
  /** 사업자등록번호 */
  companyRegistrationNumber?: Maybe<Scalars['String']>;
  /** 생성일 */
  createdAt: Scalars['String'];
  /** 부서 */
  department?: Maybe<Scalars['String']>;
  email: Scalars['String'];
  files?: Maybe<Array<CapaQuotationUserFile>>;
  /** 주소 */
  fullAddress?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  /** 이름 (담당자명) */
  managerName?: Maybe<Scalars['String']>;
  notificationFilter?: Maybe<CapaQuotationUserNotificationFilter>;
  /** 회사 / 단체명 */
  organizationName?: Maybe<Scalars['String']>;
  /** 직함 */
  position?: Maybe<Scalars['String']>;
  /** [필수] 개인정보 수집 및 활용 동의 */
  privacyAgreed?: Maybe<Scalars['Boolean']>;
  /** [선택] 프로모션 정보 수신 동의 */
  promotionAgreed?: Maybe<Scalars['Boolean']>;
  /** 추천인 ID */
  referralUserId?: Maybe<Scalars['String']>;
  /** [필수] 캐파 서비스 이용약관 동의 */
  serviceAgreed?: Maybe<Scalars['Boolean']>;
  /** 짧은 주소 */
  shortAddress?: Maybe<Scalars['String']>;
  /** 상태 CAPAQuotationUserStatus */
  status: CapaQuotationUserStatus;
  /** 수정일 */
  updatedAt: Scalars['String'];
  /** 웹사이트 */
  website?: Maybe<Scalars['String']>;
};

export type CapaQuotationUserBo = {
  __typename?: 'CAPAQuotationUserBO';
  /** 사업자 여부 */
  bizType?: Maybe<CapaQuotationUserBizType>;
  /** 휴대폰 번호 */
  cellphoneNumber?: Maybe<Scalars['String']>;
  /** 회사소개 */
  companyIntroduction?: Maybe<Scalars['String']>;
  /** 사업자등록번호 */
  companyRegistrationNumber?: Maybe<Scalars['String']>;
  /** 생성일 */
  createdAt: Scalars['String'];
  /** 부서 */
  department?: Maybe<Scalars['String']>;
  email: Scalars['String'];
  files?: Maybe<Array<CapaQuotationUserFile>>;
  /** 주소 */
  fullAddress?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  /** CAPA 서비스를 어떻게 알게 되셨나요? (복수 선택 가능) */
  inflowRoute?: Maybe<Array<CapaInflowRoute>>;
  /** 이름 (담당자명) */
  managerName?: Maybe<Scalars['String']>;
  /** 회사 / 단체명 */
  organizationName?: Maybe<Scalars['String']>;
  /** 직함 */
  position?: Maybe<Scalars['String']>;
  /** [필수] 개인정보 수집 및 활용 동의 */
  privacyAgreed?: Maybe<Scalars['Boolean']>;
  /** [선택] 프로모션 정보 수신 동의 */
  promotionAgreed?: Maybe<Scalars['Boolean']>;
  /** 추천인 ID */
  referralUserId?: Maybe<Scalars['String']>;
  /** [필수] 캐파 서비스 이용약관 동의 */
  serviceAgreed?: Maybe<Scalars['Boolean']>;
  /** 짧은 주소 */
  shortAddress?: Maybe<Scalars['String']>;
  /** 상태 CAPAQuotationUserStatus */
  status: CapaQuotationUserStatus;
  /** 수정일 */
  updatedAt: Scalars['String'];
  /** 웹사이트 */
  website?: Maybe<Scalars['String']>;
  /** 탈퇴이유 */
  withdrawnReason?: Maybe<CapaWithdrawnQuotationUserReason>;
};

export type CapaQuotationUserBoOutput = {
  __typename?: 'CAPAQuotationUserBOOutput';
  data?: Maybe<CapaQuotationUserBo>;
  /** errorMessage */
  errorMessage?: Maybe<Scalars['String']>;
  /** CAPA ERROR CODE */
  result: CapaErrorCode;
};

/** 사업자 여부 */
export enum CapaQuotationUserBizType {
  /** 사업자등록번호가 있음 */
  Biz = 'BIZ',
  /**
   * 법인사업자
   * @deprecated @see {BIZ}
   */
  Corporate = 'CORPORATE',
  /** 사업자등록번호가 없음 [개인] */
  Individual = 'INDIVIDUAL',
  /** 사업자등록번호가 없음 [단체] */
  Organization = 'ORGANIZATION',
  /**
   * 개인사업자
   * @deprecated @see {BIZ}
   */
  SelfEmployed = 'SELF_EMPLOYED'
}

export type CapaQuotationUserChatRoom = {
  __typename?: 'CAPAQuotationUserChatRoom';
  chatRoomId?: Maybe<Scalars['ID']>;
  chatRoomStatus?: Maybe<CapaQuotationChatRoomStatus>;
  createdAt?: Maybe<Scalars['String']>;
  isOldRfq?: Maybe<Scalars['Boolean']>;
  lastMessage?: Maybe<CapaQuotationChatMessageUnion>;
  organizationName?: Maybe<Scalars['String']>;
  profileId?: Maybe<Scalars['String']>;
  projectName?: Maybe<Scalars['String']>;
  quotationPartnerId?: Maybe<Scalars['String']>;
  quotationPartnerStatus?: Maybe<Scalars['String']>;
  rfqId?: Maybe<Scalars['ID']>;
  serviceType?: Maybe<CapaQuotationServiceType>;
  thumbnailId?: Maybe<Scalars['String']>;
  unReadCount?: Maybe<Scalars['Float']>;
};

export type CapaQuotationUserChatRooms = {
  __typename?: 'CAPAQuotationUserChatRooms';
  chatRooms?: Maybe<Array<CapaQuotationUserChatRoom>>;
  count?: Maybe<Scalars['Float']>;
  /** 읽지 않은 메세지 수 */
  totalUnReadMessagesCount?: Maybe<Array<CapaQuotationUserUnReadMessagesCount>>;
};

export type CapaQuotationUserChatRoomsOutput = {
  __typename?: 'CAPAQuotationUserChatRoomsOutput';
  data?: Maybe<CapaQuotationUserChatRooms>;
  /** errorMessage */
  errorMessage?: Maybe<Scalars['String']>;
  /** CAPA ERROR CODE */
  result: CapaErrorCode;
};

export type CapaQuotationUserFile = {
  __typename?: 'CAPAQuotationUserFile';
  fileId?: Maybe<Scalars['String']>;
  fileName?: Maybe<Scalars['String']>;
  fileType?: Maybe<CapaQuotationUserFileType>;
};

/** 캐파 견적 유저 파일 종류 */
export enum CapaQuotationUserFileType {
  /** 프로필 */
  Profile = 'PROFILE'
}

export type CapaQuotationUserGnb = {
  __typename?: 'CAPAQuotationUserGNB';
  /** 모든 채팅방 unread chat count */
  newChatCount: Scalars['Float'];
  /** 발주 상태 채팅방 unread chat count */
  newConfirmedChatCount: Scalars['Float'];
  /** 견적 상태 채팅방 unread chat count */
  newConsultingChatCount: Scalars['Float'];
  newProjectManagementCount: Scalars['Float'];
  /** 읽지 않은 견적서 및 회사소개서 수 */
  newQuotationAndIntroductionCount: Scalars['Float'];
};

export type CapaQuotationUserGnbOutput = {
  __typename?: 'CAPAQuotationUserGNBOutput';
  data?: Maybe<CapaQuotationUserGnb>;
  /** errorMessage */
  errorMessage?: Maybe<Scalars['String']>;
  /** CAPA ERROR CODE */
  result: CapaErrorCode;
};

/** notification filter */
export type CapaQuotationUserNotificationFilter = {
  __typename?: 'CAPAQuotationUserNotificationFilter';
  chatEmail?: Maybe<Scalars['Boolean']>;
  chatPush?: Maybe<Scalars['Boolean']>;
  chatSMS?: Maybe<Scalars['Boolean']>;
  /** 방해금지 시간 */
  doNotDisturb?: Maybe<CapaDoNotDisturbFilter>;
  /** 캐파 소식 및 혜택 이메일 알림 */
  newsEmail?: Maybe<Scalars['Boolean']>;
  /** 캐파 소식 및 혜택 카카오 (실패시 SMS) 알림 */
  newsSMS?: Maybe<Scalars['Boolean']>;
  /** 프로젝트 이메일 알림 */
  projectEmail?: Maybe<Scalars['Boolean']>;
  /** 프로젝트 알림 설정 */
  projectFilters?: Maybe<Array<CapaRfqProjectFilter>>;
  /** 프로젝트 카카오 (실패시 SMS) 알림 */
  projectSMS?: Maybe<Scalars['Boolean']>;
};

/** notification filter */
export type CapaQuotationUserNotificationFilterInput = {
  /** email yes/no for new chat messages */
  chatEmail?: InputMaybe<Scalars['Boolean']>;
  /** push notification yes/no for new chat messages */
  chatPush?: InputMaybe<Scalars['Boolean']>;
  /** sms yes/no for new chat messages */
  chatSMS?: InputMaybe<Scalars['Boolean']>;
  /** 방해금지 시간 */
  doNotDisturb?: InputMaybe<CapaDoNotDisturbFilterInput>;
  /** 캐파 소식 및 혜택 이메일 알림 */
  newsEmail?: InputMaybe<Scalars['Boolean']>;
  /** 캐파 소식 및 혜택 카카오 (실패시 SMS) 알림 */
  newsSMS?: InputMaybe<Scalars['Boolean']>;
  /** 프로젝트 이메일 알림 */
  projectEmail?: InputMaybe<Scalars['Boolean']>;
  /** 프로젝트 알림 설정 */
  projectFilters?: InputMaybe<Array<CapaRfqProjectFilterInput>>;
  /** 프로젝트 카카오 (실패시 SMS) 알림 */
  projectSMS?: InputMaybe<Scalars['Boolean']>;
};

export type CapaQuotationUserOutput = {
  __typename?: 'CAPAQuotationUserOutput';
  data?: Maybe<CapaQuotationUser>;
  /** errorMessage */
  errorMessage?: Maybe<Scalars['String']>;
  /** CAPA ERROR CODE */
  result: CapaErrorCode;
};

/** CAPAQuotationUserProjectManagementList */
export type CapaQuotationUserProjectManagement = {
  __typename?: 'CAPAQuotationUserProjectManagement';
  chatRoomId: Scalars['String'];
  createdAt: Scalars['String'];
  isNew: Scalars['Boolean'];
  partnerId: Scalars['String'];
  projectName: Scalars['String'];
  rfqId: Scalars['String'];
  serviceType: CapaQuotationServiceType;
  thumbnail?: Maybe<Scalars['String']>;
  type?: Maybe<CapaRfqProjectManagementType>;
};

export type CapaQuotationUserRfq = {
  __typename?: 'CAPAQuotationUserRfq';
  /** 상담 시작 방식 */
  consultingStartMethod?: Maybe<CapaConsultingStartMethod>;
  createdAt?: Maybe<Scalars['String']>;
  eventType?: Maybe<CapaQuotationRfqEventType>;
  isItpPartner?: Maybe<Scalars['Boolean']>;
  /** 발주서(업체 확정) 발행 여부 */
  isTransaction?: Maybe<Scalars['Boolean']>;
  itpEventRegistered?: Maybe<Scalars['Boolean']>;
  itpEventSent?: Maybe<Scalars['Boolean']>;
  jsbEventRegistered?: Maybe<Scalars['Boolean']>;
  jsbEventSent?: Maybe<Scalars['Boolean']>;
  newIntroductionCount?: Maybe<Scalars['Float']>;
  newQuotationCount?: Maybe<Scalars['Float']>;
  projectName?: Maybe<Scalars['String']>;
  protoQuantity?: Maybe<Scalars['Float']>;
  quantity?: Maybe<Scalars['Float']>;
  receivedQuotationCount?: Maybe<Scalars['Float']>;
  rfqId?: Maybe<Scalars['String']>;
  rfqStatus?: Maybe<CapaRfqStatus>;
  serviceType?: Maybe<CapaQuotationServiceType>;
  thumbnailId?: Maybe<Scalars['String']>;
  uniqueViews?: Maybe<Scalars['Float']>;
};

/** 고객이 리뷰 가능한 목록 */
export type CapaQuotationUserRfqAvailableReviewOutput = {
  __typename?: 'CAPAQuotationUserRfqAvailableReviewOutput';
  data?: Maybe<CapaQuotationUserRfqAvailableReviewsResult>;
  /** errorMessage */
  errorMessage?: Maybe<Scalars['String']>;
  /** CAPA ERROR CODE */
  result: CapaErrorCode;
};

export type CapaQuotationUserRfqAvailableReviewsResult = {
  __typename?: 'CAPAQuotationUserRfqAvailableReviewsResult';
  availableReviewCount: Scalars['Float'];
  rfqs: Array<CapaRfqAvailableReviews>;
};

export type CapaQuotationUserRfqBo = {
  __typename?: 'CAPAQuotationUserRfqBO';
  closedChatRooms?: Maybe<Scalars['Float']>;
  createdAt?: Maybe<Scalars['String']>;
  dueDate?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  intoductionSuggestionCount?: Maybe<Scalars['Float']>;
  isComplete?: Maybe<Scalars['Boolean']>;
  isConfirmed?: Maybe<Scalars['Boolean']>;
  openedChatRooms?: Maybe<Scalars['Float']>;
  partnersSentQuotation?: Maybe<Scalars['Float']>;
  projectName?: Maybe<Scalars['String']>;
  quotationSuggestionCount?: Maybe<Scalars['Float']>;
  rfqProgress?: Maybe<CapaRfqProgressBoStatus>;
  serviceType?: Maybe<CapaQuotationServiceType>;
  status?: Maybe<CapaRfqStatus>;
  totalSuggetionCount?: Maybe<Scalars['Float']>;
};

export type CapaQuotationUserRfqDetail = {
  __typename?: 'CAPAQuotationUserRfqDetail';
  budgetOpen?: Maybe<Scalars['Boolean']>;
  chatRoom?: Maybe<Array<CapaQuotationChatRoom>>;
  consultingStartMethod?: Maybe<CapaConsultingStartMethod>;
  createdAt: Scalars['String'];
  design?: Maybe<CapaDesignDetail>;
  detailedRequest?: Maybe<Scalars['String']>;
  detailedServiceType?: Maybe<CapaQuotationDetailedServiceType>;
  drawingFiles?: Maybe<Array<CapaQuotationRfqDrawingFile>>;
  dueDate?: Maybe<Scalars['String']>;
  dueNegotiable?: Maybe<Scalars['Boolean']>;
  eventType?: Maybe<CapaQuotationRfqEventType>;
  id: Scalars['String'];
  isOldRfq?: Maybe<Scalars['Boolean']>;
  itpEvent?: Maybe<CapaItpEventBo>;
  jsbEvent?: Maybe<CapaJsbEventBo>;
  manufacturingStage?: Maybe<CapaRfqManufacturingStage>;
  maxEstimatedBudget?: Maybe<Scalars['Float']>;
  minEstimatedBudget?: Maybe<Scalars['Float']>;
  optionalServices?: Maybe<Array<CapaQuotationOptionalService>>;
  pcb?: Maybe<CapaPcbDetail>;
  projectName?: Maybe<Scalars['String']>;
  projectPurpose?: Maybe<CapaQuotationProductPurpose>;
  projectPurposeDetail?: Maybe<Scalars['String']>;
  publicOpen?: Maybe<Scalars['Boolean']>;
  referenceFiles?: Maybe<Array<CapaQuotationRfqReferenceFile>>;
  review?: Maybe<CapaQuotationRfqReview>;
  serviceType?: Maybe<CapaQuotationServiceType>;
  status?: Maybe<CapaRfqStatus>;
  transaction?: Maybe<CapaQuotationRfqTransaction>;
};

export type CapaQuotationUserRfqDetailOutput = {
  __typename?: 'CAPAQuotationUserRfqDetailOutput';
  data?: Maybe<CapaQuotationUserRfqDetail>;
  /** errorMessage */
  errorMessage?: Maybe<Scalars['String']>;
  /** CAPA ERROR CODE */
  result: CapaErrorCode;
};

/** 고객이 작성한 리뷰 목록 */
export type CapaQuotationUserRfqReviewsOutput = {
  __typename?: 'CAPAQuotationUserRfqReviewsOutput';
  data?: Maybe<Array<CapaRfqReview>>;
  /** errorMessage */
  errorMessage?: Maybe<Scalars['String']>;
  /** CAPA ERROR CODE */
  result: CapaErrorCode;
};

export type CapaQuotationUserRfqs = {
  __typename?: 'CAPAQuotationUserRfqs';
  count?: Maybe<Scalars['Float']>;
  rfqs?: Maybe<Array<CapaQuotationUserRfq>>;
};

export type CapaQuotationUserRfqsBoOutput = {
  __typename?: 'CAPAQuotationUserRfqsBOOutput';
  data?: Maybe<Array<CapaQuotationUserRfqBo>>;
  /** errorMessage */
  errorMessage?: Maybe<Scalars['String']>;
  /** CAPA ERROR CODE */
  result: CapaErrorCode;
};

export type CapaQuotationUserRfqsOutput = {
  __typename?: 'CAPAQuotationUserRfqsOutput';
  data?: Maybe<CapaQuotationUserRfqs>;
  /** errorMessage */
  errorMessage?: Maybe<Scalars['String']>;
  /** CAPA ERROR CODE */
  result: CapaErrorCode;
};

export enum CapaQuotationUserStatus {
  Deleted = 'DELETED',
  Registered = 'REGISTERED'
}

export enum CapaQuotationUserType {
  Client = 'CLIENT',
  Partner = 'PARTNER'
}

/** 파트너가 읽지 않은 메세지들의 수 (채팅방의 진척도에 따라 구분) */
export type CapaQuotationUserUnReadMessagesCount = {
  __typename?: 'CAPAQuotationUserUnReadMessagesCount';
  /** 해당 채팅방의 진척도 */
  chatRoomFilter?: Maybe<CapaQuotationChatRoomsFilterType>;
  /** 읽지 않은 메세지들의 총 수  */
  total?: Maybe<Scalars['Float']>;
};

/** 서비스 평가 목록 및 총 개수 */
export type CapaRatingsAndCount = {
  __typename?: 'CAPARatingsAndCount';
  count?: Maybe<Scalars['Float']>;
  ratings?: Maybe<Array<CapaServiceRatingBo>>;
};

export type CapaReceiveComplaintQuotationChatMessageModel = {
  __typename?: 'CAPAReceiveComplaintQuotationChatMessageModel';
  chatRoomId: Scalars['String'];
  complaint?: Maybe<Scalars['String']>;
  complaintType: CapaBypassComplaintType;
  /** 생성일 */
  createdAt: Scalars['String'];
  message?: Maybe<Scalars['String']>;
  rfqInfo: CapaComplaintRfqInfoModel;
  userInfo: CapaComplaintUserInfoModel;
};

export type CapaReceiveComplaintQuotationChatMessageOutput = {
  __typename?: 'CAPAReceiveComplaintQuotationChatMessageOutput';
  data?: Maybe<CapaComplaintQuotationChatMessageModel>;
  /** errorMessage */
  errorMessage?: Maybe<Scalars['String']>;
  /** CAPA ERROR CODE */
  result: CapaErrorCode;
};

/** 추천인 코드 정보 */
export type CapaReferral = {
  __typename?: 'CAPAReferral';
  /** 추천인 코드 */
  referralId: Scalars['ID'];
};

/** 추천인 코드 정보 */
export type CapaReferralOut = {
  __typename?: 'CAPAReferralOut';
  data?: Maybe<CapaReferral>;
  /** errorMessage */
  errorMessage?: Maybe<Scalars['String']>;
  /** CAPA ERROR CODE */
  result: CapaErrorCode;
};

/** 리뷰 평점 비율 */
export type CapaReviewPointRatio = {
  __typename?: 'CAPAReviewPointRatio';
  five: Scalars['Float'];
  four: Scalars['Float'];
  one: Scalars['Float'];
  three: Scalars['Float'];
  two: Scalars['Float'];
};

export type CapaReviewableRfq = {
  __typename?: 'CAPAReviewableRfq';
  completeAt?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  organizationName?: Maybe<Scalars['String']>;
  projectName: Scalars['String'];
  thumbnailId?: Maybe<Scalars['String']>;
};

export type CapaReviewableRfqsOutput = {
  __typename?: 'CAPAReviewableRfqsOutput';
  data?: Maybe<Array<CapaReviewableRfq>>;
  /** errorMessage */
  errorMessage?: Maybe<Scalars['String']>;
  /** CAPA ERROR CODE */
  result: CapaErrorCode;
};

export type CapaRfqAdjustRequestObject = {
  __typename?: 'CAPARfqAdjustRequestObject';
  message?: Maybe<Scalars['String']>;
  read?: Maybe<Scalars['Boolean']>;
};

export enum CapaRfqAdjustRequestType {
  /** PURCHASE_ORDER */
  PurchaseOrder = 'PURCHASE_ORDER',
  /** QUOTATION */
  Quotation = 'QUOTATION'
}

export type CapaRfqAvailableReviews = {
  __typename?: 'CAPARfqAvailableReviews';
  projectName: Scalars['String'];
  reviews: Array<CapaAvailableReview>;
  /** rfq 생성일 */
  rfqCreatedAt?: Maybe<Scalars['String']>;
  rfqId: Scalars['String'];
  serviceType?: Maybe<CapaQuotationServiceType>;
  thumbnailId?: Maybe<Scalars['String']>;
};

export type CapaRfqBo = {
  __typename?: 'CAPARfqBO';
  chatRoomCount?: Maybe<Scalars['Float']>;
  createdAt: Scalars['String'];
  /** 소개서로 상담 제안한 수 */
  introductionSuggestionCount?: Maybe<Scalars['Float']>;
  managerName?: Maybe<Scalars['String']>;
  organizationName?: Maybe<Scalars['String']>;
  projectName?: Maybe<Scalars['String']>;
  projectPurpose?: Maybe<CapaQuotationProductPurpose>;
  /** 견적 수 */
  quotationCount?: Maybe<Scalars['Float']>;
  /** 견적서로 상담 제안한 수 */
  quotationSuggestionCount?: Maybe<Scalars['Float']>;
  rfqId: Scalars['ID'];
  /** 진척도 */
  rfqProgress?: Maybe<CapaRfqProgressBoStatus>;
  serviceType?: Maybe<CapaQuotationServiceType>;
  status: CapaRfqStatus;
  totalCount?: Maybe<Scalars['Float']>;
  /** 전체(견적 + 상담) 상담 제안한 수 */
  totalSuggestionCount?: Maybe<Scalars['Float']>;
  viewCount?: Maybe<Scalars['Float']>;
};

export type CapaRfqChatRoomsBo = {
  __typename?: 'CAPARfqChatRoomsBO';
  annotations?: Maybe<Array<CapaQuotationChatRoomAnnotationCommentBo>>;
  annotationsCommentCount?: Maybe<Scalars['Float']>;
  chatRoomStatus?: Maybe<CapaQuotationChatRoomStatus>;
  createdAt?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isComplete?: Maybe<Scalars['Boolean']>;
  isConfirmed?: Maybe<Scalars['Boolean']>;
  managerName?: Maybe<Scalars['String']>;
  organizationName?: Maybe<Scalars['String']>;
  purchaseOrderCreatedDates?: Maybe<Array<Scalars['String']>>;
  /** 발주 거부 사유 */
  purchaseOrderRejectedReason?: Maybe<Scalars['String']>;
  quotation?: Maybe<Scalars['Float']>;
  quotationCreatedDates?: Maybe<Array<Scalars['String']>>;
  quotationPartnerId?: Maybe<Scalars['String']>;
  /** 진척도 */
  rfqProgress?: Maybe<CapaRfqProgressBoStatus>;
};

/** 발주서 상태 */
export enum CapaRfqConsultingChatStatusType {
  /** 상담전 */
  BeforeConsulting = 'BEFORE_CONSULTING',
  /** 상담중 */
  Consulting = 'CONSULTING',
  /** 발주서 발행 */
  PurchaseOrderIssued = 'PURCHASE_ORDER_ISSUED',
  /** 견적서 확정 */
  QuotationConfirmed = 'QUOTATION_CONFIRMED'
}

export type CapaRfqDetailBo = {
  __typename?: 'CAPARfqDetailBO';
  budgetOpen?: Maybe<Scalars['Boolean']>;
  chatRooms?: Maybe<Array<CapaRfqChatRoomsBo>>;
  /** 상담시작 유형 */
  consultingStartMethod?: Maybe<CapaConsultingStartMethod>;
  createdAt?: Maybe<Scalars['String']>;
  design?: Maybe<CapaDesignDetail>;
  detailedRequest?: Maybe<Scalars['String']>;
  detailedServiceType?: Maybe<CapaQuotationDetailedServiceType>;
  drawingFiles?: Maybe<Array<CapaQuotationRfqDrawingFile>>;
  dueDate?: Maybe<Scalars['String']>;
  dueNegotiable?: Maybe<Scalars['Boolean']>;
  email?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  isPublic?: Maybe<Scalars['Boolean']>;
  managerName?: Maybe<Scalars['String']>;
  maxBudget?: Maybe<Scalars['Float']>;
  minBudget?: Maybe<Scalars['Float']>;
  optionalServices?: Maybe<Array<CapaQuotationOptionalService>>;
  organizationName?: Maybe<Scalars['String']>;
  pcb?: Maybe<CapaPcbDetail>;
  phoneNumber?: Maybe<Scalars['String']>;
  projectName?: Maybe<Scalars['String']>;
  projectPurpose?: Maybe<CapaQuotationProductPurpose>;
  projectPurposeDetail?: Maybe<Scalars['String']>;
  quotationUserId?: Maybe<Scalars['String']>;
  referenceFiles?: Maybe<Array<CapaQuotationRfqReferenceFile>>;
  serviceType?: Maybe<CapaQuotationServiceType>;
  status: CapaRfqStatus;
};

export type CapaRfqDetailBoOutput = {
  __typename?: 'CAPARfqDetailBOOutput';
  data?: Maybe<CapaRfqDetailBo>;
  /** errorMessage */
  errorMessage?: Maybe<Scalars['String']>;
  /** CAPA ERROR CODE */
  result: CapaErrorCode;
};

/** 캐파 견적 상세 서비스 정보 입력 */
export type CapaRfqFilterQuotationDetailedServiceInput = {
  /** 재료 정보 입력 */
  materials?: InputMaybe<Array<CapaRfqFilterQuotationMaterialInput>>;
  /** 캐파 견적 상세 서비스 타입 */
  type?: InputMaybe<CapaQuotationDetailedServiceType>;
};

/** 재료 정보 입력 */
export type CapaRfqFilterQuotationMaterialInput = {
  /** 세부 재료 */
  detailedMaterials?: InputMaybe<Array<CapaQuotationDetailedMaterialType>>;
  /** 재료 */
  material?: InputMaybe<CapaQuotationMaterial>;
};

/** 캐파 견적 서비스 정보 입력 */
export type CapaRfqFilterQuotationServiceInput = {
  /** 캐파 견적 상세 서비스 정보 입력 */
  detailedServices?: InputMaybe<Array<CapaRfqFilterQuotationDetailedServiceInput>>;
  /** 추가 서비스 타입 (벤딩, 용접, 시제품, 제품디자인 */
  optionalServices?: InputMaybe<Array<CapaQuotationServiceType>>;
  /** 캐파 견적 서비스 타입 */
  service?: InputMaybe<CapaQuotationServiceType>;
};

/** CAPARfqManagementElement */
export type CapaRfqManagementElement = {
  __typename?: 'CAPARfqManagementElement';
  createdAt?: Maybe<Scalars['String']>;
  isNew?: Maybe<Scalars['Boolean']>;
  type?: Maybe<CapaRfqProjectManagementType>;
};

/** 제작단계 Manufacturing Stage */
export enum CapaRfqManufacturingStage {
  /** 시험 생산(Pilot Production) */
  StagePilotProduction = 'STAGE_PILOT_PRODUCTION',
  /** 제품 생산(Production) */
  StageProduction = 'STAGE_PRODUCTION',
  /** 시제품 제작(Prototype) */
  StagePrototype = 'STAGE_PROTOTYPE'
}

/** CAPARfqPartnerManagementElement */
export type CapaRfqPartnerManagementElement = {
  __typename?: 'CAPARfqPartnerManagementElement';
  createdAt?: Maybe<Scalars['String']>;
  isNew?: Maybe<Scalars['Boolean']>;
  type?: Maybe<CapaRfqProjectManagementType>;
};

/** pcb 조립 방식 */
export enum CapaRfqPcbAssemblyMethodType {
  /** Surface Mounted Technology - 표면실장기술 */
  Smt = 'SMT',
  /** 수땜 - 손 납땜 */
  Soldering = 'SOLDERING'
}

/** pcb 자제 방법 */
export enum CapaRfqPcbMaterialSupplyMethodType {
  /** 시급 */
  CustomerSupply = 'CUSTOMER_SUPPLY',
  /** 부분도급 */
  PartialSelfSupply = 'PARTIAL_SELF_SUPPLY',
  /** 도급 */
  SelfSupply = 'SELF_SUPPLY'
}

export type CapaRfqPcbassemblyMethod = {
  __typename?: 'CAPARfqPcbassemblyMethod';
  methodType?: Maybe<CapaRfqPcbAssemblyMethodType>;
};

/** 발주서 상태 */
export enum CapaRfqProgressBoStatus {
  /** 상담전 견적 x */
  BeforeConsultingWithNoQuotation = 'BEFORE_CONSULTING_WITH_NO_QUOTATION',
  /** 상담전 견적 o */
  BeforeConsultingWithQuotation = 'BEFORE_CONSULTING_WITH_QUOTATION',
  /** 상담중 견적 x */
  ConsultingWithNoQuotation = 'CONSULTING_WITH_NO_QUOTATION',
  /** 상담중 견적 o */
  ConsultingWithQuotation = 'CONSULTING_WITH_QUOTATION',
  /** 발주 */
  Ordered = 'ORDERED',
  /** 발주 거부 */
  OrderRejected = 'ORDER_REJECTED'
}

/** 프로젝트 알림 설정 */
export type CapaRfqProjectFilter = {
  __typename?: 'CAPARfqProjectFilter';
  /** 이메일 수신 여부 */
  email?: Maybe<Scalars['Boolean']>;
  /** 견적서 도착, 견적서 수정요청, 회사소개서 도착, 발주서 도착, 발주거절 */
  service?: Maybe<CapaRfqProjectManagementType>;
  /** 카카오 (실패시 SMS) 수신 여부 */
  sms?: Maybe<Scalars['Boolean']>;
};

/** 프로젝트 알림 설정 */
export type CapaRfqProjectFilterInput = {
  /** 이메일 수신 여부 */
  email?: InputMaybe<Scalars['Boolean']>;
  /** 발주서 도착 or 견적서 수정요청 도착 */
  service?: InputMaybe<CapaRfqProjectManagementType>;
  /** 카카오 (실패시 SMS) 수신 여부 */
  sms?: InputMaybe<Scalars['Boolean']>;
};

/** CAPA Rfq Purchase Order Inspection Type(발주서 검수 타입) */
export enum CapaRfqPurchaseOrderInspectionType {
  /** 치수 검사 */
  Dimension = 'DIMENSION',
  /** 기타 */
  Etc = 'ETC',
  /** 기능 검사 */
  Functionalty = 'FUNCTIONALTY',
  /** 외관 검사 */
  Surface = 'SURFACE'
}

/** CAPA Rfq Purchase Order Payment Provision Type(발주서 결제 지급 정보 타입) */
export enum CapaRfqPurchaseOrderPaymentProvisionType {
  /** 납품 직후 */
  AfterShip = 'AFTER_SHIP',
  /** 납품 및 검수 직후 */
  AfterShipInspection = 'AFTER_SHIP_INSPECTION',
  /** 계약체결 시 */
  AtContract = 'AT_CONTRACT',
  /** 계약 종료 시 */
  AtContractTermination = 'AT_CONTRACT_TERMINATION',
  /** 기타 */
  Etc = 'ETC'
}

export type CapaRfqPurchaseOrderTransfer = {
  __typename?: 'CAPARfqPurchaseOrderTransfer';
  /** 이관 보관 기간(N개월) */
  transferStorage?: Maybe<Scalars['Float']>;
  /** 이관 조건 */
  transferTerms?: Maybe<CapaRfqPurchaseOrderTransferTermsType>;
};

/** CAPA Rfq Purchase Order TransferTerms Type(발주서 이관 조건 타입) */
export enum CapaRfqPurchaseOrderTransferTermsType {
  /** 납품 후 일정 기간 보관 */
  StorageAfterShip = 'STORAGE_AFTER_SHIP',
  /** 납품 시 이관 */
  TransferAtShip = 'TRANSFER_AT_SHIP'
}

export type CapaRfqPurchaseOrdersAndPayment = {
  __typename?: 'CAPARfqPurchaseOrdersAndPayment';
  /** 결제 정보 */
  paymentDataList?: Maybe<Array<FetchPurchaseOrderPaymentData>>;
  /** 발주서 리스트 */
  purchaseOrders?: Maybe<Array<CapaQuotationRfqPurchaseOrder>>;
  /** 배송 정보 */
  shippingData?: Maybe<ShippingDataModel>;
};

export type CapaRfqPurchaseOrdersAndPaymentOutput = {
  __typename?: 'CAPARfqPurchaseOrdersAndPaymentOutput';
  data?: Maybe<CapaRfqPurchaseOrdersAndPayment>;
  /** errorMessage */
  errorMessage?: Maybe<Scalars['String']>;
  /** CAPA ERROR CODE */
  result: CapaErrorCode;
};

/** CAPA Rfq Quotation Type (견적서 타입) */
export enum CapaRfqQuotationType {
  /** DETAIL */
  Detail = 'DETAIL',
  /** SIMPLE */
  Simple = 'SIMPLE'
}

/** 특정 rfq가 파트너로부터 수령한 것 */
export enum CapaRfqReceivedType {
  /** 회사 소개서만 수령 */
  OnlyIntroduction = 'ONLY_INTRODUCTION',
  /** 견적서만 수령 */
  OnlyQuotation = 'ONLY_QUOTATION',
  /** 견적서와 회사 소개서 수령 */
  QuotationAndIntroduction = 'QUOTATION_AND_INTRODUCTION'
}

export type CapaRfqReview = {
  __typename?: 'CAPARfqReview';
  /** review id */
  id: Scalars['String'];
  indueDate: Scalars['Boolean'];
  isEditable: Scalars['Boolean'];
  managerName?: Maybe<Scalars['String']>;
  organizationName?: Maybe<Scalars['String']>;
  profileId?: Maybe<Scalars['String']>;
  projectName: Scalars['String'];
  /** 발주액 */
  purchaseOrderValue: Scalars['Float'];
  reviewComment: Scalars['String'];
  reviewFileCount?: Maybe<Scalars['Float']>;
  reviewFiles?: Maybe<Array<CapaRfqReviewFile>>;
  reviewPoint: Scalars['Float'];
  reviewedAt?: Maybe<Scalars['String']>;
  serviceType: CapaQuotationServiceType;
};

/** 리뷰들과 리뷰 총 개수 */
export type CapaRfqReviewAndCount = {
  __typename?: 'CAPARfqReviewAndCount';
  count?: Maybe<Scalars['Float']>;
  reviewAveragePoint?: Maybe<Scalars['Float']>;
  reviews?: Maybe<Array<CapaRfqReviewBo>>;
};

export type CapaRfqReviewBo = {
  __typename?: 'CAPARfqReviewBO';
  inDueDate: Scalars['Boolean'];
  partnerCompanyName?: Maybe<Scalars['String']>;
  projectName: Scalars['String'];
  reviewComment: Scalars['String'];
  reviewFiles?: Maybe<Array<CapaRfqReviewFile>>;
  reviewId: Scalars['ID'];
  reviewPoint: Scalars['Float'];
  reviewerCompanyName: Scalars['String'];
  reviewerEmail?: Maybe<Scalars['String']>;
  reviewerName: Scalars['String'];
  reviewerPhoneNumber?: Maybe<Scalars['String']>;
};

export type CapaRfqReviewChip = {
  __typename?: 'CAPARfqReviewChip';
  chipId: Scalars['ID'];
};

/** 리뷰 파일 */
export type CapaRfqReviewFile = {
  __typename?: 'CAPARfqReviewFile';
  fileId?: Maybe<Scalars['String']>;
  fileName?: Maybe<Scalars['String']>;
};

/** 리뷰 종류 */
export enum CapaRfqReviewType {
  /** 상담 + 거래 리뷰 */
  ConsultingAndTransaction = 'CONSULTING_AND_TRANSACTION',
  /** 상담 리뷰 */
  OnlyConsulting = 'ONLY_CONSULTING',
  /** 거래 리뷰 */
  OnlyTransaction = 'ONLY_TRANSACTION'
}

export type CapaRfqReviewsBoOutput = {
  __typename?: 'CAPARfqReviewsBOOutput';
  data?: Maybe<CapaRfqReviewAndCount>;
  /** errorMessage */
  errorMessage?: Maybe<Scalars['String']>;
  /** CAPA ERROR CODE */
  result: CapaErrorCode;
};

/** CAPA RFQ STATUS */
export enum CapaRfqStatus {
  /** 유효 rfq  */
  Available = 'AVAILABLE',
  /** 거래완료 --> 견적요청목록(fetchRfqsBO input) 에서 사용 X */
  Complete = 'COMPLETE',
  /** 발주 - 특정파트너와 연결이된 상태 --> 견적요청목록(fetchRfqsBO input) 에서는 사용 X */
  Confirmed = 'CONFIRMED',
  /** 7일이 지나 만료된 견적(원래 EXPIRED) + EXPIRED_BY_CLIENT + EXPIRED_BY_REWRITE + CONFIRMED + COMPLETE */
  Expired = 'EXPIRED',
  /** 클라이언트가 만료처리 --> 견적요청목록(fetchRfqsBO input) 에서는 사용 X */
  ExpiredByClient = 'EXPIRED_BY_CLIENT',
  /** 재작성으로 인해 마감됨 --> 견적요청목록(fetchRfqsBO input) 에서는 사용 X */
  ExpiredByRewrite = 'EXPIRED_BY_REWRITE',
  /** Cient가 아직 not verified */
  NotVerified = 'NOT_VERIFIED',
  /** CRM의 판단에 따라 중지됨 */
  Stopped = 'STOPPED',
  /** TEST_RFQ */
  TestRfq = 'TEST_RFQ'
}

/** 검색한 rfg 결과 및 개수 */
export type CapaRfqsAndCount = {
  __typename?: 'CAPARfqsAndCount';
  count?: Maybe<Scalars['Float']>;
  rfqs?: Maybe<Array<CapaRfqBo>>;
};

export type CapaRfqsBoOutput = {
  __typename?: 'CAPARfqsBOOutput';
  data?: Maybe<CapaRfqsAndCount>;
  /** errorMessage */
  errorMessage?: Maybe<Scalars['String']>;
  /** CAPA ERROR CODE */
  result: CapaErrorCode;
};

/** 파트너 목록에서 특정 파트너 찾기 위한 필드 값 */
export enum CapaSearchPartnersBoFieldType {
  /** 담당자 휴대폰 번호 */
  Contact = 'CONTACT',
  /** 담당자 이메일 */
  Email = 'EMAIL',
  /** 담당자명 */
  ManagerName = 'MANAGER_NAME',
  /** 회사명 */
  OrganizationName = 'ORGANIZATION_NAME'
}

/** 검색 필드 */
export enum CapaSearchQuotationUsersBoFieldType {
  /** 고객 이메일 */
  ClientEmail = 'CLIENT_EMAIL',
  /** 고객명 */
  ClientName = 'CLIENT_NAME',
  /** 회사명 */
  CompanyName = 'COMPANY_NAME',
  /** 휴대폰번호 */
  Contact = 'CONTACT'
}

/** 검색 필드 */
export enum CapaSearchRfqsBoFieldType {
  /** 고객이메일 */
  ClientEmail = 'CLIENT_EMAIL',
  /** 고객명 */
  ClientName = 'CLIENT_NAME',
  /** 회사명 */
  CompanyName = 'COMPANY_NAME',
  /** 프로젝트명 */
  ProjectName = 'PROJECT_NAME'
}

export type CapaSearchUsersBo = {
  __typename?: 'CAPASearchUsersBo';
  count?: Maybe<Scalars['Float']>;
  users?: Maybe<Array<CapaUserBo>>;
};

export type CapaServiceRatingBo = {
  __typename?: 'CAPAServiceRatingBO';
  /** 기타 의견 */
  comment?: Maybe<Scalars['String']>;
  /** 피드백 시간 */
  createdAt?: Maybe<Scalars['String']>;
  managerName?: Maybe<Scalars['String']>;
  organizationName?: Maybe<Scalars['String']>;
  /** 평가 지수 */
  rating?: Maybe<Scalars['Float']>;
  userId?: Maybe<Scalars['String']>;
  /** 구분 */
  userType?: Maybe<CapaQuotationUserType>;
};

export type CapaServiceRatingBoOutput = {
  __typename?: 'CAPAServiceRatingBOOutput';
  data?: Maybe<CapaRatingsAndCount>;
  /** errorMessage */
  errorMessage?: Maybe<Scalars['String']>;
  /** CAPA ERROR CODE */
  result: CapaErrorCode;
};

export type CapaServiceSuggestionBo = {
  __typename?: 'CAPAServiceSuggestionBO';
  /** 피드백 시간 */
  createdAt?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  managerName?: Maybe<Scalars['String']>;
  organizationName?: Maybe<Scalars['String']>;
  /** 희망 서비스 */
  suggestion?: Maybe<Scalars['String']>;
  /** 구분 */
  userType?: Maybe<CapaQuotationUserType>;
};

export type CapaServiceSuggestionBoOutput = {
  __typename?: 'CAPAServiceSuggestionBOOutput';
  data?: Maybe<CapaSuggestionsAndCount>;
  /** errorMessage */
  errorMessage?: Maybe<Scalars['String']>;
  /** CAPA ERROR CODE */
  result: CapaErrorCode;
};

/** 캐파 서비스 타입 */
export enum CapaServiceType {
  /** 캐파 백오피스 */
  Backoffice = 'BACKOFFICE',
  /** 클라우드 서비스 */
  Cloud = 'CLOUD',
  /** 캐파 커넥트 서비스 */
  Connect = 'CONNECT',
  /** 캐파 고객 (견적) 서비스 */
  Quotation = 'QUOTATION',
  /** 캐파 파트너 (견적) 서비스 */
  QuotationPartner = 'QUOTATION_PARTNER',
  Super = 'SUPER'
}

export type CapaServiceTypeStatistics = {
  __typename?: 'CAPAServiceTypeStatistics';
  /** 거래 금액 */
  amount?: Maybe<Scalars['Float']>;
  /** 요청 수량 */
  quantity: Scalars['Float'];
};

export type CapaServiceTypeStatisticsOutput = {
  __typename?: 'CAPAServiceTypeStatisticsOutput';
  data?: Maybe<CapaServiceTypeStatistics>;
  /** errorMessage */
  errorMessage?: Maybe<Scalars['String']>;
  /** CAPA ERROR CODE */
  result: CapaErrorCode;
};

/** 파트너목록 정렬 필드 */
export enum CapaSortPartnersBoFieldType {
  /** 전체 상담 수 */
  ConsultingCount = 'CONSULTING_COUNT',
  /** 가입일 */
  CreatedAt = 'CREATED_AT',
  /** 소개서로 제안한 프로젝트 수 */
  IntroductionSuggestionCount = 'INTRODUCTION_SUGGESTION_COUNT',
  /** 마지막 로그인 */
  LastLoginAt = 'LAST_LOGIN_AT',
  /** 발주 수 */
  PurchaseOrderCount = 'PURCHASE_ORDER_COUNT',
  /** 견적서로 제안한 프로젝트 수 */
  QuotationSuggestionCount = 'QUOTATION_SUGGESTION_COUNT',
  /** 견적 수 = 상담 시작 방식 및 상담 진행 여부 상관 없이 견적서 1회 이상 발송한 프로젝트 수 */
  RfqReceivedQuotationCount = 'RFQ_RECEIVED_QUOTATION_COUNT',
  /** 전체 제안 프로젝트 수 (견적서 제안 + 소개서 제안) */
  TotalSuggestionCount = 'TOTAL_SUGGESTION_COUNT'
}

/** 견적요청목록 정렬 필드 */
export enum CapaSortRfqsBoFieldType {
  /** 연결된 상담 수 */
  ChatroomCount = 'CHATROOM_COUNT',
  /** 주문 요청 일 */
  CreatedAt = 'CREATED_AT',
  /** 총수량 */
  TotalCount = 'TOTAL_COUNT',
  /** 전체(견적 + 소개서) 제안 파트너 수 */
  TotalSuggestionCount = 'TOTAL_SUGGESTION_COUNT',
  /** 조회수 */
  ViewCount = 'VIEW_COUNT'
}

/** 견적요청목록 정렬 필드 */
export enum CapaSortType {
  /** 오름차순 */
  Asc = 'ASC',
  /** 내림차순 */
  Desc = 'DESC'
}

/** 유저목록 정렬 필드 */
export enum CapaSortUsersBoFieldType {
  /** 회원가입일 */
  CreatedAt = 'CREATED_AT',
  /** 견적요청개수 */
  RfqCount = 'RFQ_COUNT'
}

export type CapaSubscribeNotifications = {
  __typename?: 'CAPASubscribeNotifications';
  count: Scalars['Float'];
};

export type CapaSubscribeNotificationsOutput = {
  __typename?: 'CAPASubscribeNotificationsOutput';
  data?: Maybe<CapaSubscribeNotifications>;
  /** errorMessage */
  errorMessage?: Maybe<Scalars['String']>;
  /** CAPA ERROR CODE */
  result: CapaErrorCode;
};

/** 서비스 제안 목록 및 총 개수 */
export type CapaSuggestionsAndCount = {
  __typename?: 'CAPASuggestionsAndCount';
  count?: Maybe<Scalars['Float']>;
  suggestions?: Maybe<Array<CapaServiceSuggestionBo>>;
};

export type Capauuid = {
  __typename?: 'CAPAUUID';
  uuid: Scalars['String'];
};

export type CapauuidOutput = {
  __typename?: 'CAPAUUIDOutput';
  data?: Maybe<Capauuid>;
  /** errorMessage */
  errorMessage?: Maybe<Scalars['String']>;
  /** CAPA ERROR CODE */
  result: CapaErrorCode;
};

export type CapaUser = {
  __typename?: 'CAPAUser';
  /** 생성일 */
  createdAt: Scalars['String'];
  email: Scalars['String'];
  id: Scalars['ID'];
  lastLoginAt?: Maybe<Scalars['String']>;
  lastLogoutAt?: Maybe<Scalars['String']>;
  status: CapaUserStatus;
  /** 수정일 */
  updatedAt: Scalars['String'];
};

export type CapaUserBo = {
  __typename?: 'CAPAUserBO';
  bizType?: Maybe<CapaQuotationUserBizType>;
  companyRegistrationNumber?: Maybe<Scalars['Boolean']>;
  createdAt?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  managerName?: Maybe<Scalars['String']>;
  organizationName?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  rfqCount?: Maybe<Scalars['Float']>;
  route?: Maybe<Array<CapaInflowRoute>>;
  status?: Maybe<CapaQuotationUserStatus>;
};

/** 유저 현황 */
export enum CapaUserStatus {
  /** 탈퇴 */
  Deleted = 'DELETED',
  /** 등록 */
  Registered = 'REGISTERED'
}

export type CapaUsersBoOutput = {
  __typename?: 'CAPAUsersBOOutput';
  data?: Maybe<CapaSearchUsersBo>;
  /** errorMessage */
  errorMessage?: Maybe<Scalars['String']>;
  /** CAPA ERROR CODE */
  result: CapaErrorCode;
};

export type CapaUsersOutput = {
  __typename?: 'CAPAUsersOutput';
  data?: Maybe<Array<CapaUser>>;
  /** errorMessage */
  errorMessage?: Maybe<Scalars['String']>;
  /** CAPA ERROR CODE */
  result: CapaErrorCode;
};

/** 고객 탈퇴 사유 */
export enum CapaWithdrawClientReasonType {
  /** 에이팀벤처스 서비스 응대가 불만 */
  AteamServiceProblem = 'ATEAM_SERVICE_PROBLEM',
  /** 파트너 품질이 불안 */
  ConcernedAboutQuality = 'CONCERNED_ABOUT_QUALITY',
  /** 기타 */
  Etc = 'ETC',
  /** 원하는 파트너를 찾지 못해서 */
  NoMatchedPartner = 'NO_MATCHED_PARTNER',
  /** 더 이상 제조 파트너 찾기에 대한 수요가 없어서 */
  NoNeedToSearchPartner = 'NO_NEED_TO_SEARCH_PARTNER',
  /** 개인정보 유출 불안 */
  PersonalInformationLeakage = 'PERSONAL_INFORMATION_LEAKAGE',
  /** 이직, 퇴사, 폐업 등 개인적인 사유 */
  PrivacyIssue = 'PRIVACY_ISSUE',
  /** 불필요한 알람이 많이 와서 */
  UselessAlarm = 'USELESS_ALARM'
}

export type CapaWithdrawOutput = {
  __typename?: 'CAPAWithdrawOutput';
  consultingChatRooms?: Maybe<CapaWithdrawnChatRoomsUnion>;
  consultingChatRoomsCount: Array<CapaQuotationChatRoomsTotalCount>;
};

/** 고객 탈퇴 사유 */
export enum CapaWithdrawPartnerReasonType {
  /** 기타 */
  Etc = 'ETC',
  /** 원하는 고객을 만나지 못해서 */
  NoMatchedClient = 'NO_MATCHED_CLIENT',
  /** 원하는 전문 서비스가 없어서 */
  NoMatchedService = 'NO_MATCHED_SERVICE',
  /** 제조 고객 찾기에 대한 수요가 없어져서 */
  NoNeedToSearchClient = 'NO_NEED_TO_SEARCH_CLIENT',
  /** 이직, 퇴사, 폐업 등 개인적인 사유 */
  PrivacyIssue = 'PRIVACY_ISSUE',
  /** 불필요한 알람이 많이 와서 */
  UselessAlarm = 'USELESS_ALARM'
}

/** BO에서 보여주기 위한 탈퇴 사유 */
export enum CapaWithdrawReasonBoType {
  /** 에이팀벤처스 서비스 응대가 불만 */
  AteamServiceProblem = 'ATEAM_SERVICE_PROBLEM',
  /** 파트너 품질이 불안 */
  ConcernedAboutQuality = 'CONCERNED_ABOUT_QUALITY',
  /** 기타 */
  Etc = 'ETC',
  /** 원하는 고객을 만나지 못해서 */
  NoMatchedClient = 'NO_MATCHED_CLIENT',
  /** 원하는 파트너를 찾지 못해서 */
  NoMatchedPartner = 'NO_MATCHED_PARTNER',
  /** 원하는 전문 서비스가 없어서 */
  NoMatchedService = 'NO_MATCHED_SERVICE',
  /** 제조 고객 찾기에 대한 수요가 없어져서 */
  NoNeedToSearchClient = 'NO_NEED_TO_SEARCH_CLIENT',
  /** 더 이상 제조 파트너 찾기에 대한 수요가 없어서 */
  NoNeedToSearchPartner = 'NO_NEED_TO_SEARCH_PARTNER',
  /** 개인정보 유출 불안 */
  PersonalInformationLeakage = 'PERSONAL_INFORMATION_LEAKAGE',
  /** 이직, 퇴사, 폐업 등 개인적인 사유 */
  PrivacyIssue = 'PRIVACY_ISSUE',
  /** 불필요한 알람이 많이 와서 */
  UselessAlarm = 'USELESS_ALARM'
}

export type CapaWithdrawnChatRoomsOutput = {
  __typename?: 'CAPAWithdrawnChatRoomsOutput';
  data?: Maybe<CapaWithdrawOutput>;
  /** errorMessage */
  errorMessage?: Maybe<Scalars['String']>;
  /** CAPA ERROR CODE */
  result: CapaErrorCode;
};

export type CapaWithdrawnChatRoomsUnion = CapaWithdrawnConnectGroupChatRooms | CapaWithdrawnPartnerChatRooms | CapaWithdrawnUserChatRooms;

/** 캐파 커넥트 그룹 채팅방 */
export type CapaWithdrawnConnectGroupChatRoom = {
  __typename?: 'CAPAWithdrawnConnectGroupChatRoom';
  /** 챗룸 아이디 */
  chatRoomId: Scalars['ID'];
  /** 그룹 ID */
  groupId: Scalars['ID'];
  /** 그룹 이름 */
  groupName: Scalars['String'];
  /** 썸네일 */
  thumbnail?: Maybe<Scalars['ID']>;
  /** 그룹멤버 */
  users?: Maybe<Array<CapaWithdrawnConnectGroupUser>>;
};

export type CapaWithdrawnConnectGroupChatRooms = {
  __typename?: 'CAPAWithdrawnConnectGroupChatRooms';
  capaServiceType: CapaServiceType;
  chatRooms?: Maybe<Array<CapaWithdrawnConnectGroupChatRoom>>;
};

/** 탈퇴하고자 하는 유저의 커넥트 그룹 */
export type CapaWithdrawnConnectGroupUser = {
  __typename?: 'CAPAWithdrawnConnectGroupUser';
  /** 커넥트유저네임 */
  connectUserName?: Maybe<Scalars['String']>;
  /** 이메일 */
  email: Scalars['String'];
  /** 그룹 ID */
  groupId?: Maybe<Scalars['ID']>;
  /** 그룹 유저 ID */
  id?: Maybe<Scalars['ID']>;
  /** 캐파유저냐 */
  isCapaUser?: Maybe<Scalars['Boolean']>;
  /** 커넥트 유저 아이디 */
  userId?: Maybe<Scalars['ID']>;
};

/** 캐파 파트너스의 채팅방 */
export type CapaWithdrawnPartnerChatRoom = {
  __typename?: 'CAPAWithdrawnPartnerChatRoom';
  chatRoomId: Scalars['ID'];
  managerName?: Maybe<Scalars['String']>;
  organizationName?: Maybe<Scalars['String']>;
  projectName?: Maybe<Scalars['String']>;
  rfqId?: Maybe<Scalars['String']>;
  thumbnailId?: Maybe<Scalars['ID']>;
};

export type CapaWithdrawnPartnerChatRooms = {
  __typename?: 'CAPAWithdrawnPartnerChatRooms';
  capaServiceType: CapaServiceType;
  chatRooms?: Maybe<Array<CapaWithdrawnPartnerChatRoom>>;
};

/** 탈퇴 이유 */
export type CapaWithdrawnQuotationPartnerReason = {
  __typename?: 'CAPAWithdrawnQuotationPartnerReason';
  /** 탈퇴 상세 사유 */
  detailedReason?: Maybe<Scalars['String']>;
  /** 기타 탈퇴 사유 */
  etcReason?: Maybe<Scalars['String']>;
  /** 탈퇴 사유 */
  reason?: Maybe<CapaWithdrawReasonBoType>;
  /** 커파 서비스 중 어디서 탈퇴를 진행했는지 */
  serviceType: CapaServiceType;
  /** 탈퇴 BO 담당자 성함 */
  withdrawerName?: Maybe<Scalars['String']>;
  /** 탈퇴 일시 */
  withdrawnAt: Scalars['String'];
};

/** 탈퇴 이유 */
export type CapaWithdrawnQuotationUserReason = {
  __typename?: 'CAPAWithdrawnQuotationUserReason';
  /** 탈퇴 상세 사유 */
  detailedReason?: Maybe<Scalars['String']>;
  /** 기타 탈퇴 사유 */
  etcReason?: Maybe<Scalars['String']>;
  /** 탈퇴 사유 */
  reason?: Maybe<CapaWithdrawReasonBoType>;
  /** 커파 서비스 중 어디서 탈퇴를 진행했는지 */
  serviceType: CapaServiceType;
  /** 탈퇴 BO 담당자 성함 */
  withdrawerName?: Maybe<Scalars['String']>;
  /** 탈퇴 일시 */
  withdrawnAt: Scalars['String'];
};

/** 캐파 클라이언트 채팅방 */
export type CapaWithdrawnUserChatRoom = {
  __typename?: 'CAPAWithdrawnUserChatRoom';
  chatRoomId: Scalars['ID'];
  isOldRfq?: Maybe<Scalars['Boolean']>;
  organizationName?: Maybe<Scalars['String']>;
  profileId?: Maybe<Scalars['ID']>;
  projectName?: Maybe<Scalars['String']>;
  rfqId?: Maybe<Scalars['String']>;
  thumbnailId?: Maybe<Scalars['ID']>;
};

export type CapaWithdrawnUserChatRooms = {
  __typename?: 'CAPAWithdrawnUserChatRooms';
  capaServiceType: CapaServiceType;
  chatRooms?: Maybe<Array<CapaWithdrawnUserChatRoom>>;
};

export type CancelRequestPaymentAgentInput = {
  mid: Scalars['String'];
  seq: Scalars['String'];
  settlmntDt: Scalars['String'];
  subId: Scalars['String'];
};

export enum CapaQuotationChatRoomSharedFileAnnotationStatus {
  /** NONE */
  None = 'NONE',
  /** OFF */
  Off = 'OFF',
  /** ON */
  On = 'ON'
}

export enum CapaQuotationChatRoomSharedFileType {
  /** CHAT_MESSAGE_FILE */
  ChatMessageFile = 'CHAT_MESSAGE_FILE',
  /** QUOTATION_FILE */
  QuotationFile = 'QUOTATION_FILE'
}

export enum CapaQuotationChatRoomSharedFilesFilterType {
  /** ALL_FILE */
  AllFile = 'ALL_FILE',
  /** CHAT_MESSAGE_FILE */
  ChatMessageFile = 'CHAT_MESSAGE_FILE',
  /** QUOTATION_FILE */
  QuotationFile = 'QUOTATION_FILE'
}

export type CapaQuotationChatRoomSpecificAnnotation = {
  __typename?: 'CapaQuotationChatRoomSpecificAnnotation';
  anchorPos?: Maybe<Capa3DPos>;
  annotationId?: Maybe<Scalars['String']>;
  commentUsers?: Maybe<Array<CommentUser>>;
  comments?: Maybe<Array<CapaQuotationSpecificAnnotationComment>>;
  createdAt?: Maybe<Scalars['String']>;
  handlePos?: Maybe<Capa3DPos>;
  isNew?: Maybe<Scalars['Boolean']>;
  nodeId?: Maybe<Scalars['Float']>;
  status?: Maybe<CapaQuotationSharedFileAnnotationStatus>;
  userId?: Maybe<Scalars['String']>;
};

export type CapaQuotationChatRoomSpecificAnnotationsOutput = {
  __typename?: 'CapaQuotationChatRoomSpecificAnnotationsOutput';
  data?: Maybe<Array<CapaQuotationChatRoomSpecificAnnotation>>;
  /** errorMessage */
  errorMessage?: Maybe<Scalars['String']>;
  /** CAPA ERROR CODE */
  result: CapaErrorCode;
};

/** Capa Rfq Project Management Type */
export enum CapaRfqProjectManagementType {
  /** 고객이 발주서를 수정 발행 했을때 */
  AdjustedPurchaseOrder = 'ADJUSTED_PURCHASE_ORDER',
  /** 파트너가 수정 견적서를 보냈을때 */
  AdjustedQuotation = 'ADJUSTED_QUOTATION',
  /** 고객이 도면 다운로드 제한시 */
  AllowDrawingFileDenied = 'ALLOW_DRAWING_FILE_DENIED',
  /** 도면 권한 요청 */
  AllowDrawingFileRequest = 'ALLOW_DRAWING_FILE_REQUEST',
  /** 고객이 도면 다운로드 허용시 */
  AllowDrawingFileResponse = 'ALLOW_DRAWING_FILE_RESPONSE',
  NewQuotationPartnerIntroduction = 'NEW_QUOTATION_PARTNER_INTRODUCTION',
  /** 고객이 발주서 발행했을때 */
  NewRfqPurchaseOrder = 'NEW_RFQ_PURCHASE_ORDER',
  /** 파트너가 견적서를 보냈을떄 */
  NewRfqQuotation = 'NEW_RFQ_QUOTATION',
  /** 파트너가 발주서 수정 요청 */
  PurchaseOrderAdjustRequest = 'PURCHASE_ORDER_ADJUST_REQUEST',
  /** 파트너가 발주서를 확정했을때 */
  PurchaseOrderConfirmed = 'PURCHASE_ORDER_CONFIRMED',
  /** 고객이 견적서 수정 요청 */
  QuotationAdjustRequest = 'QUOTATION_ADJUST_REQUEST',
  /** 고객이 견적서를 보고 채팅하기를 클릭했을때 */
  QuotationConsultingStart = 'QUOTATION_CONSULTING_START',
  RefusedPurchaseOrder = 'REFUSED_PURCHASE_ORDER'
}

/** CapaServiceTypeDetailFilter */
export type CapaServiceTypeDetailFilter = {
  /** detailedMaterials */
  detailedMaterials?: InputMaybe<Array<CapaQuotationDetailedMaterialType>>;
  /** detailedServiceTypes */
  detailedServiceTypes?: InputMaybe<Array<CapaQuotationDetailedServiceType>>;
  /** materials */
  materials?: InputMaybe<Array<CapaQuotationMaterial>>;
  /** optionalServices */
  optionalServices?: InputMaybe<Array<CapaQuotationServiceType>>;
};

export type ChangeChatMessageInvisibleInput = {
  chatRoomId?: InputMaybe<Scalars['String']>;
  fieldToChange?: InputMaybe<Scalars['String']>;
  messageType?: InputMaybe<CapaQuotationChatMessageType>;
  senderId?: InputMaybe<Scalars['String']>;
  valueToChange?: InputMaybe<Scalars['String']>;
};

export type ChangeChatRoomStatusInput = {
  chatRoomId?: InputMaybe<Scalars['String']>;
  quotationId?: InputMaybe<Scalars['String']>;
};

/** 이메일 갱신 */
export type ChangeEmailInput = {
  /** 인증번호 */
  code: Scalars['String'];
  /** 이메일 */
  newEmail: Scalars['String'];
};

/** 비밀번호 변경하기 */
export type ChangePasswordInput = {
  /** 새 비밀번호 */
  newPassword: Scalars['String'];
  /** 새 비밀번호 확인 */
  newPasswordConfirm: Scalars['String'];
  /** 비밀번호 */
  password: Scalars['String'];
  service?: InputMaybe<CapaServiceType>;
};

export type ChatFileUploadInput = {
  fileId: Scalars['String'];
  fileName?: InputMaybe<Scalars['String']>;
};

export type CheckBalanceInput = {
  /** 상점 ID */
  mid: Scalars['String'];
};

export type CheckConnectDuplicateGroupNameInput = {
  groupName: Scalars['String'];
};

export type CloudUser = {
  __typename?: 'CloudUser';
  id: Scalars['ID'];
};

export type CommentUser = {
  __typename?: 'CommentUser';
  userName?: Maybe<Scalars['String']>;
};

export type CommentUserBo = {
  __typename?: 'CommentUserBO';
  userName?: Maybe<Scalars['String']>;
};

export type CompleteRfqTransactionInput = {
  completeCost: Scalars['Float'];
  quotationPartnerId: Scalars['String'];
  rfqId: Scalars['String'];
};

export type ConfirmEscrowPurchaseInput = {
  /** 나이스페이 모달에서 결제할때 입력하는 인증번호 (휴대폰번호 or 사업자번호) -> BuyerAuthNum */
  escrowVerifiedPW: Scalars['String'];
  /** payment table pk ID */
  paymentId: Scalars['String'];
};

export type ConfirmRfqPurchaseOrderInput = {
  purchaseOrderId: Scalars['String'];
  rfqId: Scalars['String'];
};

export type ConfirmRfqQuotationInput = {
  quotationId?: InputMaybe<Scalars['String']>;
  quotationPartnerId: Scalars['String'];
  rfqId: Scalars['String'];
};

export type ConfirmRfqTransactionInput = {
  quotationPartnerId: Scalars['String'];
  rfqId: Scalars['String'];
};

export enum ConnectFileSortType {
  Latest = 'LATEST',
  Oldest = 'OLDEST'
}

export enum ConnectNotificationType {
  ChatPush = 'CHAT_PUSH',
  CommentThreadEmail = 'COMMENT_THREAD_EMAIL',
  CommentThreadPush = 'COMMENT_THREAD_PUSH',
  FileEmail = 'FILE_EMAIL',
  FilePush = 'FILE_PUSH',
  GroupEmail = 'GROUP_EMAIL',
  GroupPush = 'GROUP_PUSH'
}

/** ConnectSharedFileCommentThread */
export enum ConnectSharedFileCommentThread {
  /** no */
  No = 'NO',
  /** yes */
  Yes = 'YES'
}

export type ConnectUser = {
  __typename?: 'ConnectUser';
  id: Scalars['ID'];
  userName?: Maybe<Scalars['String']>;
};

/** Connect activete link status */
export enum ConnectUserFileLinkStatus {
  /** active */
  Active = 'ACTIVE',
  /** deactive */
  Deactive = 'DEACTIVE'
}

/** ConnectUserFileStatus status */
export enum ConnectUserFileStatus {
  /** downloadable */
  Downloadable = 'DOWNLOADABLE',
  /** viewable */
  Viewable = 'VIEWABLE'
}

export type CreateAdsImpressionBoInput = {
  /** advertisement id */
  advertisementId: Scalars['String'];
  /** 광고 타입 (배너, 카드) */
  advertisementType: CapaAdvertisementType;
  /** image background color */
  backgroundColor?: InputMaybe<Scalars['String']>;
  /** 광고 내용 */
  contents: Scalars['String'];
  /** 광고 종료 날짜 */
  expiredAt?: InputMaybe<Scalars['String']>;
  /** image file id */
  fileId: Scalars['String'];
  /** 광고 링크 주소 */
  linkUrl: Scalars['String'];
  /** 광고 타이틀 */
  title: Scalars['String'];
};

export type CreateAdvertisementBoInput = {
  /** 연락처 */
  contact: Scalars['String'];
  /** 이메일 */
  email: Scalars['String'];
  /** 담당자명 */
  managerName: Scalars['String'];
  /** 회사명 */
  organizationName: Scalars['String'];
};

export type CreateAdvertisingBoInput = {
  /** 노출 광고 id 리스트 */
  adsImpressionIds: Array<Scalars['String']>;
  /** 광고 타입 (배너, 카드) */
  advertisementType: CapaAdvertisementType;
  /** 호스팅할 서비스 타입 (배너, 카드) */
  serviceType: CapaServiceType;
};

export type CreateConnectAnnotationCommentInput = {
  annotationId: Scalars['String'];
  comment: Scalars['String'];
  connectSharedFileId: Scalars['String'];
  groupId: Scalars['String'];
};

export type CreateConnectAnnotationInput = {
  anchorPos?: InputMaybe<Capa3DPosInput>;
  comment?: InputMaybe<Scalars['String']>;
  connectSharedFileId: Scalars['String'];
  groupId: Scalars['String'];
  handlePos?: InputMaybe<Capa3DPosInput>;
  nodeId?: InputMaybe<Scalars['Float']>;
};

export type CreateConnectContactUserInput = {
  contactUserEmail: Scalars['String'];
  memo?: InputMaybe<Scalars['String']>;
  nickName?: InputMaybe<Scalars['String']>;
};

export type CreateConnectFeedbackInput = {
  /** feedBack message */
  feedBack?: InputMaybe<Scalars['String']>;
  fileIds?: InputMaybe<Array<Scalars['String']>>;
  /** 1 ~ 5 */
  rating: Scalars['Float'];
};

export type CreateConnectGroup = {
  __typename?: 'CreateConnectGroup';
  chatRoomId: Scalars['String'];
  id: Scalars['String'];
};

export type CreateConnectGroupInput = {
  groupName?: InputMaybe<Scalars['String']>;
};

export type CreateConnectGroupOutput = {
  __typename?: 'CreateConnectGroupOutput';
  data?: Maybe<CreateConnectGroup>;
  /** errorMessage */
  errorMessage?: Maybe<Scalars['String']>;
  /** CAPA ERROR CODE */
  result: CapaErrorCode;
};

export type CreateConnectIssueInput = {
  fileIds?: InputMaybe<Array<Scalars['String']>>;
  /** issue message */
  issue: Scalars['String'];
};

export type CreateDetailedQuotationInput = {
  address?: InputMaybe<Scalars['String']>;
  /** 배송비 */
  deliveryCost?: InputMaybe<Scalars['Float']>;
  /** 수정 범위 및 추가 과금 기준 */
  draftModificationTerms?: InputMaybe<Scalars['String']>;
  /** 납품 가능일 */
  dueDate?: InputMaybe<Scalars['String']>;
  /** 견적 설명 */
  etc?: InputMaybe<Scalars['String']>;
  /** false : include delevery fee, true : exclude delevery fee */
  excludeDeliveryFee?: InputMaybe<Scalars['Boolean']>;
  /** 견적서 유효기간 */
  expiration?: InputMaybe<Scalars['String']>;
  items?: InputMaybe<Array<CapaQuotationDetailedQuotationItemInput>>;
  /** 공급자 담당자명 */
  managerName?: InputMaybe<Scalars['String']>;
  /** 최대 시안 수정 횟수 */
  maxDraftModificationCount?: InputMaybe<Scalars['Float']>;
  optionalServices?: InputMaybe<Array<RfqQuotationOptionalServiceInput>>;
  partnerId: Scalars['String'];
  pcbAssemblyItems?: InputMaybe<Array<CapaQuotationDetailedQuotationPcbAssemblyItemInput>>;
  pcbFabricationItems?: InputMaybe<Array<CapaQuotationDetailedQuotationPcbFabricationItemInput>>;
  /** 공급자 연락처 */
  phone?: InputMaybe<Scalars['String']>;
  /** 공급가액 */
  quotation?: InputMaybe<Scalars['Float']>;
  /** 공급자 이메일 */
  quotationEmail: Scalars['String'];
  rfqId: Scalars['String'];
};

export type CreateNoticeScheduleInput = {
  /** 점검 종료 시간 */
  endTime: Scalars['String'];
  /** 긴급점검 / 사전점검 등 */
  noticeType: NoticeScheduleNoticeType;
  /** client partner connect 인지 */
  pageType: NoticeScheduleNoticePageType;
  /** 사전점검 종료 시간 */
  previewEndTime?: InputMaybe<Scalars['String']>;
  /** 사전점검 시작 시간 */
  previewStartTime?: InputMaybe<Scalars['String']>;
  /** 점검 시작 시간 */
  startTime: Scalars['String'];
};

export type CreatePaymentInput = {
  /** 채팅방 상태 */
  chatRoomStatus?: InputMaybe<CapaQuotationChatRoomStatus>;
  partnerId: Scalars['String'];
  pgProvider: CapapgProviders;
  purchaseOrderId: Scalars['String'];
  refundAccountInfo?: InputMaybe<CapaAccountInfo>;
  rfqId: Scalars['String'];
  transactionId: Scalars['String'];
};

export type CreatePurchaseOrderInput = {
  /** 배송비 */
  deliveryCost?: InputMaybe<Scalars['Float']>;
  /** 수정 범위 및 추가 과금 기준 */
  draftModificationTerms?: InputMaybe<Scalars['String']>;
  /** 검수 기간 */
  inspectionPeriod?: InputMaybe<Scalars['Float']>;
  /** 검수 항목 */
  inspections?: InputMaybe<Array<CapaQuotationRfqPurchaseOrderInspectionInput>>;
  items?: InputMaybe<Array<CapaQuotationDetailedQuotationItemInput>>;
  /** 발주처 담당자명 */
  managerName: Scalars['String'];
  /** 최대 시안 수정 횟수 */
  maxDraftModificationCount?: InputMaybe<Scalars['Float']>;
  partnerId: Scalars['String'];
  /** 결제 정보 */
  payment?: InputMaybe<Array<CapaQuotationRfqPurchaseOrderProvisionInput>>;
  pcbAssemblyItems?: InputMaybe<Array<CapaQuotationDetailedPcbAssemblyItemInput>>;
  pcbFabricationItems?: InputMaybe<Array<CapaQuotationDetailedPcbFabricationItemInput>>;
  /** 발주처 연락처 */
  phone: Scalars['String'];
  /** 발주처 이메일 */
  purchaseOrderEmail: Scalars['String'];
  /** 공급가액 */
  quotation?: InputMaybe<Scalars['Float']>;
  quotationId: Scalars['String'];
  rfqId: Scalars['String'];
  /** 납품주소 */
  shipAddress: Scalars['String'];
  /** 납품일 */
  shipDate: Scalars['String'];
  /** 납품상세주소 */
  shipDetailAddress?: InputMaybe<Scalars['String']>;
  /** 이관 보관 기간(N개월) */
  transferStorage?: InputMaybe<Scalars['Float']>;
  /** 이관 조건 */
  transferTerms?: InputMaybe<CapaRfqPurchaseOrderTransferTermsType>;
};

export type CreateQuotationAnnotationCommentInput = {
  annotationId: Scalars['String'];
  comment?: InputMaybe<Scalars['String']>;
};

export type CreateQuotationAnnotationInput = {
  anchorPos?: InputMaybe<Capa3DPosInput>;
  chatRoomId: Scalars['String'];
  comment?: InputMaybe<Scalars['String']>;
  filterType: CapaQuotationChatRoomSharedFileType;
  handlePos?: InputMaybe<Capa3DPosInput>;
  nodeId?: InputMaybe<Scalars['Float']>;
  quotationSharedFileId: Scalars['String'];
};

export type CreateQuotationChatRoomInput = {
  rfqId?: InputMaybe<Scalars['String']>;
};

export type CreateSimpleQuotationInput = {
  etc?: InputMaybe<Scalars['String']>;
  /** false : include delevery fee, true : exclude delevery fee */
  excludeDeliveryFee?: InputMaybe<Scalars['Boolean']>;
  partnerId: Scalars['String'];
  quotation?: InputMaybe<Scalars['Float']>;
  rfqId: Scalars['String'];
};

/** 구매확정(지급승인) 지연 */
export type DelayConfirmEscrowPurchaseInput = {
  /** 지급일 연장 사유 */
  extendReason?: InputMaybe<Scalars['String']>;
  /** 발주서 id */
  purchaseOrderId: Scalars['String'];
};

export type DeleteQuotationChatMessageInput = {
  deleteTargetMsgId: Scalars['String'];
};

export type DesignServiceInput = {
  serviceType: CapaDesignServiceType;
};

export enum EscrowPaymentRequestType {
  /** 구매확정 */
  ConfirmPurchase = 'CONFIRM_PURCHASE',
  /** 구매확정 거절 */
  RefusePurchase = 'REFUSE_PURCHASE',
  /** 배송등록 */
  RegisterShipping = 'REGISTER_SHIPPING'
}

export type EvaluateRfqPartnerInput = {
  detailed?: InputMaybe<Scalars['Boolean']>;
  etc?: InputMaybe<Scalars['String']>;
  helpful?: InputMaybe<Scalars['Boolean']>;
  kind?: InputMaybe<Scalars['Boolean']>;
  quick?: InputMaybe<Scalars['Boolean']>;
  quotationPartnerId: Scalars['String'];
};

export type EvaluateRfqPartnersInput = {
  partners: Array<EvaluateRfqPartnerInput>;
  rfqId: Scalars['String'];
};

export type ExpireRfqInput = {
  rfqId: Scalars['String'];
};

export type FactoronBizFetchIcxInput = {
  factoronBizSearchType?: InputMaybe<FactoronBizSearchType>;
  keyword?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Float']>;
  offset?: InputMaybe<Scalars['Float']>;
};

/** FactoronBizSearchType */
export enum FactoronBizSearchType {
  /** 회사명 */
  CompanyName = 'COMPANY_NAME',
  /** 공장대표주소 (도로명) */
  FactoryAddressRoadnam = 'FACTORY_ADDRESS_ROADNAM',
  /** 공장크기 */
  FactorySize = 'FACTORY_SIZE',
  /** 업종명 */
  IndustryName = 'INDUSTRY_NAME',
  /** 관할조직명 */
  JurisdictionOrganizationName = 'JURISDICTION_ORGANIZATION_NAME',
  /** 생산품 */
  Product = 'PRODUCT'
}

export type FavoriteRfqInput = {
  rfqId: Scalars['String'];
};

export type FetchActiveAdvertisingBoInput = {
  /** 광고 타입 (배너, 카드) */
  advertisementTypes: Array<CapaAdvertisementType>;
  /** 호스팅할 서비스 타입 (배너, 카드) */
  serviceType: CapaServiceType;
};

export type FetchActiveAdvertisingInput = {
  /** 광고 타입 (배너, 카드) */
  advertisementTypes: Array<CapaAdvertisementType>;
  /** 호스팅할 서비스 타입 (배너, 카드) */
  serviceType: CapaServiceType;
};

export type FetchAdsActivityLogsInput = {
  /** asd impression id */
  adsImpressionId: Scalars['String'];
};

export type FetchAdsImpressionsBoInput = {
  /** adsImpression ids */
  adsImpressionIds: Array<Scalars['String']>;
};

export type FetchAdvertisementAdsImpressionsBoInput = {
  /** advertisement id */
  advertisementId: Scalars['String'];
};

export type FetchAdvertisementsBoInput = {
  limit?: InputMaybe<Scalars['Float']>;
  offset?: InputMaybe<Scalars['Float']>;
};

export type FetchAdvertisingsBoInput = {
  limit?: InputMaybe<Scalars['Float']>;
  offset?: InputMaybe<Scalars['Float']>;
};

export type FetchAllIcxInput = {
  companyScale: Array<IndustrialCompanyScale>;
  employeesCountSortType?: InputMaybe<CapaSortType>;
  icxRegion: Array<IcxRegion>;
  industrialBizSearchType?: InputMaybe<IndustrialBizSearchType>;
  industrialComplexList: Array<IndustrialComplexName>;
  industryCategory: Array<IndustrialSectorsCategory>;
  limit?: InputMaybe<Scalars['Float']>;
  offset?: InputMaybe<Scalars['Float']>;
  searchKeyword?: InputMaybe<Scalars['String']>;
  sectors: Array<IndustrialSectorsName>;
};

/** FetchAvailableFilterRfqsInput */
export type FetchAvailableFilterRfqsInput = {
  isFavorite?: InputMaybe<Scalars['Boolean']>;
  limit?: InputMaybe<Scalars['Float']>;
  offset?: InputMaybe<Scalars['Float']>;
  productPurposes?: InputMaybe<Array<CapaQuotationProductPurpose>>;
  serviceType?: InputMaybe<CapaFilterableServiceType>;
};

export type FetchBoAmbassadorInvitationStatusInput = {
  ambassadorId: Scalars['String'];
  limit?: InputMaybe<Scalars['Float']>;
  offset?: InputMaybe<Scalars['Float']>;
};

export type FetchBoAmbassadorsInput = {
  limit?: InputMaybe<Scalars['Float']>;
  offset?: InputMaybe<Scalars['Float']>;
};

export type FetchBoTestUsersInput = {
  limit?: InputMaybe<Scalars['Float']>;
  offset?: InputMaybe<Scalars['Float']>;
};

export type FetchBoUsersInput = {
  limit?: InputMaybe<Scalars['Float']>;
  offset?: InputMaybe<Scalars['Float']>;
};

export type FetchBoMemosInput = {
  /** 유저 id */
  userId: Scalars['String'];
  /** 유저 타입 */
  userType: Scalars['String'];
};

export type FetchCxManagementRequiredUsersBoInput = {
  limit?: InputMaybe<Scalars['Float']>;
  offset?: InputMaybe<Scalars['Float']>;
};

export type FetchCapaConnectSharedFileInput = {
  fileType?: InputMaybe<CapaConnectSharedFileType>;
  groupId: Scalars['String'];
  keyword?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Float']>;
  offset?: InputMaybe<Scalars['Float']>;
  sortFileType?: InputMaybe<ConnectFileSortType>;
};

export type FetchCapabilityInput = {
  /** 캐파 견적 서비스 타입 */
  serviceType?: InputMaybe<Array<CapaQuotationServiceType>>;
};

export type FetchCommentsBoInput = {
  /** quotation user id */
  quotationUserId: Scalars['String'];
};

export type FetchConfirmDetailedQuotationInput = {
  quotationPartnerId: Scalars['String'];
  rfqId: Scalars['String'];
};

export type FetchConfirmPurchaseOrderInput = {
  quotationPartnerId: Scalars['String'];
  rfqId: Scalars['String'];
};

export type FetchConnectAnnotationsInput = {
  connectSharedFileId?: InputMaybe<Scalars['String']>;
  groupId: Scalars['String'];
  limit?: InputMaybe<Scalars['Float']>;
  offset?: InputMaybe<Scalars['Float']>;
};

export type FetchConnectChatRoomInput = {
  chatRoomId: Scalars['String'];
  limit?: InputMaybe<Scalars['Float']>;
  offset?: InputMaybe<Scalars['Float']>;
};

export type FetchConnectFeedbacksBoInput = {
  filter?: InputMaybe<CapaBackOfficeUsersFilterType>;
  limit?: InputMaybe<Scalars['Float']>;
  offset?: InputMaybe<Scalars['Float']>;
};

export type FetchConnectFileDetailInput = {
  fileId: Scalars['String'];
};

export type FetchConnectGroupChatRoomInput = {
  id: Scalars['String'];
};

export type FetchConnectGroupChatRoomsInput = {
  limit?: InputMaybe<Scalars['Float']>;
  offset?: InputMaybe<Scalars['Float']>;
};

export type FetchConnectGroupFeedbacksBoInput = {
  groupId?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Float']>;
  offset?: InputMaybe<Scalars['Float']>;
};

export type FetchConnectGroupFilePermissionInput = {
  connectFileId: Scalars['String'];
  groupId: Scalars['String'];
};

export type FetchConnectGroupInput = {
  fileType?: InputMaybe<CapaConnectSharedFileType>;
  groupId: Scalars['String'];
  keyword?: InputMaybe<Scalars['String']>;
  sortFileType?: InputMaybe<ConnectFileSortType>;
};

export type FetchConnectGroupIssuesBoInput = {
  groupId?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Float']>;
  offset?: InputMaybe<Scalars['Float']>;
};

export type FetchConnectGroupsBoInput = {
  filter?: InputMaybe<CapaBackOfficeConnectGroupsFilterType>;
  limit?: InputMaybe<Scalars['Float']>;
  offset?: InputMaybe<Scalars['Float']>;
};

export type FetchConnectGroupsInput = {
  limit?: InputMaybe<Scalars['Float']>;
  offset?: InputMaybe<Scalars['Float']>;
};

export type FetchConnectIssuesBoInput = {
  filter?: InputMaybe<CapaBackOfficeUsersFilterType>;
  limit?: InputMaybe<Scalars['Float']>;
  offset?: InputMaybe<Scalars['Float']>;
};

export type FetchConnectMyDriveInput = {
  isLatest?: InputMaybe<Scalars['Boolean']>;
  limit?: InputMaybe<Scalars['Float']>;
  offset?: InputMaybe<Scalars['Float']>;
  pathId?: InputMaybe<Scalars['String']>;
};

export type FetchConnectUserContactListInput = {
  contactUserEmail?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Float']>;
  offset?: InputMaybe<Scalars['Float']>;
};

export type FetchConnectUserFeedbacksBoInput = {
  connectUserId: Scalars['String'];
  limit?: InputMaybe<Scalars['Float']>;
  offset?: InputMaybe<Scalars['Float']>;
};

export type FetchConnectUserFileLinkBoOutput = {
  __typename?: 'FetchConnectUserFileLinkBOOutput';
  data?: Maybe<CapaConnectUserFileLinksBo>;
  /** errorMessage */
  errorMessage?: Maybe<Scalars['String']>;
  /** CAPA ERROR CODE */
  result: CapaErrorCode;
};

export type FetchConnectUserFileLinksBoInput = {
  filter?: InputMaybe<CapaBackOfficeUsersFilterType>;
  limit?: InputMaybe<Scalars['Float']>;
  offset?: InputMaybe<Scalars['Float']>;
};

export type FetchConnectUserIssuesBoInput = {
  connectUserId: Scalars['String'];
  limit?: InputMaybe<Scalars['Float']>;
  offset?: InputMaybe<Scalars['Float']>;
};

export type FetchConnectUserLinkFile = {
  __typename?: 'FetchConnectUserLinkFile';
  files?: Maybe<Array<CapaConnectMyFile>>;
};

/** 내 정보 */
export type FetchConnectUserLinkFileInput = {
  /** if status logged in */
  email?: InputMaybe<Scalars['String']>;
  /** 아이피 */
  ip: Scalars['String'];
  /** shareLink */
  shareLink: Array<Scalars['String']>;
};

export type FetchConnectUserLinkFileOutput = {
  __typename?: 'FetchConnectUserLinkFileOutput';
  data?: Maybe<FetchConnectUserLinkFile>;
  /** errorMessage */
  errorMessage?: Maybe<Scalars['String']>;
  /** CAPA ERROR CODE */
  result: CapaErrorCode;
};

export type FetchConnectUsersBoInput = {
  filter?: InputMaybe<CapaBackOfficeUsersFilterType>;
  limit?: InputMaybe<Scalars['Float']>;
  offset?: InputMaybe<Scalars['Float']>;
};

export type FetchDetailedQuotationInput = {
  quotationId: Scalars['String'];
  rfqId: Scalars['String'];
};

export type FetchFileConversionStatusInput = {
  fileId: Scalars['String'];
};

/** fetchInProgressQuotationPartnerChatRoomsInput */
export type FetchInProgressQuotationPartnerChatRoomsInput = {
  limit?: InputMaybe<Scalars['Float']>;
  offset?: InputMaybe<Scalars['Float']>;
  serviceType: CapaQuotationServiceType;
};

/** itp 이벤트 목록 표출 BO */
export type FetchItpEventsBoInput = {
  /** itp 이벤트 목록 타입 */
  listType?: InputMaybe<CapaItpEventListTypeEnum>;
  /** 고객 아이디 Filter */
  quotationUserId?: InputMaybe<Scalars['String']>;
};

/** jsb 이벤트 목록 표출 BO */
export type FetchJsbEventsBoInput = {
  /** jsb 이벤트 목록 타입 */
  listType?: InputMaybe<CapaJsbEventListTypeEnum>;
  /** 고객 아이디 Filter */
  quotationUserId?: InputMaybe<Scalars['String']>;
};

export type FetchMyCompleteRfqsInput = {
  complete: Scalars['Boolean'];
};

/** 캐파 클라우드 회원가입 */
export type FetchMyDriveInput = {
  limit?: InputMaybe<Scalars['Float']>;
  offset?: InputMaybe<Scalars['Float']>;
};

export type FetchMyReceivedQuotationsInput = {
  limit?: InputMaybe<Scalars['Float']>;
  offset?: InputMaybe<Scalars['Float']>;
  rfqId?: InputMaybe<Scalars['String']>;
};

export type FetchMyRfqQuotationsInput = {
  limit?: InputMaybe<Scalars['Float']>;
  offset?: InputMaybe<Scalars['Float']>;
  quotationPartnerId: Scalars['String'];
  rfqId: Scalars['String'];
};

export type FetchNotificationInput = {
  lastSeq?: InputMaybe<Scalars['Float']>;
  limit?: InputMaybe<Scalars['Float']>;
  offset?: InputMaybe<Scalars['Float']>;
  /** 캐파 서비스 타입 */
  service: CapaServiceType;
};

export type FetchOneIcxInput = {
  id: Scalars['String'];
};

export type FetchPartnerRfqReviewsInput = {
  quotationPartnerId: Scalars['String'];
};

export type FetchPartnersInput = {
  companyRegistration?: InputMaybe<Scalars['Boolean']>;
  includeTest?: InputMaybe<Scalars['Boolean']>;
  isItp?: InputMaybe<Scalars['Boolean']>;
  limit?: InputMaybe<Scalars['Float']>;
  offset?: InputMaybe<Scalars['Float']>;
  searchField?: InputMaybe<CapaSearchPartnersBoFieldType>;
  searchItem?: InputMaybe<Scalars['String']>;
  serviceType?: InputMaybe<CapaQuotationServiceType>;
  /** 정렬필드 */
  sortField?: InputMaybe<CapaSortPartnersBoFieldType>;
  /** 정렬 차순 - asc,desc */
  sortType?: InputMaybe<CapaSortType>;
  status?: InputMaybe<CapaQuotationPartnerStatus>;
};

export type FetchPaymentAgentResultInput = {
  mid?: InputMaybe<Scalars['String']>;
  /** 원하는 날짜 조회 YYYYMMDD 형식 */
  settlmntDt?: InputMaybe<Scalars['String']>;
  subId?: InputMaybe<Scalars['String']>;
};

export type FetchPaymentManageByPartnerIdInput = {
  limit?: InputMaybe<Scalars['Float']>;
  offset?: InputMaybe<Scalars['Float']>;
  quotationPartnerId: Scalars['String'];
};

export type FetchPaymentManageByQuotationUserIdInput = {
  limit?: InputMaybe<Scalars['Float']>;
  offset?: InputMaybe<Scalars['Float']>;
  quotationUserId: Scalars['String'];
};

/** FetchProjectManagementReceivedQuotationsInput */
export type FetchProjectManagementReceivedQuotationsInput = {
  limit?: InputMaybe<Scalars['Float']>;
  offset?: InputMaybe<Scalars['Float']>;
  rfqId?: InputMaybe<Scalars['String']>;
};

export type FetchPurchaseOrderInput = {
  purchaseOrderId: Scalars['String'];
  rfqId: Scalars['String'];
};

export type FetchPurchaseOrderPaymentData = {
  __typename?: 'FetchPurchaseOrderPaymentData';
  createdAt: Scalars['String'];
  paymentMethod: CapaPaymentMethodType;
  pgProvider: CapapgProviders;
  /** purchase order id */
  purchaseOrderId?: Maybe<Scalars['String']>;
  quotationId: Scalars['String'];
  /** quotation partner id */
  quotationPartnerId: Scalars['String'];
  /** quotation partner user id */
  quotationPartnerUserId: Scalars['String'];
  /** quotation user id */
  quotationUserId: Scalars['String'];
  /** rfq id */
  rfqId: Scalars['String'];
  /** total amount */
  totalAmount: Scalars['Float'];
  virtualAccount?: Maybe<VirtualAccountInfo>;
};

export type FetchPurchaseOrdersBoInput = {
  limit?: InputMaybe<Scalars['Float']>;
  offset?: InputMaybe<Scalars['Float']>;
  purchaseOrderCreatedAt?: InputMaybe<Scalars['String']>;
  quotationPartnerId: Scalars['String'];
  rfqId: Scalars['String'];
};

export type FetchPurchaseOrdersInput = {
  limit?: InputMaybe<Scalars['Float']>;
  offset?: InputMaybe<Scalars['Float']>;
  quotationPartnerId: Scalars['String'];
  rfqId: Scalars['String'];
};

/** QuotationChatRoomSharedFilesInput */
export type FetchQuotationChatRoomAnnotationCommentInput = {
  chatRoomId: Scalars['String'];
};

export type FetchQuotationChatRoomInput = {
  chatRoomId: Scalars['String'];
  lastMessageId?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Float']>;
  offset?: InputMaybe<Scalars['Float']>;
};

/** QuotationChatRoomSharedFilesInput */
export type FetchQuotationChatRoomSharedFilesInput = {
  chatRoomId: Scalars['String'];
  filterType: CapaQuotationChatRoomSharedFilesFilterType;
};

/** fetchQuotationChatRoomSpecificAnnotationInput */
export type FetchQuotationChatRoomSpecificAnnotationBoInput = {
  chatRoomId: Scalars['String'];
  filterType: CapaQuotationChatRoomSharedFileType;
  quotationSharedFileId: Scalars['String'];
  userId: Scalars['String'];
};

/** fetchQuotationChatRoomSpecificAnnotationInput */
export type FetchQuotationChatRoomSpecificAnnotationInput = {
  chatRoomId: Scalars['String'];
  filterType: CapaQuotationChatRoomSharedFileType;
  quotationSharedFileId: Scalars['String'];
};

export type FetchQuotationPartnerActivityInput = {
  quotationPartnerId?: InputMaybe<Scalars['String']>;
};

export type FetchQuotationPartnerChatRoomsInput = {
  chatRoomsFilter?: InputMaybe<CapaQuotationChatRoomsFilterType>;
  limit?: InputMaybe<Scalars['Float']>;
  offset?: InputMaybe<Scalars['Float']>;
};

/** FetchQuotationPartnerManagementRfqsInput */
export type FetchQuotationPartnerManagementRfqsInput = {
  limit?: InputMaybe<Scalars['Float']>;
  offset?: InputMaybe<Scalars['Float']>;
};

/** FetchQuotationPartnerProjectManagementDetailInput */
export type FetchQuotationPartnerProjectManagementDetailInput = {
  rfqId: Scalars['String'];
};

export type FetchQuotationPartnerRfqReviewInput = {
  limit?: InputMaybe<Scalars['Float']>;
  offset?: InputMaybe<Scalars['Float']>;
  quotationPartnerId?: InputMaybe<Scalars['String']>;
};

export type FetchQuotationPartnerStrategyBoInput = {
  limit?: InputMaybe<Scalars['Float']>;
  offset?: InputMaybe<Scalars['Float']>;
  quotationPartnerId: Scalars['String'];
};

export type FetchQuotationUserBoInput = {
  limit?: InputMaybe<Scalars['Float']>;
  offset?: InputMaybe<Scalars['Float']>;
  quotationUserId: Scalars['String'];
};

export type FetchQuotationUserChatRoomsInput = {
  chatRoomsFilter?: InputMaybe<CapaQuotationChatRoomsFilterType>;
  limit?: InputMaybe<Scalars['Float']>;
  offset?: InputMaybe<Scalars['Float']>;
};

/** FetchQuotationUserProjectManagementDetailInput */
export type FetchQuotationUserProjectManagementDetailInput = {
  rfqId: Scalars['String'];
};

/** FetchQuotationUserProjectManagementRfqsInput */
export type FetchQuotationUserProjectManagementRfqsInput = {
  limit?: InputMaybe<Scalars['Float']>;
  offset?: InputMaybe<Scalars['Float']>;
};

export type FetchQuotationUserRfqReviewsInput = {
  limit?: InputMaybe<Scalars['Float']>;
  offset?: InputMaybe<Scalars['Float']>;
  quotationUserId?: InputMaybe<Scalars['String']>;
};

export type FetchQuotationUserRfqsBoInput = {
  limit?: InputMaybe<Scalars['Float']>;
  offset?: InputMaybe<Scalars['Float']>;
  quotationUserId?: InputMaybe<Scalars['String']>;
};

export type FetchQuotationUserRfqsInput = {
  limit?: InputMaybe<Scalars['Float']>;
  offset?: InputMaybe<Scalars['Float']>;
};

/** 캐파 커넥트 유저 정보 */
export type FetchRecommendedContactList = {
  __typename?: 'FetchRecommendedContactList';
  /** capa user email */
  email: Scalars['String'];
  isCapaUser?: Maybe<Scalars['Boolean']>;
  /** nick name */
  nickName?: Maybe<Scalars['String']>;
};

export type FetchRecommendedContactListsOutput = {
  __typename?: 'FetchRecommendedContactListsOutput';
  data?: Maybe<Array<FetchRecommendedContactList>>;
  /** errorMessage */
  errorMessage?: Maybe<Scalars['String']>;
  /** CAPA ERROR CODE */
  result: CapaErrorCode;
};

export type FetchRecommendedContactUserListInput = {
  chatRoomUserId: Scalars['String'];
  limit?: InputMaybe<Scalars['Float']>;
  offset?: InputMaybe<Scalars['Float']>;
};

export type FetchRfqInput = {
  rfqId: Scalars['String'];
};

export type FetchRfqPartnerEvaluationInput = {
  quotationPartnerId?: InputMaybe<Scalars['String']>;
};

export type FetchRfqQuotationsBoInput = {
  limit?: InputMaybe<Scalars['Float']>;
  offset?: InputMaybe<Scalars['Float']>;
  quotationCreatedAt?: InputMaybe<Scalars['String']>;
  quotationPartnerId: Scalars['String'];
  rfqId: Scalars['String'];
};

export type FetchRfqReviewBoInput = {
  includeTest?: InputMaybe<Scalars['Boolean']>;
  limit?: InputMaybe<Scalars['Float']>;
  offset?: InputMaybe<Scalars['Float']>;
  quotationPartnerId?: InputMaybe<Scalars['String']>;
};

export type FetchRfqsInput = {
  detailedMaterials?: InputMaybe<Array<CapaQuotationDetailedMaterialType>>;
  detailedServiceTypes?: InputMaybe<Array<CapaQuotationDetailedServiceType>>;
  eventType?: InputMaybe<CapaQuotationRfqEventType>;
  favorite?: InputMaybe<Scalars['Boolean']>;
  inludeTest?: InputMaybe<Scalars['Boolean']>;
  limit?: InputMaybe<Scalars['Float']>;
  materials?: InputMaybe<Array<CapaQuotationMaterial>>;
  offset?: InputMaybe<Scalars['Float']>;
  optionalServices?: InputMaybe<Array<CapaQuotationServiceType>>;
  productPurposes?: InputMaybe<Array<CapaQuotationProductPurpose>>;
  /** 진척도 */
  rfqProgress?: InputMaybe<CapaRfqProgressBoStatus>;
  /** 검색필드 */
  searchField?: InputMaybe<CapaSearchRfqsBoFieldType>;
  /** 검색아이템 */
  searchItem?: InputMaybe<Scalars['String']>;
  serviceType?: InputMaybe<CapaQuotationServiceType>;
  /** 정렬필드 */
  sortField?: InputMaybe<CapaSortRfqsBoFieldType>;
  /** 정렬 차순 - asc,desc */
  sortType?: InputMaybe<CapaSortType>;
  /** rfq 상태 */
  status?: InputMaybe<CapaRfqStatus>;
};

export type FetchServiceRatingBoInput = {
  includeTest?: InputMaybe<Scalars['Boolean']>;
  limit?: InputMaybe<Scalars['Float']>;
  offset?: InputMaybe<Scalars['Float']>;
  ratingLimit?: InputMaybe<Scalars['Float']>;
  ratingOffset?: InputMaybe<Scalars['Float']>;
  userType?: InputMaybe<CapaQuotationUserType>;
};

export type FetchServiceSuggestionBoInput = {
  includeTest?: InputMaybe<Scalars['Boolean']>;
  limit?: InputMaybe<Scalars['Float']>;
  offset?: InputMaybe<Scalars['Float']>;
  userType?: InputMaybe<CapaQuotationUserType>;
};

export type FetchServiceTypeStatisticsInput = {
  serviceType: CapaQuotationServiceType;
};

export type FetchUsersInput = {
  bizType?: InputMaybe<CapaQuotationUserBizType>;
  companyRegistrationNumber?: InputMaybe<Scalars['Boolean']>;
  includeTest?: InputMaybe<Scalars['Boolean']>;
  limit?: InputMaybe<Scalars['Float']>;
  offset?: InputMaybe<Scalars['Float']>;
  /** 검색필드 */
  searchField?: InputMaybe<CapaSearchQuotationUsersBoFieldType>;
  /** 검색아이템 */
  searchItem?: InputMaybe<Scalars['String']>;
  /** 정렬필드 */
  sortField?: InputMaybe<CapaSortUsersBoFieldType>;
  /** 정렬 차순 - asc,desc */
  sortType?: InputMaybe<CapaSortType>;
  status?: InputMaybe<CapaQuotationUserStatus>;
};

export type FetchWithdrawnChatRoomsInput = {
  chatRoomsFilter?: InputMaybe<CapaQuotationChatRoomsFilterType>;
  limit?: InputMaybe<Scalars['Float']>;
  offset?: InputMaybe<Scalars['Float']>;
  /** 캐파 서비스 */
  serviceType?: InputMaybe<CapaServiceType>;
};

export type IcxAuthentication = {
  __typename?: 'IcxAuthentication';
  /** JWT */
  accessToken: Scalars['String'];
  expiresIn: Scalars['Float'];
  redirectUrl?: Maybe<Scalars['String']>;
  /** JWT */
  refreshToken: Scalars['String'];
  tokenType: Scalars['String'];
};

/** icx 로그인 */
export type IcxAuthenticationInput = {
  /** device token */
  deviceToken?: InputMaybe<Scalars['String']>;
  /** Ateam에서 지정해준 비밀번호 */
  password: Scalars['String'];
};

export type IcxAuthenticationOutput = {
  __typename?: 'IcxAuthenticationOutput';
  data?: Maybe<IcxAuthentication>;
  /** errorMessage */
  errorMessage?: Maybe<Scalars['String']>;
  /** CAPA ERROR CODE */
  result: CapaErrorCode;
};

export type IcxDetatilModel = {
  __typename?: 'IcxDetatilModel';
  activitiesIndustryClassification_1?: Maybe<Scalars['String']>;
  activitiesIndustryClassification_2?: Maybe<Scalars['String']>;
  activitiesIndustryClassification_3?: Maybe<Scalars['String']>;
  activitiesProductName_1?: Maybe<Scalars['String']>;
  activitiesProductName_2?: Maybe<Scalars['String']>;
  activitiesProductName_3?: Maybe<Scalars['String']>;
  activitiesProductType_1?: Maybe<Scalars['String']>;
  activitiesProductType_2?: Maybe<Scalars['String']>;
  activitiesProductType_3?: Maybe<Scalars['String']>;
  activitiesSectors_1?: Maybe<Scalars['String']>;
  activitiesSectors_2?: Maybe<Scalars['String']>;
  activitiesSectors_3?: Maybe<Scalars['String']>;
  activityCharacteristics_1?: Maybe<Scalars['String']>;
  activityCharacteristics_2?: Maybe<Scalars['String']>;
  activityCharacteristics_3?: Maybe<Scalars['String']>;
  activityCharacteristics_4?: Maybe<Scalars['String']>;
  activityCharacteristics_5?: Maybe<Scalars['String']>;
  activityCharacteristics_6?: Maybe<Scalars['String']>;
  activityCharacteristics_7?: Maybe<Scalars['String']>;
  basicAreaNumber?: Maybe<Scalars['String']>;
  basicCity?: Maybe<Scalars['String']>;
  basicCompanyName?: Maybe<Scalars['String']>;
  basicCompanyScale?: Maybe<Scalars['String']>;
  basicComplexAbbreviatedName?: Maybe<Scalars['String']>;
  basicComplexDivision?: Maybe<Scalars['String']>;
  basicComplexId?: Maybe<Scalars['String']>;
  basicComplexName?: Maybe<Scalars['String']>;
  basicCounty?: Maybe<Scalars['String']>;
  basicFactoryManagementNumber?: Maybe<Scalars['String']>;
  basicHeadquarters?: Maybe<Scalars['String']>;
  basicIndustrial?: Maybe<Scalars['String']>;
  basicIndustryCategory?: Maybe<Scalars['String']>;
  basicIndustryCode?: Maybe<Scalars['String']>;
  basicIndustryMiddleCategory?: Maybe<Scalars['String']>;
  basicKnowledgeIndustryCenter?: Maybe<Scalars['String']>;
  basicListId?: Maybe<Scalars['String']>;
  basicListStandard?: Maybe<Scalars['String']>;
  basicMapNumber?: Maybe<Scalars['String']>;
  basicNote?: Maybe<Scalars['String']>;
  basicResearchId?: Maybe<Scalars['String']>;
  basicSerialNumber?: Maybe<Scalars['String']>;
  employees2019Above_60Others?: Maybe<Scalars['String']>;
  employees2019Above_60Rnd?: Maybe<Scalars['String']>;
  employees2019Above_60SkilledForeigner?: Maybe<Scalars['String']>;
  employees2019Above_60SkilledLocals?: Maybe<Scalars['String']>;
  employees2019Above_60Total?: Maybe<Scalars['String']>;
  employees2019FullTimeForeignerWoman?: Maybe<Scalars['String']>;
  employees2019FullTimeLocalWoman?: Maybe<Scalars['String']>;
  employees2019FullTimeOthers?: Maybe<Scalars['String']>;
  employees2019FullTimeRnd?: Maybe<Scalars['String']>;
  employees2019FullTimeSkilledForeigner?: Maybe<Scalars['String']>;
  employees2019FullTimeSkilledLocals?: Maybe<Scalars['String']>;
  employees2019FullTimeTotal?: Maybe<Scalars['String']>;
  employees2019FullTimeWomanOthers?: Maybe<Scalars['String']>;
  employees2019FullTimeWomanRnd?: Maybe<Scalars['String']>;
  employees2019FullTimeWomanTotal?: Maybe<Scalars['String']>;
  employees2019_15_19Others?: Maybe<Scalars['String']>;
  employees2019_15_19Rnd?: Maybe<Scalars['String']>;
  employees2019_15_19SkilledForeigner?: Maybe<Scalars['String']>;
  employees2019_15_19SkilledLocals?: Maybe<Scalars['String']>;
  employees2019_15_19Total?: Maybe<Scalars['String']>;
  employees2019_20_29Others?: Maybe<Scalars['String']>;
  employees2019_20_29Rnd?: Maybe<Scalars['String']>;
  employees2019_20_29SkilledForeigners?: Maybe<Scalars['String']>;
  employees2019_20_29SkilledLocals?: Maybe<Scalars['String']>;
  employees2019_20_29Total?: Maybe<Scalars['String']>;
  employees2019_30_34Others?: Maybe<Scalars['String']>;
  employees2019_30_34Rnd?: Maybe<Scalars['String']>;
  employees2019_30_34SkilledForeigners?: Maybe<Scalars['String']>;
  employees2019_30_34SkilledLocals?: Maybe<Scalars['String']>;
  employees2019_30_34Total?: Maybe<Scalars['String']>;
  employees2019_35_39Others?: Maybe<Scalars['String']>;
  employees2019_35_39Rnd?: Maybe<Scalars['String']>;
  employees2019_35_39SkilledForeigners?: Maybe<Scalars['String']>;
  employees2019_35_39SkilledLocals?: Maybe<Scalars['String']>;
  employees2019_35_39Total?: Maybe<Scalars['String']>;
  employees2019_40_49Others?: Maybe<Scalars['String']>;
  employees2019_40_49Rnd?: Maybe<Scalars['String']>;
  employees2019_40_49SkilledForeigners?: Maybe<Scalars['String']>;
  employees2019_40_49SkilledLocals?: Maybe<Scalars['String']>;
  employees2019_40_49Total?: Maybe<Scalars['String']>;
  employees2019_50_59Others?: Maybe<Scalars['String']>;
  employees2019_50_59Others2?: Maybe<Scalars['String']>;
  employees2019_50_59Rnd?: Maybe<Scalars['String']>;
  employees2019_50_59SkilledForeigners?: Maybe<Scalars['String']>;
  employees2019_50_59SkilledLocals?: Maybe<Scalars['String']>;
  employees2020Above_60Others?: Maybe<Scalars['String']>;
  employees2020Above_60Rnd?: Maybe<Scalars['String']>;
  employees2020Above_60SkilledForeigner?: Maybe<Scalars['String']>;
  employees2020Above_60SkilledLocals?: Maybe<Scalars['String']>;
  employees2020Above_60Total?: Maybe<Scalars['String']>;
  employees2020FullTimeForeignerWoman?: Maybe<Scalars['String']>;
  employees2020FullTimeLocalWoman?: Maybe<Scalars['String']>;
  employees2020FullTimeOthers?: Maybe<Scalars['String']>;
  employees2020FullTimeRnd?: Maybe<Scalars['String']>;
  employees2020FullTimeSkilledForeigner?: Maybe<Scalars['String']>;
  employees2020FullTimeSkilledLocals?: Maybe<Scalars['String']>;
  employees2020FullTimeTotal?: Maybe<Scalars['String']>;
  employees2020FullTimeWomanOthers?: Maybe<Scalars['String']>;
  employees2020FullTimeWomanRnd?: Maybe<Scalars['String']>;
  employees2020FullTimeWomanTotal?: Maybe<Scalars['String']>;
  employees2020_15_19Others?: Maybe<Scalars['String']>;
  employees2020_15_19Rnd?: Maybe<Scalars['String']>;
  employees2020_15_19SkilledForeigner?: Maybe<Scalars['String']>;
  employees2020_15_19SkilledLocals?: Maybe<Scalars['String']>;
  employees2020_15_19Total?: Maybe<Scalars['String']>;
  employees2020_20_29Others?: Maybe<Scalars['String']>;
  employees2020_20_29Rnd?: Maybe<Scalars['String']>;
  employees2020_20_29SkilledForeigners?: Maybe<Scalars['String']>;
  employees2020_20_29SkilledLocals?: Maybe<Scalars['String']>;
  employees2020_20_29Total?: Maybe<Scalars['String']>;
  employees2020_30_34Others?: Maybe<Scalars['String']>;
  employees2020_30_34Rnd?: Maybe<Scalars['String']>;
  employees2020_30_34SkilledForeigners?: Maybe<Scalars['String']>;
  employees2020_30_34SkilledLocals?: Maybe<Scalars['String']>;
  employees2020_30_34Total?: Maybe<Scalars['String']>;
  employees2020_35_39Others?: Maybe<Scalars['String']>;
  employees2020_35_39Rnd?: Maybe<Scalars['String']>;
  employees2020_35_39SkilledForeigners?: Maybe<Scalars['String']>;
  employees2020_35_39SkilledLocals?: Maybe<Scalars['String']>;
  employees2020_35_39Total?: Maybe<Scalars['String']>;
  employees2020_40_49Others?: Maybe<Scalars['String']>;
  employees2020_40_49Rnd?: Maybe<Scalars['String']>;
  employees2020_40_49SkilledForeigners?: Maybe<Scalars['String']>;
  employees2020_40_49SkilledLocals?: Maybe<Scalars['String']>;
  employees2020_40_49Total?: Maybe<Scalars['String']>;
  employees2020_50_59Others?: Maybe<Scalars['String']>;
  employees2020_50_59Rnd?: Maybe<Scalars['String']>;
  employees2020_50_59SkilledForeigners?: Maybe<Scalars['String']>;
  employees2020_50_59SkilledLocals?: Maybe<Scalars['String']>;
  employees2020_50_59Total?: Maybe<Scalars['String']>;
  exportCountryChina?: Maybe<Scalars['String']>;
  exportCountryEurope?: Maybe<Scalars['String']>;
  exportCountryJapan?: Maybe<Scalars['String']>;
  exportCountryLatinAmerica?: Maybe<Scalars['String']>;
  exportCountryMiddleEast?: Maybe<Scalars['String']>;
  exportCountryNote?: Maybe<Scalars['String']>;
  exportCountryOthers?: Maybe<Scalars['String']>;
  exportCountrySoutheastAsia?: Maybe<Scalars['String']>;
  exportCountryUsa?: Maybe<Scalars['String']>;
  exportPerformance2019Absence?: Maybe<Scalars['String']>;
  exportPerformance2019ExportCost?: Maybe<Scalars['String']>;
  exportPerformance2020Absence?: Maybe<Scalars['String']>;
  exportPerformance2020ExportCost?: Maybe<Scalars['String']>;
  exportStatusExportPerformanceIn_19_20?: Maybe<Scalars['String']>;
  exportStatusNoExport?: Maybe<Scalars['String']>;
  exportStatusNotExported?: Maybe<Scalars['String']>;
  exportStatusOtherBusiness?: Maybe<Scalars['String']>;
  exportStatusOthers?: Maybe<Scalars['String']>;
  fullinvestigationAddress?: Maybe<Scalars['String']>;
  fullinvestigationCall?: Maybe<Scalars['String']>;
  fullinvestigationCompanyName?: Maybe<Scalars['String']>;
  fullinvestigationCompanyScale?: Maybe<Scalars['String']>;
  fullinvestigationCorporationNumber?: Maybe<Scalars['String']>;
  fullinvestigationDivision?: Maybe<Scalars['String']>;
  fullinvestigationEmail?: Maybe<Scalars['String']>;
  fullinvestigationFax?: Maybe<Scalars['String']>;
  fullinvestigationGender_1?: Maybe<Scalars['String']>;
  fullinvestigationGender_2?: Maybe<Scalars['String']>;
  fullinvestigationMonth?: Maybe<Scalars['String']>;
  fullinvestigationName_1?: Maybe<Scalars['String']>;
  fullinvestigationName_2?: Maybe<Scalars['String']>;
  fullinvestigationNormal?: Maybe<Scalars['String']>;
  fullinvestigationNumberAddress?: Maybe<Scalars['String']>;
  fullinvestigationOutwardAppearance?: Maybe<Scalars['String']>;
  fullinvestigationRegistrationNumber?: Maybe<Scalars['String']>;
  fullinvestigationStockKosdaq?: Maybe<Scalars['String']>;
  fullinvestigationStockMarket?: Maybe<Scalars['String']>;
  fullinvestigationStreetAddress?: Maybe<Scalars['String']>;
  fullinvestigationWhether?: Maybe<Scalars['String']>;
  fullinvestigationYear?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  keyresultsEmploy_2019?: Maybe<Scalars['String']>;
  keyresultsEmploy_2020?: Maybe<Scalars['String']>;
  keyresultsExport_2019?: Maybe<Scalars['String']>;
  keyresultsExport_2020?: Maybe<Scalars['String']>;
  keyresultsProduce_2019?: Maybe<Scalars['String']>;
  keyresultsProduce_2020?: Maybe<Scalars['String']>;
  productionPerformanceIndustrialComplexBusinessCount?: Maybe<Scalars['String']>;
  productionPerformanceResponseCriteria_1?: Maybe<Scalars['String']>;
  productionPerformanceResponseCriteria_2?: Maybe<Scalars['String']>;
  productionPerformance_2019Cost?: Maybe<Scalars['String']>;
  productionPerformance_2020Cost?: Maybe<Scalars['String']>;
  purchasesBeforePurchase?: Maybe<Scalars['String']>;
  purchasesBusan?: Maybe<Scalars['String']>;
  purchasesChonnam?: Maybe<Scalars['String']>;
  purchasesChungbuk?: Maybe<Scalars['String']>;
  purchasesChungnam?: Maybe<Scalars['String']>;
  purchasesDaejon?: Maybe<Scalars['String']>;
  purchasesGovernment?: Maybe<Scalars['String']>;
  purchasesGwangju?: Maybe<Scalars['String']>;
  purchasesHeadquarters?: Maybe<Scalars['String']>;
  purchasesIncheon?: Maybe<Scalars['String']>;
  purchasesIndividualUnspecifiedMajority?: Maybe<Scalars['String']>;
  purchasesIndustrialComplex1?: Maybe<Scalars['String']>;
  purchasesIndustrialComplex2?: Maybe<Scalars['String']>;
  purchasesIndustrialComplex3?: Maybe<Scalars['String']>;
  purchasesJeju?: Maybe<Scalars['String']>;
  purchasesJeonbuk?: Maybe<Scalars['String']>;
  purchasesKangwon?: Maybe<Scalars['String']>;
  purchasesKyongbok?: Maybe<Scalars['String']>;
  purchasesKyonggi?: Maybe<Scalars['String']>;
  purchasesKyongnam?: Maybe<Scalars['String']>;
  purchasesLargeBusiness?: Maybe<Scalars['String']>;
  purchasesNote?: Maybe<Scalars['String']>;
  purchasesOthers?: Maybe<Scalars['String']>;
  purchasesOthers2?: Maybe<Scalars['String']>;
  purchasesOversearImport?: Maybe<Scalars['String']>;
  purchasesSejong?: Maybe<Scalars['String']>;
  purchasesSeoul?: Maybe<Scalars['String']>;
  purchasesSmallBusiness?: Maybe<Scalars['String']>;
  purchasesTegu?: Maybe<Scalars['String']>;
  purchasesUlsan?: Maybe<Scalars['String']>;
  purchasesUniversity?: Maybe<Scalars['String']>;
  respondantAgreeTerms?: Maybe<Scalars['String']>;
  respondantDate?: Maybe<Scalars['String']>;
  respondantDepartment?: Maybe<Scalars['String']>;
  respondantEmail?: Maybe<Scalars['String']>;
  respondantFaxNumber?: Maybe<Scalars['String']>;
  respondantMonth?: Maybe<Scalars['String']>;
  respondantPhoneNumber?: Maybe<Scalars['String']>;
  respondantRespondant?: Maybe<Scalars['String']>;
  respondantRespondantName?: Maybe<Scalars['String']>;
  respondantRole?: Maybe<Scalars['String']>;
  respondantUserSignature?: Maybe<Scalars['String']>;
  rndInvestment_2019?: Maybe<Scalars['String']>;
  rndInvestment_2020?: Maybe<Scalars['String']>;
  rndPatentApplication_2019?: Maybe<Scalars['String']>;
  rndPatentApplication_2020?: Maybe<Scalars['String']>;
  rndPatentRegistration_2019?: Maybe<Scalars['String']>;
  rndPatentRegistration_2020?: Maybe<Scalars['String']>;
  rndWhether?: Maybe<Scalars['String']>;
  safetyFirstPlace?: Maybe<Scalars['String']>;
  safetyIndustrialRiskAres?: Maybe<Scalars['String']>;
  safetyManagerName?: Maybe<Scalars['String']>;
  safetyManagerPhoneNumber?: Maybe<Scalars['String']>;
  safetyManagerPosition?: Maybe<Scalars['String']>;
  safetyManagerPresence?: Maybe<Scalars['String']>;
  safetySecondPlace?: Maybe<Scalars['String']>;
  solarInstalledCapacity?: Maybe<Scalars['String']>;
  solarInstalledOrNot?: Maybe<Scalars['String']>;
  thirdPartyEmployees2019DispatchedForeignerWomenProduction?: Maybe<Scalars['String']>;
  thirdPartyEmployees2019DispatchedLocalWomenProduction?: Maybe<Scalars['String']>;
  thirdPartyEmployees2019DispatchedOthers?: Maybe<Scalars['String']>;
  thirdPartyEmployees2019DispatchedRnd?: Maybe<Scalars['String']>;
  thirdPartyEmployees2019DispatchedSkilledForeigner?: Maybe<Scalars['String']>;
  thirdPartyEmployees2019DispatchedSkilledLocal?: Maybe<Scalars['String']>;
  thirdPartyEmployees2019DispatchedTotal?: Maybe<Scalars['String']>;
  thirdPartyEmployees2019DispatchedWomenOthers?: Maybe<Scalars['String']>;
  thirdPartyEmployees2019DispatchedWomenRnd?: Maybe<Scalars['String']>;
  thirdPartyEmployees2019DispatchedWomenTotal?: Maybe<Scalars['String']>;
  thirdPartyEmployees2020DispatchedForeignerWomenProduction?: Maybe<Scalars['String']>;
  thirdPartyEmployees2020DispatchedLocalWomenProduction?: Maybe<Scalars['String']>;
  thirdPartyEmployees2020DispatchedOthers?: Maybe<Scalars['String']>;
  thirdPartyEmployees2020DispatchedRnd?: Maybe<Scalars['String']>;
  thirdPartyEmployees2020DispatchedSkilledForeigner?: Maybe<Scalars['String']>;
  thirdPartyEmployees2020DispatchedSkilledLocal?: Maybe<Scalars['String']>;
  thirdPartyEmployees2020DispatchedTotal?: Maybe<Scalars['String']>;
  thirdPartyEmployees2020DispatchedWomenOthers?: Maybe<Scalars['String']>;
  thirdPartyEmployees2020DispatchedWomenRnd?: Maybe<Scalars['String']>;
  thirdPartyEmployees2020DispatchedWomenTotal?: Maybe<Scalars['String']>;
  vendorBeforePurchase?: Maybe<Scalars['String']>;
  vendorBusan?: Maybe<Scalars['String']>;
  vendorChonnam?: Maybe<Scalars['String']>;
  vendorChungbuk?: Maybe<Scalars['String']>;
  vendorChungnam?: Maybe<Scalars['String']>;
  vendorDaejon?: Maybe<Scalars['String']>;
  vendorGovernment?: Maybe<Scalars['String']>;
  vendorGwangju?: Maybe<Scalars['String']>;
  vendorHeadquarters?: Maybe<Scalars['String']>;
  vendorIncheon?: Maybe<Scalars['String']>;
  vendorIndustrialComplex1?: Maybe<Scalars['String']>;
  vendorIndustrialComplex2?: Maybe<Scalars['String']>;
  vendorIndustrialComplex3?: Maybe<Scalars['String']>;
  vendorInvidualUnspecifiedMajority?: Maybe<Scalars['String']>;
  vendorJeju?: Maybe<Scalars['String']>;
  vendorJeonbuk?: Maybe<Scalars['String']>;
  vendorKangwon?: Maybe<Scalars['String']>;
  vendorKyongbok?: Maybe<Scalars['String']>;
  vendorKyonggi?: Maybe<Scalars['String']>;
  vendorKyongnam?: Maybe<Scalars['String']>;
  vendorLargeBusiness?: Maybe<Scalars['String']>;
  vendorNote?: Maybe<Scalars['String']>;
  vendorOthers?: Maybe<Scalars['String']>;
  vendorOthers2?: Maybe<Scalars['String']>;
  vendorOversearDirectExport?: Maybe<Scalars['String']>;
  vendorSejong?: Maybe<Scalars['String']>;
  vendorSeoul?: Maybe<Scalars['String']>;
  vendorSmallBusiness?: Maybe<Scalars['String']>;
  vendorTegu?: Maybe<Scalars['String']>;
  vendorUlsan?: Maybe<Scalars['String']>;
  vendorUniversity?: Maybe<Scalars['String']>;
  workplaceAllCompanyName?: Maybe<Scalars['String']>;
  workplaceBusinessStatus?: Maybe<Scalars['String']>;
  workplaceChina?: Maybe<Scalars['String']>;
  workplaceCity?: Maybe<Scalars['String']>;
  workplaceCountryName_1?: Maybe<Scalars['String']>;
  workplaceCountryName_2?: Maybe<Scalars['String']>;
  workplaceCountryName_3?: Maybe<Scalars['String']>;
  workplaceCountryName_4?: Maybe<Scalars['String']>;
  workplaceCountryName_5?: Maybe<Scalars['String']>;
  workplaceCounty?: Maybe<Scalars['String']>;
  workplaceCurrnetBusiness?: Maybe<Scalars['String']>;
  workplaceEmployeesNumber?: Maybe<Scalars['String']>;
  workplaceEtc?: Maybe<Scalars['String']>;
  workplaceEurope?: Maybe<Scalars['String']>;
  workplaceIndustrialComplexBusinessCount?: Maybe<Scalars['String']>;
  workplaceJapan?: Maybe<Scalars['String']>;
  workplaceLatinAmerica?: Maybe<Scalars['String']>;
  workplaceManyCompany?: Maybe<Scalars['String']>;
  workplaceMiddleEast?: Maybe<Scalars['String']>;
  workplaceMonth?: Maybe<Scalars['String']>;
  workplaceNone?: Maybe<Scalars['String']>;
  workplaceOnlyOneCompany?: Maybe<Scalars['String']>;
  workplaceOverseasCompany?: Maybe<Scalars['String']>;
  workplaceRegistrationStatus?: Maybe<Scalars['String']>;
  workplaceRentCompanyName?: Maybe<Scalars['String']>;
  workplaceSoutheastAsia?: Maybe<Scalars['String']>;
  workplaceStartMonth?: Maybe<Scalars['String']>;
  workplaceStartYear?: Maybe<Scalars['String']>;
  workplaceUsa?: Maybe<Scalars['String']>;
  workplaceWhetherMine?: Maybe<Scalars['String']>;
  workplaceWhetherRent?: Maybe<Scalars['String']>;
  workplaceYear?: Maybe<Scalars['String']>;
};

export type IcxFactoron = {
  __typename?: 'IcxFactoron';
  count?: Maybe<Scalars['Float']>;
  icxModelList?: Maybe<Array<IcxFactoronModel>>;
};

export type IcxFactoronModel = {
  __typename?: 'IcxFactoronModel';
  airQuality?: Maybe<Scalars['String']>;
  ancillaryFacilityArea?: Maybe<Scalars['String']>;
  applicationDate?: Maybe<Scalars['String']>;
  approvalClassification?: Maybe<Scalars['String']>;
  approvalDate?: Maybe<Scalars['String']>;
  birthOrRegistrationNumber?: Maybe<Scalars['String']>;
  buildingArea?: Maybe<Scalars['String']>;
  businessStartDate?: Maybe<Scalars['String']>;
  businessType?: Maybe<Scalars['String']>;
  cancellationDate?: Maybe<Scalars['String']>;
  cancellationReason?: Maybe<Scalars['String']>;
  changeReportDate?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  classificationOfHoldings?: Maybe<Scalars['String']>;
  companyName?: Maybe<Scalars['String']>;
  companyRegistrationNumber?: Maybe<Scalars['String']>;
  contact?: Maybe<Scalars['String']>;
  debtCapitalMillion?: Maybe<Scalars['String']>;
  employeesCount?: Maybe<Scalars['String']>;
  equityMillion?: Maybe<Scalars['String']>;
  establishment?: Maybe<Scalars['String']>;
  estimatedConstructionCompletionDate?: Maybe<Scalars['String']>;
  estimatedConstructionStartDate?: Maybe<Scalars['String']>;
  etcOil?: Maybe<Scalars['String']>;
  expirationPeriod?: Maybe<Scalars['String']>;
  factoryAddressNo?: Maybe<Scalars['String']>;
  factoryAddressRoadName?: Maybe<Scalars['String']>;
  factoryCompletionDate?: Maybe<Scalars['String']>;
  factoryCondition?: Maybe<Scalars['String']>;
  factoryControlNumber?: Maybe<Scalars['String']>;
  factoryManagementNumberOld?: Maybe<Scalars['String']>;
  factorySize?: Maybe<Scalars['String']>;
  factoryWebsite?: Maybe<Scalars['String']>;
  factoryZipCode?: Maybe<Scalars['String']>;
  faxNumber?: Maybe<Scalars['String']>;
  femaleEmployeeCount?: Maybe<Scalars['String']>;
  femaleForeigner?: Maybe<Scalars['String']>;
  firstApprovalDate?: Maybe<Scalars['String']>;
  firstRegistrationDate?: Maybe<Scalars['String']>;
  foreignInvestment?: Maybe<Scalars['String']>;
  foreignInvestmentRatio?: Maybe<Scalars['String']>;
  freeEconomicZone?: Maybe<Scalars['String']>;
  gas?: Maybe<Scalars['String']>;
  horizontalProjectionArea?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  industrialCenterName?: Maybe<Scalars['String']>;
  industrialComplex?: Maybe<Scalars['String']>;
  industrialWater?: Maybe<Scalars['String']>;
  industryName?: Maybe<Scalars['String']>;
  isNoiseVibration?: Maybe<Scalars['String']>;
  jurisdictionOrganizationCode?: Maybe<Scalars['String']>;
  jurisdictionOrganizationName?: Maybe<Scalars['String']>;
  landArea?: Maybe<Scalars['String']>;
  landCategory?: Maybe<Scalars['String']>;
  livingWater?: Maybe<Scalars['String']>;
  mainMaterial?: Maybe<Scalars['String']>;
  maleEmployeeCount?: Maybe<Scalars['String']>;
  maleForeigner?: Maybe<Scalars['String']>;
  manufacturingFacilityArea?: Maybe<Scalars['String']>;
  moveInType?: Maybe<Scalars['String']>;
  no?: Maybe<Scalars['String']>;
  officeArea?: Maybe<Scalars['String']>;
  oil?: Maybe<Scalars['String']>;
  power?: Maybe<Scalars['String']>;
  product?: Maybe<Scalars['String']>;
  reasonChange?: Maybe<Scalars['String']>;
  region?: Maybe<Scalars['String']>;
  registrationCategory?: Maybe<Scalars['String']>;
  registrationDate?: Maybe<Scalars['String']>;
  registrationNumber?: Maybe<Scalars['String']>;
  representativeAddress?: Maybe<Scalars['String']>;
  representativeEmail?: Maybe<Scalars['String']>;
  representativeIndustryCode?: Maybe<Scalars['String']>;
  representativeIndustryNumber?: Maybe<Scalars['String']>;
  representativeName?: Maybe<Scalars['String']>;
  representativePhoneNumber?: Maybe<Scalars['String']>;
  representativeZipCode?: Maybe<Scalars['String']>;
  sectors?: Maybe<Scalars['String']>;
  useArea?: Maybe<Scalars['String']>;
  warehouseArea?: Maybe<Scalars['String']>;
  waterQuality?: Maybe<Scalars['String']>;
};

export type IcxFactoronModelOutput = {
  __typename?: 'IcxFactoronModelOutput';
  data?: Maybe<IcxFactoron>;
  /** errorMessage */
  errorMessage?: Maybe<Scalars['String']>;
  /** CAPA ERROR CODE */
  result: CapaErrorCode;
};

export type IcxInnoBiz = {
  __typename?: 'IcxInnoBiz';
  count?: Maybe<Scalars['Float']>;
  icxModelList?: Maybe<Array<IcxInnoBizModel>>;
};

export type IcxInnoBizModel = {
  __typename?: 'IcxInnoBizModel';
  address?: Maybe<Scalars['String']>;
  companyContact?: Maybe<Scalars['String']>;
  companyName?: Maybe<Scalars['String']>;
  employeesCount?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  industryCode?: Maybe<Scalars['String']>;
  no?: Maybe<Scalars['String']>;
  product?: Maybe<Scalars['String']>;
  relatedIndustry?: Maybe<Scalars['String']>;
  representativeContact?: Maybe<Scalars['String']>;
  representativeEmai?: Maybe<Scalars['String']>;
  representativeName?: Maybe<Scalars['String']>;
};

export type IcxInnoBizModelOutput = {
  __typename?: 'IcxInnoBizModelOutput';
  data?: Maybe<IcxInnoBiz>;
  /** errorMessage */
  errorMessage?: Maybe<Scalars['String']>;
  /** CAPA ERROR CODE */
  result: CapaErrorCode;
};

export type IcxMainBiz = {
  __typename?: 'IcxMainBiz';
  count?: Maybe<Scalars['Float']>;
  icxModelList?: Maybe<Array<IcxMainBizModel>>;
};

export type IcxMainBizModel = {
  __typename?: 'IcxMainBizModel';
  certificationExpirationDate?: Maybe<Scalars['String']>;
  companyName?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  industryCode?: Maybe<Scalars['String']>;
  industryName?: Maybe<Scalars['String']>;
  location?: Maybe<Scalars['String']>;
  no?: Maybe<Scalars['String']>;
  region?: Maybe<Scalars['String']>;
  representativeName?: Maybe<Scalars['String']>;
};

export type IcxMainBizModelOutput = {
  __typename?: 'IcxMainBizModelOutput';
  data?: Maybe<IcxMainBiz>;
  /** errorMessage */
  errorMessage?: Maybe<Scalars['String']>;
  /** CAPA ERROR CODE */
  result: CapaErrorCode;
};

export type IcxMiniCluster = {
  __typename?: 'IcxMiniCluster';
  count?: Maybe<Scalars['Float']>;
  icxModelList?: Maybe<Array<IcxMiniClusterModel>>;
};

export type IcxMiniClusterFetchIcxInput = {
  keyword?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Float']>;
  miniClusterSearchType?: InputMaybe<MiniClusterSearchType>;
  offset?: InputMaybe<Scalars['Float']>;
};

export type IcxMiniClusterModel = {
  __typename?: 'IcxMiniClusterModel';
  base?: Maybe<Scalars['String']>;
  businessRegistrationNumber?: Maybe<Scalars['String']>;
  companyName?: Maybe<Scalars['String']>;
  companyRegistrationDate?: Maybe<Scalars['String']>;
  contact?: Maybe<Scalars['String']>;
  enterpriseType?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  industryUniversityInstituteCollaboration?: Maybe<Scalars['String']>;
  mailAddress?: Maybe<Scalars['String']>;
  memberName?: Maybe<Scalars['String']>;
  miniClusterName?: Maybe<Scalars['String']>;
  region?: Maybe<Scalars['String']>;
  registrationDate?: Maybe<Scalars['String']>;
};

export type IcxMiniClusterModelOutput = {
  __typename?: 'IcxMiniClusterModelOutput';
  data?: Maybe<IcxMiniCluster>;
  /** errorMessage */
  errorMessage?: Maybe<Scalars['String']>;
  /** CAPA ERROR CODE */
  result: CapaErrorCode;
};

export type IcxModel = {
  __typename?: 'IcxModel';
  icxDetatilModelCount?: Maybe<Scalars['Float']>;
  icxDetatilModelList?: Maybe<Array<IcxDetatilModel>>;
};

export type IcxModelOutput = {
  __typename?: 'IcxModelOutput';
  data?: Maybe<IcxDetatilModel>;
  /** errorMessage */
  errorMessage?: Maybe<Scalars['String']>;
  /** CAPA ERROR CODE */
  result: CapaErrorCode;
};

export type IcxModelsOutput = {
  __typename?: 'IcxModelsOutput';
  data?: Maybe<IcxModel>;
  /** errorMessage */
  errorMessage?: Maybe<Scalars['String']>;
  /** CAPA ERROR CODE */
  result: CapaErrorCode;
};

/** 시 도 */
export enum IcxRegion {
  Busan = 'Busan',
  Chungbuk = 'Chungbuk',
  Chungnam = 'Chungnam',
  DaeJeon = 'DaeJeon',
  Daegu = 'Daegu',
  Gangwon = 'Gangwon',
  Geyongbuk = 'Geyongbuk',
  Geyongnam = 'Geyongnam',
  GwangJu = 'GwangJu',
  Gyeonggi = 'Gyeonggi',
  Incheon = 'Incheon',
  Jeju = 'Jeju',
  Jeonbuk = 'Jeonbuk',
  Jeonnam = 'Jeonnam',
  /** NULL */
  Null = 'NULL',
  Seoul = 'Seoul',
  Ulsan = 'Ulsan'
}

/** 토큰 갱신 */
export type IcxTokenRefreshInput = {
  /** refresh 토큰 */
  refreshToken: Scalars['String'];
};

export type IcxVentureBiz = {
  __typename?: 'IcxVentureBiz';
  count?: Maybe<Scalars['Float']>;
  icxModelList?: Maybe<Array<IcxVentureBizModel>>;
};

export type IcxVentureBizModel = {
  __typename?: 'IcxVentureBizModel';
  companyName?: Maybe<Scalars['String']>;
  contact?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  industryName?: Maybe<Scalars['String']>;
  no?: Maybe<Scalars['String']>;
  region?: Maybe<Scalars['String']>;
  relatedIndustry?: Maybe<Scalars['String']>;
};

export type IcxVentureBizModelOutput = {
  __typename?: 'IcxVentureBizModelOutput';
  data?: Maybe<IcxVentureBiz>;
  /** errorMessage */
  errorMessage?: Maybe<Scalars['String']>;
  /** CAPA ERROR CODE */
  result: CapaErrorCode;
};

/** IndustrialBizSearchType */
export enum IndustrialBizSearchType {
  /** 지역 */
  BasicCity = 'BASIC_CITY',
  /** 업체명 */
  BasicCompanyName = 'BASIC_COMPANY_NAME',
  /** 단지 */
  BasicComplexName = 'BASIC_COMPLEX_NAME',
  /** 업종 */
  BasicIndustrial = 'BASIC_INDUSTRIAL',
  /** 제조업 */
  BasicIndustryCategory = 'BASIC_INDUSTRY_CATEGORY',
  /** 직원수 */
  Employees_2020FullTimeTotal = 'EMPLOYEES_2020_FULL_TIME_TOTAL',
  /** 회사 규모 */
  FullinvestigationCompanyScale = 'FULLINVESTIGATION_COMPANY_SCALE'
}

/** 기업 규모 */
export enum IndustrialCompanyScale {
  MajorCompany = 'MAJOR_COMPANY',
  MidSizedCompany = 'MID_SIZED_COMPANY',
  /** NULL */
  Null = 'NULL',
  SmallCompany = 'SMALL_COMPANY'
}

/** 단지명 */
export enum IndustrialComplexName {
  /** 남동국가산업단지 */
  IndustrialComplex_1 = 'INDUSTRIAL_COMPLEX_1',
  /** 광양국가산업단지 */
  IndustrialComplex_2 = 'INDUSTRIAL_COMPLEX_2',
  /** 광주월전중소협력단지형외국인투자지역 */
  IndustrialComplex_3 = 'INDUSTRIAL_COMPLEX_3',
  /** 광주첨단과학국가산업단지 */
  IndustrialComplex_4 = 'INDUSTRIAL_COMPLEX_4',
  /** 구미국가산업단지 */
  IndustrialComplex_5 = 'INDUSTRIAL_COMPLEX_5',
  /** 구미외국인투자지역 */
  IndustrialComplex_6 = 'INDUSTRIAL_COMPLEX_6',
  /** 국가식품클러스터국가산업단지 */
  IndustrialComplex_7 = 'INDUSTRIAL_COMPLEX_7',
  /** 국가식품클러스터식품산업단지중소협력단지형외국인투자지역 */
  IndustrialComplex_8 = 'INDUSTRIAL_COMPLEX_8',
  /** 군산2국가산업단지 */
  IndustrialComplex_9 = 'INDUSTRIAL_COMPLEX_9',
  /** 군산국가산업단지 */
  IndustrialComplex_10 = 'INDUSTRIAL_COMPLEX_10',
  /** 김해GoldenRoot일반산업단지 */
  IndustrialComplex_11 = 'INDUSTRIAL_COMPLEX_11',
  /** 달성2차외국인투자지역 */
  IndustrialComplex_12 = 'INDUSTRIAL_COMPLEX_12',
  /** 달성2차일반산업단지 */
  IndustrialComplex_13 = 'INDUSTRIAL_COMPLEX_13',
  /** 대구국가산업단지 */
  IndustrialComplex_14 = 'INDUSTRIAL_COMPLEX_14',
  /** 대불국가산업단지 */
  IndustrialComplex_15 = 'INDUSTRIAL_COMPLEX_15',
  /** 대불외국인투자지역 */
  IndustrialComplex_16 = 'INDUSTRIAL_COMPLEX_16',
  /** 명지녹산국가산업단지 */
  IndustrialComplex_17 = 'INDUSTRIAL_COMPLEX_17',
  /** 문막중소협력단지형외국인투자지역 */
  IndustrialComplex_18 = 'INDUSTRIAL_COMPLEX_18',
  /** 반월국가산업단지 */
  IndustrialComplex_19 = 'INDUSTRIAL_COMPLEX_19',
  /** 부산신평장림일반산업단지(협업단지) */
  IndustrialComplex_20 = 'INDUSTRIAL_COMPLEX_20',
  /** 북평국가산업단지 */
  IndustrialComplex_21 = 'INDUSTRIAL_COMPLEX_21',
  /** 빛그린국가산업단지 */
  IndustrialComplex_22 = 'INDUSTRIAL_COMPLEX_22',
  /** 서울디지털국가산업단지 */
  IndustrialComplex_23 = 'INDUSTRIAL_COMPLEX_23',
  /** 시화국가산업단지 */
  IndustrialComplex_24 = 'INDUSTRIAL_COMPLEX_24',
  /** 시화멀티테크노밸리 */
  IndustrialComplex_25 = 'INDUSTRIAL_COMPLEX_25',
  /** 아산국가산업단지(포승지구) */
  IndustrialComplex_26 = 'INDUSTRIAL_COMPLEX_26',
  /** 여수국가산업단지 */
  IndustrialComplex_27 = 'INDUSTRIAL_COMPLEX_27',
  /** 오송생명과학단지 */
  IndustrialComplex_28 = 'INDUSTRIAL_COMPLEX_28',
  /** 온산국가산업단지 */
  IndustrialComplex_29 = 'INDUSTRIAL_COMPLEX_29',
  /** 울산미포국가산업단지 */
  IndustrialComplex_30 = 'INDUSTRIAL_COMPLEX_30',
  /** 익산국가산업단지 */
  IndustrialComplex_31 = 'INDUSTRIAL_COMPLEX_31',
  /** 장성동화농공단지 */
  IndustrialComplex_32 = 'INDUSTRIAL_COMPLEX_32',
  /** 장성삼계농공단지 */
  IndustrialComplex_33 = 'INDUSTRIAL_COMPLEX_33',
  /** 창원국가산업단지 */
  IndustrialComplex_34 = 'INDUSTRIAL_COMPLEX_34',
  /** 청주오송제2생명과학일반산업단지(충북경제자유구역 오송바이오폴리스지구) */
  IndustrialComplex_35 = 'INDUSTRIAL_COMPLEX_35',
  /** 한국수출산업(부평)국가산업단지 */
  IndustrialComplex_36 = 'INDUSTRIAL_COMPLEX_36',
  /** 한국수출산업(주안)국가산업단지 */
  IndustrialComplex_37 = 'INDUSTRIAL_COMPLEX_37',
  /** 석문국가산업단지 */
  IndustrialComplex_38 = 'INDUSTRIAL_COMPLEX_38',
  /** 아산국가산업단지(고대부곡지구) */
  IndustrialComplex_39 = 'INDUSTRIAL_COMPLEX_39',
  /** 충주외국인투자지역 */
  IndustrialComplex_40 = 'INDUSTRIAL_COMPLEX_40',
  /** 파주탄현중소기업전용국가산업단지 */
  IndustrialComplex_41 = 'INDUSTRIAL_COMPLEX_41',
  /** 원주문막반계일반산업단지 */
  IndustrialComplex_42 = 'INDUSTRIAL_COMPLEX_42',
  /** 북평일반산업단지 */
  IndustrialComplex_43 = 'INDUSTRIAL_COMPLEX_43',
  /** 양주홍죽일반산업단지 */
  IndustrialComplex_44 = 'INDUSTRIAL_COMPLEX_44',
  /** 송산2외국인투자지역 */
  IndustrialComplex_45 = 'INDUSTRIAL_COMPLEX_45',
  /** 사천제2일반산업단지 */
  IndustrialComplex_46 = 'INDUSTRIAL_COMPLEX_46',
  /** 송산2-1외국인투자지역 */
  IndustrialComplex_47 = 'INDUSTRIAL_COMPLEX_47',
  /** 사천제1일반산업단지 */
  IndustrialComplex_48 = 'INDUSTRIAL_COMPLEX_48',
  /** 사천외국인투자지역 */
  IndustrialComplex_49 = 'INDUSTRIAL_COMPLEX_49',
  /** 아산제2테크노밸리일반산업단지 */
  IndustrialComplex_50 = 'INDUSTRIAL_COMPLEX_50',
  /** 이천장호원일반산업단지 */
  IndustrialComplex_51 = 'INDUSTRIAL_COMPLEX_51',
  /** 천안외국인투자지역 */
  IndustrialComplex_52 = 'INDUSTRIAL_COMPLEX_52',
  /** 사천임대전용산업단지 */
  IndustrialComplex_53 = 'INDUSTRIAL_COMPLEX_53',
  /** 천안5산단외국인투자지역 */
  IndustrialComplex_54 = 'INDUSTRIAL_COMPLEX_54',
  /** 진해국가산업단지 */
  IndustrialComplex_55 = 'INDUSTRIAL_COMPLEX_55',
  /** 진천산수외국인투자지역 */
  IndustrialComplex_56 = 'INDUSTRIAL_COMPLEX_56',
  /** 이천대월일반산업단지 */
  IndustrialComplex_57 = 'INDUSTRIAL_COMPLEX_57',
  /** 인주외국인투자지역 */
  IndustrialComplex_58 = 'INDUSTRIAL_COMPLEX_58',
  /** 포항국가산업단지 */
  IndustrialComplex_59 = 'INDUSTRIAL_COMPLEX_59',
  /** 장항국가생태산업단지 */
  IndustrialComplex_60 = 'INDUSTRIAL_COMPLEX_60',
  /** 오창외국인투자지역 */
  IndustrialComplex_61 = 'INDUSTRIAL_COMPLEX_61',
  /** 포항블루밸리국가산업단지 */
  IndustrialComplex_62 = 'INDUSTRIAL_COMPLEX_62',
  /** 안정국가산업단지 */
  IndustrialComplex_63 = 'INDUSTRIAL_COMPLEX_63',
  /** 송산2-2외국인투자지역 */
  IndustrialComplex_64 = 'INDUSTRIAL_COMPLEX_64',
  /** NULL */
  Null = 'NULL'
}

/** 업종_대분류 */
export enum IndustrialSectorsCategory {
  NonManufacturing = 'NON_MANUFACTURING',
  /** NULL */
  Null = 'NULL',
  Produce = 'PRODUCE'
}

/** 업종 */
export enum IndustrialSectorsName {
  /** NULL */
  Null = 'NULL',
  /** 01. 음식료 */
  SectorName_1 = 'SECTOR_NAME_1',
  /** 02. 섬유의복 */
  SectorName_2 = 'SECTOR_NAME_2',
  /** 03. 목재종이 */
  SectorName_3 = 'SECTOR_NAME_3',
  /** 04. 석유화학 */
  SectorName_4 = 'SECTOR_NAME_4',
  /** 05. 비금속 */
  SectorName_5 = 'SECTOR_NAME_5',
  /** 06. 철강 */
  SectorName_6 = 'SECTOR_NAME_6',
  /** 07. 기계 */
  SectorName_7 = 'SECTOR_NAME_7',
  /** 08. 전기전자 */
  SectorName_8 = 'SECTOR_NAME_8',
  /** 09. 운송장비 */
  SectorName_9 = 'SECTOR_NAME_9',
  /** 10. (제조)기타 */
  SectorName_10 = 'SECTOR_NAME_10',
  /** 11. 정보통신업 */
  SectorName_11 = 'SECTOR_NAME_11',
  /** 12. */
  SectorName_12 = 'SECTOR_NAME_12',
  /** 13. 출판업 */
  SectorName_13 = 'SECTOR_NAME_13',
  /** 14. (비제조)기타 */
  SectorName_14 = 'SECTOR_NAME_14'
}

export type InnoBizFetchIcxInput = {
  employeesCountSortType?: InputMaybe<CapaSortType>;
  innoBizSearchType?: InputMaybe<InnoBizSearchType>;
  keyword?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Float']>;
  offset?: InputMaybe<Scalars['Float']>;
};

/** InnoBizSearchType */
export enum InnoBizSearchType {
  /** 주소 */
  Address = 'ADDRESS',
  /** 연락처 */
  CompanyContact = 'COMPANY_CONTACT',
  /** 업체명 */
  CompanyName = 'COMPANY_NAME',
  /** 종업원수 */
  EmployeesCount = 'EMPLOYEES_COUNT',
  /** 업종코드 */
  IndustryCode = 'INDUSTRY_CODE',
  /** 업종 */
  RelatedIndustry = 'RELATED_INDUSTRY',
  /** 주생산품 */
  RepresentativeName = 'REPRESENTATIVE_NAME'
}

export type InsertCommentBoInput = {
  /** back office user id */
  backOfficeId: Scalars['String'];
  /** comment */
  comment: Scalars['String'];
  /** quotation user id */
  quotationUserId: Scalars['String'];
};

export type InsertMemoBoInput = {
  /** back office user id */
  back_office_id: Scalars['String'];
  /** user id */
  id: Scalars['String'];
  /** memo */
  memo: Scalars['String'];
  /** type */
  type: Scalars['String'];
};

export type InviteConnectGroupUserInput = {
  accessLevel: CapaConnectGroupAccessLevel;
  email: Scalars['String'];
};

export type InviteConnectGroupUsersInput = {
  groupId: Scalars['String'];
  inviteUsers: Array<InviteConnectGroupUserInput>;
};

export type IsUsedPayment = {
  __typename?: 'IsUsedPayment';
  isUsedPayment: Scalars['Boolean'];
};

/** ITP 이벤트 증빙 파일 */
export type ItpEventFileUploadInput = {
  /** fk ITP 이벤트 증빙 파일 아이디 */
  fileId: Scalars['String'];
};

/** JSB 이벤트 증빙 파일 */
export type JsbEventFileUploadInput = {
  /** fk JSB 이벤트 증빙 파일 아이디 */
  fileId: Scalars['String'];
};

export enum Language {
  Chinese = 'CHINESE',
  English = 'ENGLISH',
  Korean = 'KOREAN',
  Vietnam = 'VIETNAM'
}

export type LeaveConnectGroupInput = {
  groupId: Scalars['String'];
};

export type MainBizFetchIcxInput = {
  keyword?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Float']>;
  mainBizSearchType?: InputMaybe<MainBizSearchType>;
  offset?: InputMaybe<Scalars['Float']>;
};

/** MainBizSearchType */
export enum MainBizSearchType {
  /** 사업자명 */
  CompanyName = 'COMPANY_NAME',
  /** 업종코드 */
  IndustryCode = 'INDUSTRY_CODE',
  /** 업종명 */
  IndustryName = 'INDUSTRY_NAME',
  /** 소재지 */
  Location = 'LOCATION',
  /** 지역 */
  Region = 'REGION',
  /** 대표자명 */
  RepresentativeName = 'REPRESENTATIVE_NAME'
}

export type ManageConnectGroupUserInput = {
  accessLevel?: InputMaybe<CapaConnectGroupAccessLevel>;
  action: CapaConnectGroupUserAction;
  groupId: Scalars['String'];
  userEmail: Scalars['String'];
};

export type ManageDownloadPermissionInput = {
  connectFileId?: InputMaybe<Scalars['String']>;
  /** 그룹ID */
  groupId: Scalars['String'];
  groupUserId?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<CapaQuotationRfqAllowOpenFileStatus>;
};

/** MiniClusterSearchType */
export enum MiniClusterSearchType {
  /** 거점 */
  Base = 'BASE',
  /** 기업명 */
  CompanyName = 'COMPANY_NAME',
  /** 기업 유형 */
  EnterPriseType = 'ENTER_PRISE_TYPE',
  /** 산학 연구분 */
  IndustryUniversityInstituteCollaboration = 'INDUSTRY_UNIVERSITY_INSTITUTE_COLLABORATION',
  /** 미니클러스터 명 */
  MiniClusterName = 'MINI_CLUSTER_NAME',
  /** 지역 */
  Region = 'REGION'
}

export type MoveConnectFileInput = {
  destId?: InputMaybe<Scalars['String']>;
  fileId: Scalars['String'];
};

export type Mutation = {
  __typename?: 'Mutation';
  activateAdvertisingBO: Output;
  addConnectFiles: Output;
  addConnectLinkFiles: Output;
  allowRfqDrawingFileDownload: Output;
  approveItpEvent: Output;
  approvedQuotationPartnerByEmail: Output;
  batchShutDownQuotationPartnerChatRooms: Output;
  changeChatRoomStatusOpen: Output;
  /** 이메일 수정 */
  changeEmail: Output;
  /** 비밀번호 변경하기 */
  changePassword: Output;
  changeQuotationMessageInvisible: Output;
  checkDuplicateGroupName: Output;
  clearNewNotification: Output;
  completeRfqTransaction: Output;
  confirmRfqPurchaseOrder: Output;
  confirmRfqPurchaseOrderWithItem: Output;
  confirmRfqQuotation: Output;
  confirmRfqTransaction: Output;
  createAdsImpressionBO: Output;
  createAdvertisementBO: Output;
  createAdvertisingBO: Output;
  createConnectAnnotation: CapaConnectAnnotationOutput;
  createConnectAnnotationComment: CapaConnectAnnotationOutput;
  createConnectContactUser: Output;
  createConnectFeedback: Output;
  createConnectFolder: Output;
  createConnectIssue: Output;
  createDetailedQuotation: CapaQuotationChatRoomOutput;
  createGroup: CreateConnectGroupOutput;
  createGroupWithCapa: CreateConnectGroupOutput;
  createNoticeScheduleBO: NoticeScheduleOutput;
  createPaymentAfterCreatePurchaseOrder: Output;
  createPurchaseOrder: CapaQuotationCreatePurchaseOrderOutput;
  createPurchaseOrderWithItem: Output;
  createQuotationAnnotation: CapaQuotationAnnotationOutput;
  createQuotationAnnotationComment: CapaQuotationAnnotationOutput;
  createQuotationChatRoom: CapaQuotationChatRoomOutput;
  createSimpleQuotation: CapaQuotationChatRoomOutput;
  delayConfirmEscrowPurchase: Output;
  deleteBOMemo: Output;
  deleteQuotationChatMessage: Output;
  evaluateRfqPartners: Output;
  exitGroup: Output;
  expireRfq: Output;
  /** Authorization: Bearer 토큰 갱신 */
  icxRefreshAccessToken: IcxAuthenticationOutput;
  insertBOMemo: Output;
  insertCommentBO: Output;
  inviteGroupMembers: Output;
  leaveGroup: Output;
  manageDownloadPermission: Output;
  manageGroupMember: Output;
  migration: Output;
  moveConnectFile: Output;
  quitQuotationChatRoom: Output;
  rateQuotationServicePartner: Output;
  rateQuotationServiceUser: Output;
  readAllManagement: Output;
  readConnectAnnotationComment: Output;
  readConnectChatMessage: CapaChatMessagesReadOutput;
  readManagement: Output;
  readNotification: Output;
  readQuotationAnnotationComment: Output;
  readQuotationChatMessage: Output;
  readRfqAdjustRequest: Output;
  readRfqPurchaseOrder: Output;
  readRfqQuotation: Output;
  /** Authorization: Bearer 토큰 갱신 */
  refresh: AuthenticationOutput;
  /**
   * 캐파 유저 통합 회원 가입
   * @deprecated change name @see {registerUser, RegisterCapaUserInput}
   */
  register: AuthenticationOutput;
  registerAmbassadorBO: Output;
  registerBackOfficeUser: Output;
  /** 캐파 클라우드 회원가입 */
  registerCloudUser: AuthenticationOutput;
  registerConnectUser: AuthenticationOutput;
  /** capa_user & capa_quotation_user 통합 회원가입 */
  registerIntegratedUser: AuthenticationOutput;
  registerItpEvent: Output;
  registerJsbEvent: Output;
  registerQuotationPartner: AuthenticationOutput;
  registerQuotationPartnerBO: CapaQuotationPartnerOutput;
  registerQuotationUser: AuthenticationOutput;
  registerQuotationUserBO: Output;
  registerRFQ: Output;
  registerRequestRfqPurchaseOrder: Output;
  registerRequestRfqPurchaseOrderWithItem: Output;
  registerRequestRfqQuotation: Output;
  registerRfqReview: Output;
  registerSubmall: Output;
  /** 캐파 유저 통합 회원 가입 */
  registerUser: AuthenticationOutput;
  rejectRfqPurchaseOrder: Output;
  /**
   * 캐파 클라우드 파일 삭제
   * rest api 와 동일 기능
   * [Delete <URL>/cloud/:fileId]
   */
  removeCloudFile: Output;
  removeConnectAnnotation: Output;
  removeConnectAnnotationComment: CapaConnectAnnotationOutput;
  removeConnectContactUser: Output;
  removeConnectFile: Output;
  removeConnectUser: Output;
  removeGroup: Output;
  removeQuotationAnnotation: Output;
  removeQuotationAnnotationComment: Output;
  renameConnectFile: Output;
  renameGroupName: Output;
  replyRfqReview: Output;
  requestAdjustRfqPurchaseOrder: Output;
  requestAdjustRfqPurchaseOrderWithItem: Output;
  requestAdjustRfqQuotation: Output;
  /** 핸드폰 인증 요청 */
  requestCellPhoneVerificationCode: Output;
  requestCompleteRfqTransaction: Output;
  requestConfirmRfqTransaction: Output;
  requestDownloadPermission: Output;
  /** 이메일 인증 요청 */
  requestEmailVerificationCode: Output;
  /** 추천 아이디 코드 발급 */
  requestReferralId: CapaReferralOut;
  requestRegisterTransactionReview: Output;
  /** 비밀번호 찾기/재설정 */
  requestResetPassword: Output;
  requestRfqDrawingFileDownload: Output;
  reviewRfq: Output;
  saveCapabilities: Output;
  saveRfqFilter: Output;
  sendAnnotationCommentToChat: Output;
  sendConnectChatMessage: Output;
  sendConnectChatMessageToCapa: Output;
  sendQuotationChatMessage: CapaQuotationChatRoomOutput;
  sendQuotationPartnerIntroduction: Output;
  shareFilesToGroup: Output;
  subscribeCAPANews: Output;
  suggestService: Output;
  toggleFavorite: Output;
  unshareFileFromGroup: Output;
  updateAmbassadorBO: Output;
  /** 엠베서더 주도 신규 회원 가입 페이지 조회수 증가 */
  updateAmbassadorSignUpPageViewCountByIp: Output;
  updateBOTestConnectGroup: Output;
  updateBOTestUser: Output;
  updateBackOfficeUser: Output;
  updateBypassChatComplaint: Output;
  updateConnectAnnotation: CapaConnectAnnotationOutput;
  updateConnectAnnotationComment: CapaConnectAnnotationOutput;
  updateConnectContactUser: Output;
  updateConnectUser: CapaConnectUserOutput;
  updateConnectUserFileLinkStatus: UpdateConnectUserFileLinkOutput;
  updateConnectUserFilePermission: Output;
  updateNoticeScheduleBO: NoticeScheduleOutput;
  updatePurchaseOrderStatus: Output;
  updateQuotationAnnotation: Output;
  updateQuotationAnnotationComment: Output;
  updateQuotationPartner: UpdateCapaQuotationPartnerStrategyOutput;
  updateQuotationPartnerBO: Output;
  updateQuotationPartnerStatusBO: Output;
  updateQuotationUser: CapaQuotationUserOutput;
  updateQuotationUserBO: Output;
  updateRfqReview: Output;
  updateRfqStatusBO: Output;
  /** 캐파 유저 통합 회원 정보수정 */
  updateUser: AuthenticationOutput;
  /** 핸드폰 인증 요청 */
  verifyCellPhoneVerificationCode: Output;
  withdrawBackOfficeUser: Output;
  /** 파트너 회원 탈퇴 */
  withdrawQuotationPartner: Output;
  withdrawQuotationPartnerBO: Output;
  /** 고객 회원 탈퇴 */
  withdrawQuotationUser: Output;
  withdrawQuotationUserBO: Output;
  /** 광고 활동 로그 입력 */
  writeAdsActivityLog: Output;
  /** 사용자 활동 로그 입력 완료 */
  writeUserActivityLog: Output;
};


export type MutationActivateAdvertisingBoArgs = {
  input: ActivateAdvertisinBoInput;
};


export type MutationAddConnectFilesArgs = {
  input: AddConnectFilesInput;
};


export type MutationAddConnectLinkFilesArgs = {
  input: AddConnectFilesInput;
};


export type MutationAllowRfqDrawingFileDownloadArgs = {
  input: AllowRfqDrawingFileDownloadInput;
};


export type MutationApproveItpEventArgs = {
  input: ApproveItpEventInput;
};


export type MutationApprovedQuotationPartnerByEmailArgs = {
  input: ApprovedQuotationPartnerByEmailInput;
};


export type MutationBatchShutDownQuotationPartnerChatRoomsArgs = {
  input: BatchShutDownQuotationPartnerChatRoomsInput;
};


export type MutationChangeChatRoomStatusOpenArgs = {
  input: ChangeChatRoomStatusInput;
};


export type MutationChangeEmailArgs = {
  input: ChangeEmailInput;
};


export type MutationChangePasswordArgs = {
  input: ChangePasswordInput;
};


export type MutationChangeQuotationMessageInvisibleArgs = {
  input: ChangeChatMessageInvisibleInput;
};


export type MutationCheckDuplicateGroupNameArgs = {
  input: CheckConnectDuplicateGroupNameInput;
};


export type MutationClearNewNotificationArgs = {
  input: ReadNotificationInput;
};


export type MutationCompleteRfqTransactionArgs = {
  input: CompleteRfqTransactionInput;
};


export type MutationConfirmRfqPurchaseOrderArgs = {
  input: ConfirmRfqPurchaseOrderInput;
};


export type MutationConfirmRfqPurchaseOrderWithItemArgs = {
  input: ConfirmRfqPurchaseOrderInput;
};


export type MutationConfirmRfqQuotationArgs = {
  input: ConfirmRfqQuotationInput;
};


export type MutationConfirmRfqTransactionArgs = {
  input: ConfirmRfqTransactionInput;
};


export type MutationCreateAdsImpressionBoArgs = {
  input: CreateAdsImpressionBoInput;
};


export type MutationCreateAdvertisementBoArgs = {
  input: CreateAdvertisementBoInput;
};


export type MutationCreateAdvertisingBoArgs = {
  input: CreateAdvertisingBoInput;
};


export type MutationCreateConnectAnnotationArgs = {
  input: CreateConnectAnnotationInput;
};


export type MutationCreateConnectAnnotationCommentArgs = {
  input: CreateConnectAnnotationCommentInput;
};


export type MutationCreateConnectContactUserArgs = {
  input: CreateConnectContactUserInput;
};


export type MutationCreateConnectFeedbackArgs = {
  input: CreateConnectFeedbackInput;
};


export type MutationCreateConnectFolderArgs = {
  input: RegisterConnectUserFolderInput;
};


export type MutationCreateConnectIssueArgs = {
  input: CreateConnectIssueInput;
};


export type MutationCreateDetailedQuotationArgs = {
  input: CreateDetailedQuotationInput;
};


export type MutationCreateGroupArgs = {
  input: CreateConnectGroupInput;
};


export type MutationCreateNoticeScheduleBoArgs = {
  input: CreateNoticeScheduleInput;
};


export type MutationCreatePaymentAfterCreatePurchaseOrderArgs = {
  input: CreatePaymentInput;
};


export type MutationCreatePurchaseOrderArgs = {
  input: CreatePurchaseOrderInput;
};


export type MutationCreatePurchaseOrderWithItemArgs = {
  input: CreatePurchaseOrderInput;
};


export type MutationCreateQuotationAnnotationArgs = {
  input: CreateQuotationAnnotationInput;
};


export type MutationCreateQuotationAnnotationCommentArgs = {
  input: CreateQuotationAnnotationCommentInput;
};


export type MutationCreateQuotationChatRoomArgs = {
  input: CreateQuotationChatRoomInput;
};


export type MutationCreateSimpleQuotationArgs = {
  input: CreateSimpleQuotationInput;
};


export type MutationDelayConfirmEscrowPurchaseArgs = {
  input: DelayConfirmEscrowPurchaseInput;
};


export type MutationDeleteBoMemoArgs = {
  input: InsertMemoBoInput;
};


export type MutationDeleteQuotationChatMessageArgs = {
  input: DeleteQuotationChatMessageInput;
};


export type MutationEvaluateRfqPartnersArgs = {
  input: EvaluateRfqPartnersInput;
};


export type MutationExitGroupArgs = {
  input: FetchConnectGroupInput;
};


export type MutationExpireRfqArgs = {
  input: ExpireRfqInput;
};


export type MutationIcxRefreshAccessTokenArgs = {
  input: IcxTokenRefreshInput;
};


export type MutationInsertBoMemoArgs = {
  input: InsertMemoBoInput;
};


export type MutationInsertCommentBoArgs = {
  input: InsertCommentBoInput;
};


export type MutationInviteGroupMembersArgs = {
  input: InviteConnectGroupUsersInput;
};


export type MutationLeaveGroupArgs = {
  input: LeaveConnectGroupInput;
};


export type MutationManageDownloadPermissionArgs = {
  input: ManageDownloadPermissionInput;
};


export type MutationManageGroupMemberArgs = {
  input: ManageConnectGroupUserInput;
};


export type MutationMoveConnectFileArgs = {
  input: MoveConnectFileInput;
};


export type MutationQuitQuotationChatRoomArgs = {
  input: QuitQuotationChatRoomInput;
};


export type MutationRateQuotationServicePartnerArgs = {
  input: QuotationServiceRatingInput;
};


export type MutationRateQuotationServiceUserArgs = {
  input: QuotationServiceRatingInput;
};


export type MutationReadAllManagementArgs = {
  input: ReadAllManagementInput;
};


export type MutationReadConnectAnnotationCommentArgs = {
  input: ReadConnectAnnotationCommentInput;
};


export type MutationReadConnectChatMessageArgs = {
  input: ReadConnectChatRoomMessageInput;
};


export type MutationReadManagementArgs = {
  input: ReadManagementInput;
};


export type MutationReadNotificationArgs = {
  input: ReadNotificationInput;
};


export type MutationReadQuotationAnnotationCommentArgs = {
  input: ReadQuotationAnnotationCommentInput;
};


export type MutationReadQuotationChatMessageArgs = {
  input: ReadQuotationChatRoomMessageInput;
};


export type MutationReadRfqAdjustRequestArgs = {
  input: ReadRfqAdjustRequestInput;
};


export type MutationReadRfqPurchaseOrderArgs = {
  input: ReadRfqPurchaseOrderInput;
};


export type MutationReadRfqQuotationArgs = {
  input: ReadRfqQuotationInput;
};


export type MutationRefreshArgs = {
  input: TokenRefreshInput;
};


export type MutationRegisterArgs = {
  input: RegistrationInput;
};


export type MutationRegisterAmbassadorBoArgs = {
  input: RegisterAmbassadorBoInput;
};


export type MutationRegisterBackOfficeUserArgs = {
  input: RegisterBackOfficeUserInput;
};


export type MutationRegisterConnectUserArgs = {
  input: RegisterConnectUserInput;
};


export type MutationRegisterIntegratedUserArgs = {
  input: RegisterIntegratedUserInput;
};


export type MutationRegisterItpEventArgs = {
  input: RegisterItpEventInput;
};


export type MutationRegisterJsbEventArgs = {
  input: RegisterJsbEventInput;
};


export type MutationRegisterQuotationPartnerArgs = {
  input: RegisterQuotationPartnerInput;
};


export type MutationRegisterQuotationPartnerBoArgs = {
  input: RegisterQuotationPartnerBoInput;
};


export type MutationRegisterQuotationUserArgs = {
  input: RegisterQuotationUserInput;
};


export type MutationRegisterQuotationUserBoArgs = {
  input: UpdateQuotationUserBoInput;
};


export type MutationRegisterRfqArgs = {
  input: RegisterRfqInput;
};


export type MutationRegisterRequestRfqPurchaseOrderArgs = {
  input: RegisterRequestRfqPurchaseOrderInput;
};


export type MutationRegisterRequestRfqPurchaseOrderWithItemArgs = {
  input: RegisterRequestRfqPurchaseOrderInput;
};


export type MutationRegisterRequestRfqQuotationArgs = {
  input: RegisterRequestRfqQuotationInput;
};


export type MutationRegisterRfqReviewArgs = {
  input: RegisterRfqReviewInput;
};


export type MutationRegisterSubmallArgs = {
  input: RegisterSubmallInput;
};


export type MutationRegisterUserArgs = {
  input: RegisterCapaUserInput;
};


export type MutationRejectRfqPurchaseOrderArgs = {
  input: RejectRfqPurchaseOrderInput;
};


export type MutationRemoveCloudFileArgs = {
  input: RequestFileInput;
};


export type MutationRemoveConnectAnnotationArgs = {
  input: RemoveConnectAnnotationInput;
};


export type MutationRemoveConnectAnnotationCommentArgs = {
  input: RemoveConnectAnnotationCommentInput;
};


export type MutationRemoveConnectContactUserArgs = {
  input: RemoveConnectContactUserInput;
};


export type MutationRemoveConnectFileArgs = {
  input: RemoveConnectFileInput;
};


export type MutationRemoveConnectUserArgs = {
  input: RemoveConnectUserInput;
};


export type MutationRemoveGroupArgs = {
  input: RemoveConnectGroupInput;
};


export type MutationRemoveQuotationAnnotationArgs = {
  input: RemoveQuotationAnnotationInput;
};


export type MutationRemoveQuotationAnnotationCommentArgs = {
  input: RemoveQuotationAnnotationCommentInput;
};


export type MutationRenameConnectFileArgs = {
  input: RenameConnectFileInput;
};


export type MutationRenameGroupNameArgs = {
  input: RenameConnectGroupInput;
};


export type MutationReplyRfqReviewArgs = {
  input: ReplyRfqReviewInput;
};


export type MutationRequestAdjustRfqPurchaseOrderArgs = {
  input: RequestAdjustRfqPurchaseOrderInput;
};


export type MutationRequestAdjustRfqPurchaseOrderWithItemArgs = {
  input: RequestAdjustRfqPurchaseOrderInput;
};


export type MutationRequestAdjustRfqQuotationArgs = {
  input: RequestAdjustRfqQuotationInput;
};


export type MutationRequestCellPhoneVerificationCodeArgs = {
  input: RequestCellPhoneVerificationCodeInput;
};


export type MutationRequestCompleteRfqTransactionArgs = {
  input: RequestConfirmRfqTransactionInput;
};


export type MutationRequestConfirmRfqTransactionArgs = {
  input: RequestConfirmRfqTransactionInput;
};


export type MutationRequestDownloadPermissionArgs = {
  input: RequestDownloadPermissionInput;
};


export type MutationRequestEmailVerificationCodeArgs = {
  input: RequestEmailVerificationCodeInput;
};


export type MutationRequestReferralIdArgs = {
  input: RequestReferralInput;
};


export type MutationRequestRegisterTransactionReviewArgs = {
  input: RequestRegisterTransactionReviewInput;
};


export type MutationRequestResetPasswordArgs = {
  input: RequestResetPasswordInput;
};


export type MutationRequestRfqDrawingFileDownloadArgs = {
  input: RequestRfqDrawingFileDownloadInput;
};


export type MutationReviewRfqArgs = {
  input: ReviewRfqInput;
};


export type MutationSaveCapabilitiesArgs = {
  input: SaveRfqCapabilitiesInput;
};


export type MutationSaveRfqFilterArgs = {
  input: SaveRfqFilterInput;
};


export type MutationSendAnnotationCommentToChatArgs = {
  input: SendAnnotationCommentToChatInput;
};


export type MutationSendConnectChatMessageArgs = {
  input: SendConnectChatMessageInput;
};


export type MutationSendConnectChatMessageToCapaArgs = {
  input: SendConnectChatMessageToCapaInput;
};


export type MutationSendQuotationChatMessageArgs = {
  input: SendQuotationChatMessageInput;
};


export type MutationSendQuotationPartnerIntroductionArgs = {
  input: SendQuotationPartnerIntroductionInput;
};


export type MutationShareFilesToGroupArgs = {
  input: ShareConnectFilesInput;
};


export type MutationSubscribeCapaNewsArgs = {
  input: SubscribeCapaNewsInput;
};


export type MutationSuggestServiceArgs = {
  input: SuggestServiceInput;
};


export type MutationToggleFavoriteArgs = {
  input: FavoriteRfqInput;
};


export type MutationUnshareFileFromGroupArgs = {
  input: UnshareConnectFilesInput;
};


export type MutationUpdateAmbassadorBoArgs = {
  input: UpdateAmbassadorBoInput;
};


export type MutationUpdateAmbassadorSignUpPageViewCountByIpArgs = {
  input: UpdateAmbassadorSignUpPageViewCountByIpInput;
};


export type MutationUpdateBoTestConnectGroupArgs = {
  input: UpdateBoTestConnectGroupInput;
};


export type MutationUpdateBoTestUserArgs = {
  input: UpdateBoTestUserInput;
};


export type MutationUpdateBackOfficeUserArgs = {
  input: UpdateBackOfficeUserInput;
};


export type MutationUpdateBypassChatComplaintArgs = {
  input: UpdateReceiveComplaintQuotationChatMessageInput;
};


export type MutationUpdateConnectAnnotationArgs = {
  input: UpdateConnectAnnotationInput;
};


export type MutationUpdateConnectAnnotationCommentArgs = {
  input: UpdateConnectAnnotationCommentInput;
};


export type MutationUpdateConnectContactUserArgs = {
  input: CreateConnectContactUserInput;
};


export type MutationUpdateConnectUserArgs = {
  input: UpdateConnectUserInput;
};


export type MutationUpdateConnectUserFileLinkStatusArgs = {
  input: UpdateConnectUserFileLinkInput;
};


export type MutationUpdateConnectUserFilePermissionArgs = {
  input: UpdateConnectUserFilePermissionInput;
};


export type MutationUpdateNoticeScheduleBoArgs = {
  input: UpdateNoticeScheduleInput;
};


export type MutationUpdatePurchaseOrderStatusArgs = {
  input: UpdatePurchaseOrderStatusInput;
};


export type MutationUpdateQuotationAnnotationArgs = {
  input: UpdateQuotationAnnotationInput;
};


export type MutationUpdateQuotationAnnotationCommentArgs = {
  input: UpdateQuotationAnnotationCommentInput;
};


export type MutationUpdateQuotationPartnerArgs = {
  input: UpdateQuotationPartnerStrategyInput;
};


export type MutationUpdateQuotationPartnerBoArgs = {
  input: UpdateQuotationPartnerBoStrategyInput;
};


export type MutationUpdateQuotationPartnerStatusBoArgs = {
  input: UpdateQuotationPartnerStatusInput;
};


export type MutationUpdateQuotationUserArgs = {
  input: UpdateQuotationUserInput;
};


export type MutationUpdateQuotationUserBoArgs = {
  input: UpdateQuotationUserBoInput;
};


export type MutationUpdateRfqReviewArgs = {
  input: UpdateRfqReviewInput;
};


export type MutationUpdateRfqStatusBoArgs = {
  input: UpdateRfqStatusInput;
};


export type MutationUpdateUserArgs = {
  input: UpdateCapaUserInput;
};


export type MutationVerifyCellPhoneVerificationCodeArgs = {
  input: VerifyCellPhoneVerificationCodeInput;
};


export type MutationWithdrawBackOfficeUserArgs = {
  input: WithdrawBackOfficeUserInput;
};


export type MutationWithdrawQuotationPartnerArgs = {
  input: WithdrawQuotationPartnerInput;
};


export type MutationWithdrawQuotationPartnerBoArgs = {
  input: WithdrawQuotationPartnerBoInput;
};


export type MutationWithdrawQuotationUserArgs = {
  input: WithdrawQuotationUserInput;
};


export type MutationWithdrawQuotationUserBoArgs = {
  input: WithdrawQuotationUserBoInput;
};


export type MutationWriteAdsActivityLogArgs = {
  input: AdsActivityLogInput;
};


export type MutationWriteUserActivityLogArgs = {
  input: UserActivityLogInput;
};

/** NiceDnbAccssToken */
export type NiceDnbAccssToken = {
  __typename?: 'NiceDnbAccssToken';
  /** JWT */
  accessToken: Scalars['String'];
  /** expiresIn */
  expiresIn: Scalars['Float'];
  /** scope */
  scope: Scalars['String'];
  tokenType: Scalars['String'];
};

/** NiceDnbCompanyInformation */
export type NiceDnbCompanyInformation = {
  __typename?: 'NiceDnbCompanyInformation';
  /** 주소 */
  adr?: Maybe<Scalars['String']>;
  /** 사업자 번호 */
  bizNo?: Maybe<Scalars['String']>;
  /** 비즈니스 타입 */
  bzTypNm?: Maybe<Scalars['String']>;
  /** 비즈니스 컨텐츠 이름 */
  bzcndNm?: Maybe<Scalars['String']>;
  /** 대표자 이름 */
  ceoNm?: Maybe<Scalars['String']>;
  /** 휴폐업구분 */
  clsbzNm?: Maybe<Scalars['String']>;
  /** 기업 이름 */
  cmpNm?: Maybe<Scalars['String']>;
  /** 기업 규모 */
  cmpSclNm?: Maybe<Scalars['String']>;
  /** 상세 주소 */
  dtlAdr?: Maybe<Scalars['String']>;
  /** 직원수 */
  empCnt?: Maybe<Scalars['String']>;
  /** 설립 일자 */
  estbDate?: Maybe<Scalars['String']>;
  /** homepageUrl */
  homepageUrl?: Maybe<Scalars['String']>;
  /** 폐업일 */
  statOcrDate?: Maybe<Scalars['String']>;
  /** 우편 번호 */
  zip?: Maybe<Scalars['String']>;
};

/** NiceDnbCompanyInformationInput */
export type NiceDnbCompanyInformationInput = {
  /** 주소 */
  adr?: InputMaybe<Scalars['String']>;
  /** 사업자등록번호 */
  bizNo?: InputMaybe<Scalars['String']>;
  /** 비즈니스 타입 */
  bzTypNm?: InputMaybe<Scalars['String']>;
  /** 비즈니스 컨텐츠 이름 */
  bzcndNm?: InputMaybe<Scalars['String']>;
  /** 대표자 이름 */
  ceoNm?: InputMaybe<Scalars['String']>;
  /** 휴폐업구분 */
  clsbzNm?: InputMaybe<Scalars['String']>;
  /** 기업 이름 */
  cmpNm?: InputMaybe<Scalars['String']>;
  /** 기업 규모 */
  cmpSclNm?: InputMaybe<Scalars['String']>;
  /** 상세 주소 */
  dtlAdr?: InputMaybe<Scalars['String']>;
  /** 직원수 */
  empCnt?: InputMaybe<Scalars['String']>;
  /** 설립 일자 */
  estbDate?: InputMaybe<Scalars['String']>;
  /** homepageUrl */
  homepageUrl?: InputMaybe<Scalars['String']>;
  /** 폐업일 */
  statOcrDate?: InputMaybe<Scalars['String']>;
  /** 우편 번호 */
  zip?: InputMaybe<Scalars['String']>;
};

/** NiceDnbCompanyOverView */
export type NiceDnbCompanyOverView = {
  __typename?: 'NiceDnbCompanyOverView';
  /** 주소 */
  adr: Scalars['String'];
  /** 사업자 번호 */
  bizNo: Scalars['String'];
  /** 비즈니스 타입 */
  bzTypNm: Scalars['String'];
  /** 비즈니스 컨텐츠 이름 */
  bzcndNm: Scalars['String'];
  /** 대표자 이름 */
  ceoNm: Scalars['String'];
  /** 기업 이름 */
  cmpNm: Scalars['String'];
  /** 기업 규모 */
  cmpSclNm: Scalars['String'];
  /** 상세 주소 */
  dtlAdr: Scalars['String'];
  /** 직원수 */
  empCnt: Scalars['String'];
  /** 설립 일자 */
  estbDate: Scalars['String'];
  /** homepageUrl */
  homepageUrl: Scalars['String'];
  /** 우편 번호 */
  zip: Scalars['String'];
};

/** NiceDnbIsClosedBusiness */
export type NiceDnbIsClosedBusiness = {
  __typename?: 'NiceDnbIsClosedBusiness';
  /** 휴폐업구분 */
  clsbzNm: Scalars['String'];
  /** 폐업일 */
  statOcrDate: Scalars['String'];
};

export type NoticeSchedule = {
  __typename?: 'NoticeSchedule';
  /** 점검 종료 시간 */
  endTime: Scalars['String'];
  id: Scalars['String'];
  /** 긴급점검 / 사전점검 */
  noticeType: NoticeScheduleNoticeType;
  /** client partner connect 인지 */
  pageType: NoticeScheduleNoticePageType;
  /** 사전점검 종료 시간 */
  previewEndTime?: Maybe<Scalars['String']>;
  /** 사전점검 시작 시간 */
  previewStartTime?: Maybe<Scalars['String']>;
  /** 점검 시작 시간 */
  startTime: Scalars['String'];
  /** 시작예정 / 시작중 / 종료 */
  status: NoticeScheduleNoticeStatus;
};

export enum NoticeScheduleNoticePageType {
  Capa = 'CAPA',
  Connect = 'CONNECT'
}

export enum NoticeScheduleNoticeStatus {
  End = 'END',
  NotYetStart = 'NOT_YET_START',
  Starting = 'STARTING'
}

export enum NoticeScheduleNoticeType {
  EmergencyNotice = 'EMERGENCY_NOTICE',
  PreviewNotice = 'PREVIEW_NOTICE'
}

export type NoticeScheduleOutput = {
  __typename?: 'NoticeScheduleOutput';
  data?: Maybe<NoticeSchedule>;
  /** errorMessage */
  errorMessage?: Maybe<Scalars['String']>;
  /** CAPA ERROR CODE */
  result: CapaErrorCode;
};

/** Default Output */
export type Output = {
  __typename?: 'Output';
  /** errorMessage */
  errorMessage?: Maybe<Scalars['String']>;
  /** CAPA ERROR CODE */
  result: CapaErrorCode;
};

export type PartnerCapabilityOutput = {
  __typename?: 'PartnerCapabilityOutput';
  data?: Maybe<CapaQuotationPartnerCapability>;
  /** errorMessage */
  errorMessage?: Maybe<Scalars['String']>;
  /** CAPA ERROR CODE */
  result: CapaErrorCode;
};

export type PaymentData = {
  __typename?: 'PaymentData';
  amount: Scalars['Float'];
  impUid?: Maybe<Scalars['String']>;
  merchantId?: Maybe<Scalars['String']>;
  paymentMethod: CapaPaymentMethodType;
  payoutSeq?: Maybe<Scalars['Float']>;
  pgProvider: Scalars['String'];
  transactionId: Scalars['String'];
  virtualAccount?: Maybe<VirtualAccountInfo>;
};

export type PcbAssemblyMethodInput = {
  methodType: CapaRfqPcbAssemblyMethodType;
};

export type PcbServiceInput = {
  serviceType: CapaPcbServiceType;
};

export type Query = {
  __typename?: 'Query';
  /** 캐파 유저 통합 로그인 */
  authenticate: AuthenticationOutput;
  authenticateBO: AuthenticationOutput;
  cancelRequestPaymentAgent: Output;
  /** 지급대행 - 잔액 조회 */
  checkBalance: Output;
  /** 캐파서비스 확인 checkRegisteredCapaService */
  checkRegisteredCapaService: RegisteredCapaServicesOutput;
  /** 에스크로 - 구매확정 */
  confirmEscrowPurchase: Output;
  /** 광고 활동 로그 입력 */
  fetchActiveAdvertising: CapaAdvertisingsOutput;
  fetchActiveAdvertisingBO: CapaAdvertisingsOutput;
  fetchAdsActivityLogs: CapaAdsActivityLogsOutput;
  fetchAdsImpressionsBO: CapaAdsImpressionsBoOutput;
  fetchAdvertisementAdsImpressionsBO: CapaAdsImpressionsBoOutput;
  fetchAdvertisementsBO: CapaAdvertisementsBoOutput;
  fetchAdvertisingsBO: CapaAdvertisingsBoOutput;
  fetchAllIcxInfo: IcxModelsOutput;
  fetchAvailableFilterRfqs: CapaFetchAvailableFilterRfqsOutput;
  fetchAvailableRfqs: CapaQuotationRfqAvailableRfqsOutput;
  fetchBOAmbassadorInvitationStatus: CapaBoAmbassadorInvitationStatusOutput;
  fetchBOAmbassadors: CapaBoAmbassadorsOutput;
  fetchBOTestUsers: CapaUsersOutput;
  fetchBOUsers: CapaBackOfficeUsersOutput;
  fetchBoMemo: CapaBoMemosOutput;
  fetchBypassComplaintBO: CapaReceiveComplaintQuotationChatMessageOutput;
  fetchCAPANotification: CapaNotificationsOutput;
  fetchCXManagementRequiredUsersBO: CapacxManagementRequiredUsersBoOutput;
  fetchCapaConnectSharedFile: CapaConnectSharedFilesOutput;
  fetchCapability: PartnerCapabilityOutput;
  fetchCloudUser: CapaCloudUserOutput;
  fetchCloudUsersBO: CapaCloudUsersBoOutput;
  fetchCommentBO: CapaBoCommentsOutput;
  fetchConfirmDetailedQuotation: CapaQuotationDetailedQuotationOutput;
  fetchConfirmPurchaseOrder: CapaQuotationRfqPurchaseOrderOutput;
  fetchConfirmPurchaseOrderWithItem: CapaQuotationRfqPurchaseOrderOutput;
  fetchConnectAnnotations: CapaConnectAnnotationsOutput;
  fetchConnectChatMessages: CapaConnectChatMessagesOutput;
  fetchConnectChatMessagesBO: CapaConnectChatMessagesOutput;
  fetchConnectFeedbacksBO: CapaConnectFeedbacksBoOutput;
  fetchConnectFileBO: CapaConnectFileDetailOutput;
  fetchConnectFileDetail: CapaConnectFileDetailOutput;
  fetchConnectGroupBO: CapaConnectGroupBoOutput;
  fetchConnectGroupChatRoom: CapaConnectGroupChatRoomOutput;
  fetchConnectGroupChatRooms: CapaConnectGroupChatRoomsOutput;
  fetchConnectGroupFeedbacksBO: CapaConnectFeedbacksBoOutput;
  fetchConnectGroupIssuesBO: CapaConnectIssuesBoOutput;
  fetchConnectGroupsBO: CapaConnectGroupsBoOutput;
  fetchConnectIssuesBO: CapaConnectIssuesBoOutput;
  fetchConnectMyDrive: CapaConnectMyDrivesOutput;
  fetchConnectUser: CapaConnectUserOutput;
  fetchConnectUserBO: CapaConnectUserBoOutput;
  fetchConnectUserContactList: CapaConnectContactUsersOutput;
  fetchConnectUserFeedbacksBO: CapaConnectFeedbacksBoOutput;
  fetchConnectUserFileLinksBO: FetchConnectUserFileLinkBoOutput;
  fetchConnectUserIssuesBO: CapaConnectIssuesBoOutput;
  fetchConnectUserLinkFiles: FetchConnectUserLinkFileOutput;
  fetchConnectUsersBO: CapaConnectUsersBoOutput;
  fetchDetailedQuotation: CapaQuotationDetailedQuotationOutput;
  fetchFactoron: IcxFactoronModelOutput;
  fetchFileConversionStatus: CapaFileStatusOutput;
  fetchFilePermission: CapaConnectFilePermissionOutput;
  fetchGroup: CapaConnectGroupOutput;
  fetchGroups: CapaConnectGroupsOutput;
  fetchInProgressQuotationPartnerChatRooms: CapaInProgressQuotationPartnerChatRoomsOutput;
  fetchInnoBiz: IcxInnoBizModelOutput;
  fetchItpEventsBO: CapaItpEventsBoOutput;
  fetchJsbEventsBO: CapaJsbEventsBoOutput;
  fetchMainBiz: IcxMainBizModelOutput;
  fetchMiniCluster: IcxMiniClusterModelOutput;
  fetchMyBackOfficeUser: CapaBackOfficeUserOutput;
  fetchMyCompleteRfqs: CapaQuotationRfqMyCompleteRfqOutput;
  fetchMyConfirmedRfqs: CapaQuotationRfqMyRfqsOutput;
  fetchMyConsultingRfqs: CapaQuotationRfqMyRfqsOutput;
  fetchMyDrive: CapaMyDrivesOutput;
  fetchMyPaymentDataByPartner: CapaQuotationPaymentManageModelOutput;
  fetchMyPaymentDataByQuotationUser: CapaQuotationPaymentManageModelOutput;
  fetchMyQuotationPartner: CapaQuotationPartnerStrategyOutput;
  fetchMyQuotationUser: CapaQuotationUserOutput;
  fetchMyReceivedQuotations: CapaQuotationMyReceivedQuotationsOutput;
  fetchMyReviewableRfqs: CapaReviewableRfqsOutput;
  fetchMyRfqQuotations: CapaQuotationDetailedQuotationsOutput;
  fetchMyRfqReviews: CapaQuotationMyRfqReviewOutput;
  fetchOneIcxInfo: IcxModelOutput;
  fetchPartnerRfqReviews: CapaQuotationMyRfqReviewOutput;
  fetchPartnersBO: CapaPartnersBoOutput;
  fetchPaymentAgentResult: Output;
  fetchProjectManagementReceivedQuotations: CapaProjectManagementReceivedQuotationOutput;
  fetchPurchaseOrder: CapaQuotationRfqPurchaseOrderOutput;
  fetchPurchaseOrderWithItem: CapaQuotationRfqPurchaseOrderOutput;
  fetchPurchaseOrders: CapaRfqPurchaseOrdersAndPaymentOutput;
  fetchPurchaseOrdersWithItem: CapaQuotationRfqPurchaseOrdersOutput;
  fetchPurchaseOrdesBO: CapaQuotationRfqPurchaseOrdersOutput;
  fetchQuotationChatMessages: CapaQuotationChatMessagesOutput;
  fetchQuotationChatMessagesBO: CapaQuotationChatRoomOutput;
  fetchQuotationChatRoom: CapaQuotationChatRoomOutput;
  fetchQuotationChatRoomAnnotationComments: CapaQuotationChatRoomAnnotationCommentsOutput;
  fetchQuotationChatRoomSharedFiles: CapaQuotationChatRoomSharedFilesOutput;
  fetchQuotationChatRoomSpecificAnnotations: CapaQuotationChatRoomSpecificAnnotationsOutput;
  fetchQuotationChatRoomSpecificAnnotationsBO: CapaQuotationChatRoomSpecificAnnotationsOutput;
  fetchQuotationPartner: CapaQuotationPartnerStrategyOutput;
  fetchQuotationPartnerActivity: CapaQuotationActivityOutput;
  fetchQuotationPartnerAvailableRequestReviews: CapaQuotationPartnerAvailableRequestReviewsOutput;
  fetchQuotationPartnerBO: CapaQuotationPartnerStrategyBoOutput;
  fetchQuotationPartnerChatRooms: CapaQuotationPartnerChatRoomsOutput;
  fetchQuotationPartnerGNB: CapaQuotationPartnerGnbOutput;
  fetchQuotationPartnerProjectManagementDetail: CapaFetchQuotationPartnerProjectManagementDetailOutput;
  fetchQuotationPartnerProjectManagementRfqs: CapaFetchQuotationPartnerProjectManagementRfqsOutput;
  fetchQuotationPartnerProjectParticipationStatusBO: CapaQuotationPartnersProjectParticipationStatusBoOutput;
  fetchQuotationPartnerRfqReview: CapaQuotationPartnerRfqReviewOutput;
  fetchQuotationServicePartnerRating: CapaQuotationServiceRatingOutput;
  fetchQuotationServiceUserRating: CapaQuotationServiceRatingOutput;
  fetchQuotationUser: CapaQuotationUserOutput;
  fetchQuotationUserBO: CapaQuotationUserBoOutput;
  fetchQuotationUserChatRooms: CapaQuotationUserChatRoomsOutput;
  fetchQuotationUserGNB: CapaQuotationUserGnbOutput;
  /** 고객의 프로젝트 관리 Viewer */
  fetchQuotationUserProjectManagementDetail: CapaFetchQuotationUserProjectManagementDetailOuput;
  fetchQuotationUserProjectManagementRfqs: CapaFetchQuotationUserProjectManagementRfqsOutput;
  fetchQuotationUserRfqAvailableReviews: CapaQuotationUserRfqAvailableReviewOutput;
  fetchQuotationUserRfqDetail: CapaQuotationUserRfqDetailOutput;
  fetchQuotationUserRfqReviews: CapaQuotationUserRfqReviewsOutput;
  fetchQuotationUserRfqs: CapaQuotationUserRfqsOutput;
  fetchQuotationUserRfqsBO: CapaQuotationUserRfqsBoOutput;
  fetchRecommendedContactUsersList: FetchRecommendedContactListsOutput;
  fetchRfqDetail: CapaQuotationRfqDetailOutput;
  fetchRfqDetailBO: CapaRfqDetailBoOutput;
  fetchRfqPartnerEvaluation: CapaQuotationRfqPartnerEvaluationOutput;
  fetchRfqPartners: CapaQuotationRfqPartnersOutput;
  fetchRfqQuotationPdf: CapaQuotationDetailedQuotationOutput;
  fetchRfqQuotationsBO: CapaQuotationDetailedQuotationsOutput;
  fetchRfqReviewBO: CapaRfqReviewsBoOutput;
  fetchRfqReviews: CapaQuotationMyRfqReviewOutput;
  fetchRfqsBO: CapaRfqsBoOutput;
  fetchServiceRatingBO: CapaServiceRatingBoOutput;
  fetchServiceSuggestionBO: CapaServiceSuggestionBoOutput;
  fetchServiceTypeStatistics: CapaServiceTypeStatisticsOutput;
  fetchUsersBO: CapaUsersBoOutput;
  fetchVentureBiz: IcxVentureBizModelOutput;
  fetchWithdrawnChatRooms: CapaWithdrawnChatRoomsOutput;
  fetchWithdrawnQuotationPartner: CapaQuotationPartnerStrategyOutput;
  getNoticeScheduleBO: NoticeScheduleOutput;
  icxAuthenticate: IcxAuthenticationOutput;
  /** 에스크로 - 구매거절 */
  refuseEscrowPurchase: Output;
  /** 에스크로 - 배송 등록 */
  registerShippingEscrow: Output;
  /** 지급대행 - 서브몰 등록 */
  registerSubmall: Output;
  /** 디바이스 토큰 삭제 */
  removeDeviceToken: Output;
  /** 지급대행 - 지급대행 요청 */
  requestPaymentAgent: Output;
  requestRfqId: CapauuidOutput;
  searchFile: CapaConnectMyDrivesOutput;
  searchGroups: CapaConnectGroupChatRoomsOutput;
  searchRfq: CapaQuotationSearchOutput;
  searchUser: CapaConnectSearchUsersOutput;
  verifyCompanyRegistrationNumber: Output;
  /** 이메일 인증 확인 */
  verifyEmailVerificationCode: Output;
};


export type QueryAuthenticateArgs = {
  input: AuthenticationInput;
};


export type QueryAuthenticateBoArgs = {
  input: AuthenticationInput;
};


export type QueryCancelRequestPaymentAgentArgs = {
  input: CancelRequestPaymentAgentInput;
};


export type QueryCheckBalanceArgs = {
  input: CheckBalanceInput;
};


export type QueryCheckRegisteredCapaServiceArgs = {
  emails: Array<Scalars['String']>;
};


export type QueryConfirmEscrowPurchaseArgs = {
  input: ConfirmEscrowPurchaseInput;
};


export type QueryFetchActiveAdvertisingArgs = {
  input: FetchActiveAdvertisingInput;
};


export type QueryFetchActiveAdvertisingBoArgs = {
  input: FetchActiveAdvertisingBoInput;
};


export type QueryFetchAdsActivityLogsArgs = {
  input: FetchAdsActivityLogsInput;
};


export type QueryFetchAdsImpressionsBoArgs = {
  input: FetchAdsImpressionsBoInput;
};


export type QueryFetchAdvertisementAdsImpressionsBoArgs = {
  input: FetchAdvertisementAdsImpressionsBoInput;
};


export type QueryFetchAdvertisementsBoArgs = {
  input: FetchAdvertisementsBoInput;
};


export type QueryFetchAdvertisingsBoArgs = {
  input: FetchAdvertisingsBoInput;
};


export type QueryFetchAllIcxInfoArgs = {
  input: FetchAllIcxInput;
};


export type QueryFetchAvailableFilterRfqsArgs = {
  input: FetchAvailableFilterRfqsInput;
};


export type QueryFetchAvailableRfqsArgs = {
  input: FetchRfqsInput;
};


export type QueryFetchBoAmbassadorInvitationStatusArgs = {
  input: FetchBoAmbassadorInvitationStatusInput;
};


export type QueryFetchBoAmbassadorsArgs = {
  input: FetchBoAmbassadorsInput;
};


export type QueryFetchBoTestUsersArgs = {
  input: FetchBoTestUsersInput;
};


export type QueryFetchBoUsersArgs = {
  input: FetchBoUsersInput;
};


export type QueryFetchBoMemoArgs = {
  input: FetchBoMemosInput;
};


export type QueryFetchBypassComplaintBoArgs = {
  input: CapaBypassComplaintInput;
};


export type QueryFetchCapaNotificationArgs = {
  input: FetchNotificationInput;
};


export type QueryFetchCxManagementRequiredUsersBoArgs = {
  input: FetchCxManagementRequiredUsersBoInput;
};


export type QueryFetchCapaConnectSharedFileArgs = {
  input: FetchCapaConnectSharedFileInput;
};


export type QueryFetchCapabilityArgs = {
  input: FetchCapabilityInput;
};


export type QueryFetchCommentBoArgs = {
  input: FetchCommentsBoInput;
};


export type QueryFetchConfirmDetailedQuotationArgs = {
  input: FetchConfirmDetailedQuotationInput;
};


export type QueryFetchConfirmPurchaseOrderArgs = {
  input: FetchConfirmPurchaseOrderInput;
};


export type QueryFetchConfirmPurchaseOrderWithItemArgs = {
  input: FetchConfirmPurchaseOrderInput;
};


export type QueryFetchConnectAnnotationsArgs = {
  input: FetchConnectAnnotationsInput;
};


export type QueryFetchConnectChatMessagesArgs = {
  input: FetchConnectChatRoomInput;
};


export type QueryFetchConnectChatMessagesBoArgs = {
  input: FetchConnectChatRoomInput;
};


export type QueryFetchConnectFeedbacksBoArgs = {
  input: FetchConnectFeedbacksBoInput;
};


export type QueryFetchConnectFileBoArgs = {
  connectFileId: Scalars['String'];
};


export type QueryFetchConnectFileDetailArgs = {
  input: FetchConnectFileDetailInput;
};


export type QueryFetchConnectGroupBoArgs = {
  groupId: Scalars['String'];
};


export type QueryFetchConnectGroupChatRoomArgs = {
  input: FetchConnectGroupChatRoomInput;
};


export type QueryFetchConnectGroupChatRoomsArgs = {
  input: FetchConnectGroupChatRoomsInput;
};


export type QueryFetchConnectGroupFeedbacksBoArgs = {
  input: FetchConnectGroupFeedbacksBoInput;
};


export type QueryFetchConnectGroupIssuesBoArgs = {
  input: FetchConnectGroupIssuesBoInput;
};


export type QueryFetchConnectGroupsBoArgs = {
  input: FetchConnectGroupsBoInput;
};


export type QueryFetchConnectIssuesBoArgs = {
  input: FetchConnectIssuesBoInput;
};


export type QueryFetchConnectMyDriveArgs = {
  input: FetchConnectMyDriveInput;
};


export type QueryFetchConnectUserBoArgs = {
  connectUserId: Scalars['String'];
};


export type QueryFetchConnectUserContactListArgs = {
  input: FetchConnectUserContactListInput;
};


export type QueryFetchConnectUserFeedbacksBoArgs = {
  input: FetchConnectUserFeedbacksBoInput;
};


export type QueryFetchConnectUserFileLinksBoArgs = {
  input: FetchConnectUserFileLinksBoInput;
};


export type QueryFetchConnectUserIssuesBoArgs = {
  input: FetchConnectUserIssuesBoInput;
};


export type QueryFetchConnectUserLinkFilesArgs = {
  input: FetchConnectUserLinkFileInput;
};


export type QueryFetchConnectUsersBoArgs = {
  input: FetchConnectUsersBoInput;
};


export type QueryFetchDetailedQuotationArgs = {
  input: FetchDetailedQuotationInput;
};


export type QueryFetchFactoronArgs = {
  input: FactoronBizFetchIcxInput;
};


export type QueryFetchFileConversionStatusArgs = {
  input: FetchFileConversionStatusInput;
};


export type QueryFetchFilePermissionArgs = {
  input: FetchConnectGroupFilePermissionInput;
};


export type QueryFetchGroupArgs = {
  input: FetchConnectGroupInput;
};


export type QueryFetchGroupsArgs = {
  input: FetchConnectGroupsInput;
};


export type QueryFetchInProgressQuotationPartnerChatRoomsArgs = {
  input: FetchInProgressQuotationPartnerChatRoomsInput;
};


export type QueryFetchInnoBizArgs = {
  input: InnoBizFetchIcxInput;
};


export type QueryFetchItpEventsBoArgs = {
  input: FetchItpEventsBoInput;
};


export type QueryFetchJsbEventsBoArgs = {
  input: FetchJsbEventsBoInput;
};


export type QueryFetchMainBizArgs = {
  input: MainBizFetchIcxInput;
};


export type QueryFetchMiniClusterArgs = {
  input: IcxMiniClusterFetchIcxInput;
};


export type QueryFetchMyCompleteRfqsArgs = {
  input: FetchMyCompleteRfqsInput;
};


export type QueryFetchMyConfirmedRfqsArgs = {
  input: FetchRfqsInput;
};


export type QueryFetchMyConsultingRfqsArgs = {
  input: FetchRfqsInput;
};


export type QueryFetchMyDriveArgs = {
  input: FetchMyDriveInput;
};


export type QueryFetchMyPaymentDataByPartnerArgs = {
  input: FetchPaymentManageByPartnerIdInput;
};


export type QueryFetchMyPaymentDataByQuotationUserArgs = {
  input: FetchPaymentManageByQuotationUserIdInput;
};


export type QueryFetchMyReceivedQuotationsArgs = {
  input: FetchMyReceivedQuotationsInput;
};


export type QueryFetchMyRfqQuotationsArgs = {
  input: FetchMyRfqQuotationsInput;
};


export type QueryFetchOneIcxInfoArgs = {
  input: FetchOneIcxInput;
};


export type QueryFetchPartnerRfqReviewsArgs = {
  input: FetchPartnerRfqReviewsInput;
};


export type QueryFetchPartnersBoArgs = {
  input: FetchPartnersInput;
};


export type QueryFetchPaymentAgentResultArgs = {
  input: FetchPaymentAgentResultInput;
};


export type QueryFetchProjectManagementReceivedQuotationsArgs = {
  input: FetchProjectManagementReceivedQuotationsInput;
};


export type QueryFetchPurchaseOrderArgs = {
  input: FetchPurchaseOrderInput;
};


export type QueryFetchPurchaseOrderWithItemArgs = {
  input: FetchPurchaseOrderInput;
};


export type QueryFetchPurchaseOrdersArgs = {
  input: FetchPurchaseOrdersInput;
};


export type QueryFetchPurchaseOrdersWithItemArgs = {
  input: FetchPurchaseOrdersInput;
};


export type QueryFetchPurchaseOrdesBoArgs = {
  input: FetchPurchaseOrdersBoInput;
};


export type QueryFetchQuotationChatMessagesArgs = {
  input: FetchQuotationChatRoomInput;
};


export type QueryFetchQuotationChatMessagesBoArgs = {
  input: FetchQuotationChatRoomInput;
};


export type QueryFetchQuotationChatRoomArgs = {
  input: FetchQuotationChatRoomInput;
};


export type QueryFetchQuotationChatRoomAnnotationCommentsArgs = {
  input: FetchQuotationChatRoomAnnotationCommentInput;
};


export type QueryFetchQuotationChatRoomSharedFilesArgs = {
  input: FetchQuotationChatRoomSharedFilesInput;
};


export type QueryFetchQuotationChatRoomSpecificAnnotationsArgs = {
  input: FetchQuotationChatRoomSpecificAnnotationInput;
};


export type QueryFetchQuotationChatRoomSpecificAnnotationsBoArgs = {
  input: FetchQuotationChatRoomSpecificAnnotationBoInput;
};


export type QueryFetchQuotationPartnerArgs = {
  quotationPartnerId: Scalars['String'];
};


export type QueryFetchQuotationPartnerActivityArgs = {
  input?: InputMaybe<FetchQuotationPartnerActivityInput>;
};


export type QueryFetchQuotationPartnerAvailableRequestReviewsArgs = {
  input: FetchQuotationPartnerRfqReviewInput;
};


export type QueryFetchQuotationPartnerBoArgs = {
  input: FetchQuotationPartnerStrategyBoInput;
};


export type QueryFetchQuotationPartnerChatRoomsArgs = {
  input: FetchQuotationPartnerChatRoomsInput;
};


export type QueryFetchQuotationPartnerGnbArgs = {
  input: FetchRfqsInput;
};


export type QueryFetchQuotationPartnerProjectManagementDetailArgs = {
  input: FetchQuotationPartnerProjectManagementDetailInput;
};


export type QueryFetchQuotationPartnerProjectManagementRfqsArgs = {
  input: FetchQuotationPartnerManagementRfqsInput;
};


export type QueryFetchQuotationPartnerProjectParticipationStatusBoArgs = {
  input: FetchQuotationPartnerProjectParticipationStatusBoInput;
};


export type QueryFetchQuotationPartnerRfqReviewArgs = {
  input: FetchQuotationPartnerRfqReviewInput;
};


export type QueryFetchQuotationUserArgs = {
  quotationUserId: Scalars['String'];
};


export type QueryFetchQuotationUserBoArgs = {
  input: FetchQuotationUserBoInput;
};


export type QueryFetchQuotationUserChatRoomsArgs = {
  input?: InputMaybe<FetchQuotationUserChatRoomsInput>;
};


export type QueryFetchQuotationUserProjectManagementDetailArgs = {
  input: FetchQuotationUserProjectManagementDetailInput;
};


export type QueryFetchQuotationUserProjectManagementRfqsArgs = {
  input: FetchQuotationUserProjectManagementRfqsInput;
};


export type QueryFetchQuotationUserRfqAvailableReviewsArgs = {
  input: FetchQuotationUserRfqReviewsInput;
};


export type QueryFetchQuotationUserRfqDetailArgs = {
  input: FetchRfqInput;
};


export type QueryFetchQuotationUserRfqReviewsArgs = {
  input: FetchQuotationUserRfqReviewsInput;
};


export type QueryFetchQuotationUserRfqsArgs = {
  input: FetchQuotationUserRfqsInput;
};


export type QueryFetchQuotationUserRfqsBoArgs = {
  input: FetchQuotationUserRfqsBoInput;
};


export type QueryFetchRecommendedContactUsersListArgs = {
  input: FetchRecommendedContactUserListInput;
};


export type QueryFetchRfqDetailArgs = {
  input: FetchRfqInput;
};


export type QueryFetchRfqDetailBoArgs = {
  input: FetchRfqInput;
};


export type QueryFetchRfqPartnerEvaluationArgs = {
  input?: InputMaybe<FetchRfqPartnerEvaluationInput>;
};


export type QueryFetchRfqPartnersArgs = {
  input: FetchRfqInput;
};


export type QueryFetchRfqQuotationPdfArgs = {
  input?: InputMaybe<RequestRfqQuotationPdfInput>;
};


export type QueryFetchRfqQuotationsBoArgs = {
  input: FetchRfqQuotationsBoInput;
};


export type QueryFetchRfqReviewBoArgs = {
  input: FetchRfqReviewBoInput;
};


export type QueryFetchRfqsBoArgs = {
  input: FetchRfqsInput;
};


export type QueryFetchServiceRatingBoArgs = {
  input: FetchServiceRatingBoInput;
};


export type QueryFetchServiceSuggestionBoArgs = {
  input: FetchServiceSuggestionBoInput;
};


export type QueryFetchServiceTypeStatisticsArgs = {
  input: FetchServiceTypeStatisticsInput;
};


export type QueryFetchUsersBoArgs = {
  input: FetchUsersInput;
};


export type QueryFetchVentureBizArgs = {
  input: VentureBizFetchIcxInput;
};


export type QueryFetchWithdrawnChatRoomsArgs = {
  input: FetchWithdrawnChatRoomsInput;
};


export type QueryFetchWithdrawnQuotationPartnerArgs = {
  quotationPartnerId: Scalars['String'];
};


export type QueryIcxAuthenticateArgs = {
  input: IcxAuthenticationInput;
};


export type QueryRefuseEscrowPurchaseArgs = {
  input: RefuseEscrowPurchaseInput;
};


export type QueryRegisterShippingEscrowArgs = {
  input: RegisterExpectedDeliveryDateInput;
};


export type QueryRegisterSubmallArgs = {
  input: RegisterSubmallInput;
};


export type QueryRemoveDeviceTokenArgs = {
  input: RemoveDeviceTokenInput;
};


export type QueryRequestPaymentAgentArgs = {
  input: RequestPaymentAgentInput;
};


export type QuerySearchFileArgs = {
  input: SearchConnectFileInput;
};


export type QuerySearchGroupsArgs = {
  input: SearchConnectGroupsInput;
};


export type QuerySearchRfqArgs = {
  input: QuotationKeywordSearchInput;
};


export type QuerySearchUserArgs = {
  input: SearchConnectUsersInput;
};


export type QueryVerifyCompanyRegistrationNumberArgs = {
  input: VerifyCompanyRegistrationNumberInput;
};


export type QueryVerifyEmailVerificationCodeArgs = {
  input: VerifyEmailVerificationCodeInput;
};

export type QuitQuotationChatRoomInput = {
  chatRoomId: Scalars['String'];
};

export type QuotationKeywordSearchInput = {
  confirmed: Scalars['Boolean'];
  eventType?: InputMaybe<CapaQuotationRfqEventType>;
  keyword: Scalars['String'];
};

export type QuotationPartner = {
  __typename?: 'QuotationPartner';
  id: Scalars['ID'];
};

/** 파트너 파일 정보 입력 */
export type QuotationPartnerFileUploadInput = {
  /** fk 캐파 클라우드 파일 아이디 */
  fileId: Scalars['String'];
  /** 타입 CAPAQuotationPartnerFileType */
  fileType: CapaQuotationPartnerFileType;
};

export type QuotationServiceRatingInput = {
  /** 커멘트 */
  comment?: InputMaybe<Scalars['String']>;
  /** 점수 */
  rating: Scalars['Float'];
};

export type QuotationUser = {
  __typename?: 'QuotationUser';
  id: Scalars['ID'];
};

/** 고객 파일 정보 입력 */
export type QuotationUserFileUploadInput = {
  /** fk 파일 아이디 */
  fileId: Scalars['String'];
  /** 타입 CAPAQuotationUserFileType */
  fileType: CapaQuotationUserFileType;
};

/** ReadAllManagementInput */
export type ReadAllManagementInput = {
  rfqId: Scalars['String'];
  type: CapaRfqProjectManagementType;
};

export type ReadConnectAnnotationCommentInput = {
  annotationId: Scalars['String'];
};

export type ReadConnectChatRoomMessageInput = {
  chatRoomId: Scalars['String'];
};

/** ReadManagementInput */
export type ReadManagementInput = {
  partnerId?: InputMaybe<Scalars['String']>;
  rfqId: Scalars['String'];
  type: CapaRfqProjectManagementType;
};

export type ReadNotificationInput = {
  seq?: InputMaybe<Scalars['Float']>;
  /** 캐파 서비스 타입 */
  service: CapaServiceType;
};

export type ReadQuotationAnnotationCommentInput = {
  annotationId: Scalars['String'];
};

export type ReadQuotationChatRoomMessageInput = {
  chatRoomId: Scalars['String'];
};

export type ReadRfqPurchaseOrderInput = {
  quotationPartnerId: Scalars['String'];
  rfqId: Scalars['String'];
};

export type ReadRfqQuotationInput = {
  partnerId: Scalars['String'];
  rfqId: Scalars['String'];
};

export type RefuseEscrowPurchaseInput = {
  BuyerAuthNum?: InputMaybe<Scalars['String']>;
  CharSet?: InputMaybe<Scalars['String']>;
  EdiDate?: InputMaybe<Scalars['String']>;
  EdiType?: InputMaybe<Scalars['String']>;
  MID?: InputMaybe<Scalars['String']>;
  MallIp?: InputMaybe<Scalars['String']>;
  RefundAccount?: InputMaybe<Scalars['String']>;
  RefundBankCode?: InputMaybe<Scalars['String']>;
  RefundName?: InputMaybe<Scalars['String']>;
  RejectReason?: InputMaybe<Scalars['String']>;
  ReqType?: InputMaybe<EscrowPaymentRequestType>;
  TID?: InputMaybe<Scalars['String']>;
};

/** BO 엠버서더 등록 */
export type RegisterAmbassadorBoInput = {
  /** 담당자 휴대폰 번호 */
  cellphoneNumber: Scalars['String'];
  /** 사업자 등록번호 */
  companyRegistrationNumber: Scalars['String'];
  /** 엠베서더 등록일 */
  createdAt?: InputMaybe<Scalars['String']>;
  /** 담당자 이메일 */
  email: Scalars['String'];
  /** 담당자명 */
  managerName: Scalars['String'];
  /** 엠베서더 회사명 */
  organizationName: Scalars['String'];
};

/** BO 회원가입 */
export type RegisterBackOfficeUserInput = {
  /** 부서 */
  dept: BackOfficeUserDeptType;
  /** 이메일 */
  email: Scalars['String'];
  /** 이름 */
  name: Scalars['String'];
  /** 영어닉네임 */
  nickName: Scalars['String'];
  /** 비밀번호 */
  password: Scalars['String'];
  /** 역할 */
  role: BackOfficeAdminRole;
  /** 상태 */
  status?: InputMaybe<BackOfficeUserStatus>;
  /** 직무 */
  task: Scalars['String'];
};

/** 캐파 회원가입 */
export type RegisterCapaUserInput = {
  /** 엠버서더 ID */
  ambassadorId?: InputMaybe<Scalars['String']>;
  /** 인증번호 */
  code: Scalars['String'];
  /** 이메일 */
  email: Scalars['String'];
  /** CAPA 서비스를 어떻게 알게 되셨나요? (복수 선택 가능) */
  inflowRoute: Array<CapaInflowRoute>;
  /** 비밀번호 */
  password: Scalars['String'];
  /** 비밀번호 확인 */
  passwordConfirm: Scalars['String'];
  /** [필수] 개인정보 수집 및 활용 동의 */
  privacyAgree: Scalars['Boolean'];
  /** [선택] 프로모션 정보 수신 동의 */
  promotionAgree?: InputMaybe<Scalars['Boolean']>;
  /** 추천인 ID */
  referralUserId?: InputMaybe<Scalars['String']>;
  /** 캐파 서비스 타입 */
  service: CapaServiceType;
  /** [필수] 캐파 서비스 이용약관 동의 */
  serviceAgree: Scalars['Boolean'];
};

export type RegisterConnectUserFolderInput = {
  folderName: Scalars['String'];
  pathId?: InputMaybe<Scalars['String']>;
};

export type RegisterConnectUserInput = {
  userLanguage: Language;
  userName: Scalars['String'];
};

export type RegisterExpectedDeliveryDateInput = {
  /** 상점IP 서버주소 */
  MallIp?: InputMaybe<Scalars['String']>;
  /** 송장번호, '-' 특수문자 없이 입력 */
  invoiceNumber: Scalars['String'];
  purchaseOrderId: Scalars['String'];
  quotationPartnerId: Scalars['String'];
  /** 등록자이름 */
  registerName: Scalars['String'];
  /** 배송지 주소 */
  shippingAddress: Scalars['String'];
  /** 배송업체명 */
  shippingCompany: Scalars['String'];
};

/** 카파 User 통합 회원가입 */
export type RegisterIntegratedUserInput = {
  /** 사업자 여부 */
  bizType: CapaQuotationUserBizType;
  /** 휴대폰 인증번호 */
  cellphoneCode: Scalars['String'];
  /** 휴대폰 번호 */
  cellphoneNumber: Scalars['String'];
  /** 사업자 기업 정보 관련 */
  companyInfo?: InputMaybe<NiceDnbCompanyInformationInput>;
  /** 회사소개 */
  companyIntroduction?: InputMaybe<Scalars['String']>;
  /** 부서 */
  department?: InputMaybe<Scalars['String']>;
  /** 이메일 */
  email: Scalars['String'];
  /** 이메일 인증번호 */
  emailCode: Scalars['String'];
  /** 견적 유저 파일 업로드 정보 입력 */
  files?: InputMaybe<Array<QuotationUserFileUploadInput>>;
  /** 주소 */
  fullAddress?: InputMaybe<Scalars['String']>;
  /** CAPA 서비스를 어떻게 알게 되셨나요? (복수 선택 가능) */
  inflowRoute?: InputMaybe<Array<CapaInflowRoute>>;
  /** 이름 (담당자명) */
  managerName: Scalars['String'];
  /** 회사 / 단체명 */
  organizationName?: InputMaybe<Scalars['String']>;
  /** 비밀번호 */
  password: Scalars['String'];
  /** 비밀번호 확인 */
  passwordConfirm: Scalars['String'];
  /** 직함 */
  position?: InputMaybe<Scalars['String']>;
  /** [필수] 개인정보 수집 및 활용 동의 */
  privacyAgree: Scalars['Boolean'];
  /** [선택] 프로모션 정보 수신 동의 */
  promotionAgree?: InputMaybe<Scalars['Boolean']>;
  /** 추천인 ID */
  referralUserId?: InputMaybe<Scalars['String']>;
  /** 카파 서비스 타입 */
  service: CapaServiceType;
  /** [필수] 카파 서비스 이용약관 동의 */
  serviceAgree: Scalars['Boolean'];
  /** 짧은 주소 */
  shortAddress?: InputMaybe<Scalars['String']>;
  /** 웹사이트 */
  website?: InputMaybe<Scalars['String']>;
};

/** ITP 이벤트 RFQ 거래완료 보상 신청 */
export type RegisterItpEventInput = {
  /** 연락처 */
  cellphoneNumber: Scalars['String'];
  /** 거래완료 금액 */
  completeCost: Scalars['Float'];
  /** ITP 이벤트 거래완료 증빙 자료 */
  files: Array<ItpEventFileUploadInput>;
  /** OFFICECON 정보제공 동의여부 */
  officeconAgreed: Scalars['Boolean'];
  /** rfq 프로젝트 이름 */
  projectName: Scalars['String'];
  /** Quotation 파트너 id */
  quotationPartnerId: Scalars['String'];
  /** rfq 아이디 */
  rfqId: Scalars['String'];
};

/** ITP 이벤트 RFQ 거래완료 보상 신청 */
export type RegisterJsbEventInput = {
  /** 계좍 */
  account: Scalars['String'];
  /** 은행 */
  bank: Scalars['String'];
  /** 연락처 */
  cellphoneNumber: Scalars['String'];
  /** 거래완료 금액 */
  completeCost: Scalars['Float'];
  /** ITP 이벤트 거래완료 증빙 자료 */
  files: Array<JsbEventFileUploadInput>;
  /** rfq 프로젝트 이름 */
  projectName: Scalars['String'];
  /** Quotation 파트너 id */
  quotationPartnerId: Scalars['String'];
  /** rfq 아이디 */
  rfqId: Scalars['String'];
};

export type RegisterQuotationPartnerBoInput = {
  /** 파트너 캐파빌리티 jsonb array of { service_type, process_method, material, detailed_material, etc } */
  capabilities: CapaQuotationCapabilityInput;
  /** 회사소개 */
  companyIntroduction?: InputMaybe<Scalars['String']>;
  /** 사업자 등록번호 */
  companyRegistrationNumber: Scalars['String'];
  /** 연락처 */
  contact: Scalars['String'];
  /** 부서 */
  department: Scalars['String'];
  /** 이메일 */
  email: Scalars['String'];
  /** 장비 */
  equipment?: InputMaybe<Scalars['String']>;
  /** 공장 주소 */
  factoryAddress?: InputMaybe<Scalars['String']>;
  /** 파트너 파일 업로드 정보 입력 */
  files?: InputMaybe<Array<QuotationPartnerFileUploadInput>>;
  /** 설립년도 */
  foundedIn?: InputMaybe<Scalars['String']>;
  /** 주소 */
  fullAddress: Scalars['String'];
  /** CAPA 서비스를 어떻게 알게 되셨나요? (복수 선택 가능) */
  inflowRoute: Array<CapaInflowRoute>;
  /** 담당자명 */
  managerName: Scalars['String'];
  /** 규모 (직원수) */
  numberEmployees?: InputMaybe<Scalars['String']>;
  /** 회사명 */
  organizationName: Scalars['String'];
  /** 비밀번호 */
  password: Scalars['String'];
  /** 직위 */
  position: Scalars['String'];
  /** [선택] 프로모션 정보 수신 동의 */
  promotionAgree?: InputMaybe<Scalars['Boolean']>;
  /** 대응 시간 */
  serviceHours?: InputMaybe<Scalars['String']>;
  /** 구 까지만 보여주는 주소 */
  shortAddress: Scalars['String'];
  /** 파트너 기술관련 파일 업로드 정보 입력 */
  strategyFiles?: InputMaybe<Array<CapaQuotationPartnerStrategyFileUploadInput>>;
  /** 웹사이트 */
  website?: InputMaybe<Scalars['String']>;
};

/** 파트너 정보 입력 */
export type RegisterQuotationPartnerEquipmentInput = {
  /** 설명 */
  description?: InputMaybe<Scalars['String']>;
  /** 장비 명 */
  equipmentName: Scalars['String'];
  /** fk 캐파 파일 아이디 */
  fileId?: InputMaybe<Scalars['String']>;
  /** 수량 */
  quantity: Scalars['Float'];
};

/** 파트너 정보 입력 */
export type RegisterQuotationPartnerInput = {
  /** 파트너 캐파빌리티 jsonb array of { service_type, process_method, material, detailed_material, etc } */
  capabilities: CapaQuotationCapabilityInput;
  /** 회사소개 */
  companyIntroduction?: InputMaybe<Scalars['String']>;
  /** 사업자 등록번호 */
  companyRegistrationNumber: Scalars['String'];
  /** 연락처 */
  contact: Scalars['String'];
  /** 부서 */
  department: Scalars['String'];
  /** detail address */
  detailAddress?: InputMaybe<Scalars['String']>;
  /** 장비 */
  equipment?: InputMaybe<Scalars['String']>;
  /** 공장 주소 */
  factoryAddress?: InputMaybe<Scalars['String']>;
  /** factory detail address */
  factoryDetailAddress?: InputMaybe<Scalars['String']>;
  /** 설립년도 */
  foundedIn?: InputMaybe<Scalars['String']>;
  /** 주소 */
  fullAddress: Scalars['String'];
  /** 담당자명 */
  managerName: Scalars['String'];
  /** 규모 (직원수) */
  numberEmployees?: InputMaybe<Scalars['String']>;
  /** 회사명 */
  organizationName: Scalars['String'];
  /** 직위 */
  position: Scalars['String'];
  /** 사업자 등록증 파일 */
  registrations: Array<CapaQuotationPartnerStrategyFileUploadInput>;
  /** 대응 시간 */
  serviceHours?: InputMaybe<Scalars['String']>;
  /** 구 까지만 보여주는 주소 */
  shortAddress: Scalars['String'];
  /** 웹사이트 */
  website?: InputMaybe<Scalars['String']>;
};

/** RegisterQuotationPartnerPortfolioCapabilitiesInput */
export type RegisterQuotationPartnerPortfolioCapabilitiesInput = {
  detailedServices?: InputMaybe<Array<CapaQuotationDetailedServiceType>>;
  service?: InputMaybe<CapaQuotationServiceType>;
};

/** 파트너 정보 입력 */
export type RegisterQuotationPartnerPortfolioInput = {
  /** 제품 용도 */
  capabilities?: InputMaybe<Array<RegisterQuotationPartnerPortfolioCapabilitiesInput>>;
  /** 고객 */
  client?: InputMaybe<Scalars['String']>;
  /** 상세 정보 */
  description?: InputMaybe<Scalars['String']>;
  /** 파트너 파일 업로드 정보 입력 */
  files: Array<CapaQuotationPartnerStrategyFileUploadInput>;
  /** 제조 단계 */
  produceStep?: InputMaybe<CapaQuotationPartnerImagePortfolioProduceStepType>;
  /** 제품 종류 */
  productType?: InputMaybe<Scalars['String']>;
  /** 프로젝트 명 */
  projectName: Scalars['String'];
  /** 제품 용도 */
  projectPurpose?: InputMaybe<Array<CapaQuotationProductPurpose>>;
  /** 수량 */
  quantity?: InputMaybe<Scalars['Float']>;
};

/** 매칭 필수정보 입력 / 기본 정보 */
export type RegisterQuotationUserInput = {
  /** 사업자 여부 */
  bizType: CapaQuotationUserBizType;
  /** 휴대폰 번호 */
  cellphoneNumber: Scalars['String'];
  /** 회사소개 */
  companyIntroduction?: InputMaybe<Scalars['String']>;
  /** 사업자등록번호 */
  companyRegistrationNumber?: InputMaybe<Scalars['String']>;
  /** 부서 */
  department?: InputMaybe<Scalars['String']>;
  /** 견적 유저 파일 업로드 정보 입력 */
  files?: InputMaybe<Array<QuotationUserFileUploadInput>>;
  /** 주소 */
  fullAddress?: InputMaybe<Scalars['String']>;
  /** 이름 (담당자명) */
  managerName: Scalars['String'];
  /** 회사 / 단체명 */
  organizationName?: InputMaybe<Scalars['String']>;
  /** 직함 */
  position?: InputMaybe<Scalars['String']>;
  /** 추천인 ID */
  referralUserId?: InputMaybe<Scalars['String']>;
  /** 짧은 주소 */
  shortAddress?: InputMaybe<Scalars['String']>;
  /** 웹사이트 */
  website?: InputMaybe<Scalars['String']>;
};

export type RegisterRequestRfqPurchaseOrderInput = {
  rfqId: Scalars['String'];
};

export type RegisterRequestRfqQuotationInput = {
  partnerId: Scalars['String'];
  rfqId: Scalars['String'];
};

export type RegisterRfqDesignInput = {
  /** design 단계 - 제품 디자인, 기구 설계 */
  services: Array<DesignServiceInput>;
};

export type RegisterRfqInput = {
  budgetOpen: Scalars['Boolean'];
  /** 상담 시작 방식 */
  consultingStartMethod?: InputMaybe<CapaConsultingStartMethod>;
  /** pcb 서비스 이용 */
  design?: InputMaybe<RegisterRfqDesignInput>;
  /** 상세요청사항 */
  detailedRequest?: InputMaybe<Scalars['String']>;
  detailedServiceType?: InputMaybe<CapaQuotationDetailedServiceType>;
  drawingFiles?: InputMaybe<Array<RfqDrawingFileInput>>;
  dueDate: Scalars['String'];
  dueNegotiable: Scalars['Boolean'];
  eventType?: InputMaybe<CapaQuotationRfqEventType>;
  manufacturingStage?: InputMaybe<CapaRfqManufacturingStage>;
  maxEstimatedBudget: Scalars['Float'];
  minEstimatedBudget: Scalars['Float'];
  optionalServices?: InputMaybe<Array<RfqOptionalServiceInput>>;
  /** pcb 서비스 이용 */
  pcb?: InputMaybe<RegisterRfqPcbInput>;
  /** 재작성 베이스 rfqId */
  preRfqId?: InputMaybe<Scalars['String']>;
  projectName: Scalars['String'];
  projectPurpose: CapaQuotationProductPurpose;
  projectPurposeDetail: Scalars['String'];
  publicOpen: Scalars['Boolean'];
  referenceFiles?: InputMaybe<Array<RfqReferenceFileInput>>;
  rfqId: Scalars['String'];
  serviceType: CapaQuotationServiceType;
};

export type RegisterRfqPcbInput = {
  /** BOM 파일 - pcb 조립을 위한 파일 */
  assemblyFiles?: InputMaybe<Array<RfqPcbAssemblyFileInput>>;
  /** 조립 방식 */
  assemblyMethod?: InputMaybe<Array<PcbAssemblyMethodInput>>;
  /** 설계시 조립 수량 */
  assemblyQuantity?: InputMaybe<Scalars['Float']>;
  /** 거버파일 - pcb 제작을 위한 파일 */
  fabricationFiles?: InputMaybe<Array<RfqPcbFabricationFileInput>>;
  /** 설계시 제작 수량 */
  fabricationQuantity?: InputMaybe<Scalars['Float']>;
  /** 자재 방법 */
  materialSupplyMethod?: InputMaybe<CapaRfqPcbMaterialSupplyMethodType>;
  /** 메탈마스크 제공 여부 */
  metalMaskAvailablity?: InputMaybe<Scalars['Boolean']>;
  /** pcb 단계 - 설계, 제작, 조립 */
  services: Array<PcbServiceInput>;
};

export type RegisterRfqReviewInput = {
  /** 납기일 준수 여부 */
  inDueDate?: InputMaybe<Scalars['Boolean']>;
  /** quotation Partner id */
  quotationPartnerId: Scalars['String'];
  reviewFiles?: InputMaybe<Array<RfqTransactionReviewFileInput>>;
  /** rfq id */
  rfqId: Scalars['String'];
  /** 리뷰 타입 */
  rfqReviewType?: InputMaybe<CapaRfqReviewType>;
  /** transaction satisfaction comment */
  transactionSatisfactionComment?: InputMaybe<Scalars['String']>;
  /** transaction satisfaction comment */
  transactionSatisfactionPoint?: InputMaybe<Scalars['Float']>;
};

export type RegisterSubmallInput = {
  accountHolder: Scalars['String'];
  bankAccount: Scalars['String'];
  bankCode: Scalars['String'];
  /** 필수값임 */
  memo: Scalars['String'];
  quotationPartnerId: Scalars['String'];
  reqType?: InputMaybe<SubmallRequestType>;
  submallId: Scalars['String'];
  submallName: Scalars['String'];
  submallRegistrationNumber: Scalars['String'];
};

export type RegisteredCapaService = {
  __typename?: 'RegisteredCapaService';
  cloudUser?: Maybe<CloudUser>;
  connectUser?: Maybe<ConnectUser>;
  email: Scalars['String'];
  quotationParnter?: Maybe<QuotationPartner>;
  quotationUser?: Maybe<QuotationUser>;
  scopes?: Maybe<Array<CapaServiceType>>;
};

export type RegisteredCapaServicesOutput = {
  __typename?: 'RegisteredCapaServicesOutput';
  data?: Maybe<Array<RegisteredCapaService>>;
  /** errorMessage */
  errorMessage?: Maybe<Scalars['String']>;
  /** CAPA ERROR CODE */
  result: CapaErrorCode;
};

/** @deprecated @see {RegisterCapaUserInput} 캐파 회원가입 */
export type RegistrationInput = {
  /** 엠버서더 ID */
  ambassadorId?: InputMaybe<Scalars['String']>;
  /** 인증번호 */
  code: Scalars['String'];
  /** 이메일 */
  email: Scalars['String'];
  /** CAPA 서비스를 어떻게 알게 되셨나요? (복수 선택 가능) */
  inflowRoute: Array<CapaInflowRoute>;
  /** 비밀번호 */
  password: Scalars['String'];
  /** 비밀번호 확인 */
  passwordConfirm: Scalars['String'];
  /** [필수] 개인정보 수집 및 활용 동의 */
  privacyAgree: Scalars['Boolean'];
  /** [선택] 프로모션 정보 수신 동의 */
  promotionAgree?: InputMaybe<Scalars['Boolean']>;
  /** 추천인 ID */
  referralUserId?: InputMaybe<Scalars['String']>;
  /** 캐파 서비스 타입 */
  service: CapaServiceType;
  /** [필수] 캐파 서비스 이용약관 동의 */
  serviceAgree: Scalars['Boolean'];
};

export type RejectRfqPurchaseOrderInput = {
  /** 발주서 id */
  purchaseOrderId: Scalars['String'];
  /** 거부 이유 */
  rejectReason?: InputMaybe<Scalars['String']>;
  /** rfq id */
  rfqId: Scalars['String'];
};

export type RemoveConnectAnnotationCommentInput = {
  annotationId: Scalars['String'];
  commentId: Scalars['String'];
  connectSharedFileId: Scalars['String'];
  groupId: Scalars['String'];
};

export type RemoveConnectAnnotationInput = {
  annotationId: Scalars['String'];
  connectSharedFileId: Scalars['String'];
  groupId: Scalars['String'];
};

export type RemoveConnectContactUserInput = {
  contactUserEmails: Array<Scalars['String']>;
};

export type RemoveConnectFileInput = {
  /** 파일 */
  fileIds: Array<Scalars['String']>;
  /** filePath */
  filePath?: InputMaybe<Scalars['String']>;
  /** isFolder or not */
  isFolder?: InputMaybe<Scalars['Boolean']>;
};

export type RemoveConnectGroupInput = {
  archive?: InputMaybe<Scalars['Boolean']>;
  groupId: Scalars['String'];
};

export type RemoveConnectUserInput = {
  userId: Scalars['String'];
};

/** 디바이스 토큰 삭제 */
export type RemoveDeviceTokenInput = {
  /** device token */
  deviceToken?: InputMaybe<Scalars['String']>;
  /** 이메일 */
  email: Scalars['String'];
};

export type RemoveQuotationAnnotationCommentInput = {
  annotationCommentId: Scalars['String'];
};

export type RemoveQuotationAnnotationInput = {
  annotationId: Scalars['String'];
};

export type RenameConnectFileInput = {
  /** 파일 path */
  fileId?: InputMaybe<Scalars['String']>;
  /** 새 파일 이름 */
  toName: Scalars['String'];
};

export type RenameConnectGroupInput = {
  /** 그룹ID */
  groupId?: InputMaybe<Scalars['String']>;
  /** 새 그룹 이름 */
  toName?: InputMaybe<Scalars['String']>;
};

export type ReplyRfqReviewInput = {
  reply: Scalars['String'];
  rfqId: Scalars['String'];
};

export type RequestAdjustRfqPurchaseOrderInput = {
  /** 수정 요청 내용 */
  adjustRequest?: InputMaybe<Scalars['String']>;
  rfqId?: InputMaybe<Scalars['String']>;
};

export type RequestAdjustRfqQuotationInput = {
  /** 수정 요청 내용 */
  adjustRequest?: InputMaybe<Scalars['String']>;
  quotationPartnerId?: InputMaybe<Scalars['String']>;
  rfqId?: InputMaybe<Scalars['String']>;
};

/** 이메일 인증 코드 */
export type RequestCellPhoneVerificationCodeInput = {
  /** 휴대폰 번호 */
  cellphoneNumber: Scalars['String'];
};

export type RequestConfirmRfqTransactionInput = {
  rfqId?: InputMaybe<Scalars['String']>;
};

export type RequestDownloadPermissionInput = {
  connectFileId?: InputMaybe<Scalars['String']>;
  /** 그룹ID */
  groupId: Scalars['String'];
};

/** 이메일 인증 코드 */
export type RequestEmailVerificationCodeInput = {
  /** 이메일 */
  email: Scalars['String'];
  /** 캐파 서비스 타입 */
  service: CapaServiceType;
};

export type RequestFileInput = {
  /** 파일 id */
  fileId: Scalars['String'];
};

export type RequestPaymentAgentInput = {
  accountDesc?: InputMaybe<Scalars['String']>;
  dupChkYn?: InputMaybe<Scalars['String']>;
  mid?: InputMaybe<Scalars['String']>;
  settlmntAmt?: InputMaybe<Scalars['Float']>;
  settlmntDt?: InputMaybe<Scalars['String']>;
  subId?: InputMaybe<Scalars['String']>;
  /** transaction id */
  transactionId: Scalars['String'];
};

/** 캐파 추천인 코드 발행 */
export type RequestReferralInput = {
  /** 캐파 서비스 타입 */
  service: CapaServiceType;
};

export type RequestRefundInput = {
  /** 환불 금액 */
  amount?: InputMaybe<Scalars['Float']>;
  /** 환불 사유 */
  reason: Scalars['String'];
};

export type RequestRegisterTransactionReviewInput = {
  rfqId: Scalars['String'];
  userId?: InputMaybe<Scalars['String']>;
};

/** 비밀번호 재설정 */
export type RequestResetPasswordInput = {
  /** 이메일 */
  email: Scalars['String'];
  service?: InputMaybe<CapaServiceType>;
};

export type RequestRfqDrawingFileDownloadInput = {
  rfqId?: InputMaybe<Scalars['String']>;
};

export type RequestRfqQuotationPdfInput = {
  /** 견적서 id */
  quotationId: Scalars['String'];
};

export type ReviewRfqInput = {
  dueDate: Scalars['Float'];
  privateComment?: InputMaybe<Scalars['String']>;
  publicComment?: InputMaybe<Scalars['String']>;
  quality: Scalars['Float'];
  rfqId: Scalars['String'];
};

export type RfqDrawingFileInput = {
  detailedMaterial?: InputMaybe<CapaQuotationDetailedMaterialType>;
  etc?: InputMaybe<Scalars['String']>;
  fileId: Scalars['String'];
  fileName: Scalars['String'];
  material: CapaQuotationMaterial;
  quantity: Scalars['Float'];
  recommendation?: InputMaybe<Array<CapaQuotationRecommendation>>;
};

export type RfqOptionalServiceInput = {
  quantity?: InputMaybe<Scalars['Float']>;
  serviceType: CapaQuotationServiceType;
};

/** pcb 조립을 위한 파일 */
export type RfqPcbAssemblyFileInput = {
  fileId: Scalars['String'];
  fileName: Scalars['String'];
  quantity: Scalars['Float'];
};

/** pcb 제작을 위한 파일 */
export type RfqPcbFabricationFileInput = {
  fileId: Scalars['String'];
  fileName: Scalars['String'];
  quantity: Scalars['Float'];
  thickness: Scalars['Float'];
};

export type RfqQuotationOptionalServiceInput = {
  serviceType: CapaQuotationServiceType;
};

export type RfqReferenceFileInput = {
  fileId: Scalars['String'];
  fileName: Scalars['String'];
};

export type RfqTransactionReviewFileInput = {
  fileId: Scalars['String'];
  fileName: Scalars['String'];
};

export type SavePayment = {
  __typename?: 'SavePayment';
  id: Scalars['String'];
};

export type SaveRfqCapabilitiesInput = {
  /** capabilities */
  capabilities: CapaQuotationCapabilityInput;
  serviceType: CapaQuotationServiceType;
  status: CapaCapabilitiesStatusType;
};

export type SaveRfqFilterInput = {
  filter?: InputMaybe<CapaQuotationRfqFilterInput>;
};

export type SearchConnectFileInput = {
  keyword: Scalars['String'];
  limit?: InputMaybe<Scalars['Float']>;
  offset?: InputMaybe<Scalars['Float']>;
  pathId?: InputMaybe<Scalars['String']>;
};

export type SearchConnectGroupsInput = {
  groupName: Scalars['String'];
  limit?: InputMaybe<Scalars['Float']>;
  offset?: InputMaybe<Scalars['Float']>;
};

export type SearchConnectUsersInput = {
  keyword: Scalars['String'];
  limit?: InputMaybe<Scalars['Float']>;
  offset?: InputMaybe<Scalars['Float']>;
};

export type SendAnnotationCommentToChatInput = {
  commentId: Scalars['String'];
};

export type SendConnectChatMessageInput = {
  chatRoomId?: InputMaybe<Scalars['String']>;
  /** 파트너 파일 업로드 */
  fileIds?: InputMaybe<Array<Scalars['String']>>;
  message?: InputMaybe<Scalars['String']>;
};

export type SendConnectChatMessageToCapaInput = {
  chatRoomId?: InputMaybe<Scalars['String']>;
  /** 파트너 파일 업로드 */
  fileIds?: InputMaybe<Array<Scalars['String']>>;
  message?: InputMaybe<Scalars['String']>;
};

export type SendQuotationChatMessageInput = {
  chatRoomId?: InputMaybe<Scalars['String']>;
  /** 파트너 파일 업로드 정보 입력 */
  files?: InputMaybe<Array<ChatFileUploadInput>>;
  message?: InputMaybe<Scalars['String']>;
  messageType?: InputMaybe<CapaQuotationChatMessageType>;
};

export type ShareConnectFilesInput = {
  /** fileIds */
  connectFileIds: Array<Scalars['String']>;
  /** 그룹ID */
  groupId: Scalars['String'];
  permission?: InputMaybe<CapaQuotationRfqAllowOpenFileStatus>;
};

/** 배송 정보 */
export type ShippingDataModel = {
  __typename?: 'ShippingDataModel';
  /** 지급일 연장 사유 */
  extendReason?: Maybe<Scalars['String']>;
  /** 배송등록 예정 건 */
  id: Scalars['ID'];
  /** 송장번호 */
  invoiceNumber?: Maybe<Scalars['String']>;
  /** 지급승인 연장 여부 */
  isExtended: Scalars['Boolean'];
  /** 배송등록 여부 */
  isRegistered: Scalars['Boolean'];
  /** 배송등록 예정일(YYYYMMDD) 00:00 */
  registerExpectedDate: Scalars['String'];
  /** 배송업체 */
  shippingCompany?: Maybe<Scalars['String']>;
  /** 나이스페이 주문번호 */
  tid: Scalars['String'];
};

export type StibeeCapaUser = {
  __typename?: 'StibeeCAPAUser';
  clientManagerName: Scalars['String'];
  clientOrganizationName: Scalars['String'];
  connectManagerName: Scalars['String'];
  connectOrganizationName: Scalars['String'];
  email: Scalars['String'];
  partnerManagerName: Scalars['String'];
  partnerOrganizationName: Scalars['String'];
};

export type SubmallDataModel = {
  __typename?: 'SubmallDataModel';
  /** 예금주 */
  accountHolder: Scalars['String'];
  /** 계좌번호(`-`제외) */
  accountNumber: Scalars['String'];
  /** 계좌은행코드 */
  bankCode: Scalars['String'];
  /** id */
  id: Scalars['ID'];
  /** quotation partner id */
  partnerId: Scalars['String'];
  /** 서브몰 id */
  submallId: Scalars['String'];
  /** 서브몰 이름 */
  submallName: Scalars['String'];
  /** 서브몰 사업자 등록 번호, 수정불가 */
  submallRegistrationNumber: Scalars['String'];
};

export enum SubmallRequestType {
  /** 신규 서브몰 등록 */
  Create = 'CREATE',
  /** 기존 서브몰 수정 */
  Update = 'UPDATE'
}

export type SubscribeCapaNewsInput = {
  /** 구독 대상 이메일 */
  subscriberEmail: Scalars['String'];
  /** 사용자 이름 */
  userName: Scalars['String'];
};

export type SubscribeConnectChatRoomInput = {
  chatRoomId: Scalars['String'];
};

export type SubscribeConnectUserFileInput = {
  /** fileId */
  fileId: Scalars['String'];
};

export type SubscribeFileConversionStatusInput = {
  fileId: Scalars['String'];
};

export type SubscribeNotificationInput = {
  serviceType: CapaServiceType;
};

export type SubscribeQuotationChatRoomInput = {
  chatRoomId: Scalars['String'];
};

export type Subscription = {
  __typename?: 'Subscription';
  subscribeCAPANotification: CapaSubscribeNotificationsOutput;
  subscribeConnectChatMessages: CapaConnectChatMessagesOutput;
  subscribeConnectOnlineUsersData: CapaConnectOnlineUsersOutput;
  subscribeConnectUpdateData: CapaConnectUpdateOutput;
  subscribeConnectUserFileStatus: CapaConnectUserFileOutput;
  subscribeFileConversionStatus: CapaFileStatusOutput;
  subscribeFileStatusUpdate: CapaFileStatusOutput;
  subscribeQuotationChatMessage: CapaQuotationChatMessagesOutput;
  subscribeQuotationChatRoom: CapaQuotationChatRoomOutput;
  subscribeQuotationUpdateData: CapaQuotationUpdateOutput;
};


export type SubscriptionSubscribeCapaNotificationArgs = {
  input: SubscribeNotificationInput;
};


export type SubscriptionSubscribeConnectChatMessagesArgs = {
  input: SubscribeConnectChatRoomInput;
};


export type SubscriptionSubscribeConnectUserFileStatusArgs = {
  input: SubscribeConnectUserFileInput;
};


export type SubscriptionSubscribeFileConversionStatusArgs = {
  input: SubscribeFileConversionStatusInput;
};


export type SubscriptionSubscribeQuotationChatMessageArgs = {
  input: SubscribeQuotationChatRoomInput;
};


export type SubscriptionSubscribeQuotationChatRoomArgs = {
  input: SubscribeQuotationChatRoomInput;
};


export type SubscriptionSubscribeQuotationUpdateDataArgs = {
  input: SubscribeQuotationChatRoomInput;
};

/** 서비스 제안 */
export type SuggestServiceInput = {
  /** 이메일 */
  email?: InputMaybe<Scalars['String']>;
  /** 제안 */
  suggestion?: InputMaybe<Scalars['String']>;
  userType?: InputMaybe<Scalars['String']>;
};

/** 토큰 갱신 */
export type TokenRefreshInput = {
  /** refresh 토큰 */
  refreshToken: Scalars['String'];
};

export type UnshareConnectFilesInput = {
  chatRoomId?: InputMaybe<Scalars['String']>;
  /** fileIds */
  connectFileIds?: InputMaybe<Array<Scalars['String']>>;
  /** 그룹ID */
  groupId: Scalars['String'];
  groupName?: InputMaybe<Scalars['String']>;
  /** messageIds */
  messageIds?: InputMaybe<Array<Scalars['String']>>;
  removeAllMyFile?: InputMaybe<Scalars['Boolean']>;
};

/** BO 엠버서더 정보 수정 */
export type UpdateAmbassadorBoInput = {
  /** 담당자 휴대폰 번호 */
  cellphoneNumber?: InputMaybe<Scalars['String']>;
  /** 사업자 등록번호 */
  companyRegistrationNumber?: InputMaybe<Scalars['String']>;
  /** 담당자 이메일 */
  email?: InputMaybe<Scalars['String']>;
  /** 수정 대상 엠베서더 id */
  id: Scalars['String'];
  /** 담당자명 */
  managerName?: InputMaybe<Scalars['String']>;
  /** 엠베서더 회사명 */
  organizationName?: InputMaybe<Scalars['String']>;
};

export type UpdateAmbassadorSignUpPageViewCountByIpInput = {
  ambassadorId: Scalars['String'];
  userType: CapaQuotationUserType;
};

export type UpdateBoTestConnectGroupInput = {
  groupId: Scalars['String'];
  /** 테스트 그룹 True/False */
  isTest: Scalars['Boolean'];
};

export type UpdateBoTestUserInput = {
  /** 이메일 */
  email: Scalars['String'];
  /** 테스트 유저 True/False */
  isTest: Scalars['Boolean'];
};

/** BO 회원정보 수정 */
export type UpdateBackOfficeUserInput = {
  /** 부서 */
  dept?: InputMaybe<BackOfficeUserDeptType>;
  /** 수정 대상 회원 이메일 */
  email: Scalars['String'];
  /** 수정 대상 회원 id */
  id: Scalars['String'];
  /** 이름 */
  name?: InputMaybe<Scalars['String']>;
  /** 영어닉네임 */
  nickName?: InputMaybe<Scalars['String']>;
  /** 역할 */
  role?: InputMaybe<BackOfficeAdminRole>;
  /** 직무 */
  task?: InputMaybe<Scalars['String']>;
};

export type UpdateCapaQuotationPartnerStrategy = {
  __typename?: 'UpdateCAPAQuotationPartnerStrategy';
  /** 평균 응답 시간 */
  averageResponseTime?: Maybe<Scalars['String']>;
  capabilities?: Maybe<CapaQuotationPartnerCapability>;
  /** 인증 관련 정보 */
  certifications?: Maybe<Array<CapaQuotationPartnerTechnologyModel>>;
  companyIntroduction?: Maybe<Scalars['String']>;
  companyRegistrationNumber: Scalars['String'];
  contact?: Maybe<Scalars['String']>;
  /** 커버 이미지 */
  cover?: Maybe<CapaQuotationPartnerStrategyFile>;
  /** 생성일 */
  createdAt: Scalars['String'];
  department?: Maybe<Scalars['String']>;
  detailAddress?: Maybe<Scalars['String']>;
  email: Scalars['String'];
  /** 장비 */
  equipments?: Maybe<Array<CapaQuotationPartnerEquipment>>;
  /** 공장 주소 */
  factoryAddress?: Maybe<Scalars['String']>;
  factoryDetailAddress?: Maybe<Scalars['String']>;
  foundedIn?: Maybe<Scalars['String']>;
  fullAddress?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  /** ITP 대상 여부 */
  isItp: Scalars['Boolean'];
  /** 파트너 업로드 파일 ex) 사진 및 동영상 관련 */
  logo?: Maybe<CapaQuotationPartnerStrategyFile>;
  managerName: Scalars['String'];
  notificationFilter: CapaQuotationPartnerNotificationFilter;
  numberEmployees?: Maybe<Scalars['String']>;
  organizationName?: Maybe<Scalars['String']>;
  /** 파트너 업로드 파일 ex) 사진 및 동영상 관련 */
  partnerFiles?: Maybe<Array<CapaQuotationPartnerStrategyFile>>;
  partnerPageViewCount: Scalars['Float'];
  /** 특허 관련 정보 */
  patents?: Maybe<Array<CapaQuotationPartnerTechnologyModel>>;
  /** 포트폴리오 */
  portfolios?: Maybe<Array<CapaQuotationPartnerPortfolio>>;
  position?: Maybe<Scalars['String']>;
  /** [필수] 개인정보 수집 및 활용 동의 */
  privacyAgreed?: Maybe<Scalars['Boolean']>;
  /** [선택] 프로모션 정보 수신 동의 */
  promotionAgreed?: Maybe<Scalars['Boolean']>;
  /** 캐파 블로그 및 홍보 관련 */
  promotionModels?: Maybe<Array<CapaPromotionModel>>;
  /** 추천인 ID */
  referralUserId?: Maybe<Scalars['String']>;
  /** 사업자 등록증 자료 */
  registrations: Array<CapaQuotationPartnerStrategyFile>;
  rfqFilter?: Maybe<Scalars['String']>;
  /** [필수] 캐파 서비스 이용약관 동의 */
  serviceAgreed?: Maybe<Scalars['Boolean']>;
  serviceHours?: Maybe<Scalars['String']>;
  shortAddress?: Maybe<Scalars['String']>;
  status: CapaQuotationPartnerStatus;
  transactionCount: Scalars['Float'];
  /** 수정일 */
  updatedAt: Scalars['String'];
};

export type UpdateCapaQuotationPartnerStrategyOutput = {
  __typename?: 'UpdateCAPAQuotationPartnerStrategyOutput';
  data?: Maybe<UpdateCapaQuotationPartnerStrategy>;
  /** errorMessage */
  errorMessage?: Maybe<Scalars['String']>;
  /** CAPA ERROR CODE */
  result: CapaErrorCode;
};

/** 캐파 유저 통합 회원 정보수정 */
export type UpdateCapaUserInput = {
  /** CAPA 서비스를 어떻게 알게 되셨나요? (복수 선택 가능) */
  inflowRoute?: InputMaybe<Array<CapaInflowRoute>>;
  /** 새 비밀번호 */
  newPassword?: InputMaybe<Scalars['String']>;
  /** 새 비밀번호 확인 */
  newPasswordConfirm?: InputMaybe<Scalars['String']>;
  /** 비밀번호 */
  password?: InputMaybe<Scalars['String']>;
  /** [필수] 개인정보 수집 및 활용 동의 */
  privacyAgree?: InputMaybe<Scalars['Boolean']>;
  /** [선택] 프로모션 정보 수신 동의 */
  promotionAgree?: InputMaybe<Scalars['Boolean']>;
  /** 캐파 서비스 타입 */
  service: CapaServiceType;
  /** [필수] 캐파 서비스 이용약관 동의 */
  serviceAgree?: InputMaybe<Scalars['Boolean']>;
  /** 유저 상태 */
  status?: InputMaybe<CapaUserStatus>;
};

export type UpdateConnectAnnotationCommentInput = {
  annotationId: Scalars['String'];
  comment: Scalars['String'];
  commentId: Scalars['String'];
  connectSharedFileId: Scalars['String'];
  edited: Scalars['Boolean'];
  groupId: Scalars['String'];
};

export type UpdateConnectAnnotationInput = {
  anchorPos?: InputMaybe<Capa3DPosInput>;
  annotationId: Scalars['String'];
  connectSharedFileId: Scalars['String'];
  groupId: Scalars['String'];
  handlePos?: InputMaybe<Capa3DPosInput>;
  nodeId?: InputMaybe<Scalars['Float']>;
};

export type UpdateConnectUserFileLink = {
  __typename?: 'UpdateConnectUserFileLink';
  filePermission: ConnectUserFileStatus;
  linkStatus: ConnectUserFileLinkStatus;
  shareLink: Scalars['String'];
};

/** 내 정보 */
export type UpdateConnectUserFileLinkInput = {
  /** fileIds */
  connectFileIds: Array<Scalars['String']>;
  linkStatus: ConnectUserFileLinkStatus;
};

export type UpdateConnectUserFileLinkOutput = {
  __typename?: 'UpdateConnectUserFileLinkOutput';
  data?: Maybe<UpdateConnectUserFileLink>;
  /** errorMessage */
  errorMessage?: Maybe<Scalars['String']>;
  /** CAPA ERROR CODE */
  result: CapaErrorCode;
};

/** 내 정보 */
export type UpdateConnectUserFilePermissionInput = {
  /** fileIds */
  connectFileIds: Array<Scalars['String']>;
  permission: ConnectUserFileStatus;
};

/** 내 정보 */
export type UpdateConnectUserInput = {
  /** notification filter */
  notificationFilterType?: InputMaybe<ConnectNotificationType>;
  notificationFilterValue?: InputMaybe<Scalars['Boolean']>;
  /** language */
  userLanguage?: InputMaybe<Language>;
  /** 이름 (username) */
  username?: InputMaybe<Scalars['String']>;
};

export type UpdateNoticeScheduleInput = {
  /** 점검 종료 시간 */
  endTime: Scalars['String'];
  id: Scalars['String'];
  /** 긴급점검 / 임시점검 / 사전점검 등 */
  noticeType: NoticeScheduleNoticeType;
  /** client partner connect 인지 */
  pageType: NoticeScheduleNoticePageType;
  /** 사전점검 종료 시간 */
  previewEndTime?: InputMaybe<Scalars['String']>;
  /** 사전점검 시작 시간 */
  previewStartTime?: InputMaybe<Scalars['String']>;
  /** 점검 시작 시간 */
  startTime: Scalars['String'];
  /** 시작예정 / 시작중 / 종료 */
  status?: InputMaybe<NoticeScheduleNoticeStatus>;
};

export type UpdatePurchaseOrderStatusInput = {
  /** 나이스페이 모달에서 결제할때 입력하는 인증번호 (휴대폰번호 or 사업자번호) -> BuyerAuthNum */
  escrowVerifiedPW?: InputMaybe<Scalars['String']>;
  /** purchase order id */
  purchaseOrderId: Scalars['String'];
  /** 배송지 등록 */
  registerExpectedDeliveryDate?: InputMaybe<RegisterExpectedDeliveryDateInput>;
  /** 환불 사유 및 환불 금액 */
  requestRefund?: InputMaybe<RequestRefundInput>;
  /** 카파 서비스 타입 */
  service: CapaServiceType;
  /** 변경할 발주서 status (to-be) */
  statusToChange: CapaPurchaseOrderStatus;
};

export type UpdateQuotationAnnotationCommentInput = {
  annotationCommentId: Scalars['String'];
  annotationId: Scalars['String'];
  comment: Scalars['String'];
};

export type UpdateQuotationAnnotationInput = {
  anchorPos?: InputMaybe<Capa3DPosInput>;
  annotationId: Scalars['String'];
  handlePos?: InputMaybe<Capa3DPosInput>;
};

export type UpdateQuotationPartnerBoStrategyInput = {
  /** 파트너 캐파빌리티 jsonb array of { service_type, process_method, material, detailed_material, etc } */
  capabilities?: InputMaybe<CapaQuotationCapabilityInput>;
  /** 회사소개 */
  companyIntroduction?: InputMaybe<Scalars['String']>;
  /** 사업자 등록번호 */
  companyRegistrationNumber?: InputMaybe<Scalars['String']>;
  /** 연락처 */
  contact?: InputMaybe<Scalars['String']>;
  /** 부서 */
  department?: InputMaybe<Scalars['String']>;
  /** 이메일 */
  email?: InputMaybe<Scalars['String']>;
  /** 장비 */
  equipment?: InputMaybe<Scalars['String']>;
  /** 공장 주소 */
  factoryAddress?: InputMaybe<Scalars['String']>;
  /** 파트너 파일 업로드 정보 입력 */
  files?: InputMaybe<Array<QuotationPartnerFileUploadInput>>;
  /** 설립년도 */
  foundedIn?: InputMaybe<Scalars['String']>;
  /** 주소 */
  fullAddress?: InputMaybe<Scalars['String']>;
  /** CAPA 서비스를 어떻게 알게 되셨나요? (복수 선택 가능) */
  inflowRoute?: InputMaybe<Array<CapaInflowRoute>>;
  /** 담당자명 */
  managerName?: InputMaybe<Scalars['String']>;
  /** 연락처 */
  notificationFilter?: InputMaybe<CapaQuotationPartnerNotificationFilterInput>;
  /** 규모 (직원수) */
  numberEmployees?: InputMaybe<Scalars['String']>;
  /** 회사명 */
  organizationName?: InputMaybe<Scalars['String']>;
  /** 파트너 상태 */
  partnerStatus: CapaQuotationPartnerStatus;
  /** 비밀번호 */
  password?: InputMaybe<Scalars['String']>;
  /** 직위 */
  position?: InputMaybe<Scalars['String']>;
  /** [선택] 프로모션 정보 수신 동의 */
  promotionAgree?: InputMaybe<Scalars['Boolean']>;
  /** 파트너 홍보 관련 유튜브 영상 링크 목록 */
  promotionLinks?: InputMaybe<Array<CapaPromotionLinkInput>>;
  /** 대응 시간 */
  serviceHours?: InputMaybe<Scalars['String']>;
  /** 구 까지만 보여주는 주소 */
  shortAddress?: InputMaybe<Scalars['String']>;
  /** 유저 상태 */
  status: CapaUserStatus;
  /** 파트너 기술관련 파일 업로드 정보 입력 */
  strategyFiles?: InputMaybe<Array<CapaQuotationPartnerStrategyFileUploadInput>>;
  /** 웹사이트 */
  website?: InputMaybe<Scalars['String']>;
};

export type UpdateQuotationPartnerStatusInput = {
  quotationPartnerId: Scalars['String'];
  rejectReason?: InputMaybe<Scalars['String']>;
  rejectType?: InputMaybe<CapaQuotationPartnerRejectType>;
  status: CapaQuotationPartnerStatus;
};

export type UpdateQuotationPartnerStrategyInput = {
  /** 파트너 캐파빌리티 jsonb array of { service_type, process_method, material, detailed_material, etc } */
  capabilities?: InputMaybe<CapaQuotationCapabilityInput>;
  /** 인증 기술 관련 정보 목록 */
  certificationFiles?: InputMaybe<Array<CapaQuotationPartnerTechnologyInput>>;
  /** 회사소개 */
  companyIntroduction?: InputMaybe<Scalars['String']>;
  /** 사업자 등록번호 */
  companyRegistrationNumber?: InputMaybe<Scalars['String']>;
  /** 연락처 */
  contact?: InputMaybe<Scalars['String']>;
  /** 커버 이미지 */
  coverFile?: InputMaybe<CapaQuotationPartnerStrategyFileUploadInput>;
  /** 부서 */
  department?: InputMaybe<Scalars['String']>;
  /** detail address */
  detailAddress?: InputMaybe<Scalars['String']>;
  /** 장비 */
  equipments?: InputMaybe<Array<RegisterQuotationPartnerEquipmentInput>>;
  /** 공장 위치 */
  factoryAddress?: InputMaybe<Scalars['String']>;
  /** factory detail address */
  factoryDetailAddress?: InputMaybe<Scalars['String']>;
  /** 설립년도 */
  foundedIn?: InputMaybe<Scalars['String']>;
  /** 주소 */
  fullAddress?: InputMaybe<Scalars['String']>;
  /** 파트너 로고 파일 */
  logo?: InputMaybe<CapaQuotationPartnerStrategyRegistrationFileUploadInput>;
  /** 담당자명 */
  managerName?: InputMaybe<Scalars['String']>;
  /** notificationFilter */
  notificationFilter?: InputMaybe<CapaQuotationPartnerNotificationFilterInput>;
  /** 규모 (직원수) */
  numberEmployees?: InputMaybe<Scalars['String']>;
  /** 회사명 */
  organizationName?: InputMaybe<Scalars['String']>;
  /** 사진 및 동영상 */
  partnerFiles?: InputMaybe<Array<CapaQuotationPartnerStrategyFileUploadInput>>;
  /** 특허 기술 관련 정보 목록 */
  patentFiles?: InputMaybe<Array<CapaQuotationPartnerTechnologyInput>>;
  /** 포트폴리오 */
  portfolios?: InputMaybe<Array<RegisterQuotationPartnerPortfolioInput>>;
  /** 직위 */
  position?: InputMaybe<Scalars['String']>;
  /** [필수] 개인정보 수집 및 활용 동의 */
  privacyAgree?: InputMaybe<Scalars['Boolean']>;
  /** [선택] 프로모션 정보 수신 동의 */
  promotionAgree?: InputMaybe<Scalars['Boolean']>;
  /** 사업자 등록증 */
  registrations?: InputMaybe<Array<CapaQuotationPartnerStrategyFileUploadInput>>;
  /** rfqFilter */
  rfqFilter?: InputMaybe<CapaQuotationCapabilityInput>;
  /** [필수] 캐파 서비스 이용약관 동의 */
  serviceAgree?: InputMaybe<Scalars['Boolean']>;
  /** 대응 시간 */
  serviceHours?: InputMaybe<Scalars['String']>;
  /** 구 까지만 보여주는 주소 */
  shortAddress?: InputMaybe<Scalars['String']>;
};

/** 내 정보 */
export type UpdateQuotationUserBoInput = {
  /** 사업자 여부 */
  bizType?: InputMaybe<CapaQuotationUserBizType>;
  /** 휴대폰 번호 */
  cellphoneNumber?: InputMaybe<Scalars['String']>;
  /** 회사소개 */
  companyIntroduction?: InputMaybe<Scalars['String']>;
  /** 사업자등록번호 */
  companyRegistrationNumber?: InputMaybe<Scalars['String']>;
  /** 부서 */
  department?: InputMaybe<Scalars['String']>;
  /** 이메일 */
  email?: InputMaybe<Scalars['String']>;
  /** 프로필 사진 설정 */
  files?: InputMaybe<Array<QuotationUserFileUploadInput>>;
  /** 주소 */
  fullAddress?: InputMaybe<Scalars['String']>;
  /** CAPA 서비스를 어떻게 알게 되셨나요? (복수 선택 가능) */
  inflowRoute?: InputMaybe<Array<CapaInflowRoute>>;
  /** 이름 (담당자명) */
  managerName?: InputMaybe<Scalars['String']>;
  /** 회사 / 단체명 */
  organizationName?: InputMaybe<Scalars['String']>;
  /** 비밀번호 */
  password?: InputMaybe<Scalars['String']>;
  /** 직함 */
  position?: InputMaybe<Scalars['String']>;
  /** [선택] 프로모션 정보 수신 동의 */
  promotionAgree?: InputMaybe<Scalars['Boolean']>;
  /** 짧은 주소 */
  shortAddress?: InputMaybe<Scalars['String']>;
  /** 유저 상태 */
  status: CapaUserStatus;
  /** 유저 상태 */
  userStatus: CapaQuotationUserStatus;
  /** 웹사이트 */
  website?: InputMaybe<Scalars['String']>;
};

/** 내 정보 */
export type UpdateQuotationUserInput = {
  /** 사업자 여부 */
  bizType?: InputMaybe<CapaQuotationUserBizType>;
  /** 휴대폰 번호 */
  cellphoneNumber?: InputMaybe<Scalars['String']>;
  /** 회사소개 */
  companyIntroduction?: InputMaybe<Scalars['String']>;
  /** 사업자등록번호 */
  companyRegistrationNumber?: InputMaybe<Scalars['String']>;
  /** 부서 */
  department?: InputMaybe<Scalars['String']>;
  /** 캐파 소식 및 혜택 수신동의 */
  emailreceive?: InputMaybe<Scalars['Boolean']>;
  /** 프로필 사진 설정 */
  files?: InputMaybe<Array<QuotationUserFileUploadInput>>;
  /** 주소 */
  fullAddress?: InputMaybe<Scalars['String']>;
  /** 이름 (담당자명) */
  managerName?: InputMaybe<Scalars['String']>;
  /** 고객 알림 설정 */
  notificationFilter?: InputMaybe<CapaQuotationUserNotificationFilterInput>;
  /** 회사 / 단체명 */
  organizationName?: InputMaybe<Scalars['String']>;
  /** 직함 */
  position?: InputMaybe<Scalars['String']>;
  /** [필수] 개인정보 수집 및 활용 동의 */
  privacyAgree?: InputMaybe<Scalars['Boolean']>;
  /** [선택] 프로모션 정보 수신 동의 */
  promotionAgree?: InputMaybe<Scalars['Boolean']>;
  /** [필수] 캐파 서비스 이용약관 동의 */
  serviceAgree?: InputMaybe<Scalars['Boolean']>;
  /** 짧은 주소 */
  shortAddress?: InputMaybe<Scalars['String']>;
  /** 웹사이트 */
  website?: InputMaybe<Scalars['String']>;
};

export type UpdateReceiveComplaintQuotationChatMessageInput = {
  /** 바이패스 의심되는 chat message id */
  chatMessageId?: InputMaybe<Scalars['String']>;
  /** 유저 불편 사항 */
  complaint?: InputMaybe<Scalars['String']>;
  /** 유저 불편 사항 타입 */
  complaintType?: InputMaybe<CapaBypassComplaintType>;
};

export type UpdateRfqReviewInput = {
  /** 납기일 준수 여부 */
  inDueDate?: InputMaybe<Scalars['Boolean']>;
  reviewFiles?: InputMaybe<Array<RfqTransactionReviewFileInput>>;
  /** review id */
  reviewId: Scalars['String'];
  /** 리뷰 타입 */
  rfqReviewType?: InputMaybe<CapaRfqReviewType>;
  /** transaction satisfaction comment */
  transactionSatisfactionComment?: InputMaybe<Scalars['String']>;
  /** transaction satisfaction comment */
  transactionSatisfactionPoint?: InputMaybe<Scalars['Float']>;
};

export type UpdateRfqStatusInput = {
  rfqId: Scalars['String'];
  rfqStatus: CapaRfqStatus;
};

/** 유저 활동 로그 */
export type UserActivityLogInput = {
  /** 활동 id */
  activitiId?: InputMaybe<Scalars['String']>;
  /** 활동 타입 */
  activityType?: InputMaybe<CapaActivityType>;
  /** 브라우저 종류 */
  browser?: InputMaybe<Scalars['String']>;
  /** 기기 종류 */
  deviceType?: InputMaybe<Scalars['String']>;
  /** 이메일 */
  email?: InputMaybe<Scalars['String']>;
  /** 아이피 */
  ip?: InputMaybe<Scalars['String']>;
  /** 운영체제 */
  os?: InputMaybe<Scalars['String']>;
  /** 캐파 서비스 타입 */
  service?: InputMaybe<CapaServiceType>;
};

export type VentureBizFetchIcxInput = {
  keyword?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Float']>;
  offset?: InputMaybe<Scalars['Float']>;
  ventureBizSearchType?: InputMaybe<VentureBizSearchType>;
};

/** VentureBizSearchType */
export enum VentureBizSearchType {
  /** 기업명 */
  CompanyName = 'COMPANY_NAME',
  /** 전화번호 */
  Contact = 'CONTACT',
  /** 업종 1 */
  IndustryName = 'INDUSTRY_NAME',
  /** 지역 */
  Region = 'REGION',
  /** 관련업종 */
  RelatedIndustry = 'RELATED_INDUSTRY'
}

/** 이메일 인증 */
export type VerifyCellPhoneVerificationCodeInput = {
  /** 휴대폰 번호 */
  cellphoneNumber: Scalars['String'];
  /** 인증번호 */
  code: Scalars['String'];
};

/** 사업자 등록 번호 확인 */
export type VerifyCompanyRegistrationNumberInput = {
  /** 사업자 등록 번호 */
  companyRegistrationNumber: Scalars['String'];
};

/** 이메일 인증 */
export type VerifyEmailVerificationCodeInput = {
  /** 인증번호 */
  code: Scalars['String'];
  /** 이메일 */
  email: Scalars['String'];
};

export type VirtualAccountInfo = {
  __typename?: 'VirtualAccountInfo';
  accountNumber: Scalars['String'];
  bankCode: CapaBankCode;
  bankHolder?: Maybe<Scalars['String']>;
  bankName: Scalars['String'];
  dueDate: Scalars['Float'];
  issuedAt: Scalars['Float'];
};

/** BO 회원 탈퇴 */
export type WithdrawBackOfficeUserInput = {
  /** 탈퇴 대상 회원 이메일 */
  email: Scalars['String'];
  /** 탈퇴 대상 회원 id */
  id: Scalars['String'];
};

/** 고객 탈퇴 사유 */
export type WithdrawClientReasonInput = {
  /** 탈퇴 상세 사유 */
  detailedReason?: InputMaybe<Scalars['String']>;
  /** 기타 탈퇴 사유 */
  etcReason?: InputMaybe<Scalars['String']>;
  /** 고객탈퇴사유 */
  reason: CapaWithdrawClientReasonType;
  /** serviceType */
  serviceType: CapaServiceType;
};

/** 파트너 탈퇴 사유 */
export type WithdrawPartnerReasonInput = {
  /** 탈퇴 상세 사유 */
  detailedReason?: InputMaybe<Scalars['String']>;
  /** 기타 탈퇴 사유 */
  etcReason?: InputMaybe<Scalars['String']>;
  /** 파트너 탈퇴 사유 */
  reason: CapaWithdrawPartnerReasonType;
  /** serviceType */
  serviceType: CapaServiceType;
};

export type WithdrawQuotationPartnerBoInput = {
  /** 이메일 */
  email: Scalars['String'];
  /** 탈퇴 사유 */
  withdrawReason: WithdrawPartnerReasonInput;
};

/** 파트너 회원 탈퇴 */
export type WithdrawQuotationPartnerInput = {
  /** 탈퇴하고자 하는 파트너의 이메일 */
  email: Scalars['String'];
  /** 탈퇴 사유 */
  withdrawReason: WithdrawPartnerReasonInput;
};

/** 강제 탈퇴 */
export type WithdrawQuotationUserBoInput = {
  /** 이메일 */
  email: Scalars['String'];
  /** 탈퇴 사유 */
  withdrawReason: WithdrawClientReasonInput;
};

/** 고객 회원 탈퇴 */
export type WithdrawQuotationUserInput = {
  /** 탈퇴하고자 하는 고객의 이메일 */
  email: Scalars['String'];
  /** 탈퇴 사유 */
  withdrawReason: WithdrawClientReasonInput;
};

export type FetchCapacxManagementRequiredUsersBo = {
  __typename?: 'fetchCAPACXManagementRequiredUsersBO';
  /** 고객유형 */
  bizType?: Maybe<CapaQuotationUserBizType>;
  /** 휴대전화 */
  cellphoneNumber?: Maybe<Scalars['String']>;
  /** 코멘트수 */
  commentCount?: Maybe<Scalars['Float']>;
  /** 견적요청일 */
  createdAt?: Maybe<Scalars['String']>;
  /** 이메일 */
  email?: Maybe<Scalars['String']>;
  /** 고객명 */
  managerName?: Maybe<Scalars['String']>;
  /** 회사명 */
  organizationName?: Maybe<Scalars['String']>;
  /** 프로젝트명 */
  projectName?: Maybe<Scalars['String']>;
  quotationUserId: Scalars['String'];
  /** rfq id */
  rfqId?: Maybe<Scalars['String']>;
  /** 서비스타입 */
  serviceType?: Maybe<CapaQuotationServiceType>;
  /** RFQ 상태 */
  status?: Maybe<CapaRfqStatus>;
  /** 총 수량 */
  totalQuantity?: Maybe<Scalars['Float']>;
  /** 조회수 */
  viewCount?: Maybe<Scalars['Float']>;
  /** 조회파트너수 */
  viewPartnerCount?: Maybe<Scalars['Float']>;
};

export type FetchQuotationPartnerProjectParticipationStatusBoInput = {
  limit?: InputMaybe<Scalars['Float']>;
  offset?: InputMaybe<Scalars['Float']>;
  quotationPartnerId?: InputMaybe<Scalars['String']>;
};

/** readRfqAdjustRequestInput */
export type ReadRfqAdjustRequestInput = {
  email?: InputMaybe<Scalars['String']>;
  /** 업데이트할 adjustRequest Id */
  id: Scalars['String'];
  type: CapaRfqAdjustRequestType;
};

export type SendQuotationPartnerIntroductionInput = {
  partnerId?: InputMaybe<Scalars['String']>;
  rfqId: Scalars['String'];
};

export type FetchAllIcxInfoQueryVariables = Exact<{
  input: FetchAllIcxInput;
}>;


export type FetchAllIcxInfoQuery = { __typename?: 'Query', fetchAllIcxInfo: { __typename?: 'IcxModelsOutput', result: CapaErrorCode, errorMessage?: string | null, data?: { __typename?: 'IcxModel', icxDetatilModelCount?: number | null, icxDetatilModelList?: Array<{ __typename?: 'IcxDetatilModel', id?: string | null, basicCompanyName?: string | null, basicCity?: string | null, basicComplexName?: string | null, basicIndustryCategory?: string | null, basicIndustrial?: string | null, employees2020FullTimeTotal?: string | null, fullinvestigationCompanyScale?: string | null, keyresultsProduce_2020?: string | null, keyresultsProduce_2019?: string | null, keyresultsExport_2020?: string | null, keyresultsExport_2019?: string | null, keyresultsEmploy_2020?: string | null, keyresultsEmploy_2019?: string | null, activitiesProductName_1?: string | null, activitiesProductType_1?: string | null, activitiesIndustryClassification_1?: string | null, activitiesSectors_1?: string | null, activitiesProductName_2?: string | null, activitiesProductType_2?: string | null, activitiesIndustryClassification_2?: string | null, activitiesSectors_2?: string | null, activitiesProductName_3?: string | null, activitiesProductType_3?: string | null, activitiesIndustryClassification_3?: string | null, activitiesSectors_3?: string | null, activityCharacteristics_1?: string | null, activityCharacteristics_2?: string | null, activityCharacteristics_3?: string | null, activityCharacteristics_4?: string | null, activityCharacteristics_5?: string | null, activityCharacteristics_6?: string | null, purchasesLargeBusiness?: string | null, purchasesSmallBusiness?: string | null, purchasesGovernment?: string | null, purchasesUniversity?: string | null, purchasesHeadquarters?: string | null, purchasesOversearImport?: string | null, purchasesIndividualUnspecifiedMajority?: string | null, purchasesBeforePurchase?: string | null, purchasesOthers?: string | null, purchasesSeoul?: string | null, purchasesBusan?: string | null, purchasesTegu?: string | null, purchasesIncheon?: string | null, purchasesGwangju?: string | null, purchasesDaejon?: string | null, purchasesUlsan?: string | null, purchasesSejong?: string | null, purchasesKyonggi?: string | null, purchasesKangwon?: string | null, purchasesChungbuk?: string | null, purchasesChungnam?: string | null, purchasesJeonbuk?: string | null, purchasesChonnam?: string | null, purchasesKyongbok?: string | null, purchasesKyongnam?: string | null, purchasesJeju?: string | null, purchasesIndustrialComplex1?: string | null, purchasesIndustrialComplex2?: string | null, purchasesIndustrialComplex3?: string | null, purchasesOthers2?: string | null, vendorLargeBusiness?: string | null, vendorSmallBusiness?: string | null, vendorGovernment?: string | null, vendorUniversity?: string | null, vendorHeadquarters?: string | null, vendorOversearDirectExport?: string | null, vendorInvidualUnspecifiedMajority?: string | null, vendorOthers?: string | null, vendorSeoul?: string | null, vendorBusan?: string | null, vendorTegu?: string | null, vendorIncheon?: string | null, vendorGwangju?: string | null, vendorDaejon?: string | null, vendorUlsan?: string | null, vendorSejong?: string | null, vendorKyonggi?: string | null, vendorKangwon?: string | null, vendorChungbuk?: string | null, vendorChungnam?: string | null, vendorJeonbuk?: string | null, vendorChonnam?: string | null, vendorKyongbok?: string | null, vendorKyongnam?: string | null, vendorJeju?: string | null, vendorIndustrialComplex1?: string | null, vendorIndustrialComplex2?: string | null, vendorIndustrialComplex3?: string | null, vendorOthers2?: string | null, rndWhether?: string | null, rndInvestment_2020?: string | null, rndPatentApplication_2020?: string | null, rndPatentRegistration_2020?: string | null, rndInvestment_2019?: string | null, rndPatentApplication_2019?: string | null, rndPatentRegistration_2019?: string | null, productionPerformance_2020Cost?: string | null, productionPerformance_2019Cost?: string | null, exportPerformance2020ExportCost?: string | null, exportPerformance2019ExportCost?: string | null, exportCountryUsa?: string | null, exportCountryChina?: string | null, exportCountryJapan?: string | null, exportCountrySoutheastAsia?: string | null, exportCountryEurope?: string | null, exportCountryMiddleEast?: string | null, exportCountryLatinAmerica?: string | null, exportCountryOthers?: string | null, employees2019FullTimeTotal?: string | null, thirdPartyEmployees2020DispatchedTotal?: string | null, thirdPartyEmployees2019DispatchedTotal?: string | null, fullinvestigationName_1?: string | null, fullinvestigationCall?: string | null, fullinvestigationFax?: string | null, fullinvestigationEmail?: string | null, fullinvestigationRegistrationNumber?: string | null, fullinvestigationDivision?: string | null, fullinvestigationCorporationNumber?: string | null, fullinvestigationAddress?: string | null, fullinvestigationStreetAddress?: string | null, fullinvestigationYear?: string | null }> | null } | null } };

export type BasicInfoFragment = { __typename?: 'IcxDetatilModel', basicCompanyName?: string | null, basicCity?: string | null, basicComplexName?: string | null, basicIndustryCategory?: string | null, basicIndustrial?: string | null, employees2020FullTimeTotal?: string | null, fullinvestigationCompanyScale?: string | null };

export type KeyresultsFragment = { __typename?: 'IcxDetatilModel', keyresultsProduce_2020?: string | null, keyresultsProduce_2019?: string | null, keyresultsExport_2020?: string | null, keyresultsExport_2019?: string | null, keyresultsEmploy_2020?: string | null, keyresultsEmploy_2019?: string | null };

export type ActivitiesProductFragment = { __typename?: 'IcxDetatilModel', activitiesProductName_1?: string | null, activitiesProductType_1?: string | null, activitiesIndustryClassification_1?: string | null, activitiesSectors_1?: string | null, activitiesProductName_2?: string | null, activitiesProductType_2?: string | null, activitiesIndustryClassification_2?: string | null, activitiesSectors_2?: string | null, activitiesProductName_3?: string | null, activitiesProductType_3?: string | null, activitiesIndustryClassification_3?: string | null, activitiesSectors_3?: string | null };

export type ActivityCharacteristicsFragment = { __typename?: 'IcxDetatilModel', activityCharacteristics_1?: string | null, activityCharacteristics_2?: string | null, activityCharacteristics_3?: string | null, activityCharacteristics_4?: string | null, activityCharacteristics_5?: string | null, activityCharacteristics_6?: string | null };

export type PurchasesByPlaceFragment = { __typename?: 'IcxDetatilModel', purchasesLargeBusiness?: string | null, purchasesSmallBusiness?: string | null, purchasesGovernment?: string | null, purchasesUniversity?: string | null, purchasesHeadquarters?: string | null, purchasesOversearImport?: string | null, purchasesIndividualUnspecifiedMajority?: string | null, purchasesBeforePurchase?: string | null, purchasesOthers?: string | null };

export type PurchasesByCityFragment = { __typename?: 'IcxDetatilModel', purchasesSeoul?: string | null, purchasesBusan?: string | null, purchasesTegu?: string | null, purchasesIncheon?: string | null, purchasesGwangju?: string | null, purchasesDaejon?: string | null, purchasesUlsan?: string | null, purchasesSejong?: string | null, purchasesKyonggi?: string | null, purchasesKangwon?: string | null, purchasesChungbuk?: string | null, purchasesChungnam?: string | null, purchasesJeonbuk?: string | null, purchasesChonnam?: string | null, purchasesKyongbok?: string | null, purchasesKyongnam?: string | null, purchasesJeju?: string | null };

export type PurchasesByIndustrialFragment = { __typename?: 'IcxDetatilModel', purchasesIndustrialComplex1?: string | null, purchasesIndustrialComplex2?: string | null, purchasesIndustrialComplex3?: string | null, purchasesOthers2?: string | null };

export type VendorByPlaceFragment = { __typename?: 'IcxDetatilModel', vendorLargeBusiness?: string | null, vendorSmallBusiness?: string | null, vendorGovernment?: string | null, vendorUniversity?: string | null, vendorHeadquarters?: string | null, vendorOversearDirectExport?: string | null, vendorInvidualUnspecifiedMajority?: string | null, vendorOthers?: string | null };

export type VendorByCityFragment = { __typename?: 'IcxDetatilModel', vendorSeoul?: string | null, vendorBusan?: string | null, vendorTegu?: string | null, vendorIncheon?: string | null, vendorGwangju?: string | null, vendorDaejon?: string | null, vendorUlsan?: string | null, vendorSejong?: string | null, vendorKyonggi?: string | null, vendorKangwon?: string | null, vendorChungbuk?: string | null, vendorChungnam?: string | null, vendorJeonbuk?: string | null, vendorChonnam?: string | null, vendorKyongbok?: string | null, vendorKyongnam?: string | null, vendorJeju?: string | null };

export type VendorByIndustrialFragment = { __typename?: 'IcxDetatilModel', vendorIndustrialComplex1?: string | null, vendorIndustrialComplex2?: string | null, vendorIndustrialComplex3?: string | null, vendorOthers2?: string | null };

export type RndFragment = { __typename?: 'IcxDetatilModel', rndWhether?: string | null, rndInvestment_2020?: string | null, rndPatentApplication_2020?: string | null, rndPatentRegistration_2020?: string | null, rndInvestment_2019?: string | null, rndPatentApplication_2019?: string | null, rndPatentRegistration_2019?: string | null };

export type ProductionPerformanceFragment = { __typename?: 'IcxDetatilModel', productionPerformance_2020Cost?: string | null, productionPerformance_2019Cost?: string | null };

export type ExportPerformanceFragment = { __typename?: 'IcxDetatilModel', exportPerformance2020ExportCost?: string | null, exportPerformance2019ExportCost?: string | null, exportCountryUsa?: string | null, exportCountryChina?: string | null, exportCountryJapan?: string | null, exportCountrySoutheastAsia?: string | null, exportCountryEurope?: string | null, exportCountryMiddleEast?: string | null, exportCountryLatinAmerica?: string | null, exportCountryOthers?: string | null };

export type EmployeesFragment = { __typename?: 'IcxDetatilModel', employees2020FullTimeTotal?: string | null, employees2019FullTimeTotal?: string | null, thirdPartyEmployees2020DispatchedTotal?: string | null, thirdPartyEmployees2019DispatchedTotal?: string | null };

export type FullinvestigationFragment = { __typename?: 'IcxDetatilModel', fullinvestigationName_1?: string | null, fullinvestigationCall?: string | null, fullinvestigationFax?: string | null, fullinvestigationEmail?: string | null, fullinvestigationRegistrationNumber?: string | null, fullinvestigationDivision?: string | null, fullinvestigationCorporationNumber?: string | null, fullinvestigationAddress?: string | null, fullinvestigationStreetAddress?: string | null, fullinvestigationYear?: string | null };

export type IcxAuthenticateQueryVariables = Exact<{
  input: IcxAuthenticationInput;
}>;


export type IcxAuthenticateQuery = { __typename?: 'Query', icxAuthenticate: { __typename?: 'IcxAuthenticationOutput', result: CapaErrorCode, errorMessage?: string | null, data?: { __typename?: 'IcxAuthentication', accessToken: string, tokenType: string, expiresIn: number, refreshToken: string, redirectUrl?: string | null } | null } };

export type IcxRefreshAccessTokenMutationVariables = Exact<{
  input: IcxTokenRefreshInput;
}>;


export type IcxRefreshAccessTokenMutation = { __typename?: 'Mutation', icxRefreshAccessToken: { __typename?: 'IcxAuthenticationOutput', result: CapaErrorCode, errorMessage?: string | null, data?: { __typename?: 'IcxAuthentication', accessToken: string, tokenType: string, expiresIn: number, refreshToken: string, redirectUrl?: string | null } | null } };

export type AuthenticationInfoFragment = { __typename?: 'IcxAuthentication', accessToken: string, tokenType: string, expiresIn: number, refreshToken: string, redirectUrl?: string | null };

export type FetchFactoronQueryVariables = Exact<{
  input: FactoronBizFetchIcxInput;
}>;


export type FetchFactoronQuery = { __typename?: 'Query', fetchFactoron: { __typename?: 'IcxFactoronModelOutput', result: CapaErrorCode, errorMessage?: string | null, data?: { __typename?: 'IcxFactoron', count?: number | null, icxModelList?: Array<{ __typename?: 'IcxFactoronModel', id: string, industrialComplex?: string | null, companyName?: string | null, representativeName?: string | null, birthOrRegistrationNumber?: string | null, industrialCenterName?: string | null, factoryControlNumber?: string | null, factoryAddressRoadName?: string | null, factoryAddressNo?: string | null, companyRegistrationNumber?: string | null, representativeIndustryCode?: string | null, representativeIndustryNumber?: string | null, sectors?: string | null, industryName?: string | null, jurisdictionOrganizationName?: string | null, jurisdictionOrganizationCode?: string | null, region?: string | null, city?: string | null, establishment?: string | null, moveInType?: string | null, classificationOfHoldings?: string | null, applicationDate?: string | null, firstApprovalDate?: string | null, approvalClassification?: string | null, approvalDate?: string | null, firstRegistrationDate?: string | null, registrationCategory?: string | null, registrationDate?: string | null, registrationNumber?: string | null, changeReportDate?: string | null, businessType?: string | null, contact?: string | null, faxNumber?: string | null, maleEmployeeCount?: string | null, femaleEmployeeCount?: string | null, maleForeigner?: string | null, femaleForeigner?: string | null, employeesCount?: string | null, product?: string | null, mainMaterial?: string | null, businessStartDate?: string | null, factoryCompletionDate?: string | null, estimatedConstructionStartDate?: string | null, estimatedConstructionCompletionDate?: string | null, factorySize?: string | null, useArea?: string | null, landCategory?: string | null, landArea?: string | null, manufacturingFacilityArea?: string | null, ancillaryFacilityArea?: string | null, officeArea?: string | null, warehouseArea?: string | null, horizontalProjectionArea?: string | null, buildingArea?: string | null, airQuality?: string | null, waterQuality?: string | null, isNoiseVibration?: string | null, livingWater?: string | null, industrialWater?: string | null, power?: string | null, oil?: string | null, gas?: string | null, etcOil?: string | null, equityMillion?: string | null, debtCapitalMillion?: string | null, foreignInvestmentRatio?: string | null, foreignInvestment?: string | null, cancellationDate?: string | null, cancellationReason?: string | null, representativeEmail?: string | null, representativePhoneNumber?: string | null, factoryWebsite?: string | null, factoryZipCode?: string | null, representativeZipCode?: string | null, representativeAddress?: string | null, reasonChange?: string | null, factoryManagementNumberOld?: string | null, expirationPeriod?: string | null, factoryCondition?: string | null, freeEconomicZone?: string | null }> | null } | null } };

export type FetchInnoBizQueryVariables = Exact<{
  input: InnoBizFetchIcxInput;
}>;


export type FetchInnoBizQuery = { __typename?: 'Query', fetchInnoBiz: { __typename?: 'IcxInnoBizModelOutput', result: CapaErrorCode, errorMessage?: string | null, data?: { __typename?: 'IcxInnoBiz', count?: number | null, icxModelList?: Array<{ __typename?: 'IcxInnoBizModel', id: string, companyName?: string | null, address?: string | null, representativeName?: string | null, representativeEmai?: string | null, representativeContact?: string | null, employeesCount?: string | null, relatedIndustry?: string | null, industryCode?: string | null, product?: string | null, companyContact?: string | null }> | null } | null } };

export type FetchMainBizQueryVariables = Exact<{
  input: MainBizFetchIcxInput;
}>;


export type FetchMainBizQuery = { __typename?: 'Query', fetchMainBiz: { __typename?: 'IcxMainBizModelOutput', result: CapaErrorCode, errorMessage?: string | null, data?: { __typename?: 'IcxMainBiz', count?: number | null, icxModelList?: Array<{ __typename?: 'IcxMainBizModel', id: string, companyName?: string | null, representativeName?: string | null, industryCode?: string | null, industryName?: string | null, region?: string | null, location?: string | null, certificationExpirationDate?: string | null }> | null } | null } };

export type FetchMiniClusterQueryVariables = Exact<{
  input: IcxMiniClusterFetchIcxInput;
}>;


export type FetchMiniClusterQuery = { __typename?: 'Query', fetchMiniCluster: { __typename?: 'IcxMiniClusterModelOutput', result: CapaErrorCode, errorMessage?: string | null, data?: { __typename?: 'IcxMiniCluster', count?: number | null, icxModelList?: Array<{ __typename?: 'IcxMiniClusterModel', id?: string | null, region?: string | null, base?: string | null, miniClusterName?: string | null, enterpriseType?: string | null, companyName?: string | null, businessRegistrationNumber?: string | null, industryUniversityInstituteCollaboration?: string | null, companyRegistrationDate?: string | null, memberName?: string | null, mailAddress?: string | null, registrationDate?: string | null, contact?: string | null }> | null } | null } };

export type FetchVentureBizQueryVariables = Exact<{
  input: VentureBizFetchIcxInput;
}>;


export type FetchVentureBizQuery = { __typename?: 'Query', fetchVentureBiz: { __typename?: 'IcxVentureBizModelOutput', result: CapaErrorCode, errorMessage?: string | null, data?: { __typename?: 'IcxVentureBiz', count?: number | null, icxModelList?: Array<{ __typename?: 'IcxVentureBizModel', id: string, companyName?: string | null, contact?: string | null, relatedIndustry?: string | null, industryName?: string | null, region?: string | null }> | null } | null } };

export const BasicInfoFragmentDoc = gql`
    fragment BasicInfo on IcxDetatilModel {
  basicCompanyName
  basicCity
  basicComplexName
  basicIndustryCategory
  basicIndustrial
  employees2020FullTimeTotal
  fullinvestigationCompanyScale
}
    `;
export const KeyresultsFragmentDoc = gql`
    fragment Keyresults on IcxDetatilModel {
  keyresultsProduce_2020
  keyresultsProduce_2019
  keyresultsExport_2020
  keyresultsExport_2019
  keyresultsEmploy_2020
  keyresultsEmploy_2019
}
    `;
export const ActivitiesProductFragmentDoc = gql`
    fragment ActivitiesProduct on IcxDetatilModel {
  activitiesProductName_1
  activitiesProductType_1
  activitiesIndustryClassification_1
  activitiesSectors_1
  activitiesProductName_2
  activitiesProductType_2
  activitiesIndustryClassification_2
  activitiesSectors_2
  activitiesProductName_3
  activitiesProductType_3
  activitiesIndustryClassification_3
  activitiesSectors_3
}
    `;
export const ActivityCharacteristicsFragmentDoc = gql`
    fragment ActivityCharacteristics on IcxDetatilModel {
  activityCharacteristics_1
  activityCharacteristics_2
  activityCharacteristics_3
  activityCharacteristics_4
  activityCharacteristics_5
  activityCharacteristics_6
}
    `;
export const PurchasesByPlaceFragmentDoc = gql`
    fragment PurchasesByPlace on IcxDetatilModel {
  purchasesLargeBusiness
  purchasesSmallBusiness
  purchasesGovernment
  purchasesUniversity
  purchasesHeadquarters
  purchasesOversearImport
  purchasesIndividualUnspecifiedMajority
  purchasesBeforePurchase
  purchasesOthers
}
    `;
export const PurchasesByCityFragmentDoc = gql`
    fragment PurchasesByCity on IcxDetatilModel {
  purchasesSeoul
  purchasesBusan
  purchasesTegu
  purchasesIncheon
  purchasesGwangju
  purchasesDaejon
  purchasesUlsan
  purchasesSejong
  purchasesKyonggi
  purchasesKangwon
  purchasesChungbuk
  purchasesChungnam
  purchasesJeonbuk
  purchasesChonnam
  purchasesKyongbok
  purchasesKyongnam
  purchasesJeju
}
    `;
export const PurchasesByIndustrialFragmentDoc = gql`
    fragment PurchasesByIndustrial on IcxDetatilModel {
  purchasesIndustrialComplex1
  purchasesIndustrialComplex2
  purchasesIndustrialComplex3
  purchasesOthers2
}
    `;
export const VendorByPlaceFragmentDoc = gql`
    fragment VendorByPlace on IcxDetatilModel {
  vendorLargeBusiness
  vendorSmallBusiness
  vendorGovernment
  vendorUniversity
  vendorHeadquarters
  vendorOversearDirectExport
  vendorInvidualUnspecifiedMajority
  vendorOthers
}
    `;
export const VendorByCityFragmentDoc = gql`
    fragment VendorByCity on IcxDetatilModel {
  vendorSeoul
  vendorBusan
  vendorTegu
  vendorIncheon
  vendorGwangju
  vendorDaejon
  vendorUlsan
  vendorSejong
  vendorKyonggi
  vendorKangwon
  vendorChungbuk
  vendorChungnam
  vendorJeonbuk
  vendorChonnam
  vendorKyongbok
  vendorKyongnam
  vendorJeju
}
    `;
export const VendorByIndustrialFragmentDoc = gql`
    fragment VendorByIndustrial on IcxDetatilModel {
  vendorIndustrialComplex1
  vendorIndustrialComplex2
  vendorIndustrialComplex3
  vendorOthers2
}
    `;
export const RndFragmentDoc = gql`
    fragment Rnd on IcxDetatilModel {
  rndWhether
  rndInvestment_2020
  rndPatentApplication_2020
  rndPatentRegistration_2020
  rndInvestment_2019
  rndPatentApplication_2019
  rndPatentRegistration_2019
}
    `;
export const ProductionPerformanceFragmentDoc = gql`
    fragment ProductionPerformance on IcxDetatilModel {
  productionPerformance_2020Cost
  productionPerformance_2019Cost
}
    `;
export const ExportPerformanceFragmentDoc = gql`
    fragment ExportPerformance on IcxDetatilModel {
  exportPerformance2020ExportCost
  exportPerformance2019ExportCost
  exportCountryUsa
  exportCountryChina
  exportCountryJapan
  exportCountrySoutheastAsia
  exportCountryEurope
  exportCountryMiddleEast
  exportCountryLatinAmerica
  exportCountryOthers
}
    `;
export const EmployeesFragmentDoc = gql`
    fragment Employees on IcxDetatilModel {
  employees2020FullTimeTotal
  employees2019FullTimeTotal
  thirdPartyEmployees2020DispatchedTotal
  thirdPartyEmployees2019DispatchedTotal
}
    `;
export const FullinvestigationFragmentDoc = gql`
    fragment Fullinvestigation on IcxDetatilModel {
  fullinvestigationName_1
  fullinvestigationCall
  fullinvestigationFax
  fullinvestigationEmail
  fullinvestigationRegistrationNumber
  fullinvestigationDivision
  fullinvestigationCorporationNumber
  fullinvestigationRegistrationNumber
  fullinvestigationAddress
  fullinvestigationStreetAddress
  fullinvestigationYear
}
    `;
export const AuthenticationInfoFragmentDoc = gql`
    fragment AuthenticationInfo on IcxAuthentication {
  accessToken
  tokenType
  expiresIn
  refreshToken
  redirectUrl
}
    `;
export const FetchAllIcxInfoDocument = gql`
    query fetchAllIcxInfo($input: FetchAllIcxInput!) {
  fetchAllIcxInfo(input: $input) {
    result
    errorMessage
    data {
      icxDetatilModelCount
      icxDetatilModelList {
        id
        ...BasicInfo
        ...Keyresults
        ...ActivitiesProduct
        ...ActivityCharacteristics
        ...PurchasesByPlace
        ...PurchasesByCity
        ...PurchasesByIndustrial
        ...VendorByPlace
        ...VendorByCity
        ...VendorByIndustrial
        ...Rnd
        ...ProductionPerformance
        ...ExportPerformance
        ...Employees
        ...Fullinvestigation
      }
    }
  }
}
    ${BasicInfoFragmentDoc}
${KeyresultsFragmentDoc}
${ActivitiesProductFragmentDoc}
${ActivityCharacteristicsFragmentDoc}
${PurchasesByPlaceFragmentDoc}
${PurchasesByCityFragmentDoc}
${PurchasesByIndustrialFragmentDoc}
${VendorByPlaceFragmentDoc}
${VendorByCityFragmentDoc}
${VendorByIndustrialFragmentDoc}
${RndFragmentDoc}
${ProductionPerformanceFragmentDoc}
${ExportPerformanceFragmentDoc}
${EmployeesFragmentDoc}
${FullinvestigationFragmentDoc}`;

/**
 * __useFetchAllIcxInfoQuery__
 *
 * To run a query within a React component, call `useFetchAllIcxInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchAllIcxInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchAllIcxInfoQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useFetchAllIcxInfoQuery(baseOptions: Apollo.QueryHookOptions<FetchAllIcxInfoQuery, FetchAllIcxInfoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchAllIcxInfoQuery, FetchAllIcxInfoQueryVariables>(FetchAllIcxInfoDocument, options);
      }
export function useFetchAllIcxInfoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchAllIcxInfoQuery, FetchAllIcxInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchAllIcxInfoQuery, FetchAllIcxInfoQueryVariables>(FetchAllIcxInfoDocument, options);
        }
export type FetchAllIcxInfoQueryHookResult = ReturnType<typeof useFetchAllIcxInfoQuery>;
export type FetchAllIcxInfoLazyQueryHookResult = ReturnType<typeof useFetchAllIcxInfoLazyQuery>;
export type FetchAllIcxInfoQueryResult = Apollo.QueryResult<FetchAllIcxInfoQuery, FetchAllIcxInfoQueryVariables>;
export const IcxAuthenticateDocument = gql`
    query icxAuthenticate($input: IcxAuthenticationInput!) {
  icxAuthenticate(input: $input) {
    result
    errorMessage
    data {
      ...AuthenticationInfo
    }
  }
}
    ${AuthenticationInfoFragmentDoc}`;

/**
 * __useIcxAuthenticateQuery__
 *
 * To run a query within a React component, call `useIcxAuthenticateQuery` and pass it any options that fit your needs.
 * When your component renders, `useIcxAuthenticateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIcxAuthenticateQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useIcxAuthenticateQuery(baseOptions: Apollo.QueryHookOptions<IcxAuthenticateQuery, IcxAuthenticateQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IcxAuthenticateQuery, IcxAuthenticateQueryVariables>(IcxAuthenticateDocument, options);
      }
export function useIcxAuthenticateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IcxAuthenticateQuery, IcxAuthenticateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IcxAuthenticateQuery, IcxAuthenticateQueryVariables>(IcxAuthenticateDocument, options);
        }
export type IcxAuthenticateQueryHookResult = ReturnType<typeof useIcxAuthenticateQuery>;
export type IcxAuthenticateLazyQueryHookResult = ReturnType<typeof useIcxAuthenticateLazyQuery>;
export type IcxAuthenticateQueryResult = Apollo.QueryResult<IcxAuthenticateQuery, IcxAuthenticateQueryVariables>;
export const IcxRefreshAccessTokenDocument = gql`
    mutation icxRefreshAccessToken($input: IcxTokenRefreshInput!) {
  icxRefreshAccessToken(input: $input) {
    result
    errorMessage
    data {
      ...AuthenticationInfo
    }
  }
}
    ${AuthenticationInfoFragmentDoc}`;
export type IcxRefreshAccessTokenMutationFn = Apollo.MutationFunction<IcxRefreshAccessTokenMutation, IcxRefreshAccessTokenMutationVariables>;

/**
 * __useIcxRefreshAccessTokenMutation__
 *
 * To run a mutation, you first call `useIcxRefreshAccessTokenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useIcxRefreshAccessTokenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [icxRefreshAccessTokenMutation, { data, loading, error }] = useIcxRefreshAccessTokenMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useIcxRefreshAccessTokenMutation(baseOptions?: Apollo.MutationHookOptions<IcxRefreshAccessTokenMutation, IcxRefreshAccessTokenMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<IcxRefreshAccessTokenMutation, IcxRefreshAccessTokenMutationVariables>(IcxRefreshAccessTokenDocument, options);
      }
export type IcxRefreshAccessTokenMutationHookResult = ReturnType<typeof useIcxRefreshAccessTokenMutation>;
export type IcxRefreshAccessTokenMutationResult = Apollo.MutationResult<IcxRefreshAccessTokenMutation>;
export type IcxRefreshAccessTokenMutationOptions = Apollo.BaseMutationOptions<IcxRefreshAccessTokenMutation, IcxRefreshAccessTokenMutationVariables>;
export const FetchFactoronDocument = gql`
    query fetchFactoron($input: FactoronBizFetchIcxInput!) {
  fetchFactoron(input: $input) {
    result
    errorMessage
    data {
      count
      icxModelList {
        id
        industrialComplex
        companyName
        representativeName
        birthOrRegistrationNumber
        industrialCenterName
        factoryControlNumber
        factoryAddressRoadName
        factoryAddressNo
        companyRegistrationNumber
        representativeIndustryCode
        representativeIndustryNumber
        sectors
        industryName
        jurisdictionOrganizationName
        jurisdictionOrganizationCode
        region
        city
        establishment
        moveInType
        classificationOfHoldings
        applicationDate
        firstApprovalDate
        approvalClassification
        approvalDate
        firstRegistrationDate
        registrationCategory
        registrationDate
        registrationNumber
        changeReportDate
        businessType
        contact
        faxNumber
        maleEmployeeCount
        femaleEmployeeCount
        maleForeigner
        femaleForeigner
        employeesCount
        product
        mainMaterial
        businessStartDate
        factoryCompletionDate
        estimatedConstructionStartDate
        estimatedConstructionCompletionDate
        factorySize
        useArea
        landCategory
        landArea
        manufacturingFacilityArea
        ancillaryFacilityArea
        officeArea
        warehouseArea
        horizontalProjectionArea
        buildingArea
        airQuality
        waterQuality
        isNoiseVibration
        livingWater
        industrialWater
        power
        oil
        gas
        etcOil
        equityMillion
        debtCapitalMillion
        foreignInvestmentRatio
        foreignInvestment
        cancellationDate
        cancellationReason
        representativeEmail
        representativePhoneNumber
        factoryWebsite
        factoryZipCode
        representativeZipCode
        representativeAddress
        reasonChange
        factoryManagementNumberOld
        expirationPeriod
        factoryCondition
        freeEconomicZone
      }
    }
  }
}
    `;

/**
 * __useFetchFactoronQuery__
 *
 * To run a query within a React component, call `useFetchFactoronQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchFactoronQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchFactoronQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useFetchFactoronQuery(baseOptions: Apollo.QueryHookOptions<FetchFactoronQuery, FetchFactoronQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchFactoronQuery, FetchFactoronQueryVariables>(FetchFactoronDocument, options);
      }
export function useFetchFactoronLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchFactoronQuery, FetchFactoronQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchFactoronQuery, FetchFactoronQueryVariables>(FetchFactoronDocument, options);
        }
export type FetchFactoronQueryHookResult = ReturnType<typeof useFetchFactoronQuery>;
export type FetchFactoronLazyQueryHookResult = ReturnType<typeof useFetchFactoronLazyQuery>;
export type FetchFactoronQueryResult = Apollo.QueryResult<FetchFactoronQuery, FetchFactoronQueryVariables>;
export const FetchInnoBizDocument = gql`
    query fetchInnoBiz($input: InnoBizFetchIcxInput!) {
  fetchInnoBiz(input: $input) {
    result
    errorMessage
    data {
      count
      icxModelList {
        id
        companyName
        address
        representativeName
        representativeEmai
        representativeContact
        employeesCount
        relatedIndustry
        industryCode
        product
        companyContact
      }
    }
  }
}
    `;

/**
 * __useFetchInnoBizQuery__
 *
 * To run a query within a React component, call `useFetchInnoBizQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchInnoBizQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchInnoBizQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useFetchInnoBizQuery(baseOptions: Apollo.QueryHookOptions<FetchInnoBizQuery, FetchInnoBizQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchInnoBizQuery, FetchInnoBizQueryVariables>(FetchInnoBizDocument, options);
      }
export function useFetchInnoBizLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchInnoBizQuery, FetchInnoBizQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchInnoBizQuery, FetchInnoBizQueryVariables>(FetchInnoBizDocument, options);
        }
export type FetchInnoBizQueryHookResult = ReturnType<typeof useFetchInnoBizQuery>;
export type FetchInnoBizLazyQueryHookResult = ReturnType<typeof useFetchInnoBizLazyQuery>;
export type FetchInnoBizQueryResult = Apollo.QueryResult<FetchInnoBizQuery, FetchInnoBizQueryVariables>;
export const FetchMainBizDocument = gql`
    query fetchMainBiz($input: MainBizFetchIcxInput!) {
  fetchMainBiz(input: $input) {
    result
    errorMessage
    data {
      count
      icxModelList {
        id
        companyName
        representativeName
        industryCode
        industryName
        region
        location
        certificationExpirationDate
      }
    }
  }
}
    `;

/**
 * __useFetchMainBizQuery__
 *
 * To run a query within a React component, call `useFetchMainBizQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchMainBizQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchMainBizQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useFetchMainBizQuery(baseOptions: Apollo.QueryHookOptions<FetchMainBizQuery, FetchMainBizQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchMainBizQuery, FetchMainBizQueryVariables>(FetchMainBizDocument, options);
      }
export function useFetchMainBizLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchMainBizQuery, FetchMainBizQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchMainBizQuery, FetchMainBizQueryVariables>(FetchMainBizDocument, options);
        }
export type FetchMainBizQueryHookResult = ReturnType<typeof useFetchMainBizQuery>;
export type FetchMainBizLazyQueryHookResult = ReturnType<typeof useFetchMainBizLazyQuery>;
export type FetchMainBizQueryResult = Apollo.QueryResult<FetchMainBizQuery, FetchMainBizQueryVariables>;
export const FetchMiniClusterDocument = gql`
    query fetchMiniCluster($input: IcxMiniClusterFetchIcxInput!) {
  fetchMiniCluster(input: $input) {
    result
    errorMessage
    data {
      count
      icxModelList {
        id
        region
        base
        miniClusterName
        enterpriseType
        companyName
        businessRegistrationNumber
        industryUniversityInstituteCollaboration
        companyRegistrationDate
        memberName
        mailAddress
        registrationDate
        contact
      }
    }
  }
}
    `;

/**
 * __useFetchMiniClusterQuery__
 *
 * To run a query within a React component, call `useFetchMiniClusterQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchMiniClusterQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchMiniClusterQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useFetchMiniClusterQuery(baseOptions: Apollo.QueryHookOptions<FetchMiniClusterQuery, FetchMiniClusterQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchMiniClusterQuery, FetchMiniClusterQueryVariables>(FetchMiniClusterDocument, options);
      }
export function useFetchMiniClusterLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchMiniClusterQuery, FetchMiniClusterQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchMiniClusterQuery, FetchMiniClusterQueryVariables>(FetchMiniClusterDocument, options);
        }
export type FetchMiniClusterQueryHookResult = ReturnType<typeof useFetchMiniClusterQuery>;
export type FetchMiniClusterLazyQueryHookResult = ReturnType<typeof useFetchMiniClusterLazyQuery>;
export type FetchMiniClusterQueryResult = Apollo.QueryResult<FetchMiniClusterQuery, FetchMiniClusterQueryVariables>;
export const FetchVentureBizDocument = gql`
    query fetchVentureBiz($input: VentureBizFetchIcxInput!) {
  fetchVentureBiz(input: $input) {
    result
    errorMessage
    data {
      count
      icxModelList {
        id
        companyName
        contact
        relatedIndustry
        industryName
        region
      }
    }
  }
}
    `;

/**
 * __useFetchVentureBizQuery__
 *
 * To run a query within a React component, call `useFetchVentureBizQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchVentureBizQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchVentureBizQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useFetchVentureBizQuery(baseOptions: Apollo.QueryHookOptions<FetchVentureBizQuery, FetchVentureBizQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchVentureBizQuery, FetchVentureBizQueryVariables>(FetchVentureBizDocument, options);
      }
export function useFetchVentureBizLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchVentureBizQuery, FetchVentureBizQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchVentureBizQuery, FetchVentureBizQueryVariables>(FetchVentureBizDocument, options);
        }
export type FetchVentureBizQueryHookResult = ReturnType<typeof useFetchVentureBizQuery>;
export type FetchVentureBizLazyQueryHookResult = ReturnType<typeof useFetchVentureBizLazyQuery>;
export type FetchVentureBizQueryResult = Apollo.QueryResult<FetchVentureBizQuery, FetchVentureBizQueryVariables>;